import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Box, Text, Flex, Button, Badge, Menu, MenuItem, Stack, Card, Container as Container$1, DialogProvider, PortalProvider, BoundaryElementProvider, useToast, Layer, MenuDivider, TextSkeleton, useElementRect, LayerProvider, _raf2, rem, TextInput, Code, TabList, TabPanel, useClickOutsideEvent, Heading, Inline, Spinner, focusFirstDescendant, usePortal, Dialog as Dialog$1, Popover as Popover$1, useLayer, useGlobalKeyDown, AvatarStack, Skeleton } from "@sanity/ui";
import { useRef, useEffect, forwardRef, useState, useContext, useImperativeHandle, useLayoutEffect, useId, memo, useEffectEvent, Fragment as Fragment$1, useDeferredValue, lazy, Suspense, startTransition } from "react";
import { ReviewChangesContext, CommentsEnabledContext, ReferenceInputOptionsContext, PaneLayoutContext, PaneContext, DocumentPaneContext, DocumentActionsStateContext, StructureToolContext, DocumentPaneInfoContext, PaneRouterContext, ResolvedPanesContext, EventsContext, DocumentChangeContext } from "sanity/_singletons";
import { motion, AnimatePresence } from "motion/react";
import { isPublishedId, isDraftId, getReleaseIdFromReleaseDocumentId, getVersionFromId, useTranslation, useDocumentVersions, useActiveReleases, getPublishedId, useEditState, useWorkspace, isReleaseDocument, getReleaseTone, isReleaseScheduledOrScheduling, ReleaseAvatar, isSystemBundleName, PUBLISHED, LATEST, useFormatRelativeLocalePublishDate, getDraftId, getVersionId, ReleaseTitle, useMiddlewareComponents, ChangeIndicatorsTracker, VirtualizerScrollInstanceProvider, useDocumentForm, LoadingBlock, FormBuilder, isVersionId, createPatchChannel, getDocumentVariantType, LegacyLayerProvider, IsLastPaneProvider, useGetI18nText, useI18nText, TooltipOfDisabled, ContextMenuButton, StatusButton, isDev, CommentsEnabledProvider, useCommentsEnabled, usePerspective, CommentsProvider, COMMENTS_INSPECTOR_NAME, GetHookCollectionState, EMPTY_ARRAY as EMPTY_ARRAY$2, getDocumentIdForCanvasLink, useCanvasCompanionDoc, useUnique, isPublishedPerspective, prepareForPreview, useValuePreview, useDocumentOperationEvent, useDocumentLimitsUpsellContext, isDocumentLimitError, Translate, isNewDocument, Resizable, useKeyValueStore, isRecord, isString, isDraftPerspective, useDocumentOperation, isDeprecatedSchemaType, useProjectId, useClient, useZIndex, useCurrentUser, useListFormat, useDocumentPreviewStore, isSystemBundle, useScheduledDraftDocument, useArchivedReleases, isCardinalityOneRelease, getVersionInlineBadge, useNavigateToCanvasDoc, isPerspectiveWriteable, ReleasesNav, useVersionOperations, useConditionalToast, isAgentBundleName, useOnlyHasVersions, useSetPerspective, VersionInlineBadge, isGoingToUnpublish, useDocumentStore, useDocumentPresence, FormRow, FormContainer, PresenceOverlay, fromMutationPatches, useDocumentPreviewValues, useManageFavorite, useActiveWorkspace, CapabilityGate, useFilteredReleases, usePausedScheduledDraft, isPausedCardinalityOneRelease, ScrollContainer, useStudioUrl, VersionChip, Chip, useDateTimeFormat, useSchema, useGetDefaultPerspective, useSingleDocRelease, useAgentVersionDisplay, useFieldActions, useDocumentVersionTypeSortedList, useDocumentPairPermissions, InsufficientPermissionsMessage, useValidationStatus, useSyncState, useRelativeTime, useSource, Hotkeys, isSanityDefinedAction, UserAvatar, useUser, AvatarSkeleton, CommandList, TextWithTone, useTimelineSelector, useEvents, TIMELINE_ITEM_I18N_KEY_MAPPING as TIMELINE_ITEM_I18N_KEY_MAPPING$1, ChangeConnectorRoot, useGlobalCopyPasteElementHandler, useDocumentIdStack, GetFormValueProvider, FieldActionsResolver, FieldActionsProvider, useTemplates, useInitialValue, useCopyPaste, selectUpstreamVersion, pathToString, ParseErrorsProvider, DivergencesProvider, useDocumentDivergences, useEventsStore, EventsProvider, PerspectiveProvider, useTimelineStore, SingleDocReleaseProvider, SourceProvider, CopyPasteProvider, useDocumentType, useTemplatePermissions, ReferenceInputOptionsProvider, useDocumentVersionInfo, getPreviewStateObservable, getPreviewValueWithFallback, SanityDefaultPreview, DocumentPreviewPresence, DocumentStatusIndicator, DocumentStatus, PreviewCard, ReleaseAvatarIcon, createHookFromObservableFactory, DEFAULT_STUDIO_CLIENT_OPTIONS, EMPTY_OBJECT, CrossDatasetReferencePreview, getPreviewPaths, isNonNullable as isNonNullable$1, getReferencePaths, ErrorActions, collate, createSWR, getSearchableTypes, compileFieldPath, createSearch, useSearchMaxFieldDepth, measureFirstMatch, catchWithCount, useReconnectingToast, ChangeFieldWrapper, NoChanges, ChangeList, isDeleteDocumentVersionEvent, isDeleteDocumentGroupEvent, isUnpublishDocumentEvent, isScheduleDocumentVersionEvent, isUnscheduleDocumentVersionEvent, Event, RELEASES_INTENT, isCreateDocumentVersionEvent, isEditDocumentVersionEvent, isPublishDocumentVersionEvent, ChangesError, isArray, useParseErrors, mergeParseErrors, isValidationError, isValidationWarning, definePlugin } from "sanity";
import { useRouter, useIntentLink, useRouterState, StateLink, IntentLink, route, encodeJsonParams, decodeJsonParams } from "sanity/router";
import { structureLocaleNamespace, structureUsEnglishLocaleBundle } from "./StructureToolProvider.js";
import * as PathUtils from "@sanity/util/paths";
import { fromString, get, resolveKeyedPath, toString } from "@sanity/util/paths";
import omit from "lodash-es/omit.js";
import { MenuButton, Dialog, MenuItem as MenuItem$1, Button as Button$1, Tab, Popover, Tooltip, TooltipDelayGroupProvider, ErrorBoundary } from "./index.js";
import isEqual from "lodash-es/isEqual.js";
import shallowEquals from "shallow-equals";
import "react-i18next";
import { TransferIcon, CloseIcon, LockIcon, CheckmarkIcon, UnknownIcon, SearchIcon, DocumentRemoveIcon, ReadOnlyIcon, ErrorOutlineIcon, SyncIcon, WarningOutlineIcon, InfoOutlineIcon, ComposeSparklesIcon, LaunchIcon, PauseIcon, UnpublishIcon, ArrowRightIcon, StarFilledIcon, StarIcon, ArrowLeftIcon, RevertIcon, ShareIcon, LinkIcon, TargetIcon, ChevronUpIcon, ChevronDownIcon, SplitVerticalIcon, CollapseIcon, ExpandIcon, TrashIcon, ResetIcon, CopyIcon, PublishIcon, EditIcon, AddIcon, ChevronLeftIcon, RestoreIcon, EarthAmericasIcon, JsonIcon, DocumentsIcon, ChevronRightIcon, DocumentIcon, FolderIcon, SpinnerIcon, CheckmarkCircleIcon, MasterDetailIcon } from "@sanity/icons";
import { nanoid } from "nanoid";
import { useObservable, useObservableEvent } from "react-rx";
import { Subject, distinctUntilChanged, filter, map, of, merge, startWith, catchError, concat, firstValueFrom, BehaviorSubject, from, fromEvent, EMPTY, timer, switchMap as switchMap$1, defer, mergeMap, throwError, share, partition, throttleTime, asyncScheduler, NEVER, tap as tap$1, debounce } from "rxjs";
import { styled, css, keyframes } from "styled-components";
import { isValidationErrorMarker, isSanityDocument as isSanityDocument$1, isReferenceSchemaType, isKeySegment, isIndexSegment, isArraySchemaType } from "@sanity/types";
import { parse } from "groq-js";
import { ChannelError, ServerError, ClientError } from "@sanity/client";
import { useTelemetry } from "@sanity/telemetry/react";
import { observableCallback } from "observable-callback";
import { mapTo, delay, map as map$1, catchError as catchError$1, startWith as startWith$1, debounceTime, tap, distinctUntilChanged as distinctUntilChanged$1, switchMap, shareReplay, scan, withLatestFrom, filter as filter$1, take, mergeMap as mergeMap$1, share as share$1, takeUntil } from "rxjs/operators";
import { defineEvent } from "@sanity/telemetry";
import { exhaustMapWithTrailing } from "rxjs-exhaustmap-with-trailing";
import uniqBy from "lodash-es/uniqBy.js";
import negate from "lodash-es/negate.js";
import { MenuGroup, ConfirmPopover } from "./MenuGroup.js";
import fromPairs from "lodash-es/fromPairs.js";
import toPairs from "lodash-es/toPairs.js";
import ScrollMirror from "scrollmirror";
import noop from "lodash-es/noop.js";
import deepEquals from "react-fast-compare";
import { isHotkey } from "is-hotkey-esm";
import { JsonInspector } from "@rexxars/react-json-inspector";
import QuickLRU from "quick-lru";
import { addWeeks } from "date-fns/addWeeks";
import { isAfter } from "date-fns/isAfter";
import { isBefore } from "date-fns/isBefore";
import { getTheme_v2, rgba } from "@sanity/ui/theme";
import { uuid } from "@sanity/uuid";
import { format } from "date-fns/format";
import { diffInput, wrap } from "@sanity/diff";
import { mergeMapArray } from "rxjs-mergemap-array";
const DiffViewEntered = defineEvent({
  name: "DiffViewEntered",
  version: 1,
  description: "User entered document comparison view"
}), DiffViewExited = defineEvent({
  name: "DiffViewExited",
  version: 1,
  description: "User exited document comparison view"
}), DiffViewDocumentSelectionChanged = defineEvent({
  name: "DiffViewDocumentSelectionChanged",
  version: 1,
  description: "User set one of the documents being compared"
});
function useCreatePathSyncChannel() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = new Subject(), $[0] = t0) : t0 = $[0], t0;
}
const DIFF_VIEW_SEARCH_PARAMETER = "diffView", DIFF_VIEW_PREVIOUS_DOCUMENT_SEARCH_PARAMETER = "previousDocument", DIFF_VIEW_NEXT_DOCUMENT_SEARCH_PARAMETER = "nextDocument", DIFF_SEARCH_PARAM_DELIMITER = ",";
function useDiffViewRouter() {
  const $ = c(9), {
    navigate,
    state: routerState
  } = useRouter();
  let t0;
  $[0] !== navigate || $[1] !== routerState ? (t0 = (t12) => {
    const {
      mode,
      previousDocument,
      nextDocument
    } = t12, next = {
      ...fromPairs(routerState._searchParams),
      ...mode ? {
        [DIFF_VIEW_SEARCH_PARAMETER]: mode
      } : {},
      ...previousDocument ? {
        [DIFF_VIEW_PREVIOUS_DOCUMENT_SEARCH_PARAMETER]: [previousDocument.type, previousDocument.id].join(DIFF_SEARCH_PARAM_DELIMITER)
      } : {},
      ...nextDocument ? {
        [DIFF_VIEW_NEXT_DOCUMENT_SEARCH_PARAMETER]: [nextDocument.type, nextDocument.id].join(DIFF_SEARCH_PARAM_DELIMITER)
      } : {}
    };
    navigate({
      ...routerState,
      _searchParams: toPairs(next)
    });
  }, $[0] = navigate, $[1] = routerState, $[2] = t0) : t0 = $[2];
  const navigateDiffView = t0;
  let t1;
  $[3] !== navigate || $[4] !== routerState ? (t1 = () => {
    navigate({
      ...routerState,
      _searchParams: (routerState._searchParams ?? []).filter(_temp$M)
    });
  }, $[3] = navigate, $[4] = routerState, $[5] = t1) : t1 = $[5];
  const exitDiffView = t1;
  let t2;
  return $[6] !== exitDiffView || $[7] !== navigateDiffView ? (t2 = {
    navigateDiffView,
    exitDiffView
  }, $[6] = exitDiffView, $[7] = navigateDiffView, $[8] = t2) : t2 = $[8], t2;
}
function _temp$M(t0) {
  const [key] = t0;
  return ![DIFF_VIEW_SEARCH_PARAMETER, DIFF_VIEW_PREVIOUS_DOCUMENT_SEARCH_PARAMETER, DIFF_VIEW_NEXT_DOCUMENT_SEARCH_PARAMETER].includes(key);
}
const diffViewModes = ["version"];
function isDiffViewMode(maybeDiffViewMode) {
  return diffViewModes.includes(maybeDiffViewMode);
}
function useDiffViewState(t0) {
  const $ = c(33);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const {
    onParamsError,
    onActiveChanged,
    onTargetDocumentsChanged
  } = t1, {
    state: routerState
  } = useRouter();
  let nextDocument, previousDocument, t2;
  if ($[2] !== routerState._searchParams) {
    const searchParams = new URLSearchParams(routerState._searchParams);
    previousDocument = searchParams.get(DIFF_VIEW_PREVIOUS_DOCUMENT_SEARCH_PARAMETER), nextDocument = searchParams.get(DIFF_VIEW_NEXT_DOCUMENT_SEARCH_PARAMETER), t2 = searchParams.get(DIFF_VIEW_SEARCH_PARAMETER), $[2] = routerState._searchParams, $[3] = nextDocument, $[4] = previousDocument, $[5] = t2;
  } else
    nextDocument = $[3], previousDocument = $[4], t2 = $[5];
  const mode = t2, anyParamSet = [previousDocument, nextDocument, mode].some(_temp$L), previousState = useRef(void 0), t3 = previousDocument ?? "", t4 = nextDocument ?? "", t5 = mode ?? "";
  let t6;
  $[6] !== t3 || $[7] !== t4 || $[8] !== t5 ? (t6 = parseParams({
    previousDocument: t3,
    nextDocument: t4,
    mode: t5
  }), $[6] = t3, $[7] = t4, $[8] = t5, $[9] = t6) : t6 = $[9];
  const params = t6;
  let t7;
  $[10] !== anyParamSet || $[11] !== onParamsError || $[12] !== params.errors || $[13] !== params.result ? (t7 = () => {
    params.result === "error" && anyParamSet && onParamsError?.(params.errors);
  }, $[10] = anyParamSet, $[11] = onParamsError, $[12] = params.errors, $[13] = params.result, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== anyParamSet || $[16] !== onParamsError || $[17] !== params ? (t8 = [anyParamSet, onParamsError, params], $[15] = anyParamSet, $[16] = onParamsError, $[17] = params, $[18] = t8) : t8 = $[18], useEffect(t7, t8);
  let t9;
  bb0: {
    if (params.result === "error") {
      let t103;
      $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t103 = {
        isActive: !1
      }, $[19] = t103) : t103 = $[19], t9 = t103;
      break bb0;
    }
    let t102;
    $[20] !== params.params ? (t102 = {
      state: "ready",
      isActive: !0,
      ...params.params
    }, $[20] = params.params, $[21] = t102) : t102 = $[21], t9 = t102;
  }
  const state2 = t9;
  let t10, t11;
  $[22] !== onActiveChanged || $[23] !== state2 ? (t10 = () => {
    typeof onActiveChanged == "function" && previousState.current?.isActive !== state2.isActive && onActiveChanged(previousState.current, state2);
  }, t11 = [onActiveChanged, state2], $[22] = onActiveChanged, $[23] = state2, $[24] = t10, $[25] = t11) : (t10 = $[24], t11 = $[25]), useEffect(t10, t11);
  let t12, t13;
  $[26] !== onTargetDocumentsChanged || $[27] !== state2 ? (t12 = () => {
    typeof onTargetDocumentsChanged == "function" && previousState.current?.isActive && state2.isActive && !isEqual([previousState?.current?.documents?.previous.id, previousState?.current?.documents?.next.id], [state2.documents?.previous.id, state2.documents?.next.id]) && onTargetDocumentsChanged(previousState.current, state2);
  }, t13 = [onTargetDocumentsChanged, state2], $[26] = onTargetDocumentsChanged, $[27] = state2, $[28] = t12, $[29] = t13) : (t12 = $[28], t13 = $[29]), useEffect(t12, t13);
  let t14, t15;
  return $[30] !== state2 ? (t14 = () => {
    previousState.current = state2;
  }, t15 = [state2], $[30] = state2, $[31] = t14, $[32] = t15) : (t14 = $[31], t15 = $[32]), useEffect(t14, t15), state2;
}
function _temp$L(param) {
  return param !== null;
}
function parseParams({
  previousDocument,
  nextDocument,
  mode
}) {
  const errors = [], [previousDocumentType, previousDocumentId] = previousDocument.split(DIFF_SEARCH_PARAM_DELIMITER).filter(Boolean), [nextDocumentType, nextDocumentId] = nextDocument.split(DIFF_SEARCH_PARAM_DELIMITER).filter(Boolean);
  return isDiffViewMode(mode) || errors.push(["invalidModeParam", mode]), (typeof previousDocumentType > "u" || typeof previousDocumentId > "u") && errors.push(["invalidPreviousDocumentParam", previousDocument]), (typeof nextDocumentType > "u" || typeof nextDocumentId > "u") && errors.push(["invalidNextDocumentParam", nextDocument]), errors.length !== 0 ? {
    result: "error",
    errors
  } : {
    result: "success",
    params: {
      mode,
      documents: {
        previous: {
          type: previousDocumentType,
          id: previousDocumentId
        },
        next: {
          type: nextDocumentType,
          id: nextDocumentId
        }
      }
    }
  };
}
function selectActiveTransition(previousState, state2) {
  if (!previousState?.isActive && state2.isActive)
    return "entered";
  if (previousState?.isActive && !state2.isActive)
    return "exited";
}
function useScrollMirror(elements) {
  const $ = c(3);
  let t0, t1;
  $[0] !== elements ? (t0 = () => {
    const existentElements = elements.filter(_temp$K);
    if (existentElements.length === 0)
      return;
    const scrollMirror = new ScrollMirror(existentElements);
    return () => scrollMirror.destroy();
  }, t1 = [elements], $[0] = elements, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1);
}
function _temp$K(element) {
  return element !== null;
}
function findRelease(documentId, releases) {
  return isPublishedId(documentId) ? "published" : isDraftId(documentId) ? "draft" : releases.find(({
    _id
  }) => getReleaseIdFromReleaseDocumentId(_id) === getVersionFromId(documentId)) ?? getVersionFromId(documentId);
}
const VersionModeHeaderLayout = styled.header.withConfig({
  displayName: "VersionModeHeaderLayout",
  componentId: "sc-w17umd-0"
})`display:grid;grid-area:header;grid-template-columns:1fr min-content 1fr;border-block-end:1px solid var(--card-border-color);`, VersionModeHeaderLayoutSection = styled.div.withConfig({
  displayName: "VersionModeHeaderLayoutSection",
  componentId: "sc-w17umd-1"
})`display:flex;justify-content:space-between;align-items:center;`, VersionModeHeader = (t0) => {
  const $ = c(48), {
    documentId,
    state: state2
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const {
    data: documentVersions
  } = useDocumentVersions(t1), {
    exitDiffView,
    navigateDiffView
  } = useDiffViewRouter(), {
    documents
  } = useDiffViewState(), activeReleases = useActiveReleases();
  let t2;
  $[2] !== documentVersions ? (t2 = documentVersions.flatMap(_temp$J), $[2] = documentVersions, $[3] = t2) : t2 = $[3];
  const releasesIds = t2;
  let t3;
  if ($[4] !== activeReleases.data || $[5] !== releasesIds) {
    let t42;
    $[7] !== releasesIds ? (t42 = (release) => {
      const releaseId = getReleaseIdFromReleaseDocumentId(release._id);
      return typeof releaseId < "u" && releasesIds.includes(releaseId);
    }, $[7] = releasesIds, $[8] = t42) : t42 = $[8], t3 = activeReleases.data.filter(t42), $[4] = activeReleases.data, $[5] = releasesIds, $[6] = t3;
  } else
    t3 = $[6];
  const releases = t3;
  let t4;
  $[9] !== activeReleases ? (t4 = fetchingState(activeReleases), $[9] = activeReleases, $[10] = t4) : t4 = $[10];
  const releasesState = t4;
  let t5;
  $[11] !== documents || $[12] !== navigateDiffView ? (t5 = (selectedDocumentId) => {
    typeof documents?.previous < "u" && navigateDiffView({
      previousDocument: {
        ...documents.previous,
        id: selectedDocumentId
      }
    });
  }, $[11] = documents, $[12] = navigateDiffView, $[13] = t5) : t5 = $[13];
  const onSelectPreviousRelease = t5;
  let t6;
  $[14] !== documents || $[15] !== navigateDiffView ? (t6 = (selectedDocumentId_0) => {
    typeof documents?.next < "u" && navigateDiffView({
      nextDocument: {
        ...documents.next,
        id: selectedDocumentId_0
      }
    });
  }, $[14] = documents, $[15] = navigateDiffView, $[16] = t6) : t6 = $[16];
  const onSelectNextRelease = t6;
  let t7;
  $[17] !== t ? (t7 = t("compare-versions.title"), $[17] = t, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text, { as: "h1", size: 1, muted: !0, children: t7 }) }), $[19] = t7, $[20] = t8) : t8 = $[20];
  let t9;
  $[21] !== documentId || $[22] !== documents || $[23] !== onSelectPreviousRelease || $[24] !== releases || $[25] !== releasesState || $[26] !== state2 ? (t9 = typeof documents?.previous < "u" && /* @__PURE__ */ jsx(VersionMenu, { releases, releasesState, onSelectRelease: onSelectPreviousRelease, role: "previous", documentId, state: state2, document: documents.previous }), $[21] = documentId, $[22] = documents, $[23] = onSelectPreviousRelease, $[24] = releases, $[25] = releasesState, $[26] = state2, $[27] = t9) : t9 = $[27];
  let t10;
  $[28] !== t8 || $[29] !== t9 ? (t10 = /* @__PURE__ */ jsxs(VersionModeHeaderLayoutSection, { children: [
    t8,
    t9
  ] }), $[28] = t8, $[29] = t9, $[30] = t10) : t10 = $[30];
  let t11;
  $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Flex, { align: "center", paddingX: 3, children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(TransferIcon, {}) }) }), $[31] = t11) : t11 = $[31];
  let t12;
  $[32] !== documentId || $[33] !== documents || $[34] !== onSelectNextRelease || $[35] !== releases || $[36] !== releasesState || $[37] !== state2 ? (t12 = typeof documents?.next < "u" && /* @__PURE__ */ jsx(VersionMenu, { releases, releasesState, onSelectRelease: onSelectNextRelease, role: "next", documentId, state: state2, document: documents.next }), $[32] = documentId, $[33] = documents, $[34] = onSelectNextRelease, $[35] = releases, $[36] = releasesState, $[37] = state2, $[38] = t12) : t12 = $[38];
  let t13;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = {
    justifySelf: "end"
  }, $[39] = t13) : t13 = $[39];
  let t14;
  $[40] !== exitDiffView ? (t14 = /* @__PURE__ */ jsx(Box, { padding: 3, style: t13, children: /* @__PURE__ */ jsx(Button, { icon: CloseIcon, mode: "bleed", onClick: exitDiffView, padding: 2 }) }), $[40] = exitDiffView, $[41] = t14) : t14 = $[41];
  let t15;
  $[42] !== t12 || $[43] !== t14 ? (t15 = /* @__PURE__ */ jsxs(VersionModeHeaderLayoutSection, { children: [
    t12,
    t14
  ] }), $[42] = t12, $[43] = t14, $[44] = t15) : t15 = $[44];
  let t16;
  return $[45] !== t10 || $[46] !== t15 ? (t16 = /* @__PURE__ */ jsxs(VersionModeHeaderLayout, { children: [
    t10,
    t11,
    t15
  ] }), $[45] = t10, $[46] = t15, $[47] = t16) : t16 = $[47], t16;
}, VersionMenu = (t0) => {
  const $ = c(46), {
    releases: t1,
    releasesState,
    onSelectRelease,
    role,
    documentId,
    document: document2
  } = t0;
  let t2;
  $[0] !== t1 ? (t2 = t1 === void 0 ? [] : t1, $[0] = t1, $[1] = t2) : t2 = $[1];
  const releases = t2;
  let t3;
  $[2] !== document2.id ? (t3 = getPublishedId(document2.id), $[2] = document2.id, $[3] = t3) : t3 = $[3];
  const {
    published,
    draft
  } = useEditState(t3, document2.type);
  let t4;
  $[4] !== document2.id || $[5] !== releases ? (t4 = findRelease(document2.id, releases), $[4] = document2.id, $[5] = releases, $[6] = t4) : t4 = $[6];
  const selected = t4, {
    t: tStructure
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    document: t5
  } = useWorkspace(), {
    drafts: t6
  } = t5, {
    enabled: isDraftModelEnabled
  } = t6;
  if (releasesState === "error") {
    let t72;
    $[7] !== tStructure ? (t72 = tStructure("compare-version.error.loadReleases.title"), $[7] = tStructure, $[8] = t72) : t72 = $[8];
    let t82;
    return $[9] !== t72 ? (t82 = /* @__PURE__ */ jsx(Badge, { tone: "critical", radius: 3, children: t72 }), $[9] = t72, $[10] = t82) : t82 = $[10], t82;
  }
  let t7;
  $[11] !== releasesState || $[12] !== selected || $[13] !== tCore || $[14] !== tStructure ? (t7 = getMenuButtonProps({
    selected,
    tCore,
    tStructure,
    releasesState
  }), $[11] = releasesState, $[12] = selected, $[13] = tCore, $[14] = tStructure, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button, { type: "button", mode: "bleed", padding: 2, paddingRight: 3, radius: "full", selected: !0, ...t7 }), $[16] = t7, $[17] = t8) : t8 = $[17];
  let t9;
  $[18] !== documentId || $[19] !== onSelectRelease || $[20] !== published || $[21] !== selected ? (t9 = published && /* @__PURE__ */ jsx(VersionMenuItem, { type: "published", onSelect: onSelectRelease, isSelected: selected === "published", documentId }), $[18] = documentId, $[19] = onSelectRelease, $[20] = published, $[21] = selected, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== documentId || $[24] !== draft || $[25] !== isDraftModelEnabled || $[26] !== onSelectRelease || $[27] !== selected ? (t10 = isDraftModelEnabled && draft && /* @__PURE__ */ jsx(VersionMenuItem, { type: "draft", onSelect: onSelectRelease, isSelected: selected === "draft", documentId }), $[23] = documentId, $[24] = draft, $[25] = isDraftModelEnabled, $[26] = onSelectRelease, $[27] = selected, $[28] = t10) : t10 = $[28];
  let t11;
  if ($[29] !== documentId || $[30] !== onSelectRelease || $[31] !== releases || $[32] !== selected) {
    let t122;
    $[34] !== documentId || $[35] !== onSelectRelease || $[36] !== selected ? (t122 = (release) => /* @__PURE__ */ jsx(VersionMenuItem, { release, onSelect: onSelectRelease, isSelected: typeof selected != "string" && selected?._id === release._id, documentId }, release._id), $[34] = documentId, $[35] = onSelectRelease, $[36] = selected, $[37] = t122) : t122 = $[37], t11 = releases.map(t122), $[29] = documentId, $[30] = onSelectRelease, $[31] = releases, $[32] = selected, $[33] = t11;
  } else
    t11 = $[33];
  let t12;
  $[38] !== t10 || $[39] !== t11 || $[40] !== t9 ? (t12 = /* @__PURE__ */ jsxs(Menu, { children: [
    t9,
    t10,
    t11
  ] }), $[38] = t10, $[39] = t11, $[40] = t9, $[41] = t12) : t12 = $[41];
  let t13;
  return $[42] !== role || $[43] !== t12 || $[44] !== t8 ? (t13 = /* @__PURE__ */ jsx(MenuButton, { id: role, button: t8, menu: t12 }), $[42] = role, $[43] = t12, $[44] = t8, $[45] = t13) : t13 = $[45], t13;
}, VersionMenuItem = (t0) => {
  const $ = c(52), {
    type,
    release,
    onSelect,
    isSelected,
    documentId
  } = t0, {
    t: tCore
  } = useTranslation(), {
    t: tStructure
  } = useTranslation(structureLocaleNamespace), formatPublishDate = useFormatRelativeLocalePublishDate();
  let t1;
  $[0] !== documentId || $[1] !== onSelect || $[2] !== release || $[3] !== type ? (t1 = () => {
    if (type === "draft") {
      onSelect(getDraftId(documentId));
      return;
    }
    if (type === "published") {
      onSelect(getPublishedId(documentId));
      return;
    }
    typeof release?._id < "u" && onSelect(getVersionId(documentId, getReleaseIdFromReleaseDocumentId(release._id)));
  }, $[0] = documentId, $[1] = onSelect, $[2] = release, $[3] = type, $[4] = t1) : t1 = $[4];
  const onClick = t1;
  if (type) {
    const releasePerspective = type === "published" ? PUBLISHED : LATEST;
    let t22;
    $[5] !== releasePerspective ? (t22 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 2, release: releasePerspective }), $[5] = releasePerspective, $[6] = t22) : t22 = $[6];
    let t32;
    $[7] !== type ? (t32 = ["compare-versions.status", type], $[7] = type, $[8] = t32) : t32 = $[8];
    const t42 = t32.join(".");
    let t52;
    $[9] !== t42 || $[10] !== tStructure ? (t52 = tStructure(t42), $[9] = t42, $[10] = tStructure, $[11] = t52) : t52 = $[11];
    let t62;
    $[12] !== t52 ? (t62 = /* @__PURE__ */ jsx(Box, { paddingY: 2, children: /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t52 }) }), $[12] = t52, $[13] = t62) : t62 = $[13];
    let t72;
    $[14] !== t22 || $[15] !== t62 ? (t72 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
      t22,
      t62
    ] }), $[14] = t22, $[15] = t62, $[16] = t72) : t72 = $[16];
    let t82;
    return $[17] !== isSelected || $[18] !== onClick || $[19] !== t72 ? (t82 = /* @__PURE__ */ jsx(MenuItem, { padding: 1, paddingRight: 3, onClick, pressed: isSelected, children: t72 }), $[17] = isSelected, $[18] = onClick, $[19] = t72, $[20] = t82) : t82 = $[20], t82;
  }
  let t2;
  $[21] !== release ? (t2 = /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 2, release }), $[21] = release, $[22] = t2) : t2 = $[22];
  let t3;
  $[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    minWidth: 0
  }, $[23] = t3) : t3 = $[23];
  const t4 = release.metadata.title;
  let t5;
  $[24] !== tCore ? (t5 = tCore("release.placeholder-untitled-release"), $[24] = tCore, $[25] = t5) : t5 = $[25];
  let t6;
  $[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    size: 1,
    weight: "medium"
  }, $[26] = t6) : t6 = $[26];
  let t7;
  $[27] !== release.metadata.title || $[28] !== t5 ? (t7 = /* @__PURE__ */ jsx(ReleaseTitle, { title: t4, fallback: t5, textProps: t6 }), $[27] = release.metadata.title, $[28] = t5, $[29] = t7) : t7 = $[29];
  let t8;
  $[30] !== release.metadata.releaseType || $[31] !== tCore ? (t8 = ["asap", "undecided"].includes(release.metadata.releaseType) && /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: tCore(`release.type.${release.metadata.releaseType}`) }), $[30] = release.metadata.releaseType, $[31] = tCore, $[32] = t8) : t8 = $[32];
  let t9;
  $[33] !== formatPublishDate || $[34] !== release ? (t9 = release.metadata.releaseType === "scheduled" && /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: formatPublishDate(release) }), $[33] = formatPublishDate, $[34] = release, $[35] = t9) : t9 = $[35];
  let t10;
  $[36] !== t7 || $[37] !== t8 || $[38] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { flex: 1, paddingY: 2, paddingRight: 2, space: 2, style: t3, children: [
    t7,
    t8,
    t9
  ] }), $[36] = t7, $[37] = t8, $[38] = t9, $[39] = t10) : t10 = $[39];
  let t11;
  $[40] !== release ? (t11 = isReleaseScheduledOrScheduling(release) && /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(LockIcon, {}) }) }), $[40] = release, $[41] = t11) : t11 = $[41];
  let t12;
  $[42] !== t11 ? (t12 = /* @__PURE__ */ jsx(Flex, { flex: "none", children: t11 }), $[42] = t11, $[43] = t12) : t12 = $[43];
  let t13;
  $[44] !== t10 || $[45] !== t12 || $[46] !== t2 ? (t13 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t2,
    t10,
    t12
  ] }), $[44] = t10, $[45] = t12, $[46] = t2, $[47] = t13) : t13 = $[47];
  let t14;
  return $[48] !== isSelected || $[49] !== onClick || $[50] !== t13 ? (t14 = /* @__PURE__ */ jsx(MenuItem, { padding: 1, paddingRight: 3, onClick, pressed: isSelected, children: t13 }), $[48] = isSelected, $[49] = onClick, $[50] = t13, $[51] = t14) : t14 = $[51], t14;
};
function getMenuButtonProps({
  selected,
  tCore,
  tStructure,
  releasesState
}) {
  if (releasesState === "pending")
    return {
      text: tCore("common.loading"),
      tone: "neutral",
      disabled: !0
    };
  if (isReleaseDocument(selected)) {
    const tone = selected ? getReleaseTone(selected) : "neutral";
    return {
      text: selected?.metadata.title || tCore("release.placeholder-untitled-release"),
      icon: /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, release: selected }),
      iconRight: selected && isReleaseScheduledOrScheduling(selected) ? /* @__PURE__ */ jsx(LockIcon, {}) : void 0,
      tone
    };
  }
  if (isSystemBundleName(selected)) {
    const tone = selected === "published" ? "positive" : "caution", releasePerspective = selected === "published" ? PUBLISHED : LATEST;
    return {
      text: tStructure(["compare-versions.status", selected].join(".")),
      icon: /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, release: releasePerspective }),
      tone
    };
  }
  return {
    text: selected,
    // eslint-disable-next-line @sanity/i18n/no-attribute-string-literals
    icon: /* @__PURE__ */ jsx(ReleaseAvatar, { padding: 1, releaseType: "undecided" }),
    tone: "neutral"
  };
}
function fetchingState({
  loading,
  error
}) {
  return loading ? "pending" : typeof error < "u" ? "error" : "ready";
}
function _temp$J(id) {
  return getVersionFromId(id) ?? [];
}
const DialogLayout = styled.div.withConfig({
  displayName: "DialogLayout",
  componentId: "sc-x0jh85-0"
})`--offset-block:40px;display:grid;height:calc(100vh - var(--offset-block));min-height:0;overflow:hidden;grid-template-areas:'header header' 'previous-document next-document';grid-template-columns:1fr 1fr;grid-template-rows:min-content minmax(0,1fr);`;
function pickDocumentLayoutComponent(plugin) {
  return plugin.document?.components?.unstable_layout;
}
function usePathSyncChannel(t0) {
  const $ = c(11), {
    syncChannel,
    id
  } = t0;
  let t1;
  $[0] !== id || $[1] !== syncChannel ? (t1 = (state2) => syncChannel.next({
    ...state2,
    source: id
  }), $[0] = id, $[1] = syncChannel, $[2] = t1) : t1 = $[2];
  const push = t1;
  let t2;
  if ($[3] !== id || $[4] !== syncChannel) {
    let t32;
    $[6] !== id ? (t32 = (t4) => {
      const {
        source
      } = t4;
      return source !== id;
    }, $[6] = id, $[7] = t32) : t32 = $[7], t2 = syncChannel.pipe(distinctUntilChanged(_temp$I), filter(t32), map(_temp2$j)), $[3] = id, $[4] = syncChannel, $[5] = t2;
  } else
    t2 = $[5];
  const path = t2;
  let t3;
  return $[8] !== path || $[9] !== push ? (t3 = {
    path,
    push
  }, $[8] = path, $[9] = push, $[10] = t3) : t3 = $[10], t3;
}
function _temp2$j(state_0) {
  return state_0.path;
}
function _temp$I(previous, next) {
  return deepEquals(previous.path, next.path);
}
const Scroller$5 = styled.div.withConfig({
  displayName: "Scroller",
  componentId: "sc-16z7cpf-0"
})`position:relative;height:100%;overflow:auto;scroll-behavior:smooth;scrollbar-width:var(--scrollbar-width);overscroll-behavior:contain;will-change:scroll-position;`, DiffViewPaneLayout = styled(Card).withConfig({
  displayName: "DiffViewPaneLayout",
  componentId: "sc-1856b20-0"
})`position:relative;grid-area:var(--grid-area);`, Container = styled(Container$1).withConfig({
  displayName: "Container",
  componentId: "sc-1856b20-1"
})`width:auto;`, DiffViewPane = forwardRef(function(t0, ref) {
  const $ = c(36), {
    role,
    documentType,
    documentId,
    scrollElement,
    syncChannel,
    compareDocument
  } = t0, containerElement = useRef(null), [portalElement, setPortalElement] = useState(null), [boundaryElement, setBoundaryElement] = useState(null);
  let t1;
  $[0] !== compareDocument || $[1] !== documentId || $[2] !== documentType || $[3] !== role || $[4] !== scrollElement || $[5] !== syncChannel ? (t1 = () => /* @__PURE__ */ jsx(DiffViewDocument, { compareDocument, documentId, documentType, role, scrollElement, syncChannel }), $[0] = compareDocument, $[1] = documentId, $[2] = documentType, $[3] = role, $[4] = scrollElement, $[5] = syncChannel, $[6] = t1) : t1 = $[6];
  const t2 = t1;
  let t3;
  $[7] !== t2 ? (t3 = {
    pick: pickDocumentLayoutComponent,
    defaultComponent: t2
  }, $[7] = t2, $[8] = t3) : t3 = $[8];
  const DocumentLayout2 = useMiddlewareComponents(t3);
  let t4;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    isInteractive: !1,
    onOpenReviewChanges: noop,
    onSetFocus: noop,
    isReviewChangesOpen: !1
  }, $[9] = t4) : t4 = $[9];
  const t5 = `${role}-document`;
  let t6;
  $[10] !== t5 ? (t6 = {
    "--grid-area": t5
  }, $[10] = t5, $[11] = t6) : t6 = $[11];
  const t7 = t6, t8 = role === "next", t9 = role !== "next" && "none";
  let t10;
  $[12] !== t9 ? (t10 = {
    "--scrollbar-width": t9
  }, $[12] = t9, $[13] = t10) : t10 = $[13];
  const t11 = t10;
  let t12;
  $[14] !== DocumentLayout2 || $[15] !== documentId || $[16] !== documentType ? (t12 = /* @__PURE__ */ jsx(DialogProvider, { position: "absolute", children: /* @__PURE__ */ jsx(Container, { ref: containerElement, padding: 4, width: 1, children: /* @__PURE__ */ jsx(DocumentLayout2, { documentId, documentType }) }) }), $[14] = DocumentLayout2, $[15] = documentId, $[16] = documentType, $[17] = t12) : t12 = $[17];
  let t13;
  $[18] !== portalElement || $[19] !== t12 ? (t13 = /* @__PURE__ */ jsx(PortalProvider, { element: portalElement, children: t12 }), $[18] = portalElement, $[19] = t12, $[20] = t13) : t13 = $[20];
  let t14;
  $[21] !== ref || $[22] !== t11 || $[23] !== t13 ? (t14 = /* @__PURE__ */ jsx(Scroller$5, { ref, style: t11, children: t13 }), $[21] = ref, $[22] = t11, $[23] = t13, $[24] = t14) : t14 = $[24];
  let t15;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = /* @__PURE__ */ jsx("div", { "data-testid": "diffView-document-panel-portal", ref: setPortalElement }), $[25] = t15) : t15 = $[25];
  let t16;
  $[26] !== t14 || $[27] !== t7 || $[28] !== t8 ? (t16 = /* @__PURE__ */ jsxs(DiffViewPaneLayout, { ref: setBoundaryElement, style: t7, borderLeft: t8, children: [
    t14,
    t15
  ] }), $[26] = t14, $[27] = t7, $[28] = t8, $[29] = t16) : t16 = $[29];
  let t17;
  $[30] !== boundaryElement || $[31] !== t16 ? (t17 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: boundaryElement, children: t16 }), $[30] = boundaryElement, $[31] = t16, $[32] = t17) : t17 = $[32];
  let t18;
  return $[33] !== scrollElement || $[34] !== t17 ? (t18 = /* @__PURE__ */ jsx(ReviewChangesContext.Provider, { value: t4, children: /* @__PURE__ */ jsx(ChangeIndicatorsTracker, { children: /* @__PURE__ */ jsx(VirtualizerScrollInstanceProvider, { scrollElement, containerElement, children: t17 }) }) }), $[33] = scrollElement, $[34] = t17, $[35] = t18) : t18 = $[35], t18;
}), DiffViewDocument = (t0) => {
  const $ = c(52), {
    role,
    documentType,
    documentId,
    syncChannel,
    compareDocument
  } = t0;
  let t1;
  $[0] !== compareDocument ? (t1 = {
    compareDocument
  }, $[0] = compareDocument, $[1] = t1) : t1 = $[1];
  const compareValue = useCompareValue(t1), {
    data: releases
  } = useActiveReleases(), [patchChannel] = useState(_temp$H);
  let t2;
  $[2] !== documentId || $[3] !== releases ? (t2 = findRelease(documentId, releases), $[2] = documentId, $[3] = releases, $[4] = t2) : t2 = $[4];
  const perspective = t2;
  let t3;
  $[5] !== documentId ? (t3 = getPublishedId(documentId), $[5] = documentId, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== documentId ? (t4 = perspectiveName(documentId), $[7] = documentId, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== documentId ? (t5 = getVersionFromId(documentId), $[9] = documentId, $[10] = t5) : t5 = $[10];
  let t6;
  $[11] !== compareValue || $[12] !== documentType || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 ? (t6 = {
    documentId: t3,
    documentType,
    selectedPerspectiveName: t4,
    releaseId: t5,
    comparisonValue: compareValue,
    displayInlineChanges: !0
  }, $[11] = compareValue, $[12] = documentType, $[13] = t3, $[14] = t4, $[15] = t5, $[16] = t6) : t6 = $[16];
  const {
    formState,
    onChange,
    onFocus,
    onBlur,
    onSetActiveFieldGroup,
    onSetCollapsedFieldSet,
    onSetCollapsedPath,
    collapsedFieldSets,
    ready,
    collapsedPaths,
    schemaType,
    value,
    onProgrammaticFocus,
    openPath,
    onPathOpen: onPathOpenFromForm
  } = useDocumentForm(t6), isLoading = formState === null || !ready;
  let t7;
  $[17] !== role || $[18] !== syncChannel ? (t7 = {
    id: role,
    syncChannel
  }, $[17] = role, $[18] = syncChannel, $[19] = t7) : t7 = $[19];
  const pathSyncChannel = usePathSyncChannel(t7);
  let t8;
  $[20] !== onPathOpenFromForm || $[21] !== pathSyncChannel || $[22] !== role ? (t8 = (path) => {
    onPathOpenFromForm(path), pathSyncChannel.push({
      source: role,
      path
    });
  }, $[20] = onPathOpenFromForm, $[21] = pathSyncChannel, $[22] = role, $[23] = t8) : t8 = $[23];
  const onPathOpen = t8;
  let t9;
  $[24] !== onPathOpenFromForm || $[25] !== onProgrammaticFocus || $[26] !== pathSyncChannel.path ? (t9 = () => {
    const subscription = pathSyncChannel.path.subscribe((path_0) => {
      onPathOpenFromForm(path_0), onProgrammaticFocus(path_0);
    });
    return () => subscription.unsubscribe();
  }, $[24] = onPathOpenFromForm, $[25] = onProgrammaticFocus, $[26] = pathSyncChannel.path, $[27] = t9) : t9 = $[27];
  let t10;
  $[28] !== onPathOpenFromForm || $[29] !== onProgrammaticFocus || $[30] !== pathSyncChannel.path || $[31] !== role ? (t10 = [onPathOpenFromForm, onProgrammaticFocus, pathSyncChannel.path, role], $[28] = onPathOpenFromForm, $[29] = onProgrammaticFocus, $[30] = pathSyncChannel.path, $[31] = role, $[32] = t10) : t10 = $[32], useEffect(t9, t10);
  let t11;
  return $[33] !== collapsedFieldSets || $[34] !== collapsedPaths || $[35] !== compareValue || $[36] !== formState || $[37] !== isLoading || $[38] !== onBlur || $[39] !== onChange || $[40] !== onFocus || $[41] !== onPathOpen || $[42] !== onSetActiveFieldGroup || $[43] !== onSetCollapsedFieldSet || $[44] !== onSetCollapsedPath || $[45] !== openPath || $[46] !== patchChannel || $[47] !== perspective || $[48] !== role || $[49] !== schemaType || $[50] !== value ? (t11 = isLoading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }) : /* @__PURE__ */ jsx(CommentsEnabledContext.Provider, { value: {
    enabled: !1,
    mode: null
  }, children: /* @__PURE__ */ jsx(FormBuilder, { __internal_patchChannel: patchChannel, id: `diffView-pane-${role}`, onChange, onPathFocus: onFocus, onPathOpen, onPathBlur: onBlur, onFieldGroupSelect: onSetActiveFieldGroup, onSetFieldSetCollapsed: onSetCollapsedFieldSet, onSetPathCollapsed: onSetCollapsedPath, collapsedPaths, collapsedFieldSets, focusPath: formState.focusPath, openPath, changed: formState.changed, focused: formState.focused, groups: formState.groups, validation: formState.validation, members: formState.members, perspective: sanitizeBundleName(perspective), hasUpstreamVersion: formState.hasUpstreamVersion, presence: formState.presence, schemaType, value, compareValue }) }), $[33] = collapsedFieldSets, $[34] = collapsedPaths, $[35] = compareValue, $[36] = formState, $[37] = isLoading, $[38] = onBlur, $[39] = onChange, $[40] = onFocus, $[41] = onPathOpen, $[42] = onSetActiveFieldGroup, $[43] = onSetCollapsedFieldSet, $[44] = onSetCollapsedPath, $[45] = openPath, $[46] = patchChannel, $[47] = perspective, $[48] = role, $[49] = schemaType, $[50] = value, $[51] = t11) : t11 = $[51], t11;
};
function perspectiveName(documentId) {
  if (isVersionId(documentId))
    return getVersionFromId(documentId);
  if (isPublishedId(documentId))
    return "published";
}
function useCompareValue(t0) {
  const $ = c(4), {
    compareDocument
  } = t0;
  let t1;
  $[0] !== compareDocument.id ? (t1 = getPublishedId(compareDocument.id), $[0] = compareDocument.id, $[1] = t1) : t1 = $[1];
  const t2 = compareDocument.type;
  let t3;
  $[2] !== compareDocument.id ? (t3 = getVersionFromId(compareDocument.id), $[2] = compareDocument.id, $[3] = t3) : t3 = $[3];
  const compareDocumentEditState = useEditState(t1, t2, "low", t3);
  let t4;
  bb0: {
    if (isVersionId(compareDocument.id)) {
      t4 = compareDocumentEditState.version ?? void 0;
      break bb0;
    }
    if (isDraftId(compareDocument.id)) {
      t4 = compareDocumentEditState.draft ?? void 0;
      break bb0;
    }
    if (isPublishedId(compareDocument.id)) {
      t4 = compareDocumentEditState.published ?? void 0;
      break bb0;
    }
    t4 = void 0;
  }
  return t4;
}
function sanitizeBundleName(bundle) {
  return bundle === "draft" ? "drafts" : bundle;
}
function _temp$H() {
  return createPatchChannel();
}
const Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-ihhvnj-0"
})`flex:1;text-decoration:none;color:inherit;`, EditReferenceLinkComponent = (t0) => {
  const $ = c(6), {
    children,
    documentId: _documentId,
    documentType
  } = t0;
  let t1;
  $[0] !== _documentId || $[1] !== documentType ? (t1 = {
    intent: "edit",
    params: {
      id: _documentId,
      type: documentType
    }
  }, $[0] = _documentId, $[1] = documentType, $[2] = t1) : t1 = $[2];
  const {
    href
  } = useIntentLink(t1);
  let t2;
  return $[3] !== children || $[4] !== href ? (t2 = /* @__PURE__ */ jsx(Link, { href, target: "_blank", rel: "noopener noreferrer", children }), $[3] = children, $[4] = href, $[5] = t2) : t2 = $[5], t2;
}, DiffView = (t0) => {
  const $ = c(24), {
    documentId
  } = t0, {
    documents,
    state: state2,
    mode
  } = useDiffViewState(), {
    exitDiffView
  } = useDiffViewRouter(), syncChannel = useCreatePathSyncChannel(), [previousPaneElement, setPreviousPaneElement] = useState(null), [nextPaneElement, setNextPaneElement] = useState(null), referenceInputOptionsContext = useContext(ReferenceInputOptionsContext);
  let t1;
  $[0] !== referenceInputOptionsContext ? (t1 = {
    ...referenceInputOptionsContext,
    disableNew: !0,
    EditReferenceLinkComponent
  }, $[0] = referenceInputOptionsContext, $[1] = t1) : t1 = $[1];
  const diffViewReferenceInputOptionsContext = t1;
  let t2;
  $[2] !== nextPaneElement || $[3] !== previousPaneElement ? (t2 = [previousPaneElement, nextPaneElement], $[2] = nextPaneElement, $[3] = previousPaneElement, $[4] = t2) : t2 = $[4], useScrollMirror(t2);
  let t3;
  $[5] !== documentId || $[6] !== mode || $[7] !== state2 ? (t3 = mode === "version" && /* @__PURE__ */ jsx(VersionModeHeader, { documentId, state: state2 }), $[5] = documentId, $[6] = mode, $[7] = state2, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== documents || $[10] !== nextPaneElement || $[11] !== previousPaneElement || $[12] !== state2 || $[13] !== syncChannel ? (t4 = state2 === "ready" && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DiffViewPane, { documentType: documents.previous.type, documentId: documents.previous.id, role: "previous", ref: setPreviousPaneElement, scrollElement: previousPaneElement, syncChannel, compareDocument: documents.previous }),
    /* @__PURE__ */ jsx(DiffViewPane, { documentType: documents.next.type, documentId: documents.next.id, role: "next", ref: setNextPaneElement, scrollElement: nextPaneElement, syncChannel, compareDocument: documents.previous })
  ] }), $[9] = documents, $[10] = nextPaneElement, $[11] = previousPaneElement, $[12] = state2, $[13] = syncChannel, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== t3 || $[16] !== t4 ? (t5 = /* @__PURE__ */ jsxs(DialogLayout, { children: [
    t3,
    t4
  ] }), $[15] = t3, $[16] = t4, $[17] = t5) : t5 = $[17];
  let t6;
  $[18] !== exitDiffView || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsx(Dialog, { id: "diffView", width: "auto", onClose: exitDiffView, padding: !1, __unstable_hideCloseButton: !0, children: t5 }), $[18] = exitDiffView, $[19] = t5, $[20] = t6) : t6 = $[20];
  let t7;
  return $[21] !== diffViewReferenceInputOptionsContext || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(ReferenceInputOptionsContext.Provider, { value: diffViewReferenceInputOptionsContext, children: t6 }), $[21] = diffViewReferenceInputOptionsContext, $[22] = t6, $[23] = t7) : t7 = $[23], t7;
}, DiffViewDocumentLayout = (t0) => {
  const $ = c(16), {
    children,
    documentId
  } = t0, toast = useToast(), {
    t
  } = useTranslation(structureLocaleNamespace), {
    log
  } = useTelemetry();
  let t1;
  $[0] !== t || $[1] !== toast ? (t1 = (errors) => {
    toast.push({
      id: "diffViewParamsParsingError",
      status: "error",
      title: t("compare-version.error.invalidParams.title"),
      description: /* @__PURE__ */ jsx("ul", { children: errors.map((t22) => {
        const [error, input] = t22;
        return /* @__PURE__ */ jsx("li", { children: t(`compare-version.error.${error}`, {
          input
        }) }, error);
      }) })
    });
  }, $[0] = t, $[1] = toast, $[2] = t1) : t1 = $[2];
  let t2, t3;
  $[3] !== log ? (t2 = (previousState, state2) => {
    if (selectActiveTransition(previousState, state2) === "entered") {
      log(DiffViewEntered, {
        documentVariantTypes: documentIdsToVariantTypes([state2.documents?.previous.id, state2.documents?.next.id])
      });
      return;
    }
    selectActiveTransition(previousState, state2) === "exited" && typeof previousState < "u" && log(DiffViewExited, {
      documentVariantTypes: documentIdsToVariantTypes([previousState.documents?.previous.id, previousState.documents?.next.id])
    });
  }, t3 = (previousState_0, state_0) => {
    typeof previousState_0 > "u" || log(DiffViewDocumentSelectionChanged, {
      previousDocumentVariantTypes: documentIdsToVariantTypes([previousState_0.documents?.previous.id, previousState_0.documents?.next.id]),
      documentVariantTypes: documentIdsToVariantTypes([state_0.documents?.previous.id, state_0.documents?.next.id])
    });
  }, $[3] = log, $[4] = t2, $[5] = t3) : (t2 = $[4], t3 = $[5]);
  let t4;
  $[6] !== t1 || $[7] !== t2 || $[8] !== t3 ? (t4 = {
    onParamsError: t1,
    onActiveChanged: t2,
    onTargetDocumentsChanged: t3
  }, $[6] = t1, $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9];
  const {
    isActive
  } = useDiffViewState(t4);
  let t5;
  $[10] !== documentId || $[11] !== isActive ? (t5 = isActive && /* @__PURE__ */ jsx(DiffView, { documentId }), $[10] = documentId, $[11] = isActive, $[12] = t5) : t5 = $[12];
  let t6;
  return $[13] !== children || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    t5
  ] }), $[13] = children, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
};
function documentIdsToVariantTypes(ids) {
  return ids.filter((id) => typeof id == "string").map(getDocumentVariantType);
}
const PANE_DEBUG = !1, PANE_COLLAPSED_WIDTH = 51, PANE_DEFAULT_MIN_WIDTH = 204;
function usePaneLayout() {
  const pane = useContext(PaneLayoutContext);
  if (!pane)
    throw new Error("PaneLayout: missing context value");
  return pane;
}
const Root$a = styled(Layer).withConfig({
  displayName: "Root",
  componentId: "sc-k0eo57-0"
})`position:relative;width:1px;min-width:1px;&:before{content:'';display:block;position:absolute;top:0;left:0;bottom:0;width:1px;background-color:var(--card-border-color);}&:not([data-disabled]){cursor:ew-resize;width:9px;min-width:9px;margin:0 -4px;&:before{left:4px;}&:after{content:'';display:block;position:absolute;top:0;left:0;width:9px;bottom:0;background-color:var(--card-border-color);opacity:0;transition:opacity 150ms;}&[data-dragging]:after,&:hover:after{opacity:0.2;}}`;
function PaneDivider(t0) {
  const $ = c(7), {
    disabled,
    element
  } = t0, {
    resize
  } = usePaneLayout(), [dragging, setDragging] = useState(!1);
  let t1;
  $[0] !== element || $[1] !== resize ? (t1 = (event) => {
    if (!element)
      return;
    setDragging(!0), event.preventDefault();
    const startX = event.pageX;
    resize("start", element, 0);
    const handleMouseMove = (e) => {
      e.preventDefault();
      const deltaX = e.pageX - startX;
      resize("move", element, deltaX);
    }, handleMouseUp = (e_0) => {
      e_0.preventDefault(), setDragging(!1), window.removeEventListener("mousemove", handleMouseMove), window.removeEventListener("mouseup", handleMouseUp), resize("end", element, 0);
    };
    window.addEventListener("mousemove", handleMouseMove), window.addEventListener("mouseup", handleMouseUp);
  }, $[0] = element, $[1] = resize, $[2] = t1) : t1 = $[2];
  const handleMouseDown = t1, t2 = disabled ? "" : void 0, t3 = dragging ? "" : void 0;
  let t4;
  return $[3] !== handleMouseDown || $[4] !== t2 || $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Root$a, { "data-disabled": t2, "data-dragging": t3, onMouseDown: handleMouseDown }), $[3] = handleMouseDown, $[4] = t2, $[5] = t3, $[6] = t4) : t4 = $[6], t4;
}
const Root$9 = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-o2std4-0"
})`outline:none;box-shadow:1px 0 0 var(--card-border-color);`, Pane = forwardRef(function(props, forwardedRef) {
  const $ = c(86);
  let children, currentMaxWidthProp, currentMinWidthProp, id, maxWidthProp, minWidthProp, restProps, t0, t1;
  $[0] !== props ? ({
    children,
    currentMinWidth: currentMinWidthProp,
    currentMaxWidth: currentMaxWidthProp,
    flex: t0,
    id,
    minWidth: minWidthProp,
    maxWidth: maxWidthProp,
    selected: t1,
    ...restProps
  } = props, $[0] = props, $[1] = children, $[2] = currentMaxWidthProp, $[3] = currentMinWidthProp, $[4] = id, $[5] = maxWidthProp, $[6] = minWidthProp, $[7] = restProps, $[8] = t0, $[9] = t1) : (children = $[1], currentMaxWidthProp = $[2], currentMinWidthProp = $[3], id = $[4], maxWidthProp = $[5], minWidthProp = $[6], restProps = $[7], t0 = $[8], t1 = $[9]);
  const flexProp = t0 === void 0 ? 1 : t0, selected = t1 === void 0 ? !1 : t1, [rootElement, setRootElement] = useState(null), {
    collapse,
    collapsed: layoutCollapsed,
    expand,
    expandedElement,
    mount,
    panes
  } = usePaneLayout();
  let pane, t2;
  if ($[10] !== panes || $[11] !== rootElement) {
    let t32;
    $[14] !== rootElement ? (t32 = (p) => p.element === rootElement, $[14] = rootElement, $[15] = t32) : t32 = $[15], pane = panes.find(t32), t2 = pane && panes.indexOf(pane), $[10] = panes, $[11] = rootElement, $[12] = pane, $[13] = t2;
  } else
    pane = $[12], t2 = $[13];
  const paneIndex = t2, nextPane = typeof paneIndex == "number" ? panes[paneIndex + 1] : void 0, isLast = paneIndex === panes.length - 1, expanded = expandedElement === rootElement, collapsed = layoutCollapsed ? !1 : pane?.collapsed || !1, nextCollapsed = nextPane?.collapsed || !1, ref = useRef(null), flex = pane?.flex ?? flexProp, currentMinWidth = pane?.currentMinWidth ?? currentMinWidthProp, currentMaxWidth = pane?.currentMaxWidth ?? currentMaxWidthProp;
  let t3;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => ref.current, $[16] = t3) : t3 = $[16], useImperativeHandle(forwardedRef, t3);
  let t4;
  $[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = (refValue) => {
    setRootElement(refValue), ref.current = refValue;
  }, $[17] = t4) : t4 = $[17];
  const setRef = t4;
  let t5, t6;
  $[18] !== currentMaxWidthProp || $[19] !== currentMinWidthProp || $[20] !== flexProp || $[21] !== id || $[22] !== maxWidthProp || $[23] !== minWidthProp || $[24] !== mount || $[25] !== rootElement ? (t5 = () => {
    if (rootElement)
      return mount(rootElement, {
        currentMinWidth: currentMinWidthProp,
        currentMaxWidth: currentMaxWidthProp,
        flex: flexProp,
        id,
        minWidth: minWidthProp,
        maxWidth: maxWidthProp
      });
  }, t6 = [currentMinWidthProp, currentMaxWidthProp, flexProp, id, minWidthProp, maxWidthProp, mount, rootElement], $[18] = currentMaxWidthProp, $[19] = currentMinWidthProp, $[20] = flexProp, $[21] = id, $[22] = maxWidthProp, $[23] = minWidthProp, $[24] = mount, $[25] = rootElement, $[26] = t5, $[27] = t6) : (t5 = $[26], t6 = $[27]), useLayoutEffect(t5, t6);
  let t7;
  $[28] !== collapse || $[29] !== rootElement ? (t7 = () => {
    rootElement && collapse(rootElement);
  }, $[28] = collapse, $[29] = rootElement, $[30] = t7) : t7 = $[30];
  const handleCollapse = t7;
  let t8;
  $[31] !== expand || $[32] !== rootElement ? (t8 = () => {
    rootElement && expand(rootElement);
  }, $[31] = expand, $[32] = rootElement, $[33] = t8) : t8 = $[33];
  const handleExpand = t8, t9 = layoutCollapsed ? !1 : collapsed;
  let t10;
  $[34] !== handleCollapse || $[35] !== handleExpand || $[36] !== isLast || $[37] !== paneIndex || $[38] !== rootElement || $[39] !== t9 ? (t10 = {
    collapse: handleCollapse,
    collapsed: t9,
    expand: handleExpand,
    index: paneIndex,
    isLast,
    rootElement
  }, $[34] = handleCollapse, $[35] = handleExpand, $[36] = isLast, $[37] = paneIndex, $[38] = rootElement, $[39] = t9, $[40] = t10) : t10 = $[40];
  const contextValue = t10;
  let t11;
  bb0: {
    if (layoutCollapsed) {
      t11 = void 0;
      break bb0;
    }
    if (collapsed) {
      t11 = PANE_COLLAPSED_WIDTH;
      break bb0;
    }
    if (currentMinWidth === 0) {
      t11 = minWidthProp || PANE_DEFAULT_MIN_WIDTH;
      break bb0;
    }
    if (isLast) {
      t11 = minWidthProp || PANE_DEFAULT_MIN_WIDTH;
      break bb0;
    }
    t11 = currentMinWidth || minWidthProp || PANE_DEFAULT_MIN_WIDTH;
  }
  const minWidth = t11;
  let t12;
  bb1: {
    if (collapsed) {
      t12 = PANE_COLLAPSED_WIDTH;
      break bb1;
    }
    if (layoutCollapsed && isLast) {
      t12 = void 0;
      break bb1;
    }
    if (isLast) {
      if (maxWidthProp) {
        t12 = currentMaxWidth ?? maxWidthProp;
        break bb1;
      }
      t12 = void 0;
      break bb1;
    }
    t12 = currentMaxWidth ?? maxWidthProp;
  }
  const maxWidth = t12, hidden = layoutCollapsed && !isLast;
  let t13;
  $[41] !== collapsed || $[42] !== isLast || $[43] !== layoutCollapsed || $[44] !== nextCollapsed || $[45] !== rootElement ? (t13 = !isLast && !layoutCollapsed && /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneResizer", children: /* @__PURE__ */ jsx(PaneDivider, { disabled: collapsed || nextCollapsed, element: rootElement }) }), $[41] = collapsed, $[42] = isLast, $[43] = layoutCollapsed, $[44] = nextCollapsed, $[45] = rootElement, $[46] = t13) : t13 = $[46];
  const divider = t13, t14 = maxWidth === 1 / 0 ? void 0 : maxWidth;
  let t15;
  $[47] !== flex || $[48] !== minWidth || $[49] !== t14 ? (t15 = {
    flex,
    minWidth,
    maxWidth: t14
  }, $[47] = flex, $[48] = minWidth, $[49] = t14, $[50] = t15) : t15 = $[50];
  const style = t15, t16 = layoutCollapsed ? void 0 : "hidden", t17 = collapsed ? "" : void 0, t18 = selected ? "" : void 0;
  let t19;
  $[51] !== collapsed || $[52] !== currentMaxWidth || $[53] !== currentMinWidth || $[54] !== expanded || $[55] !== flex || $[56] !== maxWidth || $[57] !== minWidth || $[58] !== paneIndex ? (t19 = PANE_DEBUG, $[51] = collapsed, $[52] = currentMaxWidth, $[53] = currentMinWidth, $[54] = expanded, $[55] = flex, $[56] = maxWidth, $[57] = minWidth, $[58] = paneIndex, $[59] = t19) : t19 = $[59];
  let t20;
  $[60] !== children || $[61] !== hidden ? (t20 = !hidden && /* @__PURE__ */ jsx(Flex, { direction: "column", height: "fill", children }), $[60] = children, $[61] = hidden, $[62] = t20) : t20 = $[62];
  let t21;
  $[63] !== rootElement || $[64] !== t20 ? (t21 = /* @__PURE__ */ jsx(BoundaryElementProvider, { element: rootElement, children: t20 }), $[63] = rootElement, $[64] = t20, $[65] = t21) : t21 = $[65];
  let t22;
  $[66] !== hidden || $[67] !== id || $[68] !== paneIndex || $[69] !== restProps || $[70] !== style || $[71] !== t16 || $[72] !== t17 || $[73] !== t18 || $[74] !== t19 || $[75] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Root$9, { "data-testid": "pane", "data-ui": "Pane", tone: "inherit", hidden, id, overflow: t16, ...restProps, "data-pane-collapsed": t17, "data-pane-index": paneIndex, "data-pane-selected": t18, ref: setRef, style, children: [
    t19,
    t21
  ] }), $[66] = hidden, $[67] = id, $[68] = paneIndex, $[69] = restProps, $[70] = style, $[71] = t16, $[72] = t17, $[73] = t18, $[74] = t19, $[75] = t21, $[76] = t22) : t22 = $[76];
  let t23;
  $[77] !== isLast || $[78] !== t22 ? (t23 = /* @__PURE__ */ jsx(IsLastPaneProvider, { isLastPane: isLast, children: t22 }), $[77] = isLast, $[78] = t22, $[79] = t23) : t23 = $[79];
  let t24;
  $[80] !== contextValue || $[81] !== t23 ? (t24 = /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "pane", children: /* @__PURE__ */ jsx(PaneContext.Provider, { value: contextValue, children: t23 }) }), $[80] = contextValue, $[81] = t23, $[82] = t24) : t24 = $[82];
  let t25;
  return $[83] !== divider || $[84] !== t24 ? (t25 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t24,
    divider
  ] }), $[83] = divider, $[84] = t24, $[85] = t25) : t25 = $[85], t25;
}), Root$8 = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-ok1xda-0"
})`position:relative;outline:none;`;
Root$8.displayName = "PaneContent__root";
function usePane() {
  const pane = useContext(PaneContext);
  if (!pane)
    throw new Error("Pane: missing context value");
  return pane;
}
const PaneContent = forwardRef(function(props, ref) {
  const $ = c(14);
  let as, children, overflow, padding, restProps;
  $[0] !== props ? ({
    as,
    children,
    overflow,
    padding,
    ...restProps
  } = props, $[0] = props, $[1] = as, $[2] = children, $[3] = overflow, $[4] = padding, $[5] = restProps) : (as = $[1], children = $[2], overflow = $[3], padding = $[4], restProps = $[5]);
  const {
    collapsed
  } = usePane(), {
    collapsed: layoutCollapsed
  } = usePaneLayout(), t0 = layoutCollapsed ? void 0 : overflow;
  let t1;
  return $[6] !== as || $[7] !== children || $[8] !== collapsed || $[9] !== padding || $[10] !== ref || $[11] !== restProps || $[12] !== t0 ? (t1 = /* @__PURE__ */ jsx(Root$8, { "data-testid": "pane-content", forwardedAs: as, ...restProps, flex: 1, hidden: collapsed, overflow: t0, padding, ref, tone: "inherit", children }), $[6] = as, $[7] = children, $[8] = collapsed, $[9] = padding, $[10] = ref, $[11] = restProps, $[12] = t0, $[13] = t1) : t1 = $[13], t1;
});
function toLowerCaseNoSpaces(str) {
  return str ? str.toLocaleLowerCase().replaceAll(" ", "") : "";
}
const MENU_GROUP_POPOVER_PROPS = {
  constrainSize: !0,
  placement: "left-start",
  portal: !0
};
function PaneMenuButtonItem(props) {
  const $ = c(35), {
    disabled,
    isAfterGroup,
    node
  } = props, getI18nText = useGetI18nText("i18n" in node ? node : void 0);
  if (node.type === "divider") {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(MenuDivider, {}), $[0] = t02) : t02 = $[0], t02;
  }
  let t0;
  $[1] !== getI18nText || $[2] !== node ? (t0 = getI18nText(node), $[1] = getI18nText, $[2] = node, $[3] = t0) : t0 = $[3];
  const {
    title
  } = t0;
  if (node.type === "group") {
    if (node.children.length === 0)
      return null;
    if (node.expanded) {
      let t13;
      $[4] !== isAfterGroup ? (t13 = isAfterGroup && /* @__PURE__ */ jsx(MenuDivider, {}), $[4] = isAfterGroup, $[5] = t13) : t13 = $[5];
      let t23;
      $[6] !== disabled || $[7] !== node.children || $[8] !== node.disabled ? (t23 = node.children.map((child, childIndex) => /* @__PURE__ */ jsx(PaneMenuButtonItem, { disabled: disabled || !!node.disabled, isAfterGroup: node.children[childIndex - 1]?.type === "group", node: child }, child.key)), $[6] = disabled, $[7] = node.children, $[8] = node.disabled, $[9] = t23) : t23 = $[9];
      let t33;
      return $[10] !== t13 || $[11] !== t23 ? (t33 = /* @__PURE__ */ jsxs(Fragment, { children: [
        t13,
        t23
      ] }), $[10] = t13, $[11] = t23, $[12] = t33) : t33 = $[12], t33;
    }
    let t12;
    $[13] !== isAfterGroup ? (t12 = isAfterGroup && /* @__PURE__ */ jsx(MenuDivider, {}), $[13] = isAfterGroup, $[14] = t12) : t12 = $[14];
    const t22 = node.icon;
    let t32;
    $[15] !== disabled || $[16] !== node.children || $[17] !== node.disabled ? (t32 = node.children.map((child_0, childIndex_0) => /* @__PURE__ */ jsx(PaneMenuButtonItem, { disabled: disabled || !!node.disabled, isAfterGroup: node.children[childIndex_0 - 1]?.type === "group", node: child_0 }, child_0.key)), $[15] = disabled, $[16] = node.children, $[17] = node.disabled, $[18] = t32) : t32 = $[18];
    let t4;
    $[19] !== disabled || $[20] !== node.icon || $[21] !== t32 || $[22] !== title ? (t4 = /* @__PURE__ */ jsx(MenuGroup, { disabled, icon: t22, popover: MENU_GROUP_POPOVER_PROPS, text: title, children: t32 }), $[19] = disabled, $[20] = node.icon, $[21] = t32, $[22] = title, $[23] = t4) : t4 = $[23];
    let t5;
    return $[24] !== t12 || $[25] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t12,
      t4
    ] }), $[24] = t12, $[25] = t4, $[26] = t5) : t5 = $[26], t5;
  }
  let t1;
  $[27] !== isAfterGroup ? (t1 = isAfterGroup && /* @__PURE__ */ jsx(MenuDivider, {}), $[27] = isAfterGroup, $[28] = t1) : t1 = $[28];
  let t2;
  $[29] !== disabled || $[30] !== node ? (t2 = /* @__PURE__ */ jsx(PaneContextMenuItemResolver, { disabled, node }), $[29] = disabled, $[30] = node, $[31] = t2) : t2 = $[31];
  let t3;
  return $[32] !== t1 || $[33] !== t2 ? (t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t1,
    t2
  ] }), $[32] = t1, $[33] = t2, $[34] = t3) : t3 = $[34], t3;
}
function PaneContextMenuItemResolver(props) {
  const $ = c(5), {
    node
  } = props;
  if (node.intent) {
    let t02;
    return $[0] !== node.intent || $[1] !== props ? (t02 = /* @__PURE__ */ jsx(PaneContextIntentMenuItem, { ...props, intent: node.intent }), $[0] = node.intent, $[1] = props, $[2] = t02) : t02 = $[2], t02;
  }
  let t0;
  return $[3] !== props ? (t0 = /* @__PURE__ */ jsx(PaneContextMenuItem, { ...props }), $[3] = props, $[4] = t0) : t0 = $[4], t0;
}
function PaneContextMenuItem(props) {
  const $ = c(19), {
    disabled,
    node
  } = props;
  let t0;
  $[0] !== node.disabled ? (t0 = typeof node.disabled == "object" && /* @__PURE__ */ jsx(Text, { size: 1, children: node.disabled.reason }), $[0] = node.disabled, $[1] = t0) : t0 = $[1];
  const tooltipContent = t0, {
    title
  } = useI18nText(node), showSelectionIndicator = node.selected && !node.hideSelectionIndicator, t1 = disabled || !!node.disabled;
  let t2;
  $[2] !== node.hotkey ? (t2 = node.hotkey?.split("+"), $[2] = node.hotkey, $[3] = t2) : t2 = $[3];
  const t3 = node.icon, t4 = node.iconRight || showSelectionIndicator && CheckmarkIcon, t5 = node.onAction, t6 = node.tone;
  let t7;
  $[4] !== node.title ? (t7 = toLowerCaseNoSpaces(node.title), $[4] = node.title, $[5] = t7) : t7 = $[5];
  const t8 = `action-${t7}`;
  let t9;
  $[6] !== node.icon || $[7] !== node.onAction || $[8] !== node.tone || $[9] !== showSelectionIndicator || $[10] !== t1 || $[11] !== t2 || $[12] !== t4 || $[13] !== t8 || $[14] !== title ? (t9 = /* @__PURE__ */ jsx(MenuItem$1, { disabled: t1, hotkeys: t2, icon: t3, iconRight: t4, onClick: t5, pressed: showSelectionIndicator, text: title, tone: t6, "data-testid": t8 }), $[6] = node.icon, $[7] = node.onAction, $[8] = node.tone, $[9] = showSelectionIndicator, $[10] = t1, $[11] = t2, $[12] = t4, $[13] = t8, $[14] = title, $[15] = t9) : t9 = $[15];
  let t10;
  return $[16] !== t9 || $[17] !== tooltipContent ? (t10 = /* @__PURE__ */ jsx(TooltipOfDisabled, { content: tooltipContent, placement: "left", children: t9 }), $[16] = t9, $[17] = tooltipContent, $[18] = t10) : t10 = $[18], t10;
}
function PaneContextIntentMenuItem(props) {
  const $ = c(23), {
    disabled,
    intent,
    node
  } = props;
  let t0;
  $[0] !== node.disabled ? (t0 = typeof node.disabled == "object" && /* @__PURE__ */ jsx(Text, { size: 1, children: node.disabled.reason }), $[0] = node.disabled, $[1] = t0) : t0 = $[1];
  const tooltipContent = t0;
  let t1;
  $[2] !== intent.params || $[3] !== intent.type ? (t1 = {
    intent: intent.type,
    params: intent.params
  }, $[2] = intent.params, $[3] = intent.type, $[4] = t1) : t1 = $[4];
  const intentLink = useIntentLink(t1);
  let t2;
  $[5] !== intentLink || $[6] !== node ? (t2 = (event) => {
    intentLink.onClick(event), node.onAction();
  }, $[5] = intentLink, $[6] = node, $[7] = t2) : t2 = $[7];
  const handleClick = t2, {
    title
  } = useI18nText(node), showSelectionIndicator = node.selected && !node.hideSelectionIndicator, t3 = disabled || !!node.disabled;
  let t4;
  $[8] !== node.hotkey ? (t4 = node.hotkey?.split("+"), $[8] = node.hotkey, $[9] = t4) : t4 = $[9];
  const t5 = showSelectionIndicator ? CheckmarkIcon : void 0;
  let t6;
  $[10] !== handleClick || $[11] !== intentLink.href || $[12] !== node.icon || $[13] !== node.tone || $[14] !== showSelectionIndicator || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== title ? (t6 = /* @__PURE__ */ jsx(MenuItem$1, { as: "a", disabled: t3, hotkeys: t4, href: intentLink.href, icon: node.icon, iconRight: t5, onClick: handleClick, pressed: showSelectionIndicator, text: title, tone: node.tone }), $[10] = handleClick, $[11] = intentLink.href, $[12] = node.icon, $[13] = node.tone, $[14] = showSelectionIndicator, $[15] = t3, $[16] = t4, $[17] = t5, $[18] = title, $[19] = t6) : t6 = $[19];
  let t7;
  return $[20] !== t6 || $[21] !== tooltipContent ? (t7 = /* @__PURE__ */ jsx(TooltipOfDisabled, { content: tooltipContent, placement: "left", children: t6 }), $[20] = t6, $[21] = tooltipContent, $[22] = t7) : t7 = $[22], t7;
}
const CONTEXT_MENU_POPOVER_PROPS = {
  constrainSize: !0,
  placement: "bottom",
  portal: !0
};
function nodesHasTone(nodes, tone) {
  return nodes.some((node) => node.type === "item" && node.tone === tone || node.type === "group" && nodesHasTone(node.children, tone));
}
function PaneContextMenuButton(props) {
  const $ = c(13), {
    nodes,
    actionsNodes
  } = props, id = useId(), hasCritical = nodesHasTone(nodes, "critical"), hasCaution = nodesHasTone(nodes, "caution"), t0 = hasCritical ? "critical" : hasCaution ? "caution" : void 0;
  let t1;
  $[0] !== t0 ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, { tone: t0, "data-testid": "pane-context-menu-button" }), $[0] = t0, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== actionsNodes ? (t2 = actionsNodes && /* @__PURE__ */ jsxs(Fragment, { children: [
    actionsNodes,
    /* @__PURE__ */ jsx(MenuDivider, {})
  ] }), $[2] = actionsNodes, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== nodes ? (t3 = nodes.map((node, nodeIndex) => {
    const isAfterGroup = nodes[nodeIndex - 1]?.type === "group";
    return /* @__PURE__ */ jsx(PaneMenuButtonItem, { isAfterGroup, node }, node.key);
  }), $[4] = nodes, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Menu, { children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== id || $[10] !== t1 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(MenuButton, { button: t1, id, menu: t4, popover: CONTEXT_MENU_POPOVER_PROPS }), $[9] = id, $[10] = t1, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
const Root$7 = styled(Layer).withConfig({
  displayName: "Root",
  componentId: "sc-rwc61s-0"
})`position:sticky;bottom:0;`, RootCard = styled(Card).withConfig({
  displayName: "RootCard",
  componentId: "sc-rwc61s-1"
})`padding-bottom:env(safe-area-inset-bottom);`, PaneFooter = forwardRef(function(props, ref) {
  const $ = c(7), {
    children,
    padding
  } = props, {
    collapsed
  } = usePane();
  let t0;
  $[0] !== children || $[1] !== padding ? (t0 = /* @__PURE__ */ jsx(RootCard, { tone: "inherit", children: /* @__PURE__ */ jsx(Box, { padding, children }) }), $[0] = children, $[1] = padding, $[2] = t0) : t0 = $[2];
  let t1;
  return $[3] !== collapsed || $[4] !== ref || $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneFooter", children: /* @__PURE__ */ jsx(Root$7, { "data-testid": "pane-footer", hidden: collapsed, ref, children: t0 }) }), $[3] = collapsed, $[4] = ref, $[5] = t0, $[6] = t1) : t1 = $[6], t1;
}), Root$6 = /* @__PURE__ */ styled(Layer).withConfig({
  displayName: "Root",
  componentId: "sc-2mpzxb-0"
})(({
  $border
}) => css`
    line-height: 0;
    position: sticky;
    top: 0;

    &:not([data-collapsed]):after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      border-bottom: 1px solid ${$border ? "var(--card-border-color)" : "transparent"};
      opacity: 1;
    }
  `), Layout = styled(Flex).withConfig({
  displayName: "Layout",
  componentId: "sc-2mpzxb-1"
})`transform-origin:calc(51px / 2);[data-collapsed] > div > &{transform:rotate(90deg);}`, TitleCard = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "TitleCard",
  componentId: "sc-2mpzxb-2"
})(({
  theme
}) => {
  const {
    fg,
    bg
  } = theme.sanity.color.card.enabled;
  return css`
    background-color: ${bg};
    min-width: 0;

    [data-ui='Text'] {
      color: ${fg};
    }
  `;
}), TitleTextSkeleton = styled(TextSkeleton).withConfig({
  displayName: "TitleTextSkeleton",
  componentId: "sc-2mpzxb-3"
})`width:66%;max-width:175px;`, TitleText = styled(Text).withConfig({
  displayName: "TitleText",
  componentId: "sc-2mpzxb-4"
})`cursor:default;outline:none;min-width:0;`, PaneHeader$1 = forwardRef(function(props, ref) {
  const $ = c(48), {
    actions,
    backButton,
    border,
    contentAfter,
    loading,
    subActions,
    tabs,
    tabIndex,
    title,
    appendTitle
  } = props, {
    collapse,
    collapsed,
    expand,
    rootElement: paneElement
  } = usePane(), paneRect = useElementRect(paneElement || null), t0 = collapsed ? paneRect?.height || window.innerHeight : void 0;
  let t1;
  $[0] !== t0 ? (t1 = {
    width: t0
  }, $[0] = t0, $[1] = t1) : t1 = $[1];
  const layoutStyle = t1;
  let t2;
  $[2] !== collapse || $[3] !== collapsed ? (t2 = () => {
    collapsed || collapse();
  }, $[2] = collapse, $[3] = collapsed, $[4] = t2) : t2 = $[4];
  const handleTitleClick = t2;
  let t3;
  $[5] !== collapsed || $[6] !== expand ? (t3 = () => {
    collapsed && expand();
  }, $[5] = collapsed, $[6] = expand, $[7] = t3) : t3 = $[7];
  const handleLayoutClick = t3, showTabsOrSubActions = !!(!collapsed && (tabs || subActions)), t4 = collapsed ? "" : void 0, t5 = collapsed ? "" : void 0;
  let t6;
  $[8] !== backButton ? (t6 = backButton && /* @__PURE__ */ jsx(Box, { flex: "none", children: backButton }), $[8] = backButton, $[9] = t6) : t6 = $[9];
  const t7 = backButton ? 1 : 2;
  let t8;
  $[10] !== loading ? (t8 = loading && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(TitleTextSkeleton, { animated: !0, radius: 1, size: 1 }) }), $[10] = loading, $[11] = t8) : t8 = $[11];
  let t9;
  $[12] !== appendTitle || $[13] !== loading || $[14] !== title ? (t9 = !loading && /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    /* @__PURE__ */ jsx(TitleText, { size: 1, textOverflow: "ellipsis", weight: "semibold", children: title }),
    appendTitle
  ] }), $[12] = appendTitle, $[13] = loading, $[14] = title, $[15] = t9) : t9 = $[15];
  let t10;
  $[16] !== handleTitleClick || $[17] !== t7 || $[18] !== t8 || $[19] !== t9 || $[20] !== tabIndex ? (t10 = /* @__PURE__ */ jsxs(TitleCard, { __unstable_focusRing: !0, flex: 1, onClick: handleTitleClick, paddingLeft: t7, padding: 2, tabIndex, children: [
    t8,
    t9
  ] }), $[16] = handleTitleClick, $[17] = t7, $[18] = t8, $[19] = t9, $[20] = tabIndex, $[21] = t10) : t10 = $[21];
  let t11;
  $[22] !== actions || $[23] !== collapsed ? (t11 = actions && /* @__PURE__ */ jsx(Box, { hidden: collapsed, children: /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneHeader", children: actions }) }), $[22] = actions, $[23] = collapsed, $[24] = t11) : t11 = $[24];
  let t12;
  $[25] !== t10 || $[26] !== t11 || $[27] !== t6 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    t6,
    t10,
    t11
  ] }), $[25] = t10, $[26] = t11, $[27] = t6, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== collapsed || $[30] !== showTabsOrSubActions || $[31] !== subActions || $[32] !== tabs ? (t13 = showTabsOrSubActions && /* @__PURE__ */ jsxs(Flex, { align: "center", hidden: collapsed, overflow: "auto", children: [
    /* @__PURE__ */ jsx(Box, { flex: 1, marginRight: subActions ? 3 : 0, children: tabs }),
    subActions
  ] }), $[29] = collapsed, $[30] = showTabsOrSubActions, $[31] = subActions, $[32] = tabs, $[33] = t13) : t13 = $[33];
  let t14;
  $[34] !== handleLayoutClick || $[35] !== layoutStyle || $[36] !== t12 || $[37] !== t13 ? (t14 = /* @__PURE__ */ jsxs(Layout, { direction: "column", gap: 3, onClick: handleLayoutClick, padding: 3, sizing: "border", style: layoutStyle, children: [
    t12,
    t13
  ] }), $[34] = handleLayoutClick, $[35] = layoutStyle, $[36] = t12, $[37] = t13, $[38] = t14) : t14 = $[38];
  const t15 = !collapsed && contentAfter;
  let t16;
  $[39] !== t14 || $[40] !== t15 || $[41] !== t5 ? (t16 = /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneHeader", children: /* @__PURE__ */ jsxs(Card, { "data-collapsed": t5, tone: "inherit", children: [
    t14,
    t15
  ] }) }), $[39] = t14, $[40] = t15, $[41] = t5, $[42] = t16) : t16 = $[42];
  let t17;
  return $[43] !== border || $[44] !== ref || $[45] !== t16 || $[46] !== t4 ? (t17 = /* @__PURE__ */ jsx(LayerProvider, { zOffset: 100, children: /* @__PURE__ */ jsx(Root$6, { $border: border, "data-collapsed": t4, "data-testid": "pane-header", ref, children: t16 }) }), $[43] = border, $[44] = ref, $[45] = t16, $[46] = t4, $[47] = t17) : t17 = $[47], t17;
});
function getDisabledReason$1(node) {
  if (!node.disabled)
    return {
      disabledReason: void 0,
      ariaLabel: void 0,
      isDisabled: !1
    };
  const disabledReason = typeof node.disabled == "object" ? node.disabled.reason : void 0, ariaLabel = typeof node.disabled == "object" && typeof node.disabled?.reason == "string" ? node.disabled.reason : "This is disabled";
  return {
    disabledReason,
    ariaLabel,
    isDisabled: !!node.disabled
  };
}
function PaneHeaderActionButton(props) {
  const $ = c(4), {
    node
  } = props;
  if (node.type === "item") {
    let t0;
    return $[0] !== node ? (t0 = /* @__PURE__ */ jsx(PaneHeaderMenuItemActionButton, { node }), $[0] = node, $[1] = t0) : t0 = $[1], t0;
  }
  if (node.type === "group") {
    let t0;
    return $[2] !== node ? (t0 = /* @__PURE__ */ jsx(PaneHeaderMenuGroupActionButton, { node }), $[2] = node, $[3] = t0) : t0 = $[3], t0;
  }
  return console.warn('unknown menu node (expected `type: "item" | "group"`):', node), null;
}
function PaneHeaderMenuItemActionButton(props) {
  const $ = c(23), {
    node
  } = props, {
    title
  } = useI18nText(node), {
    t
  } = useTranslation();
  if (node.intent) {
    let t02;
    return $[0] !== node.intent || $[1] !== props ? (t02 = /* @__PURE__ */ jsx(PaneHeaderActionIntentButton, { ...props, intent: node.intent }), $[0] = node.intent, $[1] = props, $[2] = t02) : t02 = $[2], t02;
  }
  let t0;
  $[3] !== node ? (t0 = getDisabledReason$1(node), $[3] = node, $[4] = t0) : t0 = $[4];
  const {
    disabledReason,
    ariaLabel,
    isDisabled
  } = t0;
  let t1;
  $[5] !== ariaLabel || $[6] !== t || $[7] !== title ? (t1 = ariaLabel || title || t("status-button.aria-label"), $[5] = ariaLabel, $[6] = t, $[7] = title, $[8] = t1) : t1 = $[8];
  let t2;
  $[9] !== isDisabled || $[10] !== node.hotkey ? (t2 = !isDisabled && node.hotkey ? node.hotkey.split("+") : void 0, $[9] = isDisabled, $[10] = node.hotkey, $[11] = t2) : t2 = $[11];
  const t3 = isDisabled ? disabledReason : title;
  let t4;
  $[12] !== t2 || $[13] !== t3 ? (t4 = {
    hotkeys: t2,
    content: t3
  }, $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14];
  let t5;
  return $[15] !== isDisabled || $[16] !== node.icon || $[17] !== node.onAction || $[18] !== node.selected || $[19] !== node.tone || $[20] !== t1 || $[21] !== t4 ? (t5 = /* @__PURE__ */ jsx(StatusButton, { disabled: isDisabled, icon: node.icon, onClick: node.onAction, selected: node.selected, tone: node.tone, "aria-label": t1, tooltipProps: t4 }), $[15] = isDisabled, $[16] = node.icon, $[17] = node.onAction, $[18] = node.selected, $[19] = node.tone, $[20] = t1, $[21] = t4, $[22] = t5) : t5 = $[22], t5;
}
function PaneHeaderActionIntentButton(props) {
  const $ = c(27), {
    intent,
    node
  } = props;
  let t0;
  $[0] !== intent.params || $[1] !== intent.type ? (t0 = {
    intent: intent.type,
    params: intent.params
  }, $[0] = intent.params, $[1] = intent.type, $[2] = t0) : t0 = $[2];
  const intentLink = useIntentLink(t0), {
    t
  } = useTranslation();
  let t1;
  $[3] !== intentLink || $[4] !== node ? (t1 = (event) => {
    intentLink.onClick(event), node.onAction();
  }, $[3] = intentLink, $[4] = node, $[5] = t1) : t1 = $[5];
  const handleClick = t1;
  let t2;
  $[6] !== node ? (t2 = getDisabledReason$1(node), $[6] = node, $[7] = t2) : t2 = $[7];
  const {
    disabledReason,
    ariaLabel,
    isDisabled
  } = t2;
  let t3;
  $[8] !== ariaLabel || $[9] !== node.title || $[10] !== t ? (t3 = ariaLabel || node.title || t("status-button.aria-label"), $[8] = ariaLabel, $[9] = node.title, $[10] = t, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== isDisabled || $[13] !== node.hotkey ? (t4 = !isDisabled && node.hotkey ? node.hotkey.split("+") : void 0, $[12] = isDisabled, $[13] = node.hotkey, $[14] = t4) : t4 = $[14];
  const t5 = isDisabled ? disabledReason : node.title;
  let t6;
  $[15] !== t4 || $[16] !== t5 ? (t6 = {
    hotkeys: t4,
    content: t5,
    placement: "bottom",
    portal: !0
  }, $[15] = t4, $[16] = t5, $[17] = t6) : t6 = $[17];
  let t7;
  return $[18] !== handleClick || $[19] !== intentLink.href || $[20] !== isDisabled || $[21] !== node.icon || $[22] !== node.selected || $[23] !== node.tone || $[24] !== t3 || $[25] !== t6 ? (t7 = /* @__PURE__ */ jsx(StatusButton, { forwardedAs: "a", disabled: isDisabled, href: intentLink.href, icon: node.icon, onClick: handleClick, selected: node.selected, tone: node.tone, "aria-label": t3, tooltipProps: t6 }), $[18] = handleClick, $[19] = intentLink.href, $[20] = isDisabled, $[21] = node.icon, $[22] = node.selected, $[23] = node.tone, $[24] = t3, $[25] = t6, $[26] = t7) : t7 = $[26], t7;
}
function PaneHeaderMenuGroupActionButton(props) {
  const $ = c(16), {
    node
  } = props, {
    title
  } = useI18nText(node), t0 = !!node.disabled, t1 = node.icon ?? UnknownIcon;
  let t2;
  $[0] !== node.title ? (t2 = {
    content: node.title,
    portal: !0
  }, $[0] = node.title, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== t0 || $[3] !== t1 || $[4] !== t2 || $[5] !== title ? (t3 = /* @__PURE__ */ jsx(Button$1, { disabled: t0, icon: t1, label: title, mode: "bleed", tooltipProps: t2 }), $[2] = t0, $[3] = t1, $[4] = t2, $[5] = title, $[6] = t3) : t3 = $[6];
  const t4 = useId();
  let t5;
  $[7] !== node.children || $[8] !== node.disabled ? (t5 = node.children.map((child, idx) => /* @__PURE__ */ jsx(PaneMenuButtonItem, { disabled: !!node.disabled, isAfterGroup: node.children[idx - 1]?.type === "group", node: child }, child.key)), $[7] = node.children, $[8] = node.disabled, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t5 ? (t6 = /* @__PURE__ */ jsx(Menu, { children: t5 }), $[10] = t5, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== t3 || $[13] !== t4 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(MenuButton, { button: t3, id: t4, menu: t6 }), $[12] = t3, $[13] = t4, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}
const Root$5 = styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-9fi7st-0"
})`transition:opacity 200ms;position:relative;z-index:1;padding-left:env(safe-area-inset-left);padding-right:env(safe-area-inset-right);opacity:0;&:not([hidden]){display:flex;}&:not([data-collapsed]){overflow:auto;}&[data-mounted]{opacity:1;}&[data-resizing]{pointer-events:none;}`;
function _calcPaneResize(cache, left, right, deltaX) {
  const sum = {
    flex: cache.left.flex + cache.right.flex,
    width: cache.left.width + cache.right.width
  }, leftMinWidth = left.minWidth ?? PANE_DEFAULT_MIN_WIDTH, rightMinWidth = right.minWidth ?? PANE_DEFAULT_MIN_WIDTH, leftMaxWidth = Math.min(left.maxWidth || 1 / 0, sum.width - rightMinWidth), rightMaxWidth = Math.min(right.maxWidth || 1 / 0, sum.width - leftMinWidth);
  let minDeltaX = leftMinWidth - cache.left.width;
  const rightMinDeltaX = cache.right.width - rightMaxWidth;
  minDeltaX < rightMinDeltaX && (minDeltaX = rightMinDeltaX);
  let maxDeltaX = cache.right.width - rightMinWidth;
  const leftMaxDeltaX = leftMaxWidth - cache.left.width;
  maxDeltaX > leftMaxDeltaX && (maxDeltaX = leftMaxDeltaX);
  const _deltaX = Math.min(Math.max(deltaX, minDeltaX), maxDeltaX), leftW = cache.left.width + _deltaX, rightW = cache.right.width - _deltaX, leftFlex = leftW / sum.width * sum.flex, rightFlex = rightW / sum.width * sum.flex;
  return {
    leftFlex,
    leftW,
    rightFlex,
    rightW
  };
}
function _getDOMPath(rootElement, el) {
  const path = [];
  let e = el;
  for (; e !== rootElement; ) {
    const parentElement = e.parentElement;
    if (!parentElement) return path;
    const index = Array.from(parentElement.childNodes).indexOf(e);
    if (path.unshift(index), parentElement === rootElement)
      return path;
    e = parentElement;
  }
  return path;
}
const EMPTY_PATH = [];
function _sortElements(rootElement, elements) {
  const map2 = /* @__PURE__ */ new WeakMap();
  for (const element of elements)
    map2.set(element, _getDOMPath(rootElement, element));
  const _sortByElementPath = (a, b) => {
    const _a = map2.get(a) || EMPTY_PATH, _b = map2.get(b) || EMPTY_PATH, len = Math.max(_a.length, _b.length);
    for (let i = 0; i < len; i += 1) {
      const aIndex = _a[i] || -1, bIndex = _b[i] || -1;
      if (aIndex !== bIndex)
        return aIndex - bIndex;
    }
    return 0;
  };
  elements.sort(_sortByElementPath);
}
function createPaneLayoutController() {
  const observers = [], elements = [], optionsMap = /* @__PURE__ */ new WeakMap(), userCollapsedElementSet = /* @__PURE__ */ new Set(), cache = {};
  let rootElement = null, rootWidth = 0, expandedElement = null, maximizedElement = null, resizeDataMap = /* @__PURE__ */ new Map(), resizing = !1;
  function collapse(element) {
    userCollapsedElementSet.add(element), expandedElement === element && (expandedElement = null), _notifyObservers();
  }
  function expand(element) {
    userCollapsedElementSet.delete(element), expandedElement = element, _notifyObservers();
  }
  function maximize(element) {
    maximizedElement = element, _notifyObservers();
  }
  function mount(element, options) {
    return optionsMap.set(element, {
      ...options,
      original: options
    }), elements.push(element), rootElement && _sortElements(rootElement, elements), expand(element), () => {
      const idx = elements.indexOf(element);
      idx > -1 && elements.splice(idx, 1), optionsMap.delete(element), maximizedElement === element && (maximizedElement = null), _notifyObservers();
    };
  }
  function resize(type, leftElement, deltaX) {
    const leftIndex = elements.indexOf(leftElement), leftOptions = optionsMap.get(leftElement);
    if (!leftOptions) return;
    const rightElement = elements[leftIndex + 1], rightOptions = optionsMap.get(rightElement);
    if (rightOptions) {
      if (type === "start" && (resizing = !0, cache.left = {
        element: leftElement,
        flex: leftOptions.flex || 1,
        width: leftElement.offsetWidth
      }, cache.right = {
        element: rightElement,
        flex: rightOptions.flex || 1,
        width: rightElement.offsetWidth
      }, _notifyObservers()), type === "move" && cache.left && cache.right) {
        resizeDataMap = /* @__PURE__ */ new Map();
        const {
          leftW,
          rightW,
          leftFlex,
          rightFlex
        } = _calcPaneResize(cache, leftOptions, rightOptions, deltaX);
        resizeDataMap.set(leftElement, {
          flex: leftFlex,
          width: leftW
        }), resizeDataMap.set(rightElement, {
          flex: rightFlex,
          width: rightW
        }), _notifyObservers();
      }
      if (type === "end") {
        resizing = !1;
        const leftResizeData = resizeDataMap.get(leftElement), rightResizeData = resizeDataMap.get(rightElement);
        optionsMap.set(leftElement, {
          ...leftOptions,
          currentMinWidth: 0,
          currentMaxWidth: leftOptions.maxWidth ?? 1 / 0,
          flex: leftResizeData?.flex ?? leftOptions.flex
        }), optionsMap.set(rightElement, {
          ...rightOptions,
          currentMinWidth: 0,
          currentMaxWidth: leftOptions.maxWidth ?? 1 / 0,
          flex: rightResizeData?.flex ?? rightOptions.flex
        }), resizeDataMap = /* @__PURE__ */ new Map(), delete cache.left, delete cache.right, _notifyObservers();
      }
    }
  }
  function setRootElement(nextRootElement) {
    rootElement = nextRootElement;
  }
  function setRootWidth(nextRootWidth) {
    rootWidth = nextRootWidth, _notifyObservers();
  }
  function subscribe(observer) {
    return observers.push(observer), () => {
      const idx = observers.push(observer);
      idx > -1 && observers.splice(idx, 1);
    };
  }
  return {
    collapse,
    expand,
    maximize,
    mount,
    resize,
    setRootElement,
    setRootWidth,
    subscribe
  };
  function _notifyObservers() {
    if (!rootWidth) return;
    const _elements = [];
    for (const element of elements)
      element !== expandedElement && _elements.unshift(element);
    expandedElement && _elements.unshift(expandedElement);
    const dataMap = /* @__PURE__ */ new WeakMap(), len = _elements.length, lastElement = _elements[0], collapsedWidth = (len - 1) * PANE_COLLAPSED_WIDTH;
    let remaingWidth = rootWidth - collapsedWidth;
    for (const element of _elements) {
      const options = optionsMap.get(element);
      if (!options)
        continue;
      const minWidth = options.currentMinWidth || options.minWidth || PANE_DEFAULT_MIN_WIDTH, isLast = element === lastElement, userCollapsed = userCollapsedElementSet.has(element), sizeCollapsed = minWidth > remaingWidth, collapsed = isLast ? !1 : userCollapsed || sizeCollapsed, resizeData = resizeDataMap.get(element);
      dataMap.set(element, {
        element,
        collapsed,
        currentMinWidth: resizeData?.width ?? options.currentMinWidth,
        currentMaxWidth: resizeData?.width ?? options.currentMaxWidth,
        flex: resizeData?.flex ?? options.flex ?? 1,
        maximized: element === maximizedElement
      }), collapsed ? remaingWidth -= PANE_COLLAPSED_WIDTH : remaingWidth -= minWidth - PANE_COLLAPSED_WIDTH;
    }
    const panes = [];
    for (const element of elements) {
      const data = dataMap.get(element);
      data && panes.push(data);
    }
    for (const observer of observers)
      observer({
        expandedElement: expandedElement || elements[elements.length - 1] || null,
        panes,
        resizing
      });
  }
}
function PaneLayout(props) {
  const $ = c(41);
  let children, minWidth, onCollapse, onExpand, restProps;
  $[0] !== props ? ({
    children,
    minWidth,
    onCollapse,
    onExpand,
    ...restProps
  } = props, $[0] = props, $[1] = children, $[2] = minWidth, $[3] = onCollapse, $[4] = onExpand, $[5] = restProps) : (children = $[1], minWidth = $[2], onCollapse = $[3], onExpand = $[4], restProps = $[5]);
  const [controller] = useState(_temp$G), [rootElement, setRootElement] = useState(null), width = useElementRect(rootElement)?.width || 0, collapsed = width === void 0 || !minWidth ? void 0 : width < minWidth;
  let t0;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    expandedElement: null,
    panes: [],
    resizing: !1
  }, $[6] = t0) : t0 = $[6];
  const [state2, setState] = useState(t0);
  let t1, t2;
  $[7] !== controller || $[8] !== rootElement ? (t1 = () => controller.setRootElement(rootElement), t2 = [controller, rootElement], $[7] = controller, $[8] = rootElement, $[9] = t1, $[10] = t2) : (t1 = $[9], t2 = $[10]), useEffect(t1, t2);
  let t3, t4;
  $[11] !== controller || $[12] !== width ? (t3 = () => controller.setRootWidth(width), t4 = [controller, width], $[11] = controller, $[12] = width, $[13] = t3, $[14] = t4) : (t3 = $[13], t4 = $[14]), useEffect(t3, t4);
  let t5, t6;
  $[15] !== controller ? (t5 = () => controller.subscribe(setState), t6 = [controller], $[15] = controller, $[16] = t5, $[17] = t6) : (t5 = $[16], t6 = $[17]), useEffect(t5, t6);
  let t7, t8;
  $[18] !== collapsed || $[19] !== onCollapse || $[20] !== onExpand ? (t7 = () => {
    collapsed !== void 0 && (collapsed && onCollapse && onCollapse(), !collapsed && onExpand && onExpand());
  }, t8 = [collapsed, onCollapse, onExpand], $[18] = collapsed, $[19] = onCollapse, $[20] = onExpand, $[21] = t7, $[22] = t8) : (t7 = $[21], t8 = $[22]), useEffect(t7, t8);
  let t9;
  $[23] !== collapsed || $[24] !== controller.collapse || $[25] !== controller.expand || $[26] !== controller.mount || $[27] !== controller.resize || $[28] !== state2.expandedElement || $[29] !== state2.panes || $[30] !== state2.resizing ? (t9 = {
    collapse: controller.collapse,
    collapsed,
    expand: controller.expand,
    expandedElement: state2.expandedElement,
    mount: controller.mount,
    panes: state2.panes,
    resize: controller.resize,
    resizing: state2.resizing
  }, $[23] = collapsed, $[24] = controller.collapse, $[25] = controller.expand, $[26] = controller.mount, $[27] = controller.resize, $[28] = state2.expandedElement, $[29] = state2.panes, $[30] = state2.resizing, $[31] = t9) : t9 = $[31];
  const paneLayout = t9, t10 = collapsed ? "" : void 0, t11 = state2.resizing ? "" : void 0, t12 = width ? "" : void 0;
  let t13;
  $[32] !== children || $[33] !== restProps || $[34] !== t10 || $[35] !== t11 || $[36] !== t12 ? (t13 = /* @__PURE__ */ jsx(Root$5, { "data-ui": "PaneLayout", ...restProps, "data-collapsed": t10, "data-resizing": t11, "data-mounted": t12, ref: setRootElement, children }), $[32] = children, $[33] = restProps, $[34] = t10, $[35] = t11, $[36] = t12, $[37] = t13) : t13 = $[37];
  let t14;
  return $[38] !== paneLayout || $[39] !== t13 ? (t14 = /* @__PURE__ */ jsx(PaneLayoutContext.Provider, { value: paneLayout, children: t13 }), $[38] = paneLayout, $[39] = t13, $[40] = t14) : t14 = $[40], t14;
}
function _temp$G() {
  return createPaneLayoutController();
}
function ErrorPane(props) {
  const $ = c(12), {
    children,
    currentMinWidth,
    flex,
    minWidth,
    paneKey,
    title: t0,
    tone: t1
  } = props, title = t0 === void 0 ? "Error" : t0, tone = t1 === void 0 ? "critical" : t1;
  let t2;
  $[0] !== title ? (t2 = /* @__PURE__ */ jsx(PaneHeader$1, { title }), $[0] = title, $[1] = t2) : t2 = $[1];
  let t3;
  $[2] !== children ? (t3 = /* @__PURE__ */ jsx(PaneContent, { overflow: "auto", children: /* @__PURE__ */ jsx(Box, { paddingX: 4, paddingY: 5, children }) }), $[2] = children, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== currentMinWidth || $[5] !== flex || $[6] !== minWidth || $[7] !== paneKey || $[8] !== t2 || $[9] !== t3 || $[10] !== tone ? (t4 = /* @__PURE__ */ jsxs(Pane, { currentMinWidth, flex, id: paneKey, minWidth, tone, children: [
    t2,
    t3
  ] }), $[4] = currentMinWidth, $[5] = flex, $[6] = minWidth, $[7] = paneKey, $[8] = t2, $[9] = t3, $[10] = tone, $[11] = t4) : t4 = $[11], t4;
}
function Delay(t0) {
  const $ = c(6), {
    children,
    ms: t1
  } = t0, ms = t1 === void 0 ? 0 : t1, [ready, setReady] = useState(ms <= 0);
  let t2, t3;
  if ($[0] !== ms ? (t2 = () => {
    if (ms <= 0)
      return;
    const timeoutId = setTimeout(() => setReady(!0), ms);
    return () => {
      clearTimeout(timeoutId);
    };
  }, t3 = [ms], $[0] = ms, $[1] = t2, $[2] = t3) : (t2 = $[1], t3 = $[2]), useEffect(t2, t3), !ready || !children) {
    let t42;
    return $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(Fragment, {}), $[3] = t42) : t42 = $[3], t42;
  }
  let t4;
  return $[4] !== children ? (t4 = typeof children == "function" ? children() : children, $[4] = children, $[5] = t4) : t4 = $[5], t4;
}
function getWaitMessages(path) {
  const thresholds = [{
    ms: 300,
    messageKey: "panes.resolving.default-message"
  }, {
    ms: 5e3,
    messageKey: "panes.resolving.slow-resolve-message"
  }];
  if (isDev) {
    const message = ["Check console for errors?", "Is your observable/promise resolving?", path.length > 0 ? `Structure path: ${path.join(" \u279D ")}` : ""];
    thresholds.push({
      ms: 1e4,
      message: message.join(`
`)
    });
  }
  const src = of(null);
  return merge(...thresholds.map((threshold) => src.pipe(mapTo("messageKey" in threshold ? {
    messageKey: threshold.messageKey
  } : {
    message: threshold.message
  }), delay(threshold.ms))));
}
const DEFAULT_MESSAGE_KEY = "panes.resolving.default-message", Content$2 = styled(Flex).withConfig({
  displayName: "Content",
  componentId: "sc-1viiodb-0"
})`opacity:0;transition:opacity 200ms;&[data-mounted]{opacity:1;}`, LoadingPane = memo((props) => {
  const $ = c(28), {
    delay: t0,
    flex,
    message: t1,
    minWidth,
    paneKey,
    path,
    selected,
    title,
    tone
  } = props, delay2 = t0 === void 0 ? 300 : t0, messageProp = t1 === void 0 ? getWaitMessages : t1, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t2;
  bb0: {
    if (typeof messageProp == "function") {
      let t32;
      $[0] !== messageProp || $[1] !== path ? (t32 = messageProp(path ? path.split(";") : []), $[0] = messageProp, $[1] = path, $[2] = t32) : t32 = $[2], t2 = t32;
      break bb0;
    }
    t2 = messageProp;
  }
  const resolvedMessage = t2;
  let t3;
  $[3] !== resolvedMessage || $[4] !== t ? (t3 = () => typeof resolvedMessage == "string" ? resolvedMessage : t(DEFAULT_MESSAGE_KEY), $[3] = resolvedMessage, $[4] = t, $[5] = t3) : t3 = $[5];
  const [currentMessage, setCurrentMessage] = useState(t3);
  let t4, t5;
  $[6] !== resolvedMessage || $[7] !== t ? (t4 = () => {
    if (typeof resolvedMessage != "object" || typeof resolvedMessage.subscribe != "function")
      return;
    const sub = resolvedMessage.subscribe((message) => {
      setCurrentMessage("messageKey" in message ? t(message.messageKey) : message.message);
    });
    return () => sub.unsubscribe();
  }, t5 = [resolvedMessage, t], $[6] = resolvedMessage, $[7] = t, $[8] = t4, $[9] = t5) : (t4 = $[8], t5 = $[9]), useEffect(t4, t5);
  const [contentElement, setContentElement] = useState(null), [mounted, setMounted] = useState(!1);
  let t6, t7;
  $[10] !== contentElement ? (t6 = () => {
    if (contentElement)
      return _raf2(() => setMounted(!0));
  }, t7 = [contentElement], $[10] = contentElement, $[11] = t6, $[12] = t7) : (t6 = $[11], t7 = $[12]), useEffect(t6, t7);
  const t8 = mounted ? "" : void 0, t9 = title || currentMessage;
  let t10;
  $[13] !== t9 ? (t10 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: t9 }), $[13] = t9, $[14] = t10) : t10 = $[14];
  let t11;
  $[15] !== t10 || $[16] !== t8 ? (t11 = /* @__PURE__ */ jsx(Content$2, { align: "center", "data-mounted": t8, direction: "column", height: "fill", justify: "center", ref: setContentElement, children: t10 }), $[15] = t10, $[16] = t8, $[17] = t11) : t11 = $[17];
  const content = t11;
  let t12;
  $[18] !== content || $[19] !== delay2 ? (t12 = /* @__PURE__ */ jsx(PaneContent, { children: content }), $[18] = content, $[19] = delay2, $[20] = t12) : t12 = $[20];
  let t13;
  return $[21] !== flex || $[22] !== minWidth || $[23] !== paneKey || $[24] !== selected || $[25] !== t12 || $[26] !== tone ? (t13 = /* @__PURE__ */ jsx(Pane, { flex, id: paneKey, minWidth, selected, tone, children: t12 }), $[21] = flex, $[22] = minWidth, $[23] = paneKey, $[24] = selected, $[25] = t12, $[26] = tone, $[27] = t13) : t13 = $[27], t13;
});
LoadingPane.displayName = "Memo(LoadingPane)";
function useDocumentPane() {
  const documentPane = useContext(DocumentPaneContext);
  if (!documentPane)
    throw new Error("DocumentPane: missing context value");
  return documentPane;
}
function CommentsWrapper(props) {
  const $ = c(8), {
    children,
    documentId,
    documentType
  } = props;
  let t0;
  $[0] !== children || $[1] !== documentId || $[2] !== documentType ? (t0 = /* @__PURE__ */ jsx(CommentsProviderWrapper, { documentId, documentType, children }), $[0] = children, $[1] = documentId, $[2] = documentType, $[3] = t0) : t0 = $[3];
  let t1;
  return $[4] !== documentId || $[5] !== documentType || $[6] !== t0 ? (t1 = /* @__PURE__ */ jsx(CommentsEnabledProvider, { documentId, documentType, children: t0 }), $[4] = documentId, $[5] = documentType, $[6] = t0, $[7] = t1) : t1 = $[7], t1;
}
function CommentsProviderWrapper(props) {
  const $ = c(28), {
    children,
    documentId,
    documentType
  } = props, {
    enabled
  } = useCommentsEnabled(), {
    connectionState,
    onPathOpen,
    inspector,
    openInspector
  } = useDocumentPane(), {
    selectedReleaseId
  } = usePerspective(), {
    params,
    setParams
  } = usePaneRouter(), {
    resolveIntentLink
  } = useRouter(), selectedCommentId = params?.comment, scheduledDraft = params?.scheduledDraft, paramsRef = useRef(params);
  let t0, t1;
  $[0] !== params ? (t0 = () => {
    paramsRef.current = params;
  }, t1 = [params], $[0] = params, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useLayoutEffect(t0, t1);
  let t2;
  $[3] !== documentId || $[4] !== documentType || $[5] !== resolveIntentLink || $[6] !== scheduledDraft || $[7] !== selectedReleaseId ? (t2 = (commentId) => {
    const searchParams = selectedReleaseId && !scheduledDraft ? [["perspective", selectedReleaseId]] : [], intentLink = resolveIntentLink("edit", {
      id: documentId,
      type: documentType,
      inspect: COMMENTS_INSPECTOR_NAME,
      comment: commentId,
      ...scheduledDraft ? {
        scheduledDraft
      } : {}
    }, searchParams);
    return `${window.location.origin}${intentLink}`;
  }, $[3] = documentId, $[4] = documentType, $[5] = resolveIntentLink, $[6] = scheduledDraft, $[7] = selectedReleaseId, $[8] = t2) : t2 = $[8];
  const getCommentLink = t2;
  let t3;
  $[9] !== setParams ? (t3 = () => {
    setParams({
      ...paramsRef.current,
      comment: void 0
    });
  }, $[9] = setParams, $[10] = t3) : t3 = $[10];
  const handleClearSelectedComment = t3;
  let t4;
  $[11] !== inspector?.name || $[12] !== openInspector ? (t4 = () => {
    inspector?.name !== COMMENTS_INSPECTOR_NAME && openInspector(COMMENTS_INSPECTOR_NAME);
  }, $[11] = inspector?.name, $[12] = openInspector, $[13] = t4) : t4 = $[13];
  const handleOpenCommentsInspector = t4;
  if (!enabled) {
    let t52;
    return $[14] !== children ? (t52 = /* @__PURE__ */ jsx(Fragment, { children }), $[14] = children, $[15] = t52) : t52 = $[15], t52;
  }
  const t5 = inspector?.name === COMMENTS_INSPECTOR_NAME, t6 = connectionState === "connecting";
  let t7;
  return $[16] !== children || $[17] !== documentId || $[18] !== documentType || $[19] !== getCommentLink || $[20] !== handleClearSelectedComment || $[21] !== handleOpenCommentsInspector || $[22] !== onPathOpen || $[23] !== selectedCommentId || $[24] !== selectedReleaseId || $[25] !== t5 || $[26] !== t6 ? (t7 = /* @__PURE__ */ jsx(CommentsProvider, { documentId, documentType, getCommentLink, isCommentsOpen: t5, isConnecting: t6, onClearSelectedComment: handleClearSelectedComment, onCommentsOpen: handleOpenCommentsInspector, onPathOpen, selectedCommentId, sortOrder: "desc", type: "field", releaseId: selectedReleaseId, children }), $[16] = children, $[17] = documentId, $[18] = documentType, $[19] = getCommentLink, $[20] = handleClearSelectedComment, $[21] = handleOpenCommentsInspector, $[22] = onPathOpen, $[23] = selectedCommentId, $[24] = selectedReleaseId, $[25] = t5, $[26] = t6, $[27] = t7) : t7 = $[27], t7;
}
function DocumentActionsProvider(props) {
  const $ = c(20), {
    children
  } = props, {
    data: activeReleases
  } = useActiveReleases(), {
    actions,
    editState,
    isInitialValueLoading,
    revisionId
  } = useDocumentPane(), onCompleteRef = useRef(null);
  let t0;
  if ($[0] !== activeReleases || $[1] !== editState?.release) {
    let t12;
    $[3] !== editState?.release ? (t12 = (candidate) => candidate === editState?.release, $[3] = editState?.release, $[4] = t12) : t12 = $[4], t0 = activeReleases.map(_temp$F).find(t12), $[0] = activeReleases, $[1] = editState?.release, $[2] = t0;
  } else
    t0 = $[2];
  const matchingReleaseName = t0;
  let t1;
  $[5] !== editState || $[6] !== isInitialValueLoading || $[7] !== matchingReleaseName || $[8] !== revisionId ? (t1 = editState ? {
    ...editState,
    release: matchingReleaseName,
    revision: revisionId || void 0,
    initialValueResolved: !isInitialValueLoading
  } : null, $[5] = editState, $[6] = isInitialValueLoading, $[7] = matchingReleaseName, $[8] = revisionId, $[9] = t1) : t1 = $[9];
  const actionProps = t1;
  if (!actionProps)
    return null;
  let t2;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => onCompleteRef.current?.(), $[10] = t2) : t2 = $[10];
  let t3;
  $[11] !== actionProps ? (t3 = {
    ...actionProps,
    onComplete: t2
  }, $[11] = actionProps, $[12] = t3) : t3 = $[12];
  const t4 = actions || EMPTY_ARRAY$2;
  let t5;
  $[13] !== actionProps || $[14] !== children ? (t5 = (t62) => {
    const {
      states
    } = t62;
    return /* @__PURE__ */ jsx(ActionsGuardWrapper, { states, actionProps, children });
  }, $[13] = actionProps, $[14] = children, $[15] = t5) : t5 = $[15];
  let t6;
  return $[16] !== t3 || $[17] !== t4 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(GetHookCollectionState, { args: t3, hooks: t4, resetRef: onCompleteRef, children: t5 }), $[16] = t3, $[17] = t4, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}
function _temp$F(r) {
  return getReleaseIdFromReleaseDocumentId(r._id);
}
const SUPPORTED_LINKED_TO_CANVAS_ACTIONS = ["delete", "duplicate", "publish", "unpublish", "unlinkFromCanvas", "editInCanvas", "linkToCanvas", "schedule", "discardVersion", "unpublishVersion"];
function ActionsGuardWrapper(props) {
  const $ = c(9), {
    states,
    children,
    actionProps
  } = props, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[0] !== actionProps ? (t0 = getDocumentIdForCanvasLink(actionProps), $[0] = actionProps, $[1] = t0) : t0 = $[1];
  const {
    isLinked
  } = useCanvasCompanionDoc(t0);
  let t1;
  $[2] !== isLinked || $[3] !== states || $[4] !== t ? (t1 = isLinked ? states.map((s) => !s.action || !SUPPORTED_LINKED_TO_CANVAS_ACTIONS.includes(s.action) ? {
    ...s,
    disabled: !0,
    title: t("action.disabled-by-canvas.tooltip")
  } : s) : states, $[2] = isLinked, $[3] = states, $[4] = t, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== children || $[7] !== t1 ? (t2 = /* @__PURE__ */ jsx(DocumentActionsStateContext.Provider, { value: t1, children }), $[6] = children, $[7] = t1, $[8] = t2) : t2 = $[8], t2;
}
function useStructureTool() {
  const structureTool2 = useContext(StructureToolContext);
  if (!structureTool2)
    throw new Error("StructureTool: missing context value");
  return structureTool2;
}
const DOCUMENT_PANEL_MIN_WIDTH = 320, DOCUMENT_PANEL_INITIAL_MIN_WIDTH = 600, DOCUMENT_INSPECTOR_MIN_WIDTH = 320, DOCUMENT_INSPECTOR_MAX_WIDTH = 540, EMPTY_PARAMS$2 = {}, INSPECT_ACTION_PREFIX = "inspect:", DEFAULT_MENU_ITEM_GROUPS = [{
  id: "inspectors"
}, {
  id: "links"
}], HISTORY_INSPECTOR_NAME = "sanity/structure/history", VALIDATION_INSPECTOR_NAME = "sanity/structure/validation", INCOMING_REFERENCES_INSPECTOR_NAME = "sanity/structure/incoming-references";
function DocumentInspectorMenuItemsResolver(props) {
  const $ = c(22), {
    documentId,
    documentType,
    inspectors: inspectors2,
    onMenuItems
  } = props, len = inspectors2.length;
  let t0;
  $[0] !== len ? (t0 = () => Array.from(new Array(len)), $[0] = len, $[1] = t0) : t0 = $[1];
  const [menuItems, setMenuItems] = useState(t0);
  let t1, t2;
  $[2] !== len || $[3] !== menuItems ? (t1 = () => {
    if (menuItems.length !== len) {
      const newFieldActions = Array.from(new Array(len));
      for (let i = 0; i < len; i++)
        newFieldActions[i] = menuItems[i];
      setMenuItems(newFieldActions);
    }
  }, t2 = [len, menuItems], $[2] = len, $[3] = menuItems, $[4] = t1, $[5] = t2) : (t1 = $[4], t2 = $[5]), useEffect(t1, t2);
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = (index, node) => {
    setMenuItems((prev) => {
      const next = [...prev];
      return next[index] = node, next;
    });
  }, $[6] = t3) : t3 = $[6];
  const setMenuItem = t3;
  let t4, t5;
  $[7] !== menuItems || $[8] !== onMenuItems ? (t4 = () => {
    onMenuItems(menuItems.filter(Boolean));
  }, t5 = [menuItems, onMenuItems], $[7] = menuItems, $[8] = onMenuItems, $[9] = t4, $[10] = t5) : (t4 = $[9], t5 = $[10]), useEffect(t4, t5);
  let t6;
  if ($[11] !== documentId || $[12] !== documentType || $[13] !== inspectors2) {
    let t72;
    $[15] !== documentId || $[16] !== documentType ? (t72 = (inspector, index_0) => inspector.useMenuItem ? [defineInspectorMenuItemComponent({
      documentId,
      documentType,
      index: index_0,
      setMenuItem,
      useMenuItem: inspector.useMenuItem
    }), inspector.name] : [_temp$E, ""], $[15] = documentId, $[16] = documentType, $[17] = t72) : t72 = $[17], t6 = inspectors2.map(t72), $[11] = documentId, $[12] = documentType, $[13] = inspectors2, $[14] = t6;
  } else
    t6 = $[14];
  const InspectorMenuItems = t6;
  let t7;
  $[18] !== InspectorMenuItems ? (t7 = InspectorMenuItems.map(_temp2$i), $[18] = InspectorMenuItems, $[19] = t7) : t7 = $[19];
  let t8;
  return $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(Fragment, { children: t7 }), $[20] = t7, $[21] = t8) : t8 = $[21], t8;
}
function _temp2$i(t0) {
  const [InspectorMenuItem, key] = t0;
  return key && /* @__PURE__ */ jsx(InspectorMenuItem, {}, key);
}
function _temp$E() {
  return null;
}
DocumentInspectorMenuItemsResolver.displayName = "DocumentInspectorMenuItemsResolver";
function defineInspectorMenuItemComponent({
  documentId,
  documentType,
  index,
  setMenuItem,
  useMenuItem: useMenuItem2
}) {
  return memo(function() {
    const $ = c(4);
    let t0;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
      documentId,
      documentType
    }, $[0] = t0) : t0 = $[0];
    const menuItem = useMenuItem2(t0), node = useUnique(menuItem);
    let t1, t2;
    return $[1] !== node ? (t1 = () => {
      setMenuItem(index, node);
    }, t2 = [node], $[1] = node, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), null;
  });
}
function useDocumentPaneInfo() {
  const documentPaneInfo = useContext(DocumentPaneInfoContext);
  if (!documentPaneInfo)
    throw new Error("DocumentPane: missing info context value");
  return documentPaneInfo;
}
function useDocumentTitle() {
  const $ = c(22), {
    connectionState,
    schemaType,
    editState,
    isDeleted,
    lastRevisionDocument
  } = useDocumentPane(), {
    selectedPerspectiveName
  } = usePerspective(), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  bb0: {
    if (isDeleted) {
      t0 = lastRevisionDocument;
      break bb0;
    }
    if (selectedPerspectiveName && isPublishedPerspective(selectedPerspectiveName)) {
      t0 = editState?.published;
      break bb0;
    }
    t0 = editState?.version || editState?.draft || editState?.published;
  }
  const documentValue = t0, subscribed = !!documentValue;
  let t1;
  bb1: {
    if (isDeleted && lastRevisionDocument && schemaType)
      try {
        let t32;
        $[0] !== lastRevisionDocument || $[1] !== schemaType ? (t32 = prepareForPreview(lastRevisionDocument, schemaType), $[0] = lastRevisionDocument, $[1] = schemaType, $[2] = t32) : t32 = $[2], t1 = t32;
        break bb1;
      } catch (t22) {
        console.warn("Failed to prepare preview for deleted document:", t22), t1 = null;
        break bb1;
      }
    t1 = null;
  }
  const deletedDocumentPreview = t1, t2 = subscribed && !isDeleted;
  let t3;
  $[3] !== documentValue || $[4] !== schemaType || $[5] !== t2 ? (t3 = {
    enabled: t2,
    schemaType,
    value: documentValue
  }, $[3] = documentValue, $[4] = schemaType, $[5] = t2, $[6] = t3) : t3 = $[6];
  const {
    error: error_0,
    value
  } = useValuePreview(t3);
  if (connectionState === "connecting" && !subscribed) {
    let t42;
    return $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = {
      error: void 0,
      title: void 0
    }, $[7] = t42) : t42 = $[7], t42;
  }
  if (isDeleted && deletedDocumentPreview) {
    let t42;
    return $[8] !== deletedDocumentPreview.title ? (t42 = {
      error: void 0,
      title: deletedDocumentPreview.title
    }, $[8] = deletedDocumentPreview.title, $[9] = t42) : t42 = $[9], t42;
  }
  if (!value && !isDeleted) {
    const t42 = schemaType?.title || schemaType?.name;
    let t52;
    $[10] !== t || $[11] !== t42 ? (t52 = t("panes.document-header-title.new.text", {
      schemaType: t42
    }), $[10] = t, $[11] = t42, $[12] = t52) : t52 = $[12];
    let t6;
    return $[13] !== t52 ? (t6 = {
      error: void 0,
      title: t52
    }, $[13] = t52, $[14] = t6) : t6 = $[14], t6;
  }
  if (error_0) {
    let t42;
    $[15] !== error_0.message || $[16] !== t ? (t42 = t("panes.document-list-pane.error.text", {
      error: error_0.message
    }), $[15] = error_0.message, $[16] = t, $[17] = t42) : t42 = $[17];
    let t52;
    return $[18] !== t42 ? (t52 = {
      error: t42,
      title: void 0
    }, $[18] = t42, $[19] = t52) : t52 = $[19], t52;
  }
  const t4 = value?.title;
  let t5;
  return $[20] !== t4 ? (t5 = {
    error: void 0,
    title: t4
  }, $[20] = t4, $[21] = t5) : t5 = $[21], t5;
}
const IGNORE_OPS = ["patch", "commit"], DocumentOperationResults = memo(function() {
  const $ = c(13), {
    push: pushToast
  } = useToast(), {
    value: documentPaneValue
  } = useDocumentPane(), {
    documentId,
    documentType
  } = useDocumentPaneInfo(), documentTitleInfo = useDocumentTitle(), titleError = documentTitleInfo.error, event = useDocumentOperationEvent(documentId, documentType), prevEvent = useRef(event), paneRouter = usePaneRouter(), {
    t
  } = useTranslation(structureLocaleNamespace), {
    handleOpenDialog
  } = useDocumentLimitsUpsellContext();
  let t0;
  bb0: {
    if (!documentTitleInfo.title && !titleError && event && !IGNORE_OPS.includes(event.op) && typeof documentPaneValue.title == "string" && event?.type === "success") {
      t0 = documentPaneValue.title;
      break bb0;
    }
    t0 = documentTitleInfo.title;
  }
  const title = t0;
  let t1;
  $[0] !== t || $[1] !== title ? (t1 = title || t("panes.document-operation-results.operation-undefined-title"), $[0] = t, $[1] = title, $[2] = t1) : t1 = $[2];
  const documentTitleBase = t1;
  let t2;
  $[3] !== documentTitleBase ? (t2 = documentTitleBase.length > 25 ? `${documentTitleBase.slice(0, 25)}...` : documentTitleBase, $[3] = documentTitleBase, $[4] = t2) : t2 = $[4];
  const documentTitle = t2;
  let t3, t4;
  return $[5] !== documentTitle || $[6] !== event || $[7] !== handleOpenDialog || $[8] !== paneRouter || $[9] !== pushToast || $[10] !== t ? (t3 = () => {
    if (!event || event === prevEvent.current)
      return;
    let cleanupId;
    if (event.type === "error") {
      if (isDocumentLimitError(event.error)) {
        handleOpenDialog("document_action");
        return;
      }
      pushToast({
        closable: !0,
        duration: 3e4,
        status: "error",
        title: t("panes.document-operation-results.operation-error", {
          context: event.op
        }),
        description: /* @__PURE__ */ jsxs("details", { children: [
          /* @__PURE__ */ jsx("summary", { children: t("panes.document-operation-results.error.summary.title") }),
          event.error.message
        ] })
      });
    }
    return event.type === "success" && !IGNORE_OPS.includes(event.op) && pushToast({
      closable: !0,
      status: "success",
      title: /* @__PURE__ */ jsx(Translate, { context: event.op === "publish" && event.idPair.versionId ? "publishVersion" : event.op, i18nKey: "panes.document-operation-results.operation-success", t, values: {
        op: event.op,
        title: documentTitle
      }, components: {
        Strong: "strong"
      } })
    }), event.type === "success" && event.op === "delete" && (cleanupId = setTimeout(() => paneRouter.closeCurrentAndAfter(), 0)), prevEvent.current = event, () => clearTimeout(cleanupId);
  }, t4 = [event, paneRouter, pushToast, t, documentTitle, handleOpenDialog], $[5] = documentTitle, $[6] = event, $[7] = handleOpenDialog, $[8] = paneRouter, $[9] = pushToast, $[10] = t, $[11] = t3, $[12] = t4) : (t3 = $[11], t4 = $[12]), useEffect(t3, t4), null;
}), isLiveEditEnabled = (schemaType) => schemaType.liveEdit === !0;
function hasObsoleteDraft({
  editState,
  workspace,
  schemaType
}) {
  if (!editState?.ready)
    return {
      result: void 0
    };
  const draftExists = editState.draft !== null, {
    document: {
      drafts: {
        enabled: isDraftModelEnabled
      }
    }
  } = workspace;
  return draftExists ? isDraftModelEnabled ? isLiveEditEnabled(schemaType) ? {
    result: !0,
    reason: "LIVE_EDIT_ACTIVE"
  } : {
    result: !1
  } : {
    result: !0,
    reason: "DRAFT_MODEL_INACTIVE"
  } : {
    result: !1
  };
}
function mustChooseNewDocumentDestination({
  isSelectedPerspectiveWriteable,
  editState
}) {
  return isNewDocument(editState) && !isSelectedPerspectiveWriteable.result;
}
const Root$4 = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "Root",
  componentId: "sc-1anmotz-0"
})({
  position: "relative",
  zIndex: "1",
  lineHeight: "0"
});
function DocumentInspectorHeader(props) {
  const $ = c(25);
  let children, closeButtonLabel, forwardedAs, onClose, restProps, title;
  $[0] !== props ? ({
    as: forwardedAs,
    children,
    closeButtonLabel,
    onClose,
    title,
    ...restProps
  } = props, $[0] = props, $[1] = children, $[2] = closeButtonLabel, $[3] = forwardedAs, $[4] = onClose, $[5] = restProps, $[6] = title) : (children = $[1], closeButtonLabel = $[2], forwardedAs = $[3], onClose = $[4], restProps = $[5], title = $[6]);
  const {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[7] !== title ? (t0 = /* @__PURE__ */ jsx(Box, { flex: 1, padding: 3, children: /* @__PURE__ */ jsx(Text, { as: "h1", size: 1, weight: "medium", children: title }) }), $[7] = title, $[8] = t0) : t0 = $[8];
  let t1;
  $[9] !== t ? (t1 = t("document-inspector.close-button.tooltip"), $[9] = t, $[10] = t1) : t1 = $[10];
  let t2;
  $[11] !== t1 ? (t2 = {
    content: t1
  }, $[11] = t1, $[12] = t2) : t2 = $[12];
  let t3;
  $[13] !== closeButtonLabel || $[14] !== onClose || $[15] !== t2 ? (t3 = /* @__PURE__ */ jsx(Box, { flex: "none", padding: 1, children: /* @__PURE__ */ jsx(Button$1, { "aria-label": closeButtonLabel, icon: CloseIcon, mode: "bleed", onClick: onClose, tooltipProps: t2 }) }), $[13] = closeButtonLabel, $[14] = onClose, $[15] = t2, $[16] = t3) : t3 = $[16];
  let t4;
  $[17] !== t0 || $[18] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { padding: 2, children: [
    t0,
    t3
  ] }), $[17] = t0, $[18] = t3, $[19] = t4) : t4 = $[19];
  let t5;
  return $[20] !== children || $[21] !== forwardedAs || $[22] !== restProps || $[23] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Root$4, { ...restProps, as: forwardedAs, children: [
    t4,
    children
  ] }), $[20] = children, $[21] = forwardedAs, $[22] = restProps, $[23] = t4, $[24] = t5) : t5 = $[24], t5;
}
function DocumentInspectorPanel(props) {
  const $ = c(14), {
    documentId,
    documentType,
    flex
  } = props, {
    collapsed
  } = usePane(), {
    closeInspector,
    inspector
  } = useDocumentPane(), {
    features
  } = useStructureTool();
  let t0;
  $[0] !== closeInspector || $[1] !== inspector ? (t0 = () => {
    inspector && closeInspector(inspector.name);
  }, $[0] = closeInspector, $[1] = inspector, $[2] = t0) : t0 = $[2];
  const handleClose = t0;
  if (collapsed || !inspector)
    return null;
  const Component = inspector.component;
  let t1;
  $[3] !== Component || $[4] !== documentId || $[5] !== documentType || $[6] !== handleClose ? (t1 = /* @__PURE__ */ jsx(Component, { onClose: handleClose, documentId, documentType }), $[3] = Component, $[4] = documentId, $[5] = documentType, $[6] = handleClose, $[7] = t1) : t1 = $[7];
  const element = t1;
  if (features.resizablePanes) {
    let t22;
    return $[8] !== element || $[9] !== flex ? (t22 = /* @__PURE__ */ jsx(Resizable, { as: "aside", "data-ui": "DocumentInspectorPanel", flex, resizerPosition: "left", maxWidth: DOCUMENT_INSPECTOR_MAX_WIDTH, minWidth: DOCUMENT_INSPECTOR_MIN_WIDTH, children: element }), $[8] = element, $[9] = flex, $[10] = t22) : t22 = $[10], t22;
  }
  let t2;
  return $[11] !== element || $[12] !== flex ? (t2 = /* @__PURE__ */ jsx(Box, { as: "aside", "data-ui": "DocumentInspectorPanel", flex, children: element }), $[11] = element, $[12] = flex, $[13] = t2) : t2 = $[13], t2;
}
const STRUCTURE_TOOL_NAMESPACE = "studio.structure-tool";
function useStructureToolSetting(namespace, key, defaultValue) {
  const $ = c(16), keyValueStore = useKeyValueStore();
  let t0;
  $[0] !== key || $[1] !== namespace ? (t0 = [STRUCTURE_TOOL_NAMESPACE, namespace, key].filter(Boolean), $[0] = key, $[1] = namespace, $[2] = t0) : t0 = $[2];
  const keyValueStoreKey = t0.join(".");
  let t1;
  if ($[3] !== defaultValue || $[4] !== keyValueStore || $[5] !== keyValueStoreKey) {
    let t22;
    $[7] !== defaultValue ? (t22 = (value) => value === null ? defaultValue : value, $[7] = defaultValue, $[8] = t22) : t22 = $[8], t1 = keyValueStore.getKey(keyValueStoreKey).pipe(map$1(t22)), $[3] = defaultValue, $[4] = keyValueStore, $[5] = keyValueStoreKey, $[6] = t1;
  } else
    t1 = $[6];
  const value_0 = useObservable(t1, defaultValue);
  let t2;
  $[9] !== keyValueStore || $[10] !== keyValueStoreKey || $[11] !== value_0 ? (t2 = async (newValue) => {
    newValue !== value_0 && await keyValueStore.setKey(keyValueStoreKey, newValue);
  }, $[9] = keyValueStore, $[10] = keyValueStoreKey, $[11] = value_0, $[12] = t2) : t2 = $[12];
  const set = t2;
  let t3;
  return $[13] !== set || $[14] !== value_0 ? (t3 = [value_0, set], $[13] = set, $[14] = value_0, $[15] = t3) : t3 = $[15], t3;
}
const VIEW_MODE_PARSED = {
  id: "parsed",
  title: "document-inspector.view-mode.parsed"
}, VIEW_MODE_RAW = {
  id: "raw",
  title: "document-inspector.view-mode.raw-json"
}, VIEW_MODES = [VIEW_MODE_PARSED, VIEW_MODE_RAW], lru = new QuickLRU({
  maxSize: 1e3
});
function isExpanded(keyPath, value) {
  const cached = lru.get(keyPath);
  return cached === void 0 ? (lru.set(keyPath, Array.isArray(value) || isRecord(value)), isExpanded(keyPath, value)) : cached;
}
function toggleExpanded(event) {
  const {
    path
  } = event, current = lru.get(path);
  current !== void 0 && lru.set(path, !current);
}
function selectElement(element) {
  const sel = window.getSelection();
  if (sel) {
    const range = document.createRange();
    sel.removeAllRanges(), range.selectNodeContents(element), sel.addRange(range);
  }
}
function select(event) {
  selectElement(event.target);
}
function maybeSelectAll(event) {
  event.keyCode === 65 && (event.metaKey || event.ctrlKey) && (event.preventDefault(), selectElement(event.currentTarget));
}
function isDocumentLike(value) {
  return isRecord(value) && isString(value._id) && isString(value._type);
}
const JSONInspectorWrapper = /* @__PURE__ */ styled.div.withConfig({
  displayName: "JSONInspectorWrapper",
  componentId: "sc-1nlr6yd-0"
})(({
  theme
}) => {
  const {
    color,
    fonts,
    space
  } = theme.sanity;
  return css`
    & .json-inspector,
    & .json-inspector .json-inspector__selection {
      font-family: ${fonts.code.family};
      font-size: ${fonts.code.sizes[1].fontSize}px;
      line-height: ${fonts.code.sizes[1].lineHeight}px;
      color: var(--card-code-fg-color);
    }

    & .json-inspector .json-inspector__leaf {
      padding-left: ${rem(space[4])};
    }

    & .json-inspector .json-inspector__leaf.json-inspector__leaf_root {
      padding-top: ${rem(space[3])};
      padding-left: 0;
    }

    & .json-inspector > .json-inspector__leaf_root > .json-inspector__line > .json-inspector__key {
      display: none;
    }

    & .json-inspector .json-inspector__line {
      display: block;
      position: relative;
      cursor: default;
    }

    & .json-inspector .json-inspector__line::after {
      content: '';
      position: absolute;
      top: 0;
      left: -200px;
      right: -50px;
      bottom: 0;
      z-index: -1;
      pointer-events: none;
    }

    & .json-inspector .json-inspector__line:hover::after {
      background: var(--card-code-bg-color);
    }

    & .json-inspector .json-inspector__leaf_composite > .json-inspector__line {
      cursor: pointer;
    }

    & .json-inspector .json-inspector__leaf_composite > .json-inspector__line::before {
      content: '▸ ';
      margin-left: calc(0 - ${rem(space[4])} + 3px);
      font-size: ${fonts.code.sizes[1].fontSize}px;
      line-height: ${fonts.code.sizes[1].lineHeight}px;
    }

    &
      .json-inspector
      .json-inspector__leaf_expanded.json-inspector__leaf_composite
      > .json-inspector__line::before {
      content: '▾ ';
      font-size: ${fonts.code.sizes[1].fontSize}px;
      line-height: ${fonts.code.sizes[1].lineHeight}px;
    }

    & .json-inspector .json-inspector__radio,
    & .json-inspector .json-inspector__flatpath {
      display: none;
    }

    & .json-inspector .json-inspector__value {
      margin-left: ${rem(space[4] / 2)};
    }

    &
      .json-inspector
      > .json-inspector__leaf_root
      > .json-inspector__line
      > .json-inspector__key
      + .json-inspector__value {
      margin: 0;
    }

    & .json-inspector .json-inspector__key {
      color: ${color.syntax.property};
    }

    & .json-inspector .json-inspector__value_helper,
    & .json-inspector .json-inspector__value_null {
      color: ${color.syntax.constant};
    }

    & .json-inspector .json-inspector__not-found {
      padding-top: ${rem(space[3])};
    }

    & .json-inspector .json-inspector__value_string {
      color: ${color.syntax.string};
    }

    & .json-inspector .json-inspector__value_boolean {
      color: ${color.syntax.boolean};
    }

    & .json-inspector .json-inspector__value_number {
      color: ${color.syntax.number};
    }

    & .json-inspector .json-inspector__show-original {
      display: inline-block;
      padding: 0 6px;
      cursor: pointer;
    }

    & .json-inspector .json-inspector__show-original:hover {
      color: inherit;
    }

    & .json-inspector .json-inspector__show-original::before {
      content: '↔';
    }

    & .json-inspector .json-inspector__show-original:hover::after {
      content: ' expand';
    }
  `;
});
function Search(props) {
  const $ = c(8), {
    onChange,
    query
  } = props;
  let t0;
  $[0] !== onChange ? (t0 = (event) => onChange(event.target.value), $[0] = onChange, $[1] = t0) : t0 = $[1];
  const handleChange = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[2] !== t ? (t1 = t("document-inspector.search.placeholder"), $[2] = t, $[3] = t1) : t1 = $[3];
  const t2 = query || "";
  let t3;
  return $[4] !== handleChange || $[5] !== t1 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(TextInput, { icon: SearchIcon, onChange: handleChange, placeholder: t1, radius: 2, value: t2 }), $[4] = handleChange, $[5] = t1, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}
function InspectDialog(props) {
  const $ = c(49), {
    value
  } = props, {
    onInspectClose,
    paneKey
  } = useDocumentPane(), dialogIdPrefix = `${paneKey}_inspect_`, [viewModeId, onViewModeChange] = useStructureToolSetting("inspect-view-mode", null, "parsed");
  let t0;
  $[0] !== viewModeId ? (t0 = VIEW_MODES.find((mode) => mode.id === viewModeId), $[0] = viewModeId, $[1] = t0) : t0 = $[1];
  const viewMode = t0;
  let t1;
  $[2] !== onViewModeChange ? (t1 = async () => {
    await onViewModeChange(VIEW_MODE_PARSED.id);
  }, $[2] = onViewModeChange, $[3] = t1) : t1 = $[3];
  const setParsedViewMode = t1;
  let t2;
  $[4] !== onViewModeChange ? (t2 = async () => {
    await onViewModeChange(VIEW_MODE_RAW.id);
  }, $[4] = onViewModeChange, $[5] = t2) : t2 = $[5];
  const setRawViewMode = t2, {
    t
  } = useTranslation(structureLocaleNamespace), t3 = `${dialogIdPrefix}dialog`;
  let t4;
  $[6] !== t || $[7] !== value ? (t4 = isDocumentLike(value) ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "document-inspector.dialog.title", components: {
    DocumentTitle: () => /* @__PURE__ */ jsx("em", { children: /* @__PURE__ */ jsx(DocTitle, { document: value }) })
  } }) : /* @__PURE__ */ jsx("em", { children: t("document-inspector.dialog.title-no-value") }), $[6] = t, $[7] = value, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    position: "sticky",
    bottom: 0,
    zIndex: 3
  }, $[9] = t5) : t5 = $[9];
  const t6 = `${dialogIdPrefix}tabpanel`, t7 = `${dialogIdPrefix}tab-${VIEW_MODE_PARSED.id}`;
  let t8;
  $[10] !== t ? (t8 = t(VIEW_MODE_PARSED.title), $[10] = t, $[11] = t8) : t8 = $[11];
  const t9 = viewMode === VIEW_MODE_PARSED;
  let t10;
  $[12] !== setParsedViewMode || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9 ? (t10 = /* @__PURE__ */ jsx(Tab, { "aria-controls": t6, id: t7, label: t8, onClick: setParsedViewMode, selected: t9 }), $[12] = setParsedViewMode, $[13] = t6, $[14] = t7, $[15] = t8, $[16] = t9, $[17] = t10) : t10 = $[17];
  const t11 = `${dialogIdPrefix}tabpanel`, t12 = `${dialogIdPrefix}tab-${VIEW_MODE_RAW.id}`;
  let t13;
  $[18] !== t ? (t13 = t(VIEW_MODE_RAW.title), $[18] = t, $[19] = t13) : t13 = $[19];
  const t14 = viewMode === VIEW_MODE_RAW;
  let t15;
  $[20] !== setRawViewMode || $[21] !== t11 || $[22] !== t12 || $[23] !== t13 || $[24] !== t14 ? (t15 = /* @__PURE__ */ jsx(Tab, { "aria-controls": t11, id: t12, label: t13, onClick: setRawViewMode, selected: t14 }), $[20] = setRawViewMode, $[21] = t11, $[22] = t12, $[23] = t13, $[24] = t14, $[25] = t15) : t15 = $[25];
  let t16;
  $[26] !== t10 || $[27] !== t15 ? (t16 = /* @__PURE__ */ jsx(Card, { padding: 3, paddingTop: 0, shadow: 1, style: t5, children: /* @__PURE__ */ jsxs(TabList, { space: 1, children: [
    t10,
    t15
  ] }) }), $[26] = t10, $[27] = t15, $[28] = t16) : t16 = $[28];
  const t17 = `${dialogIdPrefix}tab-${viewModeId}`, t18 = `${dialogIdPrefix}tabpanel`;
  let t19;
  $[29] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = {
    outline: "none"
  }, $[29] = t19) : t19 = $[29];
  let t20;
  $[30] !== value || $[31] !== viewMode ? (t20 = viewMode === VIEW_MODE_PARSED && /* @__PURE__ */ jsx(JSONInspectorWrapper, { children: /* @__PURE__ */ jsx(JsonInspector, { data: value, isExpanded, onClick: toggleExpanded, search: Search, filterOptions: {
    ignoreCase: !0
  } }) }), $[30] = value, $[31] = viewMode, $[32] = t20) : t20 = $[32];
  let t21;
  $[33] !== value || $[34] !== viewMode ? (t21 = viewMode === VIEW_MODE_RAW && /* @__PURE__ */ jsx(Code, { language: "json", tabIndex: 0, onKeyDown: maybeSelectAll, onDoubleClick: select, size: 1, children: JSON.stringify(value, null, 2) }), $[33] = value, $[34] = viewMode, $[35] = t21) : t21 = $[35];
  let t22;
  $[36] !== t17 || $[37] !== t18 || $[38] !== t20 || $[39] !== t21 ? (t22 = /* @__PURE__ */ jsxs(TabPanel, { "aria-labelledby": t17, flex: 1, id: t18, overflow: "auto", padding: 4, style: t19, children: [
    t20,
    t21
  ] }), $[36] = t17, $[37] = t18, $[38] = t20, $[39] = t21, $[40] = t22) : t22 = $[40];
  let t23;
  $[41] !== t16 || $[42] !== t22 ? (t23 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", children: [
    t16,
    t22
  ] }), $[41] = t16, $[42] = t22, $[43] = t23) : t23 = $[43];
  let t24;
  return $[44] !== onInspectClose || $[45] !== t23 || $[46] !== t3 || $[47] !== t4 ? (t24 = /* @__PURE__ */ jsx(Dialog, { bodyHeight: "fill", id: t3, header: t4, onClose: onInspectClose, onClickOutside: onInspectClose, padding: !1, width: 2, children: t23 }), $[44] = onInspectClose, $[45] = t23, $[46] = t3, $[47] = t4, $[48] = t24) : t24 = $[48], t24;
}
function Banner(props) {
  const $ = c(22);
  let Icon, action, content, rest, t0, t1;
  $[0] !== props ? ({
    action,
    content,
    icon: Icon,
    tone: t0,
    paddingY: t1,
    ...rest
  } = props, $[0] = props, $[1] = Icon, $[2] = action, $[3] = content, $[4] = rest, $[5] = t0, $[6] = t1) : (Icon = $[1], action = $[2], content = $[3], rest = $[4], t0 = $[5], t1 = $[6]);
  const tone = t0 === void 0 ? "transparent" : t0, paddingY = t1 === void 0 ? 2 : t1;
  let t2;
  $[7] !== Icon ? (t2 = Icon && /* @__PURE__ */ jsx(Text, { size: 0, children: /* @__PURE__ */ jsx(Icon, {}) }), $[7] = Icon, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== content ? (t3 = /* @__PURE__ */ jsx(Flex, { align: "center", flex: 1, gap: 2, paddingY: 2, children: content }), $[9] = content, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== action ? (t4 = action && /* @__PURE__ */ jsx(Button$1, { ...action, mode: action.mode || "ghost", tone: action.tone || "default" }), $[11] = action, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== t2 || $[14] !== t3 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, paddingX: 2, children: [
    t2,
    t3,
    t4
  ] }), $[13] = t2, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== paddingY || $[18] !== rest || $[19] !== t5 || $[20] !== tone ? (t6 = /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(Card, { radius: 3, paddingX: 2, paddingY, tone, ...rest, children: t5 }) }), $[17] = paddingY, $[18] = rest, $[19] = t5, $[20] = tone, $[21] = t6) : t6 = $[21], t6;
}
function DeletedDocumentBanners() {
  const $ = c(3), {
    isDeleted,
    isDeleting,
    ready
  } = useDocumentPane(), {
    selectedPerspective
  } = usePerspective();
  if (!ready)
    return null;
  if (!isPublishedPerspective(selectedPerspective) && !isDraftPerspective(selectedPerspective) && isReleaseDocument(selectedPerspective) && selectedPerspective.state === "archived") {
    let t0;
    return $[0] !== selectedPerspective ? (t0 = /* @__PURE__ */ jsx(ArchivedReleaseBanner, { release: selectedPerspective }), $[0] = selectedPerspective, $[1] = t0) : t0 = $[1], t0;
  }
  if (isDeleted && !isDeleting) {
    let t0;
    return $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(DeletedDocumentBanner, {}), $[2] = t0) : t0 = $[2], t0;
  }
}
function DeletedDocumentBanner() {
  const $ = c(17), {
    documentId,
    documentType
  } = useDocumentPane(), {
    restore
  } = useDocumentOperation(documentId, documentType), {
    navigateIntent
  } = useRouter();
  let t0;
  $[0] !== documentId || $[1] !== documentType || $[2] !== navigateIntent || $[3] !== restore ? (t0 = () => {
    restore.execute("lastRevision"), navigateIntent("edit", {
      id: documentId,
      type: documentType
    });
  }, $[0] = documentId, $[1] = documentType, $[2] = navigateIntent, $[3] = restore, $[4] = t0) : t0 = $[4];
  const handleRestore = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[5] !== t ? (t1 = t("banners.deleted-document-banner.restore-button.text"), $[5] = t, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== handleRestore || $[8] !== t1 ? (t2 = {
    onClick: handleRestore,
    text: t1
  }, $[7] = handleRestore, $[8] = t1, $[9] = t2) : t2 = $[9];
  let t3;
  $[10] !== t ? (t3 = t("banners.deleted-document-banner.text"), $[10] = t, $[11] = t3) : t3 = $[11];
  let t4;
  $[12] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t3 }), $[12] = t3, $[13] = t4) : t4 = $[13];
  let t5;
  return $[14] !== t2 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(Banner, { action: t2, content: t4, "data-testid": "deleted-document-banner", icon: ReadOnlyIcon }), $[14] = t2, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
}
const ArchivedReleaseBanner = (t0) => {
  const $ = c(8), {
    release
  } = t0, {
    t
  } = useTranslation();
  let t1;
  $[0] !== release.metadata?.title || $[1] !== t ? (t1 = release.metadata?.title || t("release.placeholder-untitled-release"), $[0] = release.metadata?.title, $[1] = t, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t1 ? (t2 = {
    title: t1
  }, $[3] = t1, $[4] = t2) : t2 = $[4];
  let t3;
  return $[5] !== t || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Banner, { tone: "caution", content: /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.deleted-release-banner.text", values: t2 }) }), "data-testid": "deleted-release-banner", icon: DocumentRemoveIcon }), $[5] = t, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
};
function DeprecatedDocumentTypeBanner() {
  const $ = c(5), {
    schemaType
  } = useDocumentPaneInfo(), {
    t
  } = useTranslation(structureLocaleNamespace);
  if (!isDeprecatedSchemaType(schemaType))
    return null;
  let t0;
  $[0] !== t ? (t0 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.deprecated-document-type-banner.text" }), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== schemaType.deprecated.reason || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Banner, { content: /* @__PURE__ */ jsxs(Text, { size: 1, weight: "medium", children: [
    t0,
    " ",
    schemaType.deprecated.reason
  ] }), "data-testid": "deprecated-document-type-banner", icon: ErrorOutlineIcon }), $[2] = schemaType.deprecated.reason, $[3] = t0, $[4] = t1) : t1 = $[4], t1;
}
const AskToEditDialogOpened = defineEvent({
  name: "Ask To Edit Dialog Opened",
  version: 1,
  description: 'User clicked the "Ask to edit" button in the document permissions banner'
}), AskToEditRequestSent = defineEvent({
  name: "Ask To Edit Request Sent",
  version: 1,
  description: "User sent a role change request from the dialog"
}), MAX_NOTE_LENGTH = 150, DialogBody$1 = styled(Box).withConfig({
  displayName: "DialogBody",
  componentId: "sc-68p9pn-0"
})`box-sizing:border-box;`;
styled(Flex).attrs({
  align: "center",
  direction: "column",
  justify: "center"
}).withConfig({
  displayName: "LoadingContainer",
  componentId: "sc-68p9pn-1"
})`height:110px;`;
function RequestPermissionDialog(t0) {
  const $ = c(56), {
    onClose,
    onRequestSubmitted
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), telemtry = useTelemetry(), dialogId = `request-permissions-${useId()}`, projectId = useProjectId();
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    apiVersion: "2024-09-26"
  }, $[0] = t1) : t1 = $[0];
  const client = useClient(t1), toast = useToast(), zOffset = useZIndex(), [isSubmitting, setIsSubmitting] = useState(!1), [note, setNote] = useState(""), [msgError, setMsgError] = useState(), [hasTooManyRequests, setHasTooManyRequests] = useState(!1), [hasBeenDenied, setHasBeenDenied] = useState(!1);
  let t2;
  bb0: {
    const adminRole = "administrator";
    if (!projectId || !client) {
      let t33;
      $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t33 = of(adminRole), $[1] = t33) : t33 = $[1], t2 = t33;
      break bb0;
    }
    let t32;
    if ($[2] !== client.observable || $[3] !== projectId) {
      let t42;
      $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = (roles) => roles.filter(_temp$D).find(_temp2$h) ? "editor" : adminRole, $[5] = t42) : t42 = $[5];
      let t52;
      $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t52 = () => of(adminRole), $[6] = t52) : t52 = $[6], t32 = client.observable.request({
        url: `/projects/${projectId}/roles`
      }).pipe(map(t42), startWith(adminRole), catchError(t52)), $[2] = client.observable, $[3] = projectId, $[4] = t32;
    } else
      t32 = $[4];
    t2 = t32;
  }
  const requestedRole = useObservable(t2);
  let t3;
  $[7] !== client || $[8] !== note || $[9] !== onRequestSubmitted || $[10] !== projectId || $[11] !== requestedRole || $[12] !== telemtry || $[13] !== toast ? (t3 = () => {
    setIsSubmitting(!0), client.request({
      url: `/access/project/${projectId}/requests`,
      method: "post",
      body: {
        note,
        requestUrl: window?.location.href,
        requestedRole,
        type: "role"
      }
    }).then((request) => {
      request && (onRequestSubmitted && onRequestSubmitted(), telemtry.log(AskToEditRequestSent), toast.push({
        title: "Edit access requested"
      }));
    }).catch((err) => {
      const statusCode = err?.response?.statusCode, errMessage = err?.response?.body?.message;
      statusCode === 429 && (setHasTooManyRequests(!0), setMsgError(errMessage)), statusCode === 409 ? (setHasBeenDenied(!0), setMsgError(errMessage)) : toast.push({
        title: "There was a problem submitting your request.",
        status: "error"
      });
    }).finally(() => {
      setIsSubmitting(!1);
    });
  }, $[7] = client, $[8] = note, $[9] = onRequestSubmitted, $[10] = projectId, $[11] = requestedRole, $[12] = telemtry, $[13] = toast, $[14] = t3) : t3 = $[14];
  const onSubmit = t3, t4 = zOffset.fullscreen;
  let t5;
  $[15] !== t ? (t5 = t("request-permission-dialog.header.text"), $[15] = t, $[16] = t5) : t5 = $[16];
  let t6;
  $[17] !== t ? (t6 = t("confirm-dialog.cancel-button.fallback-text"), $[17] = t, $[18] = t6) : t6 = $[18];
  let t7;
  $[19] !== onClose || $[20] !== t6 ? (t7 = {
    onClick: onClose,
    text: t6
  }, $[19] = onClose, $[20] = t6, $[21] = t7) : t7 = $[21];
  const t8 = hasTooManyRequests || hasBeenDenied;
  let t9;
  $[22] !== t ? (t9 = t("request-permission-dialog.confirm-button.text"), $[22] = t, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== isSubmitting || $[25] !== onSubmit || $[26] !== t8 || $[27] !== t9 ? (t10 = {
    onClick: onSubmit,
    loading: isSubmitting,
    disabled: t8,
    text: t9,
    tone: "primary",
    type: "submit"
  }, $[24] = isSubmitting, $[25] = onSubmit, $[26] = t8, $[27] = t9, $[28] = t10) : t10 = $[28];
  let t11;
  $[29] !== t10 || $[30] !== t7 ? (t11 = {
    cancelButton: t7,
    confirmButton: t10
  }, $[29] = t10, $[30] = t7, $[31] = t11) : t11 = $[31];
  let t12;
  $[32] !== t ? (t12 = t("request-permission-dialog.description.text"), $[32] = t, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] !== t12 ? (t13 = /* @__PURE__ */ jsx(Text, { children: t12 }), $[34] = t12, $[35] = t13) : t13 = $[35];
  let t14;
  $[36] !== hasBeenDenied || $[37] !== hasTooManyRequests || $[38] !== isSubmitting || $[39] !== msgError || $[40] !== note || $[41] !== onSubmit || $[42] !== t ? (t14 = hasTooManyRequests || hasBeenDenied ? /* @__PURE__ */ jsx(Card, { tone: "caution", padding: 3, radius: 2, shadow: 1, children: /* @__PURE__ */ jsxs(Text, { size: 1, children: [
    hasTooManyRequests && /* @__PURE__ */ jsx(Fragment, { children: msgError ?? t("request-permission-dialog.warning.limit-reached.text") }),
    hasBeenDenied && /* @__PURE__ */ jsx(Fragment, { children: msgError ?? t("request-permission-dialog.warning.denied.text") })
  ] }) }) : /* @__PURE__ */ jsxs(Stack, { space: 3, paddingBottom: 0, children: [
    /* @__PURE__ */ jsx(TextInput, { placeholder: t("request-permission-dialog.note-input.placeholder.text"), disabled: isSubmitting, onKeyDown: (e) => {
      e.key === "Enter" && onSubmit();
    }, maxLength: MAX_NOTE_LENGTH, value: note, onChange: (e_0) => {
      setNote(e_0.currentTarget.value);
    } }),
    /* @__PURE__ */ jsx(Text, { align: "right", muted: !0, size: 1, children: `${note.length}/${MAX_NOTE_LENGTH}` })
  ] }), $[36] = hasBeenDenied, $[37] = hasTooManyRequests, $[38] = isSubmitting, $[39] = msgError, $[40] = note, $[41] = onSubmit, $[42] = t, $[43] = t14) : t14 = $[43];
  let t15;
  $[44] !== t13 || $[45] !== t14 ? (t15 = /* @__PURE__ */ jsx(DialogBody$1, { children: /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t13,
    t14
  ] }) }), $[44] = t13, $[45] = t14, $[46] = t15) : t15 = $[46];
  let t16;
  $[47] !== dialogId || $[48] !== onClose || $[49] !== t11 || $[50] !== t15 || $[51] !== t5 ? (t16 = /* @__PURE__ */ jsx(Dialog, { width: 1, id: dialogId, header: t5, footer: t11, onClose, onClickOutside: onClose, children: t15 }), $[47] = dialogId, $[48] = onClose, $[49] = t11, $[50] = t15, $[51] = t5, $[52] = t16) : t16 = $[52];
  let t17;
  return $[53] !== t16 || $[54] !== zOffset.fullscreen ? (t17 = /* @__PURE__ */ jsx(DialogProvider, { position: "fixed", zOffset: t4, children: t16 }), $[53] = t16, $[54] = zOffset.fullscreen, $[55] = t17) : t17 = $[55], t17;
}
function _temp2$h(role_0) {
  return role_0.name === "editor";
}
function _temp$D(role) {
  return role?.appliesToUsers;
}
const LOADING_STATE = {
  loading: !0,
  error: !1,
  status: void 0
}, EMPTY_STATE = {
  loading: !1,
  error: !1,
  status: "none"
}, DECLINED_STATE = {
  loading: !1,
  error: !1,
  status: "declined"
}, PENDING_STATE = {
  loading: !1,
  error: !1,
  status: "pending"
}, EXPIRED_STATE = {
  loading: !1,
  error: !1,
  status: "expired"
}, useRoleRequestsStatus = () => {
  const $ = c(9);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    apiVersion: "2024-07-01"
  }, $[0] = t0) : t0 = $[0];
  const client = useClient(t0), projectId = useProjectId();
  let t1;
  bb0: {
    if (!client || !projectId) {
      let t23;
      $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = of(EMPTY_STATE), $[1] = t23) : t23 = $[1], t1 = t23;
      break bb0;
    }
    let t22;
    $[2] !== client || $[3] !== projectId ? (t22 = checkRoleRequests(client, projectId), $[2] = client, $[3] = projectId, $[4] = t22) : t22 = $[4], t1 = t22;
  }
  const checkRoleRequests$ = t1, {
    loading,
    error,
    status
  } = useObservable(checkRoleRequests$, LOADING_STATE);
  let t2;
  return $[5] !== error || $[6] !== loading || $[7] !== status ? (t2 = {
    data: status,
    loading,
    error
  }, $[5] = error, $[6] = loading, $[7] = status, $[8] = t2) : t2 = $[8], t2;
};
function checkRoleRequests(client, projectId) {
  return client.observable.request({
    url: "/access/requests/me",
    tag: "use-role-requests-status"
  }).pipe(
    map$1((requests) => {
      if (!requests || requests.length === 0)
        return EMPTY_STATE;
      const projectRequests = requests.filter((request) => request.resourceId === projectId && request.type === "role"), declinedRequest = projectRequests.find((request) => request.status === "declined");
      return declinedRequest && isAfter(addWeeks(new Date(declinedRequest.createdAt), 2), /* @__PURE__ */ new Date()) ? DECLINED_STATE : projectRequests.find((request) => request.status === "pending" && isAfter(addWeeks(new Date(request.createdAt), 2), /* @__PURE__ */ new Date())) ? PENDING_STATE : projectRequests.find((request) => request.status === "pending" && isBefore(addWeeks(new Date(request.createdAt), 2), /* @__PURE__ */ new Date())) ? EXPIRED_STATE : EMPTY_STATE;
    }),
    catchError$1((err) => (console.error("Failed to fetch access requests", err), of({
      loading: !1,
      error: !0,
      status: void 0
    }))),
    startWith$1(LOADING_STATE)
    // Start with loading state
  );
}
function InsufficientPermissionBanner(t0) {
  const $ = c(30), {
    requiredPermission
  } = t0, currentUser = useCurrentUser(), workspace = useWorkspace(), {
    documentId,
    schemaType
  } = useDocumentPane();
  let t1;
  $[0] !== documentId || $[1] !== schemaType.name || $[2] !== workspace.document.askToEdit ? (t1 = workspace.document.askToEdit.enabled({
    documentId,
    documentType: schemaType.name
  }), $[0] = documentId, $[1] = schemaType.name, $[2] = workspace.document.askToEdit, $[3] = t1) : t1 = $[3];
  const askToEditEnabled = t1, {
    data: roleRequestStatus,
    loading: requestStatusLoading,
    error: requestStatusError
  } = useRoleRequestsStatus(), [requestSent, setRequestSent] = useState(!1), requestPending = roleRequestStatus === "pending" || roleRequestStatus === "declined" || requestSent, currentUserRoles = currentUser?.roles || [], isOnlyViewer = currentUserRoles.length === 1 && currentUserRoles[0].name === "viewer", [showRequestPermissionDialog, setShowRequestPermissionDialog] = useState(!1);
  let t2;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    style: "short"
  }, $[4] = t2) : t2 = $[4];
  const listFormat = useListFormat(t2), {
    t
  } = useTranslation(structureLocaleNamespace), telemetry = useTelemetry(), roleTitles = currentUserRoles.map(_temp$C), roles = listFormat.formatToParts(roleTitles).map(_temp2$g), showAskToEditAction = askToEditEnabled && isOnlyViewer && roleRequestStatus && !requestStatusError && !requestStatusLoading;
  let t3;
  $[5] !== roles ? (t3 = {
    Roles: () => /* @__PURE__ */ jsx(Fragment, { children: roles })
  }, $[5] = roles, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== roleTitles || $[8] !== roles.length ? (t4 = {
    count: roles.length,
    roles: roleTitles
  }, $[7] = roleTitles, $[8] = roles.length, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== requiredPermission || $[11] !== t || $[12] !== t3 || $[13] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.permission-check-banner.missing-permission", components: t3, values: t4, context: requiredPermission }) }), $[10] = requiredPermission, $[11] = t, $[12] = t3, $[13] = t4, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== requestPending || $[16] !== setShowRequestPermissionDialog || $[17] !== showAskToEditAction || $[18] !== t || $[19] !== telemetry ? (t6 = showAskToEditAction ? {
    onClick: requestPending ? void 0 : () => {
      setShowRequestPermissionDialog(!0), telemetry.log(AskToEditDialogOpened);
    },
    text: t(requestPending ? "banners.permission-check-banner.request-permission-button.sent" : "banners.permission-check-banner.request-permission-button.text"),
    tone: requestPending ? "default" : "primary",
    disabled: requestPending,
    mode: requestPending ? "bleed" : void 0
  } : void 0, $[15] = requestPending, $[16] = setShowRequestPermissionDialog, $[17] = showAskToEditAction, $[18] = t, $[19] = telemetry, $[20] = t6) : t6 = $[20];
  let t7;
  $[21] !== t5 || $[22] !== t6 ? (t7 = /* @__PURE__ */ jsx(Banner, { content: t5, action: t6, "data-testid": "permission-check-banner", icon: ReadOnlyIcon }), $[21] = t5, $[22] = t6, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] !== setShowRequestPermissionDialog || $[25] !== showRequestPermissionDialog ? (t8 = showRequestPermissionDialog && /* @__PURE__ */ jsx(RequestPermissionDialog, { onClose: () => setShowRequestPermissionDialog(!1), onRequestSubmitted: () => {
    setRequestSent(!0), setShowRequestPermissionDialog(!1);
  } }), $[24] = setShowRequestPermissionDialog, $[25] = showRequestPermissionDialog, $[26] = t8) : t8 = $[26];
  let t9;
  return $[27] !== t7 || $[28] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t7,
    t8
  ] }), $[27] = t7, $[28] = t8, $[29] = t9) : t9 = $[29], t9;
}
function _temp2$g(part) {
  return part.type === "element" ? /* @__PURE__ */ jsx("code", { children: part.value }, part.value) : part.value;
}
function _temp$C(role) {
  return role.title;
}
const ReferenceChangedBanner = memo(() => {
  const $ = c(32), documentPreviewStore = useDocumentPreviewStore(), {
    selectedPerspectiveName
  } = usePerspective(), {
    params,
    groupIndex,
    routerPanesState,
    replaceCurrent,
    BackLink: BackLink2
  } = usePaneRouter(), routerReferenceId = routerPanesState[groupIndex]?.[0].id, parentSibling = routerPanesState[groupIndex - 1]?.[0], parentId = parentSibling?.id, hasHistoryOpen = !!parentSibling?.params?.rev;
  let t0;
  $[0] !== params ? (t0 = params?.parentRefPath && fromString(params.parentRefPath) || null, $[0] = params, $[1] = t0) : t0 = $[1];
  const parentRefPath = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  bb0: {
    const parentRefPathSegment = parentRefPath?.[0];
    if (!parentId || !parentRefPathSegment || !parentRefPath) {
      let t23;
      $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t23 = of({
        loading: !1
      }), $[2] = t23) : t23 = $[2], t1 = t23;
      break bb0;
    }
    let t22;
    if ($[3] !== documentPreviewStore || $[4] !== parentId || $[5] !== parentRefPath || $[6] !== parentRefPathSegment || $[7] !== selectedPerspectiveName) {
      const publishedId = getPublishedId(parentId), path = fromString(parentRefPathSegment), keyedSegmentIndex = path.findIndex(_temp$B);
      let t32;
      $[9] !== selectedPerspectiveName ? (t32 = isSystemBundle(selectedPerspectiveName) ? void 0 : selectedPerspectiveName, $[9] = selectedPerspectiveName, $[10] = t32) : t32 = $[10];
      let t42;
      $[11] !== parentRefPath ? (t42 = (t52) => {
        const {
          draft,
          published,
          version
        } = t52;
        return {
          loading: !1,
          result: {
            availability: {
              draft: draft.availability,
              published: published.availability,
              ...version?.availability ? {
                version: version.availability
              } : {}
            },
            refValue: get(version?.snapshot || draft.snapshot || published.snapshot, parentRefPath)?._ref
          }
        };
      }, $[11] = parentRefPath, $[12] = t42) : t42 = $[12], t22 = concat(of({
        loading: !0
      }), documentPreviewStore.unstable_observePathsDocumentPair(publishedId, keyedSegmentIndex === -1 ? path : path.slice(0, keyedSegmentIndex), {
        version: t32
      }).pipe(debounceTime(750), map$1(t42))), $[3] = documentPreviewStore, $[4] = parentId, $[5] = parentRefPath, $[6] = parentRefPathSegment, $[7] = selectedPerspectiveName, $[8] = t22;
    } else
      t22 = $[8];
    t1 = t22;
  }
  const referenceInfoObservable = t1;
  let t2;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    loading: !0
  }, $[13] = t2) : t2 = $[13];
  const referenceInfo = useObservable(referenceInfoObservable, t2);
  let t3;
  $[14] !== params || $[15] !== referenceInfo.loading || $[16] !== referenceInfo.result || $[17] !== replaceCurrent ? (t3 = () => {
    referenceInfo.loading || referenceInfo.result?.refValue && replaceCurrent({
      id: referenceInfo.result.refValue,
      params
    });
  }, $[14] = params, $[15] = referenceInfo.loading, $[16] = referenceInfo.result, $[17] = replaceCurrent, $[18] = t3) : t3 = $[18];
  const handleReloadReference = t3;
  if (!parentId || !parentRefPath || hasHistoryOpen || referenceInfo.loading || !referenceInfo.result?.availability.draft.available && !referenceInfo.result?.availability.published.available || referenceInfo.result?.refValue === routerReferenceId)
    return null;
  let t4;
  $[19] !== BackLink2 || $[20] !== handleReloadReference || $[21] !== referenceInfo.result?.refValue || $[22] !== t ? (t4 = referenceInfo.result?.refValue ? {
    onClick: handleReloadReference,
    icon: SyncIcon,
    text: t("banners.reference-changed-banner.reason-changed.reload-button.text")
  } : {
    as: BackLink2,
    icon: CloseIcon,
    text: t("banners.reference-changed-banner.reason-removed.close-button.text")
  }, $[19] = BackLink2, $[20] = handleReloadReference, $[21] = referenceInfo.result?.refValue, $[22] = t, $[23] = t4) : t4 = $[23];
  let t5;
  $[24] !== referenceInfo.result?.refValue || $[25] !== t ? (t5 = referenceInfo.result?.refValue ? t("banners.reference-changed-banner.reason-changed.text") : t("banners.reference-changed-banner.reason-removed.text"), $[24] = referenceInfo.result?.refValue, $[25] = t, $[26] = t5) : t5 = $[26];
  let t6;
  $[27] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t5 }), $[27] = t5, $[28] = t6) : t6 = $[28];
  let t7;
  return $[29] !== t4 || $[30] !== t6 ? (t7 = /* @__PURE__ */ jsx(Banner, { action: t4, "data-testid": "reference-changed-banner", content: t6, icon: WarningOutlineIcon, tone: "caution" }), $[29] = t4, $[30] = t6, $[31] = t7) : t7 = $[31], t7;
});
ReferenceChangedBanner.displayName = "Memo(ReferenceChangedBanner)";
function _temp$B(p) {
  return typeof p == "object" && "_key" in p;
}
function ScheduledDraftOverrideBanner(t0) {
  const $ = c(2), {
    releaseId,
    draftDocument
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), {
    firstDocument: scheduledDraftDocument
  } = useScheduledDraftDocument(releaseId), draftPublishedId = draftDocument?._id ? getPublishedId(draftDocument._id) : null, scheduledPublishedId = scheduledDraftDocument?._id ? getPublishedId(scheduledDraftDocument._id) : null, draftRev = draftDocument?._rev, scheduledBaseRev = scheduledDraftDocument?._system?.base?.rev;
  if (draftPublishedId !== scheduledPublishedId || !(!draftRev || !scheduledBaseRev || draftRev !== scheduledBaseRev))
    return null;
  let t1;
  return $[0] !== t ? (t1 = /* @__PURE__ */ jsx(Banner, { tone: "caution", icon: WarningOutlineIcon, content: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.scheduled-draft-override-banner.text" }) }) }), $[0] = t, $[1] = t1) : t1 = $[1], t1;
}
function usePaneRouter() {
  return useContext(PaneRouterContext);
}
function ArchivedReleaseDocumentBanner(t0) {
  const $ = c(26);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const {
    releaseId
  } = t1, {
    t
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    data: archivedReleases
  } = useArchivedReleases(), {
    params,
    setParams
  } = usePaneRouter(), effectiveReleaseId = releaseId ?? params?.historyVersion;
  let t2;
  $[2] !== params || $[3] !== setParams ? (t2 = () => {
    setParams({
      ...params,
      rev: params?.historyEvent || void 0,
      since: void 0,
      historyVersion: void 0,
      scheduledDraft: void 0
    });
  }, $[2] = params, $[3] = setParams, $[4] = t2) : t2 = $[4];
  const handleGoBack = t2;
  let t3;
  if ($[5] !== archivedReleases || $[6] !== effectiveReleaseId) {
    let t42;
    $[8] !== effectiveReleaseId ? (t42 = (r) => getReleaseIdFromReleaseDocumentId(r._id) === effectiveReleaseId, $[8] = effectiveReleaseId, $[9] = t42) : t42 = $[9], t3 = archivedReleases.find(t42), $[5] = archivedReleases, $[6] = effectiveReleaseId, $[7] = t3;
  } else
    t3 = $[7];
  const release = t3;
  let t4;
  bb0: {
    if (release?.state === "published") {
      t4 = "banners.published-release.description";
      break bb0;
    }
    if (release && isCardinalityOneRelease(release)) {
      t4 = "banners.archived-scheduled-draft.description";
      break bb0;
    }
    t4 = "banners.archived-release.description";
  }
  const description = t4, t5 = release?.metadata.title;
  let t6;
  $[10] !== tCore ? (t6 = tCore("release.placeholder-untitled-release"), $[10] = tCore, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== description || $[13] !== release || $[14] !== t ? (t7 = (t82) => {
    const {
      displayTitle
    } = t82;
    return /* @__PURE__ */ jsx(Translate, { t, i18nKey: description, values: {
      title: displayTitle
    }, components: {
      VersionBadge: (t92) => {
        const {
          children
        } = t92, BadgeWithTone = getVersionInlineBadge(release);
        return /* @__PURE__ */ jsx(BadgeWithTone, { children });
      }
    } });
  }, $[12] = description, $[13] = release, $[14] = t, $[15] = t7) : t7 = $[15];
  let t8;
  $[16] !== t5 || $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(ReleaseTitle, { title: t5, fallback: t6, children: t7 }) }), $[16] = t5, $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== handleGoBack || $[21] !== params?.archivedRelease ? (t9 = params?.archivedRelease ? void 0 : {
    text: "Go back to published version",
    onClick: handleGoBack
  }, $[20] = handleGoBack, $[21] = params?.archivedRelease, $[22] = t9) : t9 = $[22];
  let t10;
  return $[23] !== t8 || $[24] !== t9 ? (t10 = /* @__PURE__ */ jsx(Banner, { tone: "caution", content: t8, action: t9 }), $[23] = t8, $[24] = t9, $[25] = t10) : t10 = $[25], t10;
}
const Image = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-9vwcvu-0"
})`object-fit:cover;width:100%;height:100%;height:180px;display:flex;`, CANVAS_IMAGE_URL = "https://cdn.sanity.io/images/pyrmmpch/production/b47224e2f3a7d1747e43b9da1ac31739250e628b-632x376.png", CANVAS_APP_NAME = "Canvas", CanvasPopoverContent = (t0) => {
  const $ = c(24), {
    onClose,
    isLockedByCanvas
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), ref = useRef(null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => [ref.current], $[0] = t1) : t1 = $[0], useClickOutsideEvent(onClose, t1);
  let t2;
  $[1] !== isLockedByCanvas || $[2] !== t ? (t2 = t(isLockedByCanvas ? "canvas.banner.popover-heading" : "canvas.banner.editable.popover-heading"), $[1] = isLockedByCanvas, $[2] = t, $[3] = t2) : t2 = $[3];
  const popoverHeading = t2;
  let t3;
  $[4] !== isLockedByCanvas || $[5] !== t ? (t3 = t(isLockedByCanvas ? "canvas.banner.popover-description" : "canvas.banner.editable.popover-description"), $[4] = isLockedByCanvas, $[5] = t, $[6] = t3) : t3 = $[6];
  const popoverDescription = t3;
  let t4;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Image, { src: CANVAS_IMAGE_URL, alt: "Canvas" }), $[7] = t4) : t4 = $[7];
  let t5;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "semibold", children: CANVAS_APP_NAME }), $[8] = t5) : t5 = $[8];
  let t6;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsxs(Flex, { paddingY: 1, gap: 2, children: [
    t5,
    /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(ComposeSparklesIcon, {}) })
  ] }), $[9] = t6) : t6 = $[9];
  let t7;
  $[10] !== popoverHeading ? (t7 = /* @__PURE__ */ jsx(Box, { paddingTop: 3, children: /* @__PURE__ */ jsx(Heading, { size: 1, children: popoverHeading }) }), $[10] = popoverHeading, $[11] = t7) : t7 = $[11];
  let t8;
  $[12] !== popoverDescription ? (t8 = /* @__PURE__ */ jsx(Box, { paddingTop: 4, children: /* @__PURE__ */ jsx(Text, { size: 1, children: popoverDescription }) }), $[12] = popoverDescription, $[13] = t8) : t8 = $[13];
  let t9;
  $[14] !== t7 || $[15] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { paddingX: 4, paddingBottom: 4, paddingTop: 3, direction: "column", children: [
    t6,
    t7,
    t8
  ] }), $[14] = t7, $[15] = t8, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== t ? (t10 = t("canvas.banner.popover-button-text"), $[17] = t, $[18] = t10) : t10 = $[18];
  let t11;
  $[19] !== t10 ? (t11 = /* @__PURE__ */ jsx(Flex, { width: "full", gap: 3, justify: "flex-end", paddingX: 4, paddingBottom: 4, children: /* @__PURE__ */ jsx(Button$1, { mode: "bleed", text: t10, autoFocus: !0, tone: "primary", href: "https://snty.link/canvas-docs", target: "_blank", rel: "noopener noreferrer", as: "a", iconRight: LaunchIcon }) }), $[19] = t10, $[20] = t11) : t11 = $[20];
  let t12;
  return $[21] !== t11 || $[22] !== t9 ? (t12 = /* @__PURE__ */ jsx(Card, { radius: 3, overflow: "hidden", width: 0, ref, children: /* @__PURE__ */ jsxs(Container$1, { width: 0, children: [
    t4,
    t9,
    t11
  ] }) }), $[21] = t11, $[22] = t9, $[23] = t12) : t12 = $[23], t12;
}, CanvasLinkedBannerContent = (t0) => {
  const $ = c(21), {
    documentId
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), [open, setOpen] = useState(!1), documentVariantType = getDocumentVariantType(documentId), {
    isLockedByCanvas
  } = useCanvasCompanionDoc(documentId);
  let t1;
  bb0: {
    if (!isLockedByCanvas) {
      let t23;
      $[0] !== t ? (t23 = t("canvas.banner.editable.linked-text"), $[0] = t, $[1] = t23) : t23 = $[1], t1 = t23;
      break bb0;
    }
    if (documentVariantType === "published") {
      let t23;
      $[2] !== t ? (t23 = t("canvas.banner.linked-text.published"), $[2] = t, $[3] = t23) : t23 = $[3], t1 = t23;
      break bb0;
    }
    if (documentVariantType === "draft") {
      let t23;
      $[4] !== t ? (t23 = t("canvas.banner.linked-text.draft"), $[4] = t, $[5] = t23) : t23 = $[5], t1 = t23;
      break bb0;
    }
    let t22;
    $[6] !== t ? (t22 = t("canvas.banner.linked-text.version"), $[6] = t, $[7] = t22) : t22 = $[7], t1 = t22;
  }
  const variantText = t1;
  let t2;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => setOpen(_temp$A), $[8] = t2) : t2 = $[8];
  const togglePopover = t2;
  let t3;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setOpen(!1), $[9] = t3) : t3 = $[9];
  const onClose = t3;
  let t4;
  $[10] !== variantText ? (t4 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: variantText }), $[10] = variantText, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== isLockedByCanvas ? (t5 = /* @__PURE__ */ jsx(CanvasPopoverContent, { onClose, isLockedByCanvas }), $[12] = isLockedByCanvas, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = /* @__PURE__ */ jsx(Button$1, { tooltipProps: null, mode: "bleed", tone: "default", icon: InfoOutlineIcon, onClick: togglePopover }), $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== open || $[16] !== t5 ? (t7 = /* @__PURE__ */ jsx(Popover, { open, size: 0, tone: "default", portal: !0, placement: "bottom-start", content: t5, children: t6 }), $[15] = open, $[16] = t5, $[17] = t7) : t7 = $[17];
  let t8;
  return $[18] !== t4 || $[19] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t4,
    t7
  ] }), $[18] = t4, $[19] = t7, $[20] = t8) : t8 = $[20], t8;
};
function CanvasLinkedBanner() {
  const $ = c(10), {
    documentId,
    displayed
  } = useDocumentPane(), {
    t
  } = useTranslation(structureLocaleNamespace), id = displayed?._id || documentId, {
    companionDoc
  } = useCanvasCompanionDoc(id), navigateToCanvas = useNavigateToCanvasDoc(companionDoc?.canvasDocumentId, "banner");
  if (!companionDoc)
    return null;
  let t0;
  $[0] !== id ? (t0 = /* @__PURE__ */ jsx(CanvasLinkedBannerContent, { documentId: id }), $[0] = id, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("canvas.banner.edit-in-canvas-action"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== navigateToCanvas || $[5] !== t1 ? (t2 = {
    mode: "ghost",
    text: t1,
    onClick: navigateToCanvas
  }, $[4] = navigateToCanvas, $[5] = t1, $[6] = t2) : t2 = $[6];
  let t3;
  return $[7] !== t0 || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsx(Banner, { tone: "neutral", "data-test-id": "canvas-linked-banner", paddingY: 0, content: t0, action: t2 }), $[7] = t0, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}
function _temp$A(prev) {
  return !prev;
}
const ChooseNewDocumentDestinationBanner = (t0) => {
  const $ = c(32), {
    schemaType,
    selectedPerspective,
    reason
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    document: t1
  } = useWorkspace(), {
    drafts: t2
  } = t1, {
    enabled: isDraftModelEnabled
  } = t2;
  let t3;
  $[0] !== isDraftModelEnabled || $[1] !== schemaType ? (t3 = (t42) => {
    const {
      perspective
    } = t42;
    return {
      disabled: !isPerspectiveWriteable({
        selectedPerspective: perspective,
        isDraftModelEnabled,
        schemaType
      }).result
    };
  }, $[0] = isDraftModelEnabled, $[1] = schemaType, $[2] = t3) : t3 = $[2];
  const menuItemProps = t3, releaseDoc = isReleaseDocument(selectedPerspective) ? selectedPerspective : void 0;
  let t4;
  $[3] !== releaseDoc || $[4] !== tCore ? (t4 = releaseDoc ? releaseDoc.metadata.title || tCore("release.placeholder-untitled-release") : void 0, $[3] = releaseDoc, $[4] = tCore, $[5] = t4) : t4 = $[5];
  const releaseTitle = t4;
  let t5;
  $[6] !== reason || $[7] !== t ? (t5 = reason === "PUBLISHED_NOT_WRITEABLE" && t("banners.choose-new-document-destination.cannot-create-published-document"), $[6] = reason, $[7] = t, $[8] = t5) : t5 = $[8];
  let t6;
  $[9] !== reason || $[10] !== t ? (t6 = reason === "DRAFTS_NOT_WRITEABLE" && t("banners.choose-new-document-destination.cannot-create-draft-document"), $[9] = reason, $[10] = t, $[11] = t6) : t6 = $[11];
  let t7;
  $[12] !== reason || $[13] !== releaseDoc || $[14] !== releaseTitle || $[15] !== t || $[16] !== tCore ? (t7 = reason === "RELEASE_NOT_ACTIVE" && releaseDoc && releaseTitle && /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.choose-new-document-destination.release-inactive", values: {
    title: releaseTitle
  }, components: {
    VersionBadge: (t82) => {
      const {
        children
      } = t82, BadgeWithTone = getVersionInlineBadge(releaseDoc);
      return /* @__PURE__ */ jsx(ReleaseTitle, { title: releaseDoc.metadata.title, fallback: tCore("release.placeholder-untitled-release"), children: () => /* @__PURE__ */ jsx(BadgeWithTone, { children }) });
    }
  } }), $[12] = reason, $[13] = releaseDoc, $[14] = releaseTitle, $[15] = t, $[16] = tCore, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== t ? (t8 = t("banners.choose-new-document-destination.choose-destination"), $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Fragment, { children: [
    " ",
    t8
  ] }), $[20] = t8, $[21] = t9) : t9 = $[21];
  let t10;
  $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Text, { size: 1, children: [
    t5,
    t6,
    t7,
    t9
  ] }), $[22] = t5, $[23] = t6, $[24] = t7, $[25] = t9, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== menuItemProps ? (t11 = /* @__PURE__ */ jsx(ReleasesNav, { menuItemProps }), $[27] = menuItemProps, $[28] = t11) : t11 = $[28];
  let t12;
  return $[29] !== t10 || $[30] !== t11 ? (t12 = /* @__PURE__ */ jsx(Banner, { tone: "caution", icon: WarningOutlineIcon, content: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, children: [
    t10,
    t11
  ] }) }), $[29] = t10, $[30] = t11, $[31] = t12) : t12 = $[31], t12;
}, TOAST_DELAY = 1e3;
function DocumentNotInReleaseBanner(t0) {
  const $ = c(42), {
    documentId,
    currentRelease,
    isScheduledRelease
  } = t0, t1 = currentRelease ?? LATEST;
  let t2;
  $[0] !== t1 ? (t2 = getReleaseTone(t1), $[0] = t1, $[1] = t2) : t2 = $[1];
  const tone = t2, {
    t
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation(), {
    createVersion
  } = useVersionOperations(), isAnonymousBundle = typeof currentRelease == "string";
  let t3;
  $[2] !== currentRelease || $[3] !== isAnonymousBundle || $[4] !== tCore ? (t3 = isAnonymousBundle ? currentRelease : currentRelease?.metadata?.title || tCore("release.placeholder-untitled-release"), $[2] = currentRelease, $[3] = isAnonymousBundle, $[4] = tCore, $[5] = t3) : t3 = $[5];
  const releaseTitle = t3, [versionCreateState, setVersionCreateState] = useState(), toast = useToast();
  let t4;
  $[6] !== createVersion || $[7] !== currentRelease || $[8] !== documentId || $[9] !== isAnonymousBundle || $[10] !== t || $[11] !== toast ? (t4 = async () => {
    if (isAnonymousBundle || currentRelease._id) {
      setVersionCreateState({
        status: "creating",
        lastUpdate: /* @__PURE__ */ new Date()
      });
      const bundleId = isAnonymousBundle ? currentRelease : getReleaseIdFromReleaseDocumentId(currentRelease._id);
      try {
        await createVersion(bundleId, documentId), setVersionCreateState({
          status: "created",
          lastUpdate: /* @__PURE__ */ new Date()
        });
      } catch (t52) {
        const err = t52;
        toast.push({
          status: "error",
          closable: !0,
          title: t("banners.release.error.title"),
          description: t("banners.release.error.description", {
            message: err.message
          })
        }), setVersionCreateState(void 0);
      }
    }
  }, $[6] = createVersion, $[7] = currentRelease, $[8] = documentId, $[9] = isAnonymousBundle, $[10] = t, $[11] = toast, $[12] = t4) : t4 = $[12];
  const handleAddToRelease = t4, now = useCurrentTime(200), t5 = versionCreateState?.status === "created" && now.getTime() - versionCreateState.lastUpdate.getTime() > TOAST_DELAY;
  let t6;
  $[13] !== t ? (t6 = t("banners.release.waiting.title"), $[13] = t, $[14] = t6) : t6 = $[14];
  let t7;
  $[15] !== t ? (t7 = t("banners.release.waiting.description"), $[15] = t, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== t5 || $[18] !== t6 || $[19] !== t7 ? (t8 = {
    status: "info",
    id: "add-document-to-release",
    enabled: t5,
    closable: !0,
    title: t6,
    description: t7
  }, $[17] = t5, $[18] = t6, $[19] = t7, $[20] = t8) : t8 = $[20], useConditionalToast(t8);
  let t9;
  $[21] !== releaseTitle ? (t9 = {
    title: releaseTitle
  }, $[21] = releaseTitle, $[22] = t9) : t9 = $[22];
  let t10;
  $[23] !== currentRelease || $[24] !== isAnonymousBundle || $[25] !== tCore ? (t10 = {
    VersionBadge: (t112) => {
      const {
        children
      } = t112, BadgeWithTone = getVersionInlineBadge(currentRelease);
      return isAnonymousBundle ? /* @__PURE__ */ jsx(BadgeWithTone, { children }) : /* @__PURE__ */ jsx(ReleaseTitle, { title: currentRelease.metadata?.title, fallback: tCore("release.placeholder-untitled-release"), children: () => /* @__PURE__ */ jsx(BadgeWithTone, { children }) });
    }
  }, $[23] = currentRelease, $[24] = isAnonymousBundle, $[25] = tCore, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== t || $[28] !== t10 || $[29] !== t9 ? (t11 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "banners.release.not-in-release", t, values: t9, components: t10 }) }), $[27] = t, $[28] = t10, $[29] = t9, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] !== currentRelease || $[32] !== handleAddToRelease || $[33] !== isScheduledRelease || $[34] !== t || $[35] !== tone || $[36] !== versionCreateState ? (t12 = isScheduledRelease ? void 0 : {
    text: isAgentBundleName(currentRelease) ? t("banners.release.action.add-to-bundle") : t("banners.release.action.add-to-release"),
    tone,
    disabled: !!versionCreateState,
    onClick: handleAddToRelease,
    mode: "default"
  }, $[31] = currentRelease, $[32] = handleAddToRelease, $[33] = isScheduledRelease, $[34] = t, $[35] = tone, $[36] = versionCreateState, $[37] = t12) : t12 = $[37];
  let t13;
  return $[38] !== t11 || $[39] !== t12 || $[40] !== tone ? (t13 = /* @__PURE__ */ jsx(Banner, { tone, content: t11, action: t12 }), $[38] = t11, $[39] = t12, $[40] = tone, $[41] = t13) : t13 = $[41], t13;
}
function useCurrentTime(updateIntervalMs) {
  const $ = c(4);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ new Date(), $[0] = t0) : t0 = $[0];
  const [currentTime, setCurrentTime] = useState(t0);
  let t1, t2;
  return $[1] !== updateIntervalMs ? (t1 = () => {
    const intervalId = setInterval(() => {
      setCurrentTime(/* @__PURE__ */ new Date());
    }, updateIntervalMs);
    return () => clearInterval(intervalId);
  }, t2 = [updateIntervalMs], $[1] = updateIntervalMs, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2), currentTime;
}
const ResolvedLiveEdit = defineEvent({
  name: "LiveEdit Draft Resolved",
  version: 1,
  description: "User resolved a draft of a live edit document to continue editing"
}), ObsoleteDraftBanner = (t0) => {
  const $ = c(47), {
    displayed,
    documentId,
    schemaType,
    i18nKey,
    isEditBlocking
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), [isPublishing, setPublishing] = useState(!1), [isDiscarding, setDiscarding] = useState(!1), telemetry = useTelemetry(), {
    publish,
    discardChanges
  } = useDocumentOperation(documentId, displayed?._type || "");
  let t1;
  $[0] !== publish || $[1] !== telemetry ? (t1 = () => {
    publish.execute(), setPublishing(!0), telemetry.log(ResolvedLiveEdit, {
      liveEditResolveType: "publish"
    });
  }, $[0] = publish, $[1] = telemetry, $[2] = t1) : t1 = $[2];
  const handlePublish = t1;
  let t2;
  $[3] !== discardChanges || $[4] !== telemetry ? (t2 = () => {
    discardChanges.execute(), setDiscarding(!0), telemetry.log(ResolvedLiveEdit, {
      liveEditResolveType: "discard"
    });
  }, $[3] = discardChanges, $[4] = telemetry, $[5] = t2) : t2 = $[5];
  const handleDiscard = t2;
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => () => {
    setPublishing(!1), setDiscarding(!1);
  }, $[6] = t3) : t3 = $[6], useEffect(t3);
  const diffViewRouter = useDiffViewRouter();
  let t4;
  $[7] !== diffViewRouter || $[8] !== displayed?._id || $[9] !== schemaType.name ? (t4 = () => {
    typeof displayed?._id > "u" || diffViewRouter.navigateDiffView({
      mode: "version",
      previousDocument: {
        type: schemaType.name,
        id: getPublishedId(displayed?._id)
      },
      nextDocument: {
        type: schemaType.name,
        id: getDraftId(displayed?._id)
      }
    });
  }, $[7] = diffViewRouter, $[8] = displayed?._id, $[9] = schemaType.name, $[10] = t4) : t4 = $[10];
  const compareDraft = t4;
  let t5;
  $[11] !== schemaType.title ? (t5 = {
    schemaType: schemaType.title
  }, $[11] = schemaType.title, $[12] = t5) : t5 = $[12];
  let t6;
  $[13] !== i18nKey || $[14] !== t || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey, values: t5 }) }), $[13] = i18nKey, $[14] = t, $[15] = t5, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== t ? (t7 = t("banners.obsolete-draft.actions.compare-draft.text"), $[17] = t, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== compareDraft || $[20] !== t7 ? (t8 = /* @__PURE__ */ jsx(Button$1, { text: t7, mode: "ghost", onClick: compareDraft }), $[19] = compareDraft, $[20] = t7, $[21] = t8) : t8 = $[21];
  let t9;
  $[22] !== t ? (t9 = t("banners.obsolete-draft.actions.publish-draft.text"), $[22] = t, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== isEditBlocking || $[25] !== t ? (t10 = isEditBlocking ? {
    content: t("banners.live-edit-draft-banner.publish.tooltip")
  } : {}, $[24] = isEditBlocking, $[25] = t, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== handlePublish || $[28] !== isPublishing || $[29] !== t10 || $[30] !== t9 ? (t11 = /* @__PURE__ */ jsx(Button$1, { onClick: handlePublish, text: t9, tooltipProps: t10, loading: isPublishing, tone: "positive" }), $[27] = handlePublish, $[28] = isPublishing, $[29] = t10, $[30] = t9, $[31] = t11) : t11 = $[31];
  let t12;
  $[32] !== t ? (t12 = t("banners.obsolete-draft.actions.discard-draft.text"), $[32] = t, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] !== isEditBlocking || $[35] !== t ? (t13 = isEditBlocking ? {
    content: t("banners.live-edit-draft-banner.discard.tooltip")
  } : {}, $[34] = isEditBlocking, $[35] = t, $[36] = t13) : t13 = $[36];
  let t14;
  $[37] !== handleDiscard || $[38] !== isDiscarding || $[39] !== t12 || $[40] !== t13 ? (t14 = /* @__PURE__ */ jsx(Button$1, { onClick: handleDiscard, text: t12, tooltipProps: t13, loading: isDiscarding, tone: "caution" }), $[37] = handleDiscard, $[38] = isDiscarding, $[39] = t12, $[40] = t13, $[41] = t14) : t14 = $[41];
  let t15;
  return $[42] !== t11 || $[43] !== t14 || $[44] !== t6 || $[45] !== t8 ? (t15 = /* @__PURE__ */ jsx(Banner, { content: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", gap: 2, children: [
    t6,
    t8,
    t11,
    t14
  ] }), "data-testid": "live-edit-type-banner", icon: ErrorOutlineIcon }), $[42] = t11, $[43] = t14, $[44] = t6, $[45] = t8, $[46] = t15) : t15 = $[46], t15;
};
function OpenReleaseToEditBanner(t0) {
  const $ = c(4), {
    documentId,
    isPinnedDraftOrPublished
  } = t0;
  let t1;
  $[0] !== documentId ? (t1 = {
    documentId
  }, $[0] = documentId, $[1] = t1) : t1 = $[1];
  const onlyHasVersions = useOnlyHasVersions(t1);
  if (!isVersionId(documentId) || !onlyHasVersions || !isPinnedDraftOrPublished)
    return null;
  let t2;
  return $[2] !== documentId ? (t2 = /* @__PURE__ */ jsx(OpenReleaseToEditBannerInner, { documentId }), $[2] = documentId, $[3] = t2) : t2 = $[3], t2;
}
function OpenReleaseToEditBannerInner(t0) {
  const $ = c(37), {
    documentId
  } = t0, {
    data: activeReleases
  } = useActiveReleases(), setPerspective = useSetPerspective();
  let t1;
  $[0] !== documentId ? (t1 = getVersionFromId(documentId) ?? "", $[0] = documentId, $[1] = t1) : t1 = $[1];
  const releaseId = t1;
  let t2;
  if ($[2] !== activeReleases || $[3] !== releaseId) {
    let t32;
    $[5] !== releaseId ? (t32 = (version) => version._id.includes(releaseId), $[5] = releaseId, $[6] = t32) : t32 = $[6], t2 = activeReleases.find(t32), $[2] = activeReleases, $[3] = releaseId, $[4] = t2;
  } else
    t2 = $[4];
  const currentVersion = t2, {
    t: tCore
  } = useTranslation();
  let t3;
  $[7] !== documentId ? (t3 = {
    documentId
  }, $[7] = documentId, $[8] = t3) : t3 = $[8];
  const {
    data: documentVersions
  } = useDocumentVersions(t3);
  let t4;
  if ($[9] !== activeReleases || $[10] !== documentVersions) {
    let t52;
    $[12] !== documentVersions ? (t52 = (version_0) => documentVersions.find((release) => {
      const r = getVersionFromId(release) ?? "";
      return getReleaseIdFromReleaseDocumentId(version_0._id) === r;
    }) && !isCardinalityOneRelease(version_0), $[12] = documentVersions, $[13] = t52) : t52 = $[13], t4 = activeReleases.filter(t52), $[9] = activeReleases, $[10] = documentVersions, $[11] = t4;
  } else
    t4 = $[11];
  const documentVersionReleases = t4;
  let t5;
  $[14] !== currentVersion ? (t5 = currentVersion && getReleaseTone(currentVersion), $[14] = currentVersion, $[15] = t5) : t5 = $[15];
  const tone = t5, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t6;
  $[16] !== releaseId || $[17] !== setPerspective ? (t6 = async () => {
    setPerspective(releaseId);
  }, $[16] = releaseId, $[17] = setPerspective, $[18] = t6) : t6 = $[18];
  const handleGoToEdit = t6;
  if (documentVersionReleases.length === 0)
    return null;
  const firstRelease = documentVersionReleases[0];
  let t7;
  $[19] !== tCore ? (t7 = tCore("release.placeholder-untitled-release"), $[19] = tCore, $[20] = t7) : t7 = $[20];
  const fallback = t7;
  let t8;
  $[21] !== documentVersionReleases.length || $[22] !== t ? (t8 = (t92) => {
    const {
      displayTitle
    } = t92;
    return documentVersionReleases.length > 1 ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.release.navigate-to-edit-description-multiple", components: {
      VersionBadge: () => /* @__PURE__ */ jsx(VersionInlineBadge, { children: displayTitle })
    }, values: {
      count: documentVersionReleases.length - 1
    } }) : /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.release.navigate-to-edit-description-single", components: {
      VersionBadge: () => /* @__PURE__ */ jsx(VersionInlineBadge, { children: displayTitle })
    } });
  }, $[21] = documentVersionReleases.length, $[22] = t, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== fallback || $[25] !== firstRelease.metadata.title || $[26] !== t8 ? (t9 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Flex, { direction: "row", gap: 1, wrap: "wrap", children: /* @__PURE__ */ jsx(ReleaseTitle, { title: firstRelease.metadata.title, fallback, children: t8 }) }) }), $[24] = fallback, $[25] = firstRelease.metadata.title, $[26] = t8, $[27] = t9) : t9 = $[27];
  let t10;
  $[28] !== documentVersionReleases.length || $[29] !== handleGoToEdit || $[30] !== t || $[31] !== tone ? (t10 = documentVersionReleases.length > 0 ? {
    text: t("banners.release.action.open-to-edit"),
    tone,
    onClick: handleGoToEdit,
    mode: "default"
  } : void 0, $[28] = documentVersionReleases.length, $[29] = handleGoToEdit, $[30] = t, $[31] = tone, $[32] = t10) : t10 = $[32];
  let t11;
  return $[33] !== t10 || $[34] !== t9 || $[35] !== tone ? (t11 = /* @__PURE__ */ jsx(Banner, { tone, "data-testid": "open-release-to-edit-banner", content: t9, action: t10 }), $[33] = t10, $[34] = t9, $[35] = tone, $[36] = t11) : t11 = $[36], t11;
}
function PausedScheduledDraftBanner() {
  const $ = c(2), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  return $[0] !== t ? (t0 = /* @__PURE__ */ jsx(Banner, { tone: "caution", icon: PauseIcon, content: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.paused-scheduled-draft.text" }) }) }), $[0] = t, $[1] = t0) : t0 = $[1], t0;
}
function RevisionNotFoundBanner() {
  const $ = c(4), {
    revisionNotFound
  } = useDocumentPane(), {
    t
  } = useTranslation(structureLocaleNamespace);
  if (!revisionNotFound)
    return null;
  let t0;
  $[0] !== t ? (t0 = t("banners.revision-not-found.description"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Banner, { tone: "caution", "data-test-id": "revision-not-found-banner", icon: WarningOutlineIcon, content: /* @__PURE__ */ jsx(Text, { size: 1, children: t0 }) }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
function ScheduledReleaseBanner(t0) {
  const $ = c(13), {
    currentRelease
  } = t0, t1 = currentRelease ?? LATEST;
  let t2;
  $[0] !== t1 ? (t2 = getReleaseTone(t1), $[0] = t1, $[1] = t2) : t2 = $[1];
  const tone = t2, {
    t: tCore
  } = useTranslation(), formatPublishDate = useFormatRelativeLocalePublishDate();
  let t3;
  $[2] !== currentRelease || $[3] !== formatPublishDate ? (t3 = formatPublishDate(currentRelease), $[2] = currentRelease, $[3] = formatPublishDate, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = {
    date: t3
  }, $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t4 || $[8] !== tCore ? (t5 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t: tCore, i18nKey: "release.banner.scheduled-for-publishing-on", values: t4 }) }), $[7] = t4, $[8] = tCore, $[9] = t5) : t5 = $[9];
  let t6;
  return $[10] !== t5 || $[11] !== tone ? (t6 = /* @__PURE__ */ jsx(Banner, { tone, icon: LockIcon, content: t5 }), $[10] = t5, $[11] = tone, $[12] = t6) : t6 = $[12], t6;
}
function UnpublishedDocumentBanner() {
  const $ = c(17), {
    value,
    editState
  } = useDocumentPane(), {
    selectedPerspective
  } = usePerspective(), isCurrentVersionGoingToUnpublish = isGoingToUnpublish(value) || editState?.version && isGoingToUnpublish(editState?.version), {
    t
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation();
  if (isReleaseDocument(selectedPerspective) && isCurrentVersionGoingToUnpublish) {
    let t0;
    $[0] !== selectedPerspective.metadata?.title || $[1] !== tCore ? (t0 = selectedPerspective.metadata?.title || tCore("release.placeholder-untitled-release"), $[0] = selectedPerspective.metadata?.title, $[1] = tCore, $[2] = t0) : t0 = $[2];
    const releaseTitle = t0;
    let t1;
    $[3] !== releaseTitle ? (t1 = {
      title: releaseTitle
    }, $[3] = releaseTitle, $[4] = t1) : t1 = $[4];
    let t2;
    $[5] !== selectedPerspective || $[6] !== tCore ? (t2 = {
      VersionBadge: (t32) => {
        const {
          children
        } = t32, BadgeWithTone = getVersionInlineBadge(selectedPerspective);
        return /* @__PURE__ */ jsx(ReleaseTitle, { title: selectedPerspective.metadata?.title, fallback: tCore("release.placeholder-untitled-release"), children: () => /* @__PURE__ */ jsx(BadgeWithTone, { children }) });
      }
    }, $[5] = selectedPerspective, $[6] = tCore, $[7] = t2) : t2 = $[7];
    let t3;
    $[8] !== t || $[9] !== t1 || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.unpublished-release-banner.text", values: t1, components: t2 }) }), $[8] = t, $[9] = t1, $[10] = t2, $[11] = t3) : t3 = $[11];
    let t4;
    $[12] !== t ? (t4 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "banners.unpublished-release-banner.text-with-published" }) }), $[12] = t, $[13] = t4) : t4 = $[13];
    let t5;
    return $[14] !== t3 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsx(Banner, { tone: "critical", content: /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
      t3,
      t4
    ] }), icon: UnpublishIcon }), $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16], t5;
  }
  return null;
}
const TitleContainer = styled(Stack).withConfig({
  displayName: "TitleContainer",
  componentId: "sc-e3cjxp-0"
})`${({
  theme
}) => css`
      @supports not (container-type: inline-size) {
        display: none !important;
      }

      container-type: inline-size;

      [data-heading] {
        font-size: ${theme.sanity.fonts.heading.sizes[4].fontSize}px;
        line-height: ${theme.sanity.fonts.heading.sizes[4].lineHeight}px;
        overflow-wrap: break-word;
        text-wrap: pretty;
      }

      @container (max-width: 560px) {
        [data-heading] {
          font-size: ${theme.sanity.fonts.heading.sizes[3].fontSize}px;
          line-height: ${theme.sanity.fonts.heading.sizes[3].lineHeight}px;
        }
      }

      @container (max-width: 420px) {
        [data-heading] {
          font-size: ${theme.sanity.fonts.heading.sizes[2].fontSize}px;
          line-height: ${theme.sanity.fonts.heading.sizes[2].lineHeight}px;
        }
      }
    `}`, FormHeader = (t0) => {
  const $ = c(14), {
    documentId,
    schemaType,
    title
  } = t0, isSingleton = documentId === schemaType.name, description = schemaType.description, {
    t
  } = useTranslation(structureLocaleNamespace);
  if (schemaType.__experimental_formPreviewTitle === !1)
    return null;
  let t1;
  $[0] !== description || $[1] !== isSingleton || $[2] !== schemaType.name || $[3] !== schemaType.title ? (t1 = !isSingleton && /* @__PURE__ */ jsxs(Inline, { space: 1, children: [
    /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: schemaType.title ?? schemaType.name }),
    description && /* @__PURE__ */ jsx(Tooltip, { content: description, placement: "right", children: /* @__PURE__ */ jsx(InfoOutlineIcon, { "data-testid": "schema-description-icon" }) })
  ] }), $[0] = description, $[1] = isSingleton, $[2] = schemaType.name, $[3] = schemaType.title, $[4] = t1) : t1 = $[4];
  const t2 = !title;
  let t3;
  $[5] !== t || $[6] !== title ? (t3 = title ?? t("document-view.form-view.form-title-fallback"), $[5] = t, $[6] = title, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t2 || $[9] !== t3 ? (t4 = /* @__PURE__ */ jsx(Heading, { as: "h2", "data-heading": !0, muted: t2, "data-testid": "document-panel-document-title", children: t3 }), $[8] = t2, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  return $[11] !== t1 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsxs(TitleContainer, { marginBottom: 6, space: 4, children: [
    t1,
    t4
  ] }), $[11] = t1, $[12] = t4, $[13] = t5) : t5 = $[13], t5;
}, preventDefault = (ev) => ev.preventDefault(), FormView = forwardRef(function(props, ref) {
  const $ = c(82), {
    hidden,
    margins
  } = props, {
    collapsedFieldSets,
    collapsedPaths,
    displayed: value,
    editState,
    documentId,
    documentType,
    fieldActions,
    onChange,
    validation,
    ready,
    formState,
    onFocus,
    connectionState,
    onBlur,
    onSetCollapsedPath,
    onPathOpen,
    onSetCollapsedFieldSet,
    onSetActiveFieldGroup,
    openPath,
    inspectOpen,
    compareValue,
    hasUpstreamVersion,
    focusPath
  } = useDocumentPane(), {
    selectedReleaseId,
    selectedPerspective
  } = usePerspective(), documentStore = useDocumentStore(), presence = useDocumentPresence(documentId), {
    title
  } = useDocumentTitle(), [patchChannel] = useState(_temp$z), isLocked = editState?.transactionSyncLock?.enabled, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[0] !== t ? (t0 = t("document-view.form-view.sync-lock-toast.title"), $[0] = t, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t ? (t1 = t("document-view.form-view.sync-lock-toast.description"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== isLocked || $[5] !== t0 || $[6] !== t1 ? (t2 = {
    id: "sync-lock",
    status: "warning",
    enabled: isLocked,
    title: t0,
    description: t1,
    closable: !0
  }, $[4] = isLocked, $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7], useConditionalToast(t2);
  let t3;
  $[8] !== documentId || $[9] !== documentStore.pair || $[10] !== documentType || $[11] !== patchChannel || $[12] !== selectedReleaseId ? (t3 = () => {
    const sub = documentStore.pair.documentEvents(documentId, documentType, selectedReleaseId).pipe(tap((event) => {
      event.type === "mutation" && patchChannel.publish(prepareMutationEvent(event)), event.type === "rebase" && patchChannel.publish(prepareRebaseEvent(event));
    })).subscribe();
    return () => {
      sub.unsubscribe();
    };
  }, $[8] = documentId, $[9] = documentStore.pair, $[10] = documentType, $[11] = patchChannel, $[12] = selectedReleaseId, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== documentId || $[15] !== documentStore || $[16] !== documentType || $[17] !== patchChannel || $[18] !== selectedReleaseId ? (t4 = [documentId, documentStore, documentType, patchChannel, selectedReleaseId], $[14] = documentId, $[15] = documentStore, $[16] = documentType, $[17] = patchChannel, $[18] = selectedReleaseId, $[19] = t4) : t4 = $[19], useEffect(t3, t4);
  const hasRev = !!value?._rev;
  let t5;
  $[20] !== patchChannel || $[21] !== value ? (t5 = () => {
    patchChannel.publish({
      type: "mutation",
      patches: [],
      snapshot: value
    });
  }, $[20] = patchChannel, $[21] = value, $[22] = t5) : t5 = $[22];
  const handleInitialValue = useEffectEvent(t5);
  let t6;
  $[23] !== handleInitialValue || $[24] !== hasRev ? (t6 = () => {
    hasRev && handleInitialValue();
  }, $[23] = handleInitialValue, $[24] = hasRev, $[25] = t6) : t6 = $[25];
  let t7;
  $[26] !== hasRev ? (t7 = [hasRev], $[26] = hasRev, $[27] = t7) : t7 = $[27], useEffect(t6, t7);
  const [formRef, setFormRef] = useState(null), [hasFocusedAnyPath, setHasFocusedAnyPath] = useState(!1);
  let t8;
  $[28] !== formRef || $[29] !== formState?.focusPath.length || $[30] !== hasFocusedAnyPath || $[31] !== ready ? (t8 = () => {
    !hasFocusedAnyPath && ready && !formState?.focusPath.length && formRef && focusFirstDescendant(formRef);
  }, $[28] = formRef, $[29] = formState?.focusPath.length, $[30] = hasFocusedAnyPath, $[31] = ready, $[32] = t8) : t8 = $[32];
  const t9 = formState?.focusPath.length;
  let t10;
  $[33] !== formRef || $[34] !== hasFocusedAnyPath || $[35] !== ready || $[36] !== t9 ? (t10 = [hasFocusedAnyPath, formRef, t9, ready], $[33] = formRef, $[34] = hasFocusedAnyPath, $[35] = ready, $[36] = t9, $[37] = t10) : t10 = $[37], useEffect(t8, t10);
  let t11;
  $[38] !== focusPath.length ? (t11 = () => {
    focusPath.length !== 0 && setHasFocusedAnyPath(!0);
  }, $[38] = focusPath.length, $[39] = t11) : t11 = $[39];
  let t12;
  $[40] !== focusPath ? (t12 = [focusPath], $[40] = focusPath, $[41] = t12) : t12 = $[41], useEffect(t11, t12);
  let t13;
  $[42] !== ref ? (t13 = (node) => {
    setFormRef(node), typeof ref == "function" ? ref(node) : ref && (ref.current = node);
  }, $[42] = ref, $[43] = t13) : t13 = $[43];
  const setRef = t13, isReadOnly = connectionState === "reconnecting" || formState?.readOnly || !editState?.ready, t14 = isReadOnly ? "true" : void 0;
  let t15;
  $[44] !== collapsedFieldSets || $[45] !== collapsedPaths || $[46] !== compareValue || $[47] !== connectionState || $[48] !== documentId || $[49] !== editState?.draft || $[50] !== editState?.published || $[51] !== fieldActions || $[52] !== formState || $[53] !== hasUpstreamVersion || $[54] !== hidden || $[55] !== inspectOpen || $[56] !== isReadOnly || $[57] !== onBlur || $[58] !== onChange || $[59] !== onFocus || $[60] !== onPathOpen || $[61] !== onSetActiveFieldGroup || $[62] !== onSetCollapsedFieldSet || $[63] !== onSetCollapsedPath || $[64] !== openPath || $[65] !== patchChannel || $[66] !== presence || $[67] !== selectedPerspective || $[68] !== t || $[69] !== title || $[70] !== validation ? (t15 = connectionState === "connecting" && !editState?.draft && !editState?.published ? /* @__PURE__ */ jsx(Delay, { ms: 300, children: /* @__PURE__ */ jsxs(Flex, { align: "center", direction: "column", height: "fill", justify: "center", children: [
    /* @__PURE__ */ jsx(Spinner, { muted: !0 }),
    /* @__PURE__ */ jsx(Box, { marginTop: 3, children: /* @__PURE__ */ jsx(Text, { align: "center", muted: !0, size: 1, children: t("document-view.form-view.loading") }) })
  ] }) }) : formState === null || hidden ? /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text, { children: t("document-view.form-view.form-hidden") }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(FormRow, { children: /* @__PURE__ */ jsx(FormHeader, { documentId, schemaType: formState.schemaType, title }) }),
    /* @__PURE__ */ jsx(FormBuilder, { __internal_fieldActions: fieldActions, __internal_inspectOpen: inspectOpen, __internal_patchChannel: patchChannel, changed: formState.changed, collapsedFieldSets, collapsedPaths, compareValue: compareValue ?? void 0, focused: formState.focused, focusPath: formState.focusPath, groups: formState.groups, id: "root", members: formState.members, onChange, onFieldGroupSelect: onSetActiveFieldGroup, onPathBlur: onBlur, onPathFocus: onFocus, onPathOpen, onSetFieldSetCollapsed: onSetCollapsedFieldSet, onSetPathCollapsed: onSetCollapsedPath, openPath, perspective: selectedPerspective, hasUpstreamVersion, presence, readOnly: isReadOnly, schemaType: formState.schemaType, validation, value: formState.value })
  ] }), $[44] = collapsedFieldSets, $[45] = collapsedPaths, $[46] = compareValue, $[47] = connectionState, $[48] = documentId, $[49] = editState?.draft, $[50] = editState?.published, $[51] = fieldActions, $[52] = formState, $[53] = hasUpstreamVersion, $[54] = hidden, $[55] = inspectOpen, $[56] = isReadOnly, $[57] = onBlur, $[58] = onChange, $[59] = onFocus, $[60] = onPathOpen, $[61] = onSetActiveFieldGroup, $[62] = onSetCollapsedFieldSet, $[63] = onSetCollapsedPath, $[64] = openPath, $[65] = patchChannel, $[66] = presence, $[67] = selectedPerspective, $[68] = t, $[69] = title, $[70] = validation, $[71] = t15) : t15 = $[71];
  let t16;
  $[72] !== setRef || $[73] !== t14 || $[74] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { as: "form", onSubmit: preventDefault, ref: setRef, "data-testid": "form-view", "data-read-only": t14, children: t15 }), $[72] = setRef, $[73] = t14, $[74] = t15, $[75] = t16) : t16 = $[75];
  let t17;
  $[76] !== margins || $[77] !== t16 ? (t17 = /* @__PURE__ */ jsx(PresenceOverlay, { margins, children: t16 }), $[76] = margins, $[77] = t16, $[78] = t17) : t17 = $[78];
  let t18;
  return $[79] !== hidden || $[80] !== t17 ? (t18 = /* @__PURE__ */ jsx(FormContainer, { hidden, children: t17 }), $[79] = hidden, $[80] = t17, $[81] = t18) : t18 = $[81], t18;
});
function prepareMutationEvent(event) {
  const patches = event.mutations.map((mut) => mut.patch).filter(Boolean);
  return {
    type: "mutation",
    snapshot: event.document,
    patches: fromMutationPatches(event.origin, patches)
  };
}
function prepareRebaseEvent(event) {
  const remotePatches = event.remoteMutations.map((mut) => mut.patch).filter(Boolean), localPatches = event.localMutations.map((mut) => mut.patch).filter(Boolean);
  return {
    type: "rebase",
    snapshot: event.document,
    patches: fromMutationPatches("remote", remotePatches).concat(fromMutationPatches("local", localPatches))
  };
}
function _temp$z() {
  return createPatchChannel();
}
function DocumentHeaderTabs() {
  const $ = c(11), {
    activeViewId
  } = useDocumentPane(), {
    paneKey,
    views
  } = useDocumentPaneInfo(), tabPanelId = `${paneKey}tabpanel`;
  let t0;
  if ($[0] !== activeViewId || $[1] !== paneKey || $[2] !== tabPanelId || $[3] !== views) {
    let t12;
    $[5] !== activeViewId || $[6] !== paneKey || $[7] !== tabPanelId ? (t12 = (view, index) => /* @__PURE__ */ jsx(DocumentHeaderTab, { icon: view.icon, id: `${paneKey}tab-${view.id}`, isActive: activeViewId === view.id, label: view.title, tabPanelId, viewId: index === 0 ? null : view.id ?? null }, view.id), $[5] = activeViewId, $[6] = paneKey, $[7] = tabPanelId, $[8] = t12) : t12 = $[8], t0 = views.map(t12), $[0] = activeViewId, $[1] = paneKey, $[2] = tabPanelId, $[3] = views, $[4] = t0;
  } else
    t0 = $[4];
  let t1;
  return $[9] !== t0 ? (t1 = /* @__PURE__ */ jsx(TabList, { space: 1, children: t0 }), $[9] = t0, $[10] = t1) : t1 = $[10], t1;
}
function DocumentHeaderTab(props) {
  const $ = c(20);
  let icon, id, isActive, label, rest, tabPanelId, viewId;
  $[0] !== props ? ({
    icon,
    id,
    isActive,
    label,
    tabPanelId,
    viewId,
    ...rest
  } = props, $[0] = props, $[1] = icon, $[2] = id, $[3] = isActive, $[4] = label, $[5] = rest, $[6] = tabPanelId, $[7] = viewId) : (icon = $[1], id = $[2], isActive = $[3], label = $[4], rest = $[5], tabPanelId = $[6], viewId = $[7]);
  const {
    ready,
    editState
  } = useDocumentPane(), {
    setView
  } = usePaneRouter();
  let t0;
  $[8] !== setView || $[9] !== viewId ? (t0 = () => setView(viewId), $[8] = setView, $[9] = viewId, $[10] = t0) : t0 = $[10];
  const handleClick = t0, t1 = !ready && !editState?.draft && !editState?.published;
  let t2;
  return $[11] !== handleClick || $[12] !== icon || $[13] !== id || $[14] !== isActive || $[15] !== label || $[16] !== rest || $[17] !== t1 || $[18] !== tabPanelId ? (t2 = /* @__PURE__ */ jsx(Tab, { ...rest, "aria-controls": tabPanelId, disabled: t1, icon, id, label, onClick: handleClick, selected: isActive }), $[11] = handleClick, $[12] = icon, $[13] = id, $[14] = isActive, $[15] = label, $[16] = rest, $[17] = t1, $[18] = tabPanelId, $[19] = t2) : t2 = $[19], t2;
}
const DEFAULT_VALUE = {
  paneDataItems: [],
  routerPanes: [],
  resolvedPanes: [],
  maximizedPane: null,
  setMaximizedPane: () => {
  }
};
function useResolvedPanesList() {
  return useContext(ResolvedPanesContext) ?? DEFAULT_VALUE;
}
const _DEBUG = !1, EMPTY_PARAMS$1 = Object.freeze({}), LOADING_PANE = /* @__PURE__ */ Symbol("LOADING_PANE"), DOCUMENT_PANEL_PORTAL_ELEMENT = "documentPanelPortalElement", FocusDocumentPaneClicked = defineEvent({
  name: "Maximized Document Pane Clicked",
  version: 1,
  description: "User pressed to maximize a document by click the focus pane button"
}), FocusDocumentPaneCollapsed = defineEvent({
  name: "Maximized Document Pane Collapsed",
  version: 1,
  description: "User disabled the maximization on a document pane by clicking the focus pane button"
}), FocusDocumentPaneNavigated = defineEvent({
  name: "Maximized Document Pane Navigated Via Breadcrumbs",
  version: 1,
  description: "User navigated to a different document pane via the breadcrumbs in the document header"
});
function DocumentHeaderBreadcrumbItem(t0) {
  const $ = c(27), {
    paneData,
    index
  } = t0, {
    pane
  } = paneData, router2 = useRouter(), {
    t
  } = useTranslation(structureLocaleNamespace), routerState = useRouterState(), telemetry = useTelemetry();
  let t1;
  $[0] !== routerState?.panes ? (t1 = routerState?.panes || [], $[0] = routerState?.panes, $[1] = t1) : t1 = $[1];
  const routerPanes = t1, {
    perspectiveStack
  } = usePerspective(), staticTitle = pane !== LOADING_PANE && "title" in pane ? pane.title : null, documentId = pane !== LOADING_PANE && pane.type === "document" ? pane.options.id : null, documentType = pane !== LOADING_PANE && pane.type === "document" ? pane.options.type : null, t2 = documentId ?? "", t3 = documentType ?? "";
  let t4;
  $[2] !== perspectiveStack || $[3] !== t2 || $[4] !== t3 ? (t4 = {
    documentId: t2,
    documentType: t3,
    perspectiveStack
  }, $[2] = perspectiveStack, $[3] = t2, $[4] = t3, $[5] = t4) : t4 = $[5];
  const {
    value: previewValue,
    isLoading
  } = useDocumentPreviewValues(t4);
  let t5;
  bb0: {
    if (documentId && !isLoading) {
      let t62;
      $[6] !== previewValue?.title || $[7] !== t ? (t62 = previewValue?.title || t("panes.document-header-title.untitled.text"), $[6] = previewValue?.title, $[7] = t, $[8] = t62) : t62 = $[8], t5 = t62;
      break bb0;
    }
    t5 = staticTitle;
  }
  const displayTitle = t5;
  let t6;
  $[9] !== paneData.groupIndex || $[10] !== router2 || $[11] !== routerPanes || $[12] !== telemetry ? (t6 = () => {
    telemetry.log(FocusDocumentPaneNavigated), router2.navigate({
      panes: routerPanes.slice(0, paneData.groupIndex)
    });
  }, $[9] = paneData.groupIndex, $[10] = router2, $[11] = routerPanes, $[12] = telemetry, $[13] = t6) : t6 = $[13];
  const handleClick = t6;
  if (!displayTitle && !isLoading)
    return null;
  let t7;
  $[14] !== displayTitle || $[15] !== t ? (t7 = displayTitle || t("panes.document-header-title.untitled.text"), $[14] = displayTitle, $[15] = t, $[16] = t7) : t7 = $[16];
  let t8;
  $[17] !== displayTitle || $[18] !== t ? (t8 = displayTitle || t("panes.document-header-title.untitled.text"), $[17] = displayTitle, $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== t8 ? (t9 = {
    content: t8
  }, $[20] = t8, $[21] = t9) : t9 = $[21];
  const t10 = index === 0 ? 0 : 1;
  let t11;
  return $[22] !== handleClick || $[23] !== t10 || $[24] !== t7 || $[25] !== t9 ? (t11 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", text: t7, tooltipProps: t9, onClick: handleClick, paddingLeft: t10 }), $[22] = handleClick, $[23] = t10, $[24] = t7, $[25] = t9, $[26] = t11) : t11 = $[26], t11;
}
function DocumentHeaderBreadcrumb(t0) {
  const $ = c(7), {
    paneDataItems,
    currentPaneIndex
  } = t0;
  let t1;
  if ($[0] !== currentPaneIndex || $[1] !== paneDataItems) {
    let t22;
    $[3] !== currentPaneIndex ? (t22 = (paneData, idx) => {
      if (idx > currentPaneIndex)
        return null;
      const isDocumentPane2 = paneData.pane !== LOADING_PANE && paneData.pane.type === "document";
      return /* @__PURE__ */ jsxs(Fragment$1, { children: [
        /* @__PURE__ */ jsx(DocumentHeaderBreadcrumbItem, { paneData, index: idx }),
        idx < currentPaneIndex && (isDocumentPane2 ? /* @__PURE__ */ jsx(Box, { padding: 1, children: /* @__PURE__ */ jsx(ArrowRightIcon, {}) }) : /* @__PURE__ */ jsx(Text, { children: "/" }))
      ] }, `breadcrumb-item-${paneData.key}-${idx}`);
    }, $[3] = currentPaneIndex, $[4] = t22) : t22 = $[4], t1 = paneDataItems.map(t22), $[0] = currentPaneIndex, $[1] = paneDataItems, $[2] = t1;
  } else
    t1 = $[2];
  let t2;
  return $[5] !== t1 ? (t2 = /* @__PURE__ */ jsx(Flex, { direction: "row", align: "center", "data-testid": "document-header-breadcrumb", children: t1 }), $[5] = t1, $[6] = t2) : t2 = $[6], t2;
}
function DocumentHeaderTitle() {
  const $ = c(23), {
    connectionState,
    schemaType,
    title,
    value: documentValue,
    index
  } = useDocumentPane(), {
    paneDataItems
  } = useResolvedPanesList(), {
    title: documentTitle,
    error
  } = useDocumentTitle(), subscribed = !!documentValue, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[0] !== paneDataItems ? (t0 = paneDataItems.some(_temp$y), $[0] = paneDataItems, $[1] = t0) : t0 = $[1];
  const hasMaximizedPane = t0;
  if (connectionState === "connecting" && !subscribed) {
    let t12;
    return $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(Fragment, {}), $[2] = t12) : t12 = $[2], t12;
  }
  if (title) {
    let t12;
    return $[3] !== title ? (t12 = /* @__PURE__ */ jsx(Fragment, { children: title }), $[3] = title, $[4] = t12) : t12 = $[4], t12;
  }
  if (!documentValue) {
    const t12 = schemaType?.title || schemaType?.name;
    let t22;
    $[5] !== t || $[6] !== t12 ? (t22 = t("panes.document-header-title.new.text", {
      schemaType: t12
    }), $[5] = t, $[6] = t12, $[7] = t22) : t22 = $[7];
    let t3;
    return $[8] !== t22 ? (t3 = /* @__PURE__ */ jsx(Fragment, { children: t22 }), $[8] = t22, $[9] = t3) : t3 = $[9], t3;
  }
  if (error) {
    let t12;
    $[10] !== error || $[11] !== t ? (t12 = t("panes.document-header-title.error.text", {
      error
    }), $[10] = error, $[11] = t, $[12] = t12) : t12 = $[12];
    let t22;
    return $[13] !== t12 ? (t22 = /* @__PURE__ */ jsx(Fragment, { children: t12 }), $[13] = t12, $[14] = t22) : t22 = $[14], t22;
  }
  let t1;
  $[15] !== documentTitle || $[16] !== hasMaximizedPane || $[17] !== index || $[18] !== paneDataItems || $[19] !== t ? (t1 = hasMaximizedPane ? /* @__PURE__ */ jsx(DocumentHeaderBreadcrumb, { paneDataItems, currentPaneIndex: index }) : documentTitle || /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("panes.document-header-title.untitled.text") }), $[15] = documentTitle, $[16] = hasMaximizedPane, $[17] = index, $[18] = paneDataItems, $[19] = t, $[20] = t1) : t1 = $[20];
  let t2;
  return $[21] !== t1 ? (t2 = /* @__PURE__ */ jsx(Fragment, { children: t1 }), $[21] = t1, $[22] = t2) : t2 = $[22], t2;
}
function _temp$y(paneData) {
  return paneData.maximized;
}
const FavoriteToggle = (t0) => {
  const $ = c(16);
  let documentExists, props;
  $[0] !== t0 ? ({
    documentExists,
    ...props
  } = t0, $[0] = t0, $[1] = documentExists, $[2] = props) : (documentExists = $[1], props = $[2]);
  const {
    isFavorited,
    isReady,
    favorite,
    unfavorite
  } = useManageFavorite(props), {
    t
  } = useTranslation(structureLocaleNamespace), t1 = isFavorited ? "document.favorites.remove-from-favorites" : "document.favorites.add-to-favorites";
  let t2;
  $[3] !== t || $[4] !== t1 ? (t2 = t(t1), $[3] = t, $[4] = t1, $[5] = t2) : t2 = $[5];
  const description = t2, t3 = isFavorited ? unfavorite : favorite, t4 = !isReady || !documentExists;
  let t5;
  $[6] !== description ? (t5 = {
    content: /* @__PURE__ */ jsx(Text, { size: 1, children: description }),
    placement: "right"
  }, $[6] = description, $[7] = t5) : t5 = $[7];
  let t6;
  $[8] !== isFavorited ? (t6 = /* @__PURE__ */ jsx(Text, { size: 1, children: isFavorited ? /* @__PURE__ */ jsx(StarFilledIcon, {}) : /* @__PURE__ */ jsx(StarIcon, {}) }), $[8] = isFavorited, $[9] = t6) : t6 = $[9];
  let t7;
  return $[10] !== description || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", onClick: t3, disabled: t4, "aria-label": description, "aria-live": "assertive", tooltipProps: t5, children: t6 }), $[10] = description, $[11] = t3, $[12] = t4, $[13] = t5, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}, DocumentPanelSubHeader = memo(function() {
  const $ = c(24), {
    editState,
    connectionState,
    views,
    documentId,
    displayed
  } = useDocumentPane(), {
    features
  } = useStructureTool(), {
    index,
    BackLink: BackLink2
  } = usePaneRouter(), {
    activeWorkspace
  } = useActiveWorkspace(), showTabs = views.length > 1, {
    collapsed,
    isLast
  } = usePane(), tabIndex = isLast && !collapsed ? -1 : 0, showBackButton = features.backButton && index > 0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(DocumentHeaderTitle, {}), $[0] = t0) : t0 = $[0];
  const title = t0;
  let t1;
  $[1] !== showTabs ? (t1 = showTabs && /* @__PURE__ */ jsx(DocumentHeaderTabs, {}), $[1] = showTabs, $[2] = t1) : t1 = $[2];
  const tabs = t1;
  let t2;
  $[3] !== BackLink2 || $[4] !== showBackButton || $[5] !== t ? (t2 = showBackButton && /* @__PURE__ */ jsx(Button$1, { as: BackLink2, "data-as": "a", icon: ArrowLeftIcon, mode: "bleed", tooltipProps: {
    content: t("pane-header.back-button.text")
  } }), $[3] = BackLink2, $[4] = showBackButton, $[5] = t, $[6] = t2) : t2 = $[6];
  const backButton = t2, t3 = displayed?._id ?? documentId, t4 = displayed?._type ?? "";
  let t5;
  $[7] !== activeWorkspace.dataset || $[8] !== activeWorkspace.projectId ? (t5 = [activeWorkspace.projectId, activeWorkspace.dataset], $[7] = activeWorkspace.dataset, $[8] = activeWorkspace.projectId, $[9] = t5) : t5 = $[9];
  const t6 = t5.join("."), t7 = (editState?.ready && (editState.version ?? editState.draft ?? editState.published) !== null) ?? !1;
  let t8;
  $[10] !== activeWorkspace.dataset || $[11] !== activeWorkspace.name || $[12] !== activeWorkspace.projectId || $[13] !== t3 || $[14] !== t4 || $[15] !== t6 || $[16] !== t7 ? (t8 = /* @__PURE__ */ jsx(CapabilityGate, { capability: "comlink", condition: "available", children: /* @__PURE__ */ jsx(FavoriteToggle, { resourceType: "studio", documentId: t3, documentType: t4, resourceId: t6, schemaName: activeWorkspace.name, projectId: activeWorkspace.projectId, dataset: activeWorkspace.dataset, documentExists: t7 }) }), $[10] = activeWorkspace.dataset, $[11] = activeWorkspace.name, $[12] = activeWorkspace.projectId, $[13] = t3, $[14] = t4, $[15] = t6, $[16] = t7, $[17] = t8) : t8 = $[17];
  const favoriteToggle = t8, t9 = connectionState === "connecting" && !editState?.draft && !editState?.published;
  let t10;
  return $[18] !== backButton || $[19] !== favoriteToggle || $[20] !== t9 || $[21] !== tabIndex || $[22] !== tabs ? (t10 = /* @__PURE__ */ jsx(PaneHeader$1, { loading: t9, title, tabs, tabIndex, backButton, appendTitle: favoriteToggle }), $[18] = backButton, $[19] = favoriteToggle, $[20] = t9, $[21] = tabIndex, $[22] = tabs, $[23] = t10) : t10 = $[23], t10;
}), DocumentBox = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "DocumentBox",
  componentId: "sc-10i0hcs-0"
})({
  position: "relative"
}), Scroller$4 = /* @__PURE__ */ styled(ScrollContainer).withConfig({
  displayName: "Scroller",
  componentId: "sc-10i0hcs-1"
})(({
  $disabled
}) => $disabled ? {
  height: "100%"
} : css`
    height: 100%;
    overflow: auto;
    position: relative;
    scroll-behavior: smooth;
    outline: none;
  `), DocumentPanel = function(props) {
  const $ = c(83), {
    footerHeight,
    headerHeight,
    isInspectOpen,
    rootElement,
    setDocumentPanelPortalElement,
    footer
  } = props, {
    activeViewId,
    displayed,
    documentId,
    editState,
    inspector,
    value,
    views,
    ready,
    schemaType,
    permissions,
    isPermissionsLoading
  } = useDocumentPane(), {
    params
  } = usePaneRouter(), {
    collapsed: layoutCollapsed
  } = usePaneLayout(), {
    collapsed
  } = usePane(), parentPortal = usePortal(), {
    features
  } = useStructureTool(), [_portalElement, setPortalElement] = useState(null), [documentScrollElement, setDocumentScrollElement] = useState(null), formContainerElement = useRef(null), workspace = useWorkspace(), requiredPermission = value._createdAt ? "update" : "create";
  let t0;
  $[0] !== activeViewId || $[1] !== views ? (t0 = views.find((view) => view.id === activeViewId) || views[0] || {
    type: "form"
  }, $[0] = activeViewId, $[1] = views, $[2] = t0) : t0 = $[2];
  const activeView = t0, portalElement = features.splitPanes && _portalElement || parentPortal.element;
  let t1;
  bb0: {
    if (layoutCollapsed) {
      const t23 = headerHeight || 0, t32 = footerHeight ? footerHeight + 2 : 2;
      let t42;
      $[3] !== t23 || $[4] !== t32 ? (t42 = [t23, 0, t32, 0], $[3] = t23, $[4] = t32, $[5] = t42) : t42 = $[5], t1 = t42;
      break bb0;
    }
    let t22;
    $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = [0, 0, 2, 0], $[6] = t22) : t22 = $[6], t1 = t22;
  }
  const margins = t1, formViewHidden = activeView.type !== "form";
  let t2;
  $[7] !== activeView.component || $[8] !== activeView.options || $[9] !== activeView.type || $[10] !== displayed || $[11] !== documentId || $[12] !== editState?.draft || $[13] !== editState?.published || $[14] !== schemaType || $[15] !== value ? (t2 = () => {
    if (activeView.type === "component" && activeView.component) {
      const ActiveViewComponent = activeView.component;
      return /* @__PURE__ */ jsx(ActiveViewComponent, { document: {
        draft: editState?.draft || null,
        displayed: displayed || value,
        historical: displayed,
        published: editState?.published || null
      }, documentId, options: activeView.options, schemaType });
    }
    return !1;
  }, $[7] = activeView.component, $[8] = activeView.options, $[9] = activeView.type, $[10] = displayed, $[11] = documentId, $[12] = editState?.draft, $[13] = editState?.published, $[14] = schemaType, $[15] = value, $[16] = t2) : t2 = $[16];
  let t3;
  $[17] !== t2 ? (t3 = t2(), $[17] = t2, $[18] = t3) : t3 = $[18];
  const activeViewNode = t3, prevDocumentIdRef = useRef(void 0);
  let t4, t5;
  $[19] !== documentId || $[20] !== documentScrollElement ? (t4 = () => {
    if (documentScrollElement?.scrollTo) {
      if (prevDocumentIdRef.current === void 0) {
        prevDocumentIdRef.current = documentId;
        return;
      }
      prevDocumentIdRef.current !== documentId && (documentScrollElement.scrollTo(0, 0), prevDocumentIdRef.current = documentId);
    }
  }, t5 = [documentId, documentScrollElement], $[19] = documentId, $[20] = documentScrollElement, $[21] = t4, $[22] = t5) : (t4 = $[21], t5 = $[22]), useEffect(t4, t5);
  let t6, t7;
  $[23] !== portalElement || $[24] !== setDocumentPanelPortalElement ? (t6 = () => {
    portalElement && setDocumentPanelPortalElement(portalElement);
  }, t7 = [portalElement, setDocumentPanelPortalElement], $[23] = portalElement, $[24] = setDocumentPanelPortalElement, $[25] = t6, $[26] = t7) : (t6 = $[25], t7 = $[26]), useEffect(t6, t7);
  let t8;
  $[27] !== displayed || $[28] !== isInspectOpen || $[29] !== value ? (t8 = isInspectOpen ? /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "inspectorDialog", children: /* @__PURE__ */ jsx(InspectDialog, { value: displayed || value }) }) : null, $[27] = displayed, $[28] = isInspectOpen, $[29] = value, $[30] = t8) : t8 = $[30];
  const inspectDialog = t8, showInspector = !!(!collapsed && inspector), {
    selectedPerspective,
    selectedReleaseId,
    selectedPerspectiveName
  } = usePerspective(), t9 = params?.historyVersion;
  let t10;
  $[31] !== displayed || $[32] !== documentId || $[33] !== t9 ? (t10 = {
    historyVersion: t9,
    displayed,
    documentId
  }, $[31] = displayed, $[32] = documentId, $[33] = t9, $[34] = t10) : t10 = $[34];
  const filteredReleases = useFilteredReleases(t10), {
    isPaused: isPausedDraft
  } = usePausedScheduledDraft(), {
    data: archivedReleases
  } = useArchivedReleases();
  let t11;
  if ($[35] !== archivedReleases || $[36] !== selectedPerspectiveName) {
    let t122;
    $[38] !== selectedPerspectiveName ? (t122 = (release) => getReleaseIdFromReleaseDocumentId(release._id) === selectedPerspectiveName && isCardinalityOneRelease(release), $[38] = selectedPerspectiveName, $[39] = t122) : t122 = $[39], t11 = archivedReleases.find(t122), $[35] = archivedReleases, $[36] = selectedPerspectiveName, $[37] = t11;
  } else
    t11 = $[37];
  const archivedScheduledDraftRelease = t11;
  let t12;
  $[40] !== activeView.type || $[41] !== archivedScheduledDraftRelease || $[42] !== displayed || $[43] !== documentId || $[44] !== editState || $[45] !== filteredReleases || $[46] !== isPausedDraft || $[47] !== isPermissionsLoading || $[48] !== params?.historyVersion || $[49] !== permissions?.granted || $[50] !== ready || $[51] !== requiredPermission || $[52] !== schemaType || $[53] !== selectedPerspective || $[54] !== selectedPerspectiveName || $[55] !== selectedReleaseId || $[56] !== value._id || $[57] !== workspace ? (t12 = () => {
    const archivedReleaseId = params?.historyVersion ?? (archivedScheduledDraftRelease ? getReleaseIdFromReleaseDocumentId(archivedScheduledDraftRelease._id) : void 0);
    if (archivedReleaseId)
      return /* @__PURE__ */ jsx(ArchivedReleaseDocumentBanner, { releaseId: archivedReleaseId });
    const isScheduledRelease = isReleaseDocument(selectedPerspective) && isReleaseScheduledOrScheduling(selectedPerspective), documentInScheduledRelease = !!(isScheduledRelease && displayed?._id && getVersionFromId(displayed?._id) === selectedReleaseId), isSelectedPerspectiveWriteable = isPerspectiveWriteable({
      selectedPerspective,
      isDraftModelEnabled: workspace.document.drafts.enabled,
      schemaType
    });
    if (mustChooseNewDocumentDestination({
      isSelectedPerspectiveWriteable,
      editState
    }))
      return !isSelectedPerspectiveWriteable.result && /* @__PURE__ */ jsx(ChooseNewDocumentDestinationBanner, { schemaType, selectedPerspective, reason: isSelectedPerspectiveWriteable.reason });
    if (isPausedDraft && displayed?._id)
      return /* @__PURE__ */ jsx(PausedScheduledDraftBanner, {});
    if (documentInScheduledRelease)
      return /* @__PURE__ */ jsx(ScheduledReleaseBanner, { currentRelease: selectedPerspective });
    const scheduledCardinalityOneRelease = [...filteredReleases.currentReleases, ...filteredReleases.notCurrentReleases].find(_temp$x), isPinnedDraftOrPublish = isSystemBundle(selectedPerspective), isCurrentVersionGoingToUnpublish = editState?.version && isGoingToUnpublish(editState?.version);
    if (!isSystemBundle(selectedPerspective) && displayed?._id && getVersionFromId(displayed._id) !== selectedPerspectiveName && ready && !isPinnedDraftOrPublish && isNewDocument(editState) === !1 && !isCurrentVersionGoingToUnpublish)
      return /* @__PURE__ */ jsx(DocumentNotInReleaseBanner, { documentId: value._id, currentRelease: selectedPerspective, isScheduledRelease });
    const displayedHasObsoleteDraft = hasObsoleteDraft({
      editState,
      workspace,
      schemaType
    });
    if (activeView.type === "form" && !selectedReleaseId && displayedHasObsoleteDraft.result) {
      if (displayedHasObsoleteDraft.reason === "DRAFT_MODEL_INACTIVE")
        return /* @__PURE__ */ jsx(ObsoleteDraftBanner, { displayed, documentId, schemaType, i18nKey: "banners.obsolete-draft.draft-model-inactive.text" });
      if (displayedHasObsoleteDraft.reason === "LIVE_EDIT_ACTIVE")
        return /* @__PURE__ */ jsx(ObsoleteDraftBanner, { displayed, documentId, schemaType, i18nKey: "banners.live-edit-draft-banner.text", isEditBlocking: !0 });
    }
    if (activeView.type !== "form" || isPermissionsLoading)
      return null;
    const displayedIsDraft = displayed?._id && isDraftId(displayed._id);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      selectedPerspective === "drafts" && scheduledCardinalityOneRelease && displayedIsDraft && /* @__PURE__ */ jsx(ScheduledDraftOverrideBanner, { releaseId: scheduledCardinalityOneRelease._id, draftDocument: displayed }),
      !permissions?.granted && /* @__PURE__ */ jsx(InsufficientPermissionBanner, { requiredPermission }),
      /* @__PURE__ */ jsx(RevisionNotFoundBanner, {}),
      /* @__PURE__ */ jsx(ReferenceChangedBanner, {}),
      /* @__PURE__ */ jsx(DeprecatedDocumentTypeBanner, {}),
      /* @__PURE__ */ jsx(CanvasLinkedBanner, {}),
      /* @__PURE__ */ jsx(DeletedDocumentBanners, {}),
      /* @__PURE__ */ jsx(UnpublishedDocumentBanner, {}),
      /* @__PURE__ */ jsx(OpenReleaseToEditBanner, { documentId: displayed?._id ?? documentId, isPinnedDraftOrPublished: isPinnedDraftOrPublish })
    ] });
  }, $[40] = activeView.type, $[41] = archivedScheduledDraftRelease, $[42] = displayed, $[43] = documentId, $[44] = editState, $[45] = filteredReleases, $[46] = isPausedDraft, $[47] = isPermissionsLoading, $[48] = params?.historyVersion, $[49] = permissions?.granted, $[50] = ready, $[51] = requiredPermission, $[52] = schemaType, $[53] = selectedPerspective, $[54] = selectedPerspectiveName, $[55] = selectedReleaseId, $[56] = value._id, $[57] = workspace, $[58] = t12) : t12 = $[58];
  let t13;
  $[59] !== t12 ? (t13 = t12(), $[59] = t12, $[60] = t13) : t13 = $[60];
  const banners = t13;
  let t14;
  $[61] !== documentScrollElement ? (t14 = {
    documentScrollElement
  }, $[61] = documentScrollElement, $[62] = t14) : t14 = $[62];
  const portalElements = t14, showFormView = features.resizablePanes || !showInspector;
  let t15;
  $[63] !== activeViewNode || $[64] !== banners || $[65] !== documentScrollElement || $[66] !== footer || $[67] !== formViewHidden || $[68] !== inspectDialog || $[69] !== layoutCollapsed || $[70] !== margins || $[71] !== portalElement || $[72] !== portalElements || $[73] !== showFormView ? (t15 = showFormView && /* @__PURE__ */ jsxs(Flex, { height: "fill", direction: "column", width: "fill", flex: 2, children: [
    /* @__PURE__ */ jsxs(LegacyLayerProvider, { zOffset: "paneHeader", children: [
      banners,
      /* @__PURE__ */ jsx(DocumentPanelSubHeader, {})
    ] }),
    /* @__PURE__ */ jsx(DocumentBox, { flex: 2, children: /* @__PURE__ */ jsx(PortalProvider, { element: portalElement, __unstable_elements: portalElements, children: /* @__PURE__ */ jsx(BoundaryElementProvider, { element: documentScrollElement, children: /* @__PURE__ */ jsxs(VirtualizerScrollInstanceProvider, { scrollElement: documentScrollElement, containerElement: formContainerElement, children: [
      /* @__PURE__ */ jsxs(Scroller$4, { $disabled: layoutCollapsed || !1, "data-testid": "document-panel-scroller", ref: setDocumentScrollElement, children: [
        /* @__PURE__ */ jsx(FormView, { hidden: formViewHidden, margins, ref: formContainerElement }),
        activeViewNode
      ] }),
      inspectDialog,
      /* @__PURE__ */ jsx("div", { "data-testid": "document-panel-portal", ref: setPortalElement })
    ] }) }) }) }),
    footer
  ] }), $[63] = activeViewNode, $[64] = banners, $[65] = documentScrollElement, $[66] = footer, $[67] = formViewHidden, $[68] = inspectDialog, $[69] = layoutCollapsed, $[70] = margins, $[71] = portalElement, $[72] = portalElements, $[73] = showFormView, $[74] = t15) : t15 = $[74];
  let t16;
  $[75] !== documentId || $[76] !== rootElement || $[77] !== schemaType || $[78] !== showInspector ? (t16 = showInspector && /* @__PURE__ */ jsx(BoundaryElementProvider, { element: rootElement, children: /* @__PURE__ */ jsx(DocumentInspectorPanel, { documentId, documentType: schemaType.name, flex: 1 }) }), $[75] = documentId, $[76] = rootElement, $[77] = schemaType, $[78] = showInspector, $[79] = t16) : t16 = $[79];
  let t17;
  return $[80] !== t15 || $[81] !== t16 ? (t17 = /* @__PURE__ */ jsx(PaneContent, { children: /* @__PURE__ */ jsxs(Flex, { height: "fill", children: [
    t15,
    t16
  ] }) }), $[80] = t15, $[81] = t16, $[82] = t17) : t17 = $[82], t17;
};
DocumentPanel.displayName = "DocumentPanel";
function _temp$x(release_0) {
  return isCardinalityOneRelease(release_0) && (isReleaseScheduledOrScheduling(release_0) || isPausedCardinalityOneRelease(release_0));
}
const useHistoryRestoreAction = (t0) => {
  const $ = c(26), {
    id,
    type,
    revision,
    release
  } = t0, {
    restore
  } = useDocumentOperation(id, type, release), {
    revisionNotFound
  } = useDocumentPane(), event = useDocumentOperationEvent(id, type), {
    navigateIntent
  } = useRouter(), prevEvent = useRef(event), [isConfirmDialogOpen, setConfirmDialogOpen] = useState(!1), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== restore || $[1] !== revision ? (t1 = () => {
    restore.execute(revision), setConfirmDialogOpen(!1);
  }, $[0] = restore, $[1] = revision, $[2] = t1) : t1 = $[2];
  const handleConfirm = t1;
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setConfirmDialogOpen(!1);
  }, $[3] = t2) : t2 = $[3];
  const handleCancel = t2;
  let t3, t4;
  $[4] !== event || $[5] !== id || $[6] !== navigateIntent || $[7] !== type ? (t3 = () => {
    !event || event === prevEvent.current || (event.type === "success" && event.op === "restore" && navigateIntent("edit", {
      id,
      type
    }), prevEvent.current = event);
  }, t4 = [event, id, navigateIntent, type], $[4] = event, $[5] = id, $[6] = navigateIntent, $[7] = type, $[8] = t3, $[9] = t4) : (t3 = $[8], t4 = $[9]), useEffect(t3, t4);
  let t5;
  $[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setConfirmDialogOpen(!0);
  }, $[10] = t5) : t5 = $[10];
  const handle = t5;
  let t6;
  bb0: {
    if (isConfirmDialogOpen) {
      let t72;
      $[11] !== t ? (t72 = t("action.restore.confirm.message"), $[11] = t, $[12] = t72) : t72 = $[12];
      let t8;
      $[13] !== handleConfirm || $[14] !== t72 ? (t8 = {
        type: "confirm",
        tone: "critical",
        onCancel: handleCancel,
        onConfirm: handleConfirm,
        message: t72
      }, $[13] = handleConfirm, $[14] = t72, $[15] = t8) : t8 = $[15], t6 = t8;
      break bb0;
    }
    t6 = null;
  }
  const dialog = t6, isRevisionInitial = revision === "@initial", isRevisionLatest = revision === void 0;
  let t7;
  bb1: {
    if (isRevisionLatest || revisionNotFound) {
      t7 = null;
      break bb1;
    }
    let t8;
    $[16] !== t ? (t8 = t("action.restore.label"), $[16] = t, $[17] = t8) : t8 = $[17];
    const t9 = isRevisionInitial ? "action.restore.disabled.cannot-restore-initial" : "action.restore.tooltip";
    let t10;
    $[18] !== t || $[19] !== t9 ? (t10 = t(t9), $[18] = t, $[19] = t9, $[20] = t10) : t10 = $[20];
    let t11;
    $[21] !== dialog || $[22] !== isRevisionInitial || $[23] !== t10 || $[24] !== t8 ? (t11 = {
      label: t8,
      tone: "caution",
      onHandle: handle,
      title: t10,
      icon: RevertIcon,
      dialog,
      disabled: isRevisionInitial
    }, $[21] = dialog, $[22] = isRevisionInitial, $[23] = t10, $[24] = t8, $[25] = t11) : t11 = $[25], t7 = t11;
  }
  return t7;
};
useHistoryRestoreAction.action = "restore";
useHistoryRestoreAction.displayName = "HistoryRestoreAction";
function isMenuNodeButton(node) {
  return (node.type === "item" || node.type === "group") && node.renderAsButton;
}
const isNotMenuNodeButton = negate(isMenuNodeButton);
function resolveMenuNodes(params) {
  const {
    fieldActions = [],
    menuItems,
    menuItemGroups
  } = params, nodes = [];
  let keyOffset = 0;
  for (let i = 0; i < fieldActions.length; i += 1) {
    const a = fieldActions[i];
    nodes.push(mapFieldActionToPaneMenuNode(a, `${i}-${a.type}`));
  }
  keyOffset += nodes.length;
  const groups = [];
  for (const itemGroup of menuItemGroups)
    groups.find((g) => g.key === itemGroup.id) || groups.push({
      type: "group",
      key: itemGroup.id,
      children: [],
      expanded: !0,
      renderAsButton: !1,
      title: itemGroup.title,
      i18n: itemGroup.i18n
    });
  const ungroupedItems = [];
  for (let i = 0; i < menuItems.length; i += 1) {
    const item = menuItems[i];
    let group = item.group && groups.find((g) => g.key === item.group);
    const disabled = typeof item.disabled == "string" ? {
      reason: item.disabled
    } : item.disabled;
    item.group && !group && (group = {
      type: "group",
      key: item.group,
      disabled,
      expanded: !0,
      icon: item.icon,
      title: item.group,
      children: [],
      renderAsButton: !1
    }, groups.push(group)), group ? group.children.push({
      type: "item",
      key: `${keyOffset + i}-item`,
      hideSelectionIndicator: item.params?.hideSelectionIndicator === !0,
      hotkey: item.shortcut,
      icon: item.icon,
      intent: item.intent,
      disabled,
      onAction: () => params.actionHandler(item),
      renderAsButton: item.showAsAction ?? !1,
      selected: item.selected,
      title: item.title,
      i18n: item.i18n,
      tone: item.tone
    }) : ungroupedItems.push({
      type: "item",
      key: `${keyOffset + i}-item`,
      hideSelectionIndicator: item.params?.hideSelectionIndicator === !0,
      hotkey: item.shortcut,
      icon: item.icon,
      intent: item.intent,
      disabled,
      onAction: () => params.actionHandler(item),
      renderAsButton: item.showAsAction ?? !1,
      selected: item.selected,
      title: item.title,
      i18n: item.i18n,
      tone: item.tone
    });
  }
  return [...ungroupedItems, ...groups, ...nodes];
}
function mapFieldActionToPaneMenuNode(a, key) {
  return a.type === "divider" ? {
    type: "divider",
    key
  } : a.type === "group" ? {
    type: "group",
    key,
    children: a.children.map((child, childIdx) => mapFieldActionToPaneMenuNode(child, `${key}-${childIdx}-${child.type}`)),
    disabled: a.disabled,
    expanded: a.expanded ?? !0,
    icon: a.icon,
    title: a.title,
    i18n: a.i18n,
    renderAsButton: a.renderAsButton ?? !1
  } : {
    type: "item",
    key,
    intent: a.intent,
    disabled: a.disabled,
    icon: a.icon,
    iconRight: a.iconRight,
    onAction: a.onAction,
    renderAsButton: a.renderAsButton ?? !1,
    selected: a.selected,
    title: a.title,
    i18n: a.i18n,
    tone: a.tone
  };
}
const POPOVER_FALLBACK_PLACEMENTS = ["left", "bottom"], DIALOG_WIDTH_TO_UI_WIDTH = {
  small: 0,
  medium: 1,
  large: 2,
  full: "auto"
};
function ConfirmDialog(props) {
  const $ = c(16), {
    dialog,
    referenceElement
  } = props, {
    t
  } = useTranslation(structureLocaleNamespace), {
    cancelButtonIcon,
    cancelButtonText,
    confirmButtonIcon,
    confirmButtonText,
    message,
    onCancel,
    onConfirm,
    tone
  } = dialog;
  let t0;
  $[0] !== cancelButtonText || $[1] !== t ? (t0 = cancelButtonText || t("confirm-dialog.cancel-button.fallback-text"), $[0] = cancelButtonText, $[1] = t, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== confirmButtonText || $[4] !== t ? (t1 = confirmButtonText || t("confirm-dialog.confirm-button.fallback-text"), $[3] = confirmButtonText, $[4] = t, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== cancelButtonIcon || $[7] !== confirmButtonIcon || $[8] !== message || $[9] !== onCancel || $[10] !== onConfirm || $[11] !== referenceElement || $[12] !== t0 || $[13] !== t1 || $[14] !== tone ? (t2 = /* @__PURE__ */ jsx(ConfirmPopover, { cancelButtonIcon, cancelButtonText: t0, confirmButtonIcon, confirmButtonText: t1, message, onCancel, onConfirm, open: !0, referenceElement, tone, placement: "top", fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS }), $[6] = cancelButtonIcon, $[7] = confirmButtonIcon, $[8] = message, $[9] = onCancel, $[10] = onConfirm, $[11] = referenceElement, $[12] = t0, $[13] = t1, $[14] = tone, $[15] = t2) : t2 = $[15], t2;
}
function ModalDialog(props) {
  const $ = c(12), {
    dialog
  } = props, dialogId = useId();
  let t0;
  $[0] !== dialog.footer ? (t0 = dialog.footer && /* @__PURE__ */ jsx(Box, { paddingX: 4, paddingY: 3, children: dialog.footer }), $[0] = dialog.footer, $[1] = t0) : t0 = $[1];
  const footer = t0, t1 = dialog.showCloseButton === !1, t2 = dialog.width === void 0 ? 1 : DIALOG_WIDTH_TO_UI_WIDTH[dialog.width];
  let t3;
  $[2] !== dialog.content ? (t3 = /* @__PURE__ */ jsx(Box, { padding: 4, children: dialog.content }), $[2] = dialog.content, $[3] = t3) : t3 = $[3];
  let t4;
  return $[4] !== dialog.header || $[5] !== dialog.onClose || $[6] !== dialogId || $[7] !== footer || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 ? (t4 = /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "fullscreen", children: /* @__PURE__ */ jsx(Dialog$1, { animate: !0, __unstable_hideCloseButton: t1, footer, header: dialog.header, id: dialogId, onClose: dialog.onClose, onClickOutside: dialog.onClose, width: t2, children: t3 }) }), $[4] = dialog.header, $[5] = dialog.onClose, $[6] = dialogId, $[7] = footer, $[8] = t1, $[9] = t2, $[10] = t3, $[11] = t4) : t4 = $[11], t4;
}
function PopoverDialog(props) {
  const $ = c(5), {
    dialog,
    referenceElement
  } = props;
  let t0;
  $[0] !== dialog ? (t0 = /* @__PURE__ */ jsx(PopoverDialogContent, { dialog }), $[0] = dialog, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== referenceElement || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Popover$1, { content: t0, fallbackPlacements: POPOVER_FALLBACK_PLACEMENTS, open: !0, placement: "top", portal: !0, preventOverflow: !0, referenceElement }), $[2] = referenceElement, $[3] = t0, $[4] = t1) : t1 = $[4], t1;
}
function PopoverDialogContent(props) {
  const $ = c(6), {
    dialog
  } = props, {
    content,
    onClose
  } = dialog, {
    isTopLayer
  } = useLayer(), ref = useRef(null);
  let t0;
  $[0] !== isTopLayer || $[1] !== onClose ? (t0 = (event) => {
    event.key === "Escape" && isTopLayer && onClose();
  }, $[0] = isTopLayer, $[1] = onClose, $[2] = t0) : t0 = $[2], useGlobalKeyDown(t0);
  let t1;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => [ref.current], $[3] = t1) : t1 = $[3], useClickOutsideEvent(isTopLayer && onClose, t1);
  let t2;
  return $[4] !== content ? (t2 = /* @__PURE__ */ jsx("div", { ref, children: content }), $[4] = content, $[5] = t2) : t2 = $[5], t2;
}
function DocumentActionPortalProvider(props) {
  const $ = c(3), {
    children
  } = props, {
    element,
    elements
  } = usePortal(), portalElement = elements?.[DOCUMENT_PANEL_PORTAL_ELEMENT] || element;
  let t0;
  return $[0] !== children || $[1] !== portalElement ? (t0 = /* @__PURE__ */ jsx(PortalProvider, { element: portalElement, children }), $[0] = children, $[1] = portalElement, $[2] = t0) : t0 = $[2], t0;
}
function ActionStateDialog(props) {
  const $ = c(17), {
    dialog,
    referenceElement: t0
  } = props, referenceElement = t0 === void 0 ? null : t0, modalId = useId();
  if (dialog.type === "confirm") {
    let t12;
    return $[0] !== dialog || $[1] !== referenceElement ? (t12 = /* @__PURE__ */ jsx(ConfirmDialog, { dialog, referenceElement }), $[0] = dialog, $[1] = referenceElement, $[2] = t12) : t12 = $[2], t12;
  }
  if (dialog.type === "popover") {
    let t12;
    return $[3] !== dialog || $[4] !== referenceElement ? (t12 = /* @__PURE__ */ jsx(PopoverDialog, { dialog, referenceElement }), $[3] = dialog, $[4] = referenceElement, $[5] = t12) : t12 = $[5], t12;
  }
  if (dialog.type === "dialog" || !dialog.type) {
    let t12;
    return $[6] !== dialog ? (t12 = /* @__PURE__ */ jsx(DocumentActionPortalProvider, { children: /* @__PURE__ */ jsx(ModalDialog, { dialog }) }), $[6] = dialog, $[7] = t12) : t12 = $[7], t12;
  }
  if (dialog.type === "custom") {
    const t12 = dialog?.component;
    let t22;
    return $[8] !== t12 ? (t22 = /* @__PURE__ */ jsx(DocumentActionPortalProvider, { children: t12 }), $[8] = t12, $[9] = t22) : t22 = $[9], t22;
  }
  const unknownModal = dialog;
  console.warn(`Unsupported modal type ${unknownModal.type}`);
  let t1;
  $[10] !== unknownModal.content || $[11] !== unknownModal.type ? (t1 = unknownModal.content || /* @__PURE__ */ jsxs(Text, { size: 1, children: [
    "Unexpected modal type (",
    /* @__PURE__ */ jsx("code", { children: unknownModal.type }),
    ")"
  ] }), $[10] = unknownModal.content, $[11] = unknownModal.type, $[12] = t1) : t1 = $[12];
  let t2;
  return $[13] !== modalId || $[14] !== t1 || $[15] !== unknownModal.onClose ? (t2 = /* @__PURE__ */ jsx(Dialog, { id: modalId, onClose: unknownModal.onClose, onClickOutside: unknownModal.onClose, width: 1, children: t1 }), $[13] = modalId, $[14] = t1, $[15] = unknownModal.onClose, $[16] = t2) : t2 = $[16], t2;
}
const ActionDialogWrapper = memo(function(t0) {
  const $ = c(9), {
    actionStates,
    children,
    referenceElement
  } = t0, [actionIndex, setActionIndex] = useState(-1), currentAction = actionStates[actionIndex];
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (idx) => {
    setActionIndex(idx);
  }, $[0] = t1) : t1 = $[0];
  const handleAction = t1;
  let t2;
  $[1] !== children ? (t2 = children({
    handleAction
  }), $[1] = children, $[2] = t2) : t2 = $[2];
  const result = t2;
  let t3;
  $[3] !== currentAction || $[4] !== referenceElement ? (t3 = currentAction && currentAction.dialog && /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneFooter", children: /* @__PURE__ */ jsx(ActionStateDialog, { dialog: currentAction.dialog, referenceElement }) }), $[3] = currentAction, $[4] = referenceElement, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== result || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t3,
    result
  ] }), $[6] = result, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
});
function ActionMenuButton(props) {
  const $ = c(10), {
    actionStates,
    disabled
  } = props, idPrefix = useId(), [referenceElement, setReferenceElement] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    placement: "top-end",
    portal: !0,
    preventOverflow: !0
  }, $[0] = t0) : t0 = $[0];
  const popoverProps = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[1] !== actionStates || $[2] !== disabled || $[3] !== idPrefix || $[4] !== t ? (t1 = (t22) => {
    const {
      handleAction
    } = t22;
    return /* @__PURE__ */ jsx(MenuButton, { id: `${idPrefix}-action-menu`, button: /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t("buttons.action-menu-button.aria-label"), disabled, "data-testid": "action-menu-button", tooltipProps: {
      content: t("buttons.action-menu-button.tooltip")
    } }), menu: /* @__PURE__ */ jsx(Menu, { padding: 1, children: actionStates.map((actionState, idx) => /* @__PURE__ */ jsx(ActionMenuListItem, { actionState, disabled, index: idx, onAction: handleAction }, idx)) }), popover: popoverProps, ref: setReferenceElement });
  }, $[1] = actionStates, $[2] = disabled, $[3] = idPrefix, $[4] = t, $[5] = t1) : t1 = $[5];
  const renderActionDialog = t1;
  let t2;
  return $[6] !== actionStates || $[7] !== referenceElement || $[8] !== renderActionDialog ? (t2 = /* @__PURE__ */ jsx(ActionDialogWrapper, { actionStates, referenceElement, children: renderActionDialog }), $[6] = actionStates, $[7] = referenceElement, $[8] = renderActionDialog, $[9] = t2) : t2 = $[9], t2;
}
function ActionMenuListItem(props) {
  const $ = c(20), {
    actionState,
    disabled,
    index,
    onAction
  } = props, {
    onHandle
  } = actionState;
  let t0;
  $[0] !== index || $[1] !== onAction || $[2] !== onHandle ? (t0 = () => {
    onAction(index), onHandle && onHandle();
  }, $[0] = index, $[1] = onAction, $[2] = onHandle, $[3] = t0) : t0 = $[3];
  const handleClick = t0;
  let t1;
  $[4] !== actionState.shortcut ? (t1 = actionState.shortcut ? String(actionState.shortcut).split("+").map(_temp$w) : void 0, $[4] = actionState.shortcut, $[5] = t1) : t1 = $[5];
  const hotkeys = t1;
  let t2;
  $[6] !== actionState.label ? (t2 = actionState.label.replace(" ", ""), $[6] = actionState.label, $[7] = t2) : t2 = $[7];
  const t3 = `action-${t2}`, t4 = disabled || !!actionState.disabled;
  let t5;
  $[8] !== actionState.disabled || $[9] !== actionState.title ? (t5 = actionState.disabled && {
    tooltipProps: {
      content: actionState.title
    }
  }, $[8] = actionState.disabled, $[9] = actionState.title, $[10] = t5) : t5 = $[10];
  let t6;
  return $[11] !== actionState.icon || $[12] !== actionState.label || $[13] !== actionState.tone || $[14] !== handleClick || $[15] !== hotkeys || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuItem$1, { "data-testid": t3, disabled: t4, hotkeys, icon: actionState.icon, onClick: handleClick, text: actionState.label, tone: actionState.tone, ...t5 }), $[11] = actionState.icon, $[12] = actionState.label, $[13] = actionState.tone, $[14] = handleClick, $[15] = hotkeys, $[16] = t3, $[17] = t4, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}
function _temp$w(s) {
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}
const DocumentInitialLoadMeasured = defineEvent({
  name: "Document Initial Load Measured",
  version: 1,
  description: "Time from a document pane mounting to its form becoming ready to edit. Includes data load, schema resolution, template permissions, and (if applicable) timeline readiness. Superset of Document Pair Load Time Measured.",
  maxSampleRate: 3e4
}), DocumentURLCopied = defineEvent({
  name: "Document URL Copied",
  version: 1,
  description: "User copied document URL to clipboard"
}), DocumentIDCopied = defineEvent({
  name: "Document ID Copied",
  version: 1,
  description: "User copied document ID to clipboard"
}), InlineChangesSwitchedOn = defineEvent({
  name: "Inline Changes Switched On",
  version: 1,
  description: "User switched on display of inline changes"
}), InlineChangesSwitchedOff = defineEvent({
  name: "Inline Changes Switched Off",
  version: 1,
  description: "User switched off display of inline changes"
});
function CopyDocumentActions() {
  const $ = c(41), {
    documentId,
    documentType,
    schemaType
  } = useDocumentPaneInfo(), {
    selectedReleaseId,
    selectedPerspectiveName
  } = usePerspective(), {
    params
  } = usePaneRouter(), {
    resolveIntentLink
  } = useRouter(), {
    buildIntentUrl
  } = useStudioUrl(), {
    t
  } = useTranslation(structureLocaleNamespace), telemetry = useTelemetry(), {
    push: pushToast
  } = useToast(), scheduledDraft = params?.scheduledDraft;
  let t0;
  bb0: {
    const versionReleaseId = scheduledDraft || selectedReleaseId;
    if (versionReleaseId) {
      let t13;
      $[0] !== documentId || $[1] !== versionReleaseId ? (t13 = getVersionId(documentId, versionReleaseId), $[0] = documentId, $[1] = versionReleaseId, $[2] = t13) : t13 = $[2], t0 = t13;
      break bb0;
    }
    if (selectedPerspectiveName === "published" || schemaType?.liveEdit) {
      t0 = documentId;
      break bb0;
    }
    let t12;
    $[3] !== documentId ? (t12 = getDraftId(documentId), $[3] = documentId, $[4] = t12) : t12 = $[4], t0 = t12;
  }
  const contextAwareDocumentId = t0;
  let t1;
  $[5] !== buildIntentUrl || $[6] !== documentId || $[7] !== documentType || $[8] !== pushToast || $[9] !== resolveIntentLink || $[10] !== scheduledDraft || $[11] !== selectedReleaseId || $[12] !== t || $[13] !== telemetry ? (t1 = async () => {
    telemetry.log(DocumentURLCopied);
    const searchParams = selectedReleaseId && !scheduledDraft ? [["perspective", selectedReleaseId]] : [], intentParams = {
      id: documentId,
      type: documentType,
      ...scheduledDraft && {
        scheduledDraft
      }
    }, intentLink = resolveIntentLink("edit", intentParams, searchParams), copyUrl = buildIntentUrl(intentLink);
    await navigator.clipboard.writeText(copyUrl), pushToast({
      id: "copy-document-url",
      status: "info",
      title: t("panes.document-operation-results.operation-success_copy-url")
    });
  }, $[5] = buildIntentUrl, $[6] = documentId, $[7] = documentType, $[8] = pushToast, $[9] = resolveIntentLink, $[10] = scheduledDraft, $[11] = selectedReleaseId, $[12] = t, $[13] = telemetry, $[14] = t1) : t1 = $[14];
  const handleCopyLink = t1;
  let t2;
  $[15] !== contextAwareDocumentId || $[16] !== pushToast || $[17] !== t || $[18] !== telemetry ? (t2 = async () => {
    telemetry.log(DocumentIDCopied), await navigator.clipboard.writeText(contextAwareDocumentId), pushToast({
      id: "copy-document-id",
      status: "info",
      title: t("panes.document-operation-results.operation-success_copy-id")
    });
  }, $[15] = contextAwareDocumentId, $[16] = pushToast, $[17] = t, $[18] = telemetry, $[19] = t2) : t2 = $[19];
  const handleCopyId = t2;
  let t3;
  $[20] !== t ? (t3 = t("action.copy-document-url.label"), $[20] = t, $[21] = t3) : t3 = $[21];
  let t4;
  $[22] !== t3 ? (t4 = /* @__PURE__ */ jsx(Button$1, { icon: ShareIcon, mode: "bleed", tooltipProps: {
    content: t3
  }, "data-testid": "copy-document-actions-button" }), $[22] = t3, $[23] = t4) : t4 = $[23];
  let t5;
  $[24] !== t ? (t5 = t("action.copy-link-to-document.label"), $[24] = t, $[25] = t5) : t5 = $[25];
  let t6;
  $[26] !== handleCopyLink || $[27] !== t5 ? (t6 = /* @__PURE__ */ jsx(MenuItem$1, { icon: LinkIcon, onClick: handleCopyLink, text: t5, "data-testid": "copy-link-to-document" }), $[26] = handleCopyLink, $[27] = t5, $[28] = t6) : t6 = $[28];
  let t7;
  $[29] !== t ? (t7 = t("action.copy-document-id.label"), $[29] = t, $[30] = t7) : t7 = $[30];
  let t8;
  $[31] !== handleCopyId || $[32] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuItem$1, { icon: TargetIcon, onClick: handleCopyId, text: t7, "data-testid": "copy-document-id" }), $[31] = handleCopyId, $[32] = t7, $[33] = t8) : t8 = $[33];
  let t9;
  $[34] !== t6 || $[35] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Menu, { children: [
    t6,
    t8
  ] }), $[34] = t6, $[35] = t8, $[36] = t9) : t9 = $[36];
  let t10;
  $[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = {
    portal: !0,
    placement: "bottom-end"
  }, $[37] = t10) : t10 = $[37];
  let t11;
  return $[38] !== t4 || $[39] !== t9 ? (t11 = /* @__PURE__ */ jsx(MenuButton, { id: "copy-document-actions", button: t4, menu: t9, popover: t10 }), $[38] = t4, $[39] = t9, $[40] = t11) : t11 = $[40], t11;
}
function useChipScrollPosition(containerRef) {
  const $ = c(3), [showGradient, setShowGradient] = useState(!1);
  let t0, t1;
  return $[0] !== containerRef ? (t0 = () => {
    const checkOverflow = () => {
      const container = containerRef.current;
      if (!container)
        return;
      const {
        scrollWidth,
        clientWidth
      } = container;
      if (!(scrollWidth > clientWidth)) {
        setShowGradient(!1);
        return;
      }
      const {
        scrollLeft
      } = container, isAtEnd = scrollLeft + clientWidth >= scrollWidth;
      setShowGradient(!isAtEnd);
    }, setupObservers = function() {
      checkOverflow();
      const container_0 = containerRef.current;
      if (!container_0)
        return {
          intersectionObserver: null,
          mutationObserver: null
        };
      const intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        entry && setShowGradient(!entry.isIntersecting);
      }), updateLastChipObserver = () => {
        intersectionObserver.disconnect();
        const lastChip = container_0.children[container_0.children.length - 1];
        intersectionObserver.observe(lastChip);
      };
      updateLastChipObserver();
      const mutationObserver = new MutationObserver(() => {
        updateLastChipObserver(), checkOverflow();
      });
      return mutationObserver.observe(container_0, {
        childList: !0,
        subtree: !1
      }), {
        intersectionObserver,
        mutationObserver
      };
    }, {
      intersectionObserver: intersectionObserver_0,
      mutationObserver: mutationObserver_0
    } = setupObservers();
    return () => {
      intersectionObserver_0?.disconnect(), mutationObserver_0?.disconnect();
    };
  }, t1 = [containerRef], $[0] = containerRef, $[1] = t0, $[2] = t1) : (t0 = $[1], t1 = $[2]), useEffect(t0, t1), showGradient;
}
function NonReleaseVersionsSelect(props) {
  const $ = c(46), {
    nonReleaseVersions,
    selectedPerspective,
    onSelectBundle,
    onCopyToDraftsNavigate,
    documentType,
    getVersionDisplay,
    releasesLoading,
    releases
  } = props, {
    t
  } = useTranslation(), [nonReleaseDropdownOpen, setNonReleaseDropdownOpen] = useState(!1), [popoverReferenceElement, setPopoverReferenceElement] = useState(null);
  let t0;
  $[0] !== selectedPerspective ? (t0 = (v) => getVersionFromId(v) === selectedPerspective, $[0] = selectedPerspective, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== nonReleaseVersions || $[3] !== t0 ? (t1 = extract(nonReleaseVersions, t0), $[2] = nonReleaseVersions, $[3] = t0, $[4] = t1) : t1 = $[4];
  const [selectedNonReleaseVersion, otherNonReleaseVersions] = t1, popoverRef = useRef(null);
  let t2, t3;
  if ($[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (event) => {
    event.target && "matches" in event.target && typeof event.target.matches == "function" && event.target.matches("[data-portal] *") || setNonReleaseDropdownOpen(!1);
  }, t3 = () => [popoverRef.current], $[5] = t2, $[6] = t3) : (t2 = $[5], t3 = $[6]), useClickOutsideEvent(t2, t3), nonReleaseVersions.length === 0)
    return null;
  let t4;
  $[7] !== documentType || $[8] !== getVersionDisplay || $[9] !== onCopyToDraftsNavigate || $[10] !== onSelectBundle || $[11] !== releases || $[12] !== releasesLoading || $[13] !== selectedNonReleaseVersion ? (t4 = selectedNonReleaseVersion && (() => {
    const bundleId = getVersionFromId(selectedNonReleaseVersion), versionDisplay = getVersionDisplay(selectedNonReleaseVersion);
    return /* @__PURE__ */ jsx(VersionChip, { selected: !0, text: versionDisplay?.displayName ?? bundleId, tone: versionDisplay?.tone ?? "default", onClick: () => onSelectBundle(bundleId), onCopyToDraftsNavigate, contextValues: {
      documentId: getPublishedId(selectedNonReleaseVersion),
      releases,
      releasesLoading,
      documentType,
      bundleId,
      isVersion: !0
    } }, selectedNonReleaseVersion);
  })(), $[7] = documentType, $[8] = getVersionDisplay, $[9] = onCopyToDraftsNavigate, $[10] = onSelectBundle, $[11] = releases, $[12] = releasesLoading, $[13] = selectedNonReleaseVersion, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== nonReleaseDropdownOpen || $[16] !== otherNonReleaseVersions.length || $[17] !== t ? (t5 = otherNonReleaseVersions.length > 0 ? /* @__PURE__ */ jsx(Tooltip, { content: t("release.chip.tooltip.other-versions", {
    count: otherNonReleaseVersions.length
  }), fallbackPlacements: [], portal: !0, placement: nonReleaseDropdownOpen ? "top" : "bottom", children: /* @__PURE__ */ jsx(Chip, { mode: "bleed", fontSize: 1, muted: !0, selected: nonReleaseDropdownOpen, iconRight: nonReleaseDropdownOpen ? ChevronUpIcon : ChevronDownIcon, ref: setPopoverReferenceElement, onClick: () => setNonReleaseDropdownOpen(_temp$v), text: t("release.chip.button.other-versions", {
    count: otherNonReleaseVersions.length
  }) }) }) : null, $[15] = nonReleaseDropdownOpen, $[16] = otherNonReleaseVersions.length, $[17] = t, $[18] = t5) : t5 = $[18];
  let t6;
  if ($[19] !== documentType || $[20] !== getVersionDisplay || $[21] !== onCopyToDraftsNavigate || $[22] !== onSelectBundle || $[23] !== otherNonReleaseVersions || $[24] !== releases || $[25] !== releasesLoading || $[26] !== selectedPerspective) {
    let t72;
    $[28] !== documentType || $[29] !== getVersionDisplay || $[30] !== onCopyToDraftsNavigate || $[31] !== onSelectBundle || $[32] !== releases || $[33] !== releasesLoading || $[34] !== selectedPerspective ? (t72 = (nonReleaseVersionId) => {
      const bundle = getVersionFromId(nonReleaseVersionId), selected = selectedPerspective === bundle, versionDisplay_0 = getVersionDisplay(nonReleaseVersionId);
      return /* @__PURE__ */ jsx(VersionChip, { selected, text: versionDisplay_0?.displayName ?? bundle, disabled: !1, contextMenuPortal: !1, tone: versionDisplay_0?.tone ?? "default", onClick: () => onSelectBundle(bundle), onCopyToDraftsNavigate, contextValues: {
        documentId: getPublishedId(nonReleaseVersionId),
        releases,
        releasesLoading,
        documentType,
        bundleId: bundle,
        isVersion: !0
      } }, nonReleaseVersionId);
    }, $[28] = documentType, $[29] = getVersionDisplay, $[30] = onCopyToDraftsNavigate, $[31] = onSelectBundle, $[32] = releases, $[33] = releasesLoading, $[34] = selectedPerspective, $[35] = t72) : t72 = $[35], t6 = otherNonReleaseVersions.map(t72), $[19] = documentType, $[20] = getVersionDisplay, $[21] = onCopyToDraftsNavigate, $[22] = onSelectBundle, $[23] = otherNonReleaseVersions, $[24] = releases, $[25] = releasesLoading, $[26] = selectedPerspective, $[27] = t6;
  } else
    t6 = $[27];
  let t7;
  $[36] !== t6 ? (t7 = /* @__PURE__ */ jsx(Container$1, { width: 1, children: /* @__PURE__ */ jsx(Flex, { width: 1, padding: 3, gap: 2, wrap: "wrap", children: t6 }) }), $[36] = t6, $[37] = t7) : t7 = $[37];
  let t8;
  $[38] !== nonReleaseDropdownOpen || $[39] !== popoverReferenceElement || $[40] !== t7 ? (t8 = /* @__PURE__ */ jsx(Popover, { animate: !1, open: nonReleaseDropdownOpen, portal: !0, arrow: !0, ref: popoverRef, placement: "bottom", referenceElement: popoverReferenceElement, zOffset: 10, content: t7 }), $[38] = nonReleaseDropdownOpen, $[39] = popoverReferenceElement, $[40] = t7, $[41] = t8) : t8 = $[41];
  let t9;
  return $[42] !== t4 || $[43] !== t5 || $[44] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t4,
    t5,
    t8
  ] }), $[42] = t4, $[43] = t5, $[44] = t8, $[45] = t9) : t9 = $[45], t9;
}
function _temp$v(v_0) {
  return !v_0;
}
function extract(xs, predicate) {
  const i = xs.findIndex(predicate), match = i === -1 ? void 0 : xs[i], rest = i === -1 ? xs : xs.slice(0, i).concat(xs.slice(i + 1));
  return [match, rest];
}
const TooltipContent$1 = (t0) => {
  const $ = c(17), {
    release
  } = t0, {
    t
  } = useTranslation(), formatPublishDate = useFormatRelativeLocalePublishDate();
  if (release.state === "archived") {
    let t1;
    $[0] !== t ? (t1 = t("release.chip.tooltip.archived"), $[0] = t, $[1] = t1) : t1 = $[1];
    let t2;
    return $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text, { size: 1, children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3], t2;
  }
  if (release.metadata.releaseType === "asap") {
    let t1;
    $[4] !== t ? (t1 = t("release.type.asap"), $[4] = t, $[5] = t1) : t1 = $[5];
    let t2;
    return $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text, { size: 1, children: t1 }), $[6] = t1, $[7] = t2) : t2 = $[7], t2;
  }
  if (release.metadata.releaseType === "scheduled") {
    const isActive = release.state === "active";
    let t1;
    return $[8] !== formatPublishDate || $[9] !== isActive || $[10] !== release || $[11] !== t ? (t1 = release.metadata.intendedPublishAt && /* @__PURE__ */ jsx(Text, { size: 1, children: isActive ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.chip.tooltip.intended-for-date", values: {
      date: formatPublishDate(release)
    } }) : /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.chip.tooltip.scheduled-for-date", values: {
      date: formatPublishDate(release)
    } }) }), $[8] = formatPublishDate, $[9] = isActive, $[10] = release, $[11] = t, $[12] = t1) : t1 = $[12], t1;
  }
  if (release.metadata.releaseType === "undecided") {
    let t1;
    $[13] !== t ? (t1 = t("release.type.undecided"), $[13] = t, $[14] = t1) : t1 = $[14];
    let t2;
    return $[15] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text, { size: 1, children: t1 }), $[15] = t1, $[16] = t2) : t2 = $[16], t2;
  }
  return null;
}, DATE_TIME_FORMAT = {
  dateStyle: "medium",
  timeStyle: "short"
}, DocumentPerspectiveList = memo(function() {
  const $ = c(113), {
    selectedReleaseId,
    selectedPerspectiveName
  } = usePerspective(), {
    t
  } = useTranslation(), setPerspective = useSetPerspective(), {
    params,
    setParams
  } = usePaneRouter(), dateTimeFormat = useDateTimeFormat(DATE_TIME_FORMAT), {
    loading
  } = useActiveReleases(), schema = useSchema(), {
    editState,
    displayed
  } = useDocumentPane(), {
    documentType,
    documentId
  } = useDocumentPaneInfo(), isCreatingDocument = displayed && !displayed._createdAt, defaultPerspective = useGetDefaultPerspective(), t0 = params?.historyVersion;
  let t1;
  $[0] !== displayed || $[1] !== documentId || $[2] !== t0 ? (t1 = {
    historyVersion: t0,
    displayed,
    documentId
  }, $[0] = displayed, $[1] = documentId, $[2] = t0, $[3] = t1) : t1 = $[3];
  const filteredReleases = useFilteredReleases(t1);
  let t2;
  $[4] !== documentId ? (t2 = {
    documentId
  }, $[4] = documentId, $[5] = t2) : t2 = $[5];
  const {
    data: documentVersions
  } = useDocumentVersions(t2);
  let t3;
  $[6] !== documentVersions ? (t3 = documentVersions && documentVersions.length > 0 && !documentVersions.some(_temp$u), $[6] = documentVersions, $[7] = t3) : t3 = $[7];
  const onlyHasVersions = t3, workspace = useWorkspace(), {
    onSetScheduledDraftPerspective
  } = useSingleDocRelease();
  let t4;
  $[8] !== onSetScheduledDraftPerspective || $[9] !== params?.scheduledDraft || $[10] !== setPerspective ? (t4 = () => {
    params?.scheduledDraft ? onSetScheduledDraftPerspective("") : setPerspective("drafts");
  }, $[8] = onSetScheduledDraftPerspective, $[9] = params?.scheduledDraft, $[10] = setPerspective, $[11] = t4) : t4 = $[11];
  const handleCopyToDraftsNavigate = t4;
  let t5;
  $[12] !== defaultPerspective || $[13] !== onSetScheduledDraftPerspective || $[14] !== params || $[15] !== setParams || $[16] !== setPerspective ? (t5 = (perspective) => {
    if (isReleaseDocument(perspective) && isCardinalityOneRelease(perspective)) {
      onSetScheduledDraftPerspective(getReleaseIdFromReleaseDocumentId(perspective._id));
      return;
    }
    perspective === "published" && params?.historyVersion && setParams({
      ...params,
      rev: params?.historyEvent || void 0,
      since: void 0,
      historyVersion: void 0
    });
    const newPerspective = isReleaseDocument(perspective) ? getReleaseIdFromReleaseDocumentId(perspective._id) : perspective === defaultPerspective ? "" : perspective;
    params?.scheduledDraft ? setParams({
      ...params,
      scheduledDraft: void 0
    }, {
      perspective: newPerspective
    }) : setPerspective(newPerspective);
  }, $[12] = defaultPerspective, $[13] = onSetScheduledDraftPerspective, $[14] = params, $[15] = setParams, $[16] = setPerspective, $[17] = t5) : t5 = $[17];
  const handlePerspectiveChange = t5;
  let t6;
  if ($[18] !== documentType || $[19] !== schema) {
    const schemaType = schema.get(documentType);
    t6 = schemaType ? isLiveEditEnabled(schemaType) : !1, $[18] = documentType, $[19] = schema, $[20] = t6;
  } else
    t6 = $[20];
  const isLiveEdit = t6;
  let t7;
  bb0: {
    if (isLiveEdit && !selectedReleaseId) {
      t7 = !1;
      break bb0;
    }
    t7 = !editState?.published;
  }
  const isPublishedChipDisabled = t7;
  let t8;
  $[21] !== displayed?._id || $[22] !== editState?.version || $[23] !== params ? (t8 = (release) => {
    if (!params?.historyVersion) {
      const isCurrentVersionGoingToUnpublish = editState?.version && isGoingToUnpublish(editState?.version) && getReleaseIdFromReleaseDocumentId(release._id) === getVersionFromId(editState?.version?._id);
      return {
        selected: !!(getReleaseIdFromReleaseDocumentId(release._id) === getVersionFromId(displayed?._id || "") || isCurrentVersionGoingToUnpublish)
      };
    }
    const isReleaseHistoryMatch = getReleaseIdFromReleaseDocumentId(release._id) === params.historyVersion;
    return {
      selected: isReleaseHistoryMatch,
      disabled: isReleaseHistoryMatch
    };
  }, $[21] = displayed?._id, $[22] = editState?.version, $[23] = params, $[24] = t8) : t8 = $[24];
  const getReleaseChipState = t8;
  let t9;
  $[25] !== displayed?._id || $[26] !== editState?.draft?._id || $[27] !== isLiveEdit || $[28] !== selectedPerspectiveName || $[29] !== selectedReleaseId ? (t9 = () => !!(isLiveEdit && !editState?.draft?._id && !selectedReleaseId || isPublishedId(displayed?._id || "") && isPublishedPerspective(selectedPerspectiveName || "")), $[25] = displayed?._id, $[26] = editState?.draft?._id, $[27] = isLiveEdit, $[28] = selectedPerspectiveName, $[29] = selectedReleaseId, $[30] = t9) : t9 = $[30];
  const isPublishSelected = t9();
  let t10;
  bb1: {
    const displayedId = displayed?._id || "";
    if (isPublishSelected) {
      t10 = !1;
      break bb1;
    }
    if (params?.historyVersion) {
      t10 = !1;
      break bb1;
    }
    if (selectedPerspectiveName) {
      t10 = !1;
      break bb1;
    }
    if (isVersionId(displayedId)) {
      t10 = !1;
      break bb1;
    }
    if (isDraftId(displayedId)) {
      t10 = !0;
      break bb1;
    }
    if (isPublishedId(displayedId) && editState?.published && isPublishedPerspective(selectedPerspectiveName || "")) {
      t10 = !1;
      break bb1;
    }
    t10 = !0;
  }
  const isDraftSelected = t10;
  let t11;
  $[31] !== editState?.draft || $[32] !== isCreatingDocument || $[33] !== isLiveEdit || $[34] !== onlyHasVersions || $[35] !== selectedReleaseId ? (t11 = () => onlyHasVersions || isCreatingDocument && selectedReleaseId ? !0 : !editState?.draft && !isLiveEdit ? !1 : !!(isCreatingDocument && selectedReleaseId || isLiveEdit), $[31] = editState?.draft, $[32] = isCreatingDocument, $[33] = isLiveEdit, $[34] = onlyHasVersions, $[35] = selectedReleaseId, $[36] = t11) : t11 = $[36];
  const isDraftDisabled = t11(), isDraftModelEnabled = workspace.document.drafts?.enabled, {
    filteredVersionIds,
    getVersionDisplay
  } = useAgentVersionDisplay(documentVersions, selectedPerspectiveName);
  let t12;
  if ($[37] !== filteredReleases.currentReleases || $[38] !== filteredVersionIds) {
    let t132;
    $[40] !== filteredReleases.currentReleases ? (t132 = (versionDocumentId) => isPublishedId(versionDocumentId) || isDraftId(versionDocumentId) ? !1 : !filteredReleases.currentReleases.some((release_0) => getReleaseIdFromReleaseDocumentId(release_0._id) === getVersionFromId(versionDocumentId)), $[40] = filteredReleases.currentReleases, $[41] = t132) : t132 = $[41], t12 = filteredVersionIds.filter(t132), $[37] = filteredReleases.currentReleases, $[38] = filteredVersionIds, $[39] = t12;
  } else
    t12 = $[39];
  const nonReleaseVersions = t12;
  let t13;
  $[42] !== dateTimeFormat || $[43] !== editState?.published || $[44] !== t ? (t13 = /* @__PURE__ */ jsx(Text, { size: 1, children: editState?.published && editState?.published?._updatedAt ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.chip.tooltip.published-date", values: {
    date: dateTimeFormat.format(new Date(editState?.published._updatedAt))
  } }) : /* @__PURE__ */ jsx(Fragment, { children: t("release.chip.tooltip.not-published") }) }), $[42] = dateTimeFormat, $[43] = editState?.published, $[44] = t, $[45] = t13) : t13 = $[45];
  let t14;
  $[46] !== handlePerspectiveChange ? (t14 = () => handlePerspectiveChange("published"), $[46] = handlePerspectiveChange, $[47] = t14) : t14 = $[47];
  let t15;
  $[48] !== t ? (t15 = t("release.chip.published"), $[48] = t, $[49] = t15) : t15 = $[49];
  const t16 = editState?.published?._id || editState?.id || "", t17 = !editState?.published;
  let t18;
  $[50] !== documentType || $[51] !== filteredReleases.notCurrentReleases || $[52] !== loading || $[53] !== t16 || $[54] !== t17 ? (t18 = {
    documentId: t16,
    releases: filteredReleases.notCurrentReleases,
    releasesLoading: loading,
    documentType,
    bundleId: "published",
    isVersion: !1,
    disabled: t17
  }, $[50] = documentType, $[51] = filteredReleases.notCurrentReleases, $[52] = loading, $[53] = t16, $[54] = t17, $[55] = t18) : t18 = $[55];
  let t19;
  $[56] !== handleCopyToDraftsNavigate || $[57] !== isPublishSelected || $[58] !== isPublishedChipDisabled || $[59] !== t13 || $[60] !== t14 || $[61] !== t15 || $[62] !== t18 ? (t19 = /* @__PURE__ */ jsx(VersionChip, { tooltipContent: t13, disabled: isPublishedChipDisabled, onClick: t14, selected: isPublishSelected, text: t15, tone: "positive", onCopyToDraftsNavigate: handleCopyToDraftsNavigate, contextValues: t18 }), $[56] = handleCopyToDraftsNavigate, $[57] = isPublishSelected, $[58] = isPublishedChipDisabled, $[59] = t13, $[60] = t14, $[61] = t15, $[62] = t18, $[63] = t19) : t19 = $[63];
  let t20;
  $[64] !== dateTimeFormat || $[65] !== documentType || $[66] !== editState?.draft || $[67] !== editState?.id || $[68] !== editState?.published?._id || $[69] !== filteredReleases.notCurrentReleases || $[70] !== handleCopyToDraftsNavigate || $[71] !== handlePerspectiveChange || $[72] !== isDraftDisabled || $[73] !== isDraftModelEnabled || $[74] !== isDraftSelected || $[75] !== isLiveEdit || $[76] !== loading || $[77] !== t ? (t20 = isDraftModelEnabled && /* @__PURE__ */ jsx(VersionChip, { tooltipContent: /* @__PURE__ */ jsx(Text, { size: 1, children: editState?.draft ? /* @__PURE__ */ jsx(Fragment, { children: editState?.draft._updatedAt ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.chip.tooltip.edited-date", values: {
    date: dateTimeFormat.format(new Date(editState?.draft._updatedAt))
  } }) : /* @__PURE__ */ jsx(Translate, { t, i18nKey: "release.chip.tooltip.created-date", values: {
    date: dateTimeFormat.format(new Date(editState?.draft._createdAt))
  } }) }) : /* @__PURE__ */ jsx(Fragment, { children: t(isLiveEdit ? "release.chip.tooltip.draft-disabled.live-edit" : "release.chip.tooltip.no-edits") }) }), selected: isDraftSelected, disabled: isDraftDisabled, text: t("release.chip.draft"), tone: editState?.draft ? "caution" : "neutral", onClick: () => handlePerspectiveChange("drafts"), onCopyToDraftsNavigate: handleCopyToDraftsNavigate, contextValues: {
    documentId: editState?.draft?._id || editState?.published?._id || editState?.id || "",
    documentType,
    releases: filteredReleases.notCurrentReleases,
    releasesLoading: loading,
    bundleId: "draft",
    isVersion: !1
  } }), $[64] = dateTimeFormat, $[65] = documentType, $[66] = editState?.draft, $[67] = editState?.id, $[68] = editState?.published?._id, $[69] = filteredReleases.notCurrentReleases, $[70] = handleCopyToDraftsNavigate, $[71] = handlePerspectiveChange, $[72] = isDraftDisabled, $[73] = isDraftModelEnabled, $[74] = isDraftSelected, $[75] = isLiveEdit, $[76] = loading, $[77] = t, $[78] = t20) : t20 = $[78];
  let t21;
  $[79] !== displayed?._id || $[80] !== documentType || $[81] !== filteredReleases.inCreation || $[82] !== filteredReleases.notCurrentReleases || $[83] !== handleCopyToDraftsNavigate || $[84] !== loading || $[85] !== t ? (t21 = filteredReleases.inCreation && /* @__PURE__ */ jsx(ReleaseTitle, { title: filteredReleases.inCreation.metadata.title, fallback: t("release.placeholder-untitled-release"), enableTooltip: !1, children: (t222) => {
    const {
      displayTitle,
      fullTitle,
      isTruncated
    } = t222;
    return /* @__PURE__ */ jsx(VersionChip, { tooltipContent: isTruncated ? /* @__PURE__ */ jsxs(Stack, { space: 2, style: {
      maxWidth: "300px"
    }, children: [
      /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: fullTitle }),
      /* @__PURE__ */ jsx(TooltipContent$1, { release: filteredReleases.inCreation })
    ] }) : /* @__PURE__ */ jsx(TooltipContent$1, { release: filteredReleases.inCreation }), selected: !0, onClick: _temp2$f, locked: !1, tone: getReleaseTone(filteredReleases.inCreation), text: displayTitle, onCopyToDraftsNavigate: handleCopyToDraftsNavigate, contextValues: {
      documentId: displayed?._id || "",
      documentType,
      disabled: !0,
      releases: filteredReleases.notCurrentReleases,
      releasesLoading: loading,
      bundleId: getReleaseIdFromReleaseDocumentId(filteredReleases.inCreation._id),
      isVersion: !0,
      release: filteredReleases.inCreation
    } });
  } }), $[79] = displayed?._id, $[80] = documentType, $[81] = filteredReleases.inCreation, $[82] = filteredReleases.notCurrentReleases, $[83] = handleCopyToDraftsNavigate, $[84] = loading, $[85] = t, $[86] = t21) : t21 = $[86];
  let t22;
  $[87] !== displayed || $[88] !== documentType || $[89] !== editState?.version || $[90] !== filteredReleases.currentReleases || $[91] !== filteredReleases.notCurrentReleases || $[92] !== getReleaseChipState || $[93] !== handleCopyToDraftsNavigate || $[94] !== handlePerspectiveChange || $[95] !== loading || $[96] !== t ? (t22 = displayed && filteredReleases.currentReleases?.map((release_1) => /* @__PURE__ */ jsx(ReleaseTitle, { title: release_1.metadata.title, fallback: t("release.placeholder-untitled-release"), enableTooltip: !1, children: (t232) => {
    const {
      displayTitle: displayTitle_0,
      fullTitle: fullTitle_0,
      isTruncated: isTruncated_0
    } = t232;
    return /* @__PURE__ */ jsx(VersionChip, { tooltipContent: isTruncated_0 ? /* @__PURE__ */ jsxs(Stack, { space: 2, style: {
      maxWidth: "300px"
    }, children: [
      /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: fullTitle_0 }),
      /* @__PURE__ */ jsx(TooltipContent$1, { release: release_1 })
    ] }) : /* @__PURE__ */ jsx(TooltipContent$1, { release: release_1 }), ...getReleaseChipState(release_1), onClick: () => handlePerspectiveChange(release_1), text: displayTitle_0, tone: getReleaseTone(release_1), locked: isReleaseScheduledOrScheduling(release_1), onCopyToDraftsNavigate: handleCopyToDraftsNavigate, contextValues: {
      documentId: displayed?._id || "",
      documentType,
      releases: filteredReleases.notCurrentReleases,
      releasesLoading: loading,
      bundleId: getReleaseIdFromReleaseDocumentId(release_1._id),
      isVersion: !0,
      release: release_1,
      isGoingToUnpublish: editState?.version ? isGoingToUnpublish(editState?.version) : !1
    } });
  } }, release_1._id)), $[87] = displayed, $[88] = documentType, $[89] = editState?.version, $[90] = filteredReleases.currentReleases, $[91] = filteredReleases.notCurrentReleases, $[92] = getReleaseChipState, $[93] = handleCopyToDraftsNavigate, $[94] = handlePerspectiveChange, $[95] = loading, $[96] = t, $[97] = t22) : t22 = $[97];
  let t23;
  $[98] !== documentType || $[99] !== filteredReleases.notCurrentReleases || $[100] !== getVersionDisplay || $[101] !== handleCopyToDraftsNavigate || $[102] !== handlePerspectiveChange || $[103] !== loading || $[104] !== nonReleaseVersions || $[105] !== selectedPerspectiveName ? (t23 = /* @__PURE__ */ jsx(NonReleaseVersionsSelect, { nonReleaseVersions, selectedPerspective: selectedPerspectiveName, onSelectBundle: handlePerspectiveChange, onCopyToDraftsNavigate: handleCopyToDraftsNavigate, releases: filteredReleases.notCurrentReleases, releasesLoading: loading, documentType, getVersionDisplay }), $[98] = documentType, $[99] = filteredReleases.notCurrentReleases, $[100] = getVersionDisplay, $[101] = handleCopyToDraftsNavigate, $[102] = handlePerspectiveChange, $[103] = loading, $[104] = nonReleaseVersions, $[105] = selectedPerspectiveName, $[106] = t23) : t23 = $[106];
  let t24;
  return $[107] !== t19 || $[108] !== t20 || $[109] !== t21 || $[110] !== t22 || $[111] !== t23 ? (t24 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t19,
    t20,
    t21,
    t22,
    t23
  ] }), $[107] = t19, $[108] = t20, $[109] = t21, $[110] = t22, $[111] = t23, $[112] = t24) : t24 = $[112], t24;
});
function _temp$u(version) {
  return !isVersionId(version);
}
function _temp2$f() {
}
const HorizontalScroller = /* @__PURE__ */ styled(Card).withConfig({
  displayName: "HorizontalScroller",
  componentId: "sc-4smkq-0"
})((props) => {
  const theme = getTheme_v2(props.theme);
  return css`
    scrollbar-width: none;
    z-index: 1;
    flex: 1;
    position: relative;
    > div {
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }

    ${props.$showGradient && css`
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 150px;
        background: linear-gradient(to right, ${rgba(theme.color.bg, 0)}, var(--card-bg-color));
        transition: 'opacity 300ms ease-out';
        pointer-events: none;
      }
    `}
  `;
}), DocumentPanelHeader = memo(forwardRef(function(_props, ref) {
  const $ = c(42), {
    menuItems
  } = _props, {
    editState,
    onMenuAction,
    onPaneClose,
    onPaneSplit,
    onSetMaximizedPane,
    menuItemGroups,
    schemaType,
    connectionState,
    views,
    unstable_languageFilter,
    documentId
  } = useDocumentPane(), {
    features
  } = useStructureTool(), {
    index,
    BackLink: BackLink2,
    hasGroupSiblings
  } = usePaneRouter(), {
    maximizedPane
  } = useResolvedPanesList(), {
    actions: fieldActions
  } = useFieldActions(), [referenceElement, setReferenceElement] = useState(null), scrollContainerRef = useRef(null), showGradient = useChipScrollPosition(scrollContainerRef), telemetry = useTelemetry(), zIndex = useZIndex(), paneHeaderZIndex = Array.isArray(zIndex.paneHeader) ? zIndex.paneHeader[1] : zIndex.paneHeader;
  let t0;
  $[0] !== fieldActions || $[1] !== menuItemGroups || $[2] !== menuItems || $[3] !== onMenuAction ? (t0 = resolveMenuNodes({
    actionHandler: onMenuAction,
    fieldActions,
    menuItems,
    menuItemGroups
  }), $[0] = fieldActions, $[1] = menuItemGroups, $[2] = menuItems, $[3] = onMenuAction, $[4] = t0) : t0 = $[4];
  const menuNodes = t0;
  let t1;
  $[5] !== menuNodes ? (t1 = menuNodes.filter(isMenuNodeButton), $[5] = menuNodes, $[6] = t1) : t1 = $[6];
  const menuButtonNodes = t1;
  let t2;
  $[7] !== menuNodes ? (t2 = menuNodes.filter(isNotMenuNodeButton), $[7] = menuNodes, $[8] = t2) : t2 = $[8];
  const contextMenuNodes = t2, {
    collapsed,
    isLast
  } = usePane(), tabIndex = isLast && !collapsed ? -1 : 0, showSplitPaneButton = features.splitViews && onPaneSplit && views.length > 1, showSplitPaneCloseButton = showSplitPaneButton && hasGroupSiblings, showBackButton = features.backButton && index > 0, showPaneGroupCloseButton = !showSplitPaneCloseButton && !showBackButton && !!BackLink2, {
    t
  } = useTranslation(structureLocaleNamespace), isMaximizedPane = maximizedPane?.pane && typeof maximizedPane.pane == "object" && maximizedPane.pane.type === "document" && maximizedPane.pane.options.id === documentId;
  let t3;
  $[9] !== isMaximizedPane || $[10] !== onSetMaximizedPane || $[11] !== telemetry ? (t3 = () => {
    onSetMaximizedPane?.(), isMaximizedPane ? telemetry.log(FocusDocumentPaneCollapsed) : telemetry.log(FocusDocumentPaneClicked);
  }, $[9] = isMaximizedPane, $[10] = onSetMaximizedPane, $[11] = telemetry, $[12] = t3) : t3 = $[12];
  const handleFocusPane = t3;
  let t4;
  $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(DocumentHeaderTitle, {}), $[13] = t4) : t4 = $[13];
  const title = t4;
  let t5;
  $[14] !== BackLink2 || $[15] !== showBackButton || $[16] !== t ? (t5 = showBackButton && /* @__PURE__ */ jsx(Button$1, { as: BackLink2, "data-as": "a", icon: ArrowLeftIcon, mode: "bleed", tooltipProps: {
    content: t("pane-header.back-button.text")
  } }), $[14] = BackLink2, $[15] = showBackButton, $[16] = t, $[17] = t5) : t5 = $[17];
  const backButton = t5;
  let t6;
  return $[18] !== BackLink2 || $[19] !== backButton || $[20] !== collapsed || $[21] !== connectionState || $[22] !== contextMenuNodes || $[23] !== editState || $[24] !== handleFocusPane || $[25] !== isMaximizedPane || $[26] !== menuButtonNodes || $[27] !== onPaneClose || $[28] !== onPaneSplit || $[29] !== onSetMaximizedPane || $[30] !== paneHeaderZIndex || $[31] !== ref || $[32] !== referenceElement || $[33] !== schemaType || $[34] !== showGradient || $[35] !== showPaneGroupCloseButton || $[36] !== showSplitPaneButton || $[37] !== showSplitPaneCloseButton || $[38] !== t || $[39] !== tabIndex || $[40] !== unstable_languageFilter ? (t6 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: collapsed ? /* @__PURE__ */ jsx(PaneHeader$1, { border: !0, ref, loading: connectionState === "connecting" && !editState?.draft && !editState?.published, title, tabIndex, backButton }) : /* @__PURE__ */ jsx(Card, { hidden: collapsed, style: {
    lineHeight: 0,
    position: "relative",
    zIndex: paneHeaderZIndex
  }, borderBottom: !0, children: /* @__PURE__ */ jsxs(Flex, { gap: 3, paddingY: 3, children: [
    /* @__PURE__ */ jsx(HorizontalScroller, { $showGradient: showGradient, children: /* @__PURE__ */ jsx(Flex, { flex: 1, gap: 1, overflow: "auto", paddingX: 3, "data-testid": "document-perspective-list", ref: scrollContainerRef, children: /* @__PURE__ */ jsx(DocumentPerspectiveList, {}) }) }),
    /* @__PURE__ */ jsx(Box, { flex: "none", paddingRight: 3, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
      unstable_languageFilter.length > 0 && /* @__PURE__ */ jsx(Fragment, { children: unstable_languageFilter.map((LanguageFilterComponent, idx) => /* @__PURE__ */ jsx(LanguageFilterComponent, { schemaType }, `language-filter-${idx}`)) }),
      /* @__PURE__ */ jsx(CopyDocumentActions, {}),
      menuButtonNodes.map(_temp$t),
      editState && /* @__PURE__ */ jsx(RenderActionCollectionState, { group: "paneActions", children: (t7) => {
        const {
          states
        } = t7;
        return /* @__PURE__ */ jsx(DocumentPanelHeaderActionDialogDeferred, { contextMenuNodes, setReferenceElement, referenceElement, states });
      } }),
      showSplitPaneButton && /* @__PURE__ */ jsx(Button$1, { "aria-label": t("buttons.split-pane-button.aria-label"), icon: SplitVerticalIcon, mode: "bleed", onClick: onPaneSplit, tooltipProps: {
        content: t("buttons.split-pane-button.tooltip")
      } }, "split-pane-button"),
      onSetMaximizedPane && /* @__PURE__ */ jsx(Button$1, { "aria-label": t(isMaximizedPane ? "buttons.focus-pane-button.aria-label.collapse" : "buttons.focus-pane-button.aria-label.focus"), icon: isMaximizedPane ? CollapseIcon : ExpandIcon, mode: "bleed", onClick: handleFocusPane, tooltipProps: {
        content: t(isMaximizedPane ? "buttons.focus-pane-button.tooltip.collapse" : "buttons.focus-pane-button.tooltip.focus")
      }, "data-testid": isMaximizedPane ? "focus-pane-button-collapse" : "focus-pane-button-focus" }, "focus-pane-button"),
      showSplitPaneCloseButton && /* @__PURE__ */ jsx(Button$1, { icon: CloseIcon, mode: "bleed", onClick: onPaneClose, tooltipProps: {
        content: t("buttons.split-pane-close-button.title")
      } }, "close-view-button"),
      showPaneGroupCloseButton && /* @__PURE__ */ jsx(Button$1, { icon: CloseIcon, mode: "bleed", tooltipProps: {
        content: t("buttons.split-pane-close-group-button.title")
      }, as: BackLink2 }, "close-view-button")
    ] }) })
  ] }) }) }), $[18] = BackLink2, $[19] = backButton, $[20] = collapsed, $[21] = connectionState, $[22] = contextMenuNodes, $[23] = editState, $[24] = handleFocusPane, $[25] = isMaximizedPane, $[26] = menuButtonNodes, $[27] = onPaneClose, $[28] = onPaneSplit, $[29] = onSetMaximizedPane, $[30] = paneHeaderZIndex, $[31] = ref, $[32] = referenceElement, $[33] = schemaType, $[34] = showGradient, $[35] = showPaneGroupCloseButton, $[36] = showSplitPaneButton, $[37] = showSplitPaneCloseButton, $[38] = t, $[39] = tabIndex, $[40] = unstable_languageFilter, $[41] = t6) : t6 = $[41], t6;
})), DocumentPanelHeaderActionDialogDeferred = memo(function(props) {
  const $ = c(7), {
    setReferenceElement,
    referenceElement,
    contextMenuNodes
  } = props, states = useDeferredValue(props.states);
  let t0;
  $[0] !== states ? (t0 = states.filter(_temp2$e), $[0] = states, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== contextMenuNodes || $[3] !== referenceElement || $[4] !== setReferenceElement || $[5] !== t0 ? (t1 = /* @__PURE__ */ jsx(DocumentPanelHeaderActionDialog, { setReferenceElement, referenceElement, contextMenuNodes, states: t0 }), $[2] = contextMenuNodes, $[3] = referenceElement, $[4] = setReferenceElement, $[5] = t0, $[6] = t1) : t1 = $[6], t1;
}), DocumentPanelHeaderActionDialog = memo(function(props) {
  const $ = c(8), {
    states,
    setReferenceElement,
    contextMenuNodes,
    referenceElement
  } = props;
  let t0;
  $[0] !== contextMenuNodes || $[1] !== setReferenceElement || $[2] !== states ? (t0 = (t12) => {
    const {
      handleAction
    } = t12;
    return /* @__PURE__ */ jsx("div", { ref: setReferenceElement, children: /* @__PURE__ */ jsx(PaneContextMenuButton, { nodes: contextMenuNodes, actionsNodes: states.length > 0 ? states.map((actionState, actionIndex) => /* @__PURE__ */ jsx(ActionMenuListItem, { actionState, disabled: !!actionState.disabled, index: actionIndex, onAction: handleAction }, actionState.label)) : void 0 }, "context-menu") });
  }, $[0] = contextMenuNodes, $[1] = setReferenceElement, $[2] = states, $[3] = t0) : t0 = $[3];
  const renderActionDialog = t0;
  let t1;
  return $[4] !== referenceElement || $[5] !== renderActionDialog || $[6] !== states ? (t1 = /* @__PURE__ */ jsx(ActionDialogWrapper, { actionStates: states, referenceElement, children: renderActionDialog }), $[4] = referenceElement, $[5] = renderActionDialog, $[6] = states, $[7] = t1) : t1 = $[7], t1;
});
function _temp$t(item) {
  return /* @__PURE__ */ jsx(PaneHeaderActionButton, { node: item }, item.key);
}
function _temp2$e(state2) {
  return state2.action ? state2.action !== useHistoryRestoreAction.action : !0;
}
function SpacerButton(t0) {
  const $ = c(3), {
    size
  } = t0;
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    pointerEvents: "none",
    visibility: "hidden",
    width: 0
  }, $[0] = t1) : t1 = $[0];
  let t2;
  return $[1] !== size ? (t2 = /* @__PURE__ */ jsx(Button$1, { "aria-hidden": !0, disabled: !0, size, style: t1, text: "-" }), $[1] = size, $[2] = t2) : t2 = $[2], t2;
}
const BADGE_TONES = {
  primary: "primary",
  success: "positive",
  warning: "caution",
  danger: "critical"
}, DocumentBadgesInner = memo(function(t0) {
  const $ = c(4), {
    states
  } = t0;
  if (states.length === 0)
    return null;
  let t1;
  $[0] !== states ? (t1 = states.map(_temp$s), $[0] = states, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Inline, { space: 1, children: t1 }), $[2] = t1, $[3] = t2) : t2 = $[3], t2;
}), DocumentBadgesDeferred = memo(function(props) {
  const $ = c(2), states = useDeferredValue(props.states);
  let t0;
  return $[0] !== states ? (t0 = /* @__PURE__ */ jsx(DocumentBadgesInner, { states }), $[0] = states, $[1] = t0) : t0 = $[1], t0;
});
function DocumentBadges() {
  const $ = c(3), {
    badges,
    editState
  } = useDocumentPane(), renderDocumentBadges = _temp2$d;
  if (!editState || !badges)
    return null;
  let t0;
  return $[0] !== badges || $[1] !== editState ? (t0 = /* @__PURE__ */ jsx(RenderBadgeCollectionState, { badges, badgeProps: editState, children: renderDocumentBadges }), $[0] = badges, $[1] = editState, $[2] = t0) : t0 = $[2], t0;
}
function _temp2$d(t0) {
  const {
    states
  } = t0;
  return /* @__PURE__ */ jsx(DocumentBadgesDeferred, { states });
}
function _temp$s(badge, index) {
  return /* @__PURE__ */ jsx(Tooltip, { content: badge.title, disabled: !badge.title, placement: "top", portal: !0, children: /* @__PURE__ */ jsx(Badge, { fontSize: 1, mode: "outline", paddingX: 2, paddingY: 1, radius: 4, tone: badge.color ? BADGE_TONES[badge.color] : void 0, style: {
    whiteSpace: "nowrap"
  }, children: badge.label }) }, `${badge.label}-${index}`);
}
const DISABLED_REASON_TITLE_KEY$1 = {
  NOTHING_TO_DELETE: "action.delete.disabled.nothing-to-delete",
  NOT_READY: "action.delete.disabled.not-ready"
}, useDeleteAction = (t0) => {
  const $ = c(41), {
    id,
    type,
    draft,
    version
  } = t0;
  let t1;
  $[0] !== version ? (t1 = version?._id && getVersionFromId(version._id), $[0] = version, $[1] = t1) : t1 = $[1];
  const bundleId = t1, isAgentBundle = isAgentBundleName(bundleId), {
    delete: deleteOp
  } = useDocumentOperation(id, type, bundleId), [isDeleting, setIsDeleting] = useState(!1), [isConfirmDialogOpen, setConfirmDialogOpen] = useState(!1), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t2;
  $[2] !== id ? (t2 = {
    documentId: id
  }, $[2] = id, $[3] = t2) : t2 = $[3];
  const {
    sortedDocumentList
  } = useDocumentVersionTypeSortedList(t2);
  let t3;
  $[4] !== sortedDocumentList ? (t3 = sortedDocumentList.some(isReleaseScheduledOrScheduling), $[4] = sortedDocumentList, $[5] = t3) : t3 = $[5];
  const hasScheduledRelease = t3;
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setConfirmDialogOpen(!1);
  }, $[6] = t4) : t4 = $[6];
  const handleCancel = t4;
  let t5;
  $[7] !== deleteOp ? (t5 = (versions) => {
    setConfirmDialogOpen(!1), setIsDeleting(!0), deleteOp.execute(versions), setIsDeleting(!1);
  }, $[7] = deleteOp, $[8] = t5) : t5 = $[8];
  const handleConfirm = t5;
  let t6;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    setConfirmDialogOpen(!0);
  }, $[9] = t6) : t6 = $[9];
  const handle = t6;
  let t7;
  $[10] !== bundleId || $[11] !== id || $[12] !== type ? (t7 = {
    id,
    type,
    version: bundleId,
    permission: "delete"
  }, $[10] = bundleId, $[11] = id, $[12] = type, $[13] = t7) : t7 = $[13];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t7), currentUser = useCurrentUser();
  let t8;
  bb0: {
    if (isAgentBundle) {
      t8 = null;
      break bb0;
    }
    if (!isPermissionsLoading && !permissions?.granted) {
      let t92;
      $[14] !== t ? (t92 = t("action.delete.label"), $[14] = t, $[15] = t92) : t92 = $[15];
      let t102;
      $[16] !== currentUser ? (t102 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "delete-document", currentUser }), $[16] = currentUser, $[17] = t102) : t102 = $[17];
      let t112;
      $[18] !== t102 || $[19] !== t92 ? (t112 = {
        tone: "critical",
        icon: TrashIcon,
        disabled: !0,
        label: t92,
        title: t102
      }, $[18] = t102, $[19] = t92, $[20] = t112) : t112 = $[20], t8 = t112;
      break bb0;
    }
    let t9;
    $[21] !== deleteOp.disabled || $[22] !== hasScheduledRelease || $[23] !== t ? (t9 = () => hasScheduledRelease ? t("action.delete.disabled.scheduled-release") : deleteOp.disabled ? t(DISABLED_REASON_TITLE_KEY$1[deleteOp.disabled]) : "", $[21] = deleteOp.disabled, $[22] = hasScheduledRelease, $[23] = t, $[24] = t9) : t9 = $[24];
    const getTitle = t9, t10 = isDeleting || hasScheduledRelease || !!deleteOp.disabled || isPermissionsLoading;
    let t11;
    $[25] !== getTitle ? (t11 = getTitle(), $[25] = getTitle, $[26] = t11) : t11 = $[26];
    let t12;
    $[27] !== isDeleting || $[28] !== t ? (t12 = t(isDeleting ? "action.delete.running.label" : "action.delete.label"), $[27] = isDeleting, $[28] = t, $[29] = t12) : t12 = $[29];
    let t13;
    $[30] !== draft?._id || $[31] !== handleConfirm || $[32] !== id || $[33] !== isConfirmDialogOpen || $[34] !== type ? (t13 = isConfirmDialogOpen && {
      type: "custom",
      component: /* @__PURE__ */ jsx(ConfirmDeleteDialogContainer, { action: "delete", id: draft?._id || id, type, onCancel: handleCancel, onConfirm: handleConfirm })
    }, $[30] = draft?._id, $[31] = handleConfirm, $[32] = id, $[33] = isConfirmDialogOpen, $[34] = type, $[35] = t13) : t13 = $[35];
    let t14;
    $[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 ? (t14 = {
      tone: "critical",
      icon: TrashIcon,
      disabled: t10,
      title: t11,
      label: t12,
      shortcut: "Ctrl+Alt+D",
      onHandle: handle,
      dialog: t13
    }, $[36] = t10, $[37] = t11, $[38] = t12, $[39] = t13, $[40] = t14) : t14 = $[40], t8 = t14;
  }
  return t8;
};
useDeleteAction.action = "delete";
useDeleteAction.displayName = "DeleteAction";
function ConfirmDiscardDialog(t0) {
  const $ = c(18), {
    publishedExists,
    onCancel,
    onConfirm
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), dialogId = `deletion-confirmation-${useId()}`;
  let t1;
  $[0] !== t ? (t1 = t("action.discard-changes.confirm-dialog.header.text"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t ? (t2 = t("action.discard-changes.label"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== onConfirm || $[5] !== t2 ? (t3 = {
    confirmButton: {
      text: t2,
      onClick: onConfirm
    }
  }, $[4] = onConfirm, $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== publishedExists || $[8] !== t ? (t4 = t(publishedExists ? "action.discard-changes.confirm-dialog.confirm-discard-changes" : "action.discard-changes.confirm-dialog.confirm-discard-changes-draft"), $[7] = publishedExists, $[8] = t, $[9] = t4) : t4 = $[9];
  let t5;
  $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text, { size: 1, children: t4 }), $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== dialogId || $[13] !== onCancel || $[14] !== t1 || $[15] !== t3 || $[16] !== t5 ? (t6 = /* @__PURE__ */ jsx(Dialog, { width: 1, id: dialogId, header: t1, footer: t3, onClose: onCancel, onClickOutside: onCancel, children: t5 }), $[12] = dialogId, $[13] = onCancel, $[14] = t1, $[15] = t3, $[16] = t5, $[17] = t6) : t6 = $[17], t6;
}
const DISABLED_REASON_KEY$2 = {
  NO_CHANGES: "action.discard-changes.disabled.no-change",
  NOT_PUBLISHED: "action.discard-changes.disabled.not-published",
  NOT_READY: "action.discard-changes.disabled.not-ready"
}, useDiscardChangesAction = (t0) => {
  const $ = c(31), {
    id,
    type,
    published,
    version,
    draft
  } = t0;
  let t1;
  $[0] !== version ? (t1 = version?._id && getVersionFromId(version._id), $[0] = version, $[1] = t1) : t1 = $[1];
  const bundleId = t1, {
    discardChanges
  } = useDocumentOperation(id, type, bundleId), [isConfirmDialogOpen, setConfirmDialogOpen] = useState(!1);
  let t2;
  $[2] !== bundleId || $[3] !== id || $[4] !== type ? (t2 = {
    id,
    type,
    version: bundleId,
    permission: "discardDraft"
  }, $[2] = bundleId, $[3] = id, $[4] = type, $[5] = t2) : t2 = $[5];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t2), currentUser = useCurrentUser(), {
    displayed
  } = useDocumentPane(), {
    t
  } = useTranslation(structureLocaleNamespace), isPublished = displayed?._id && isPublishedId(displayed?._id);
  let t3;
  $[6] !== discardChanges ? (t3 = () => {
    discardChanges.execute(), setConfirmDialogOpen(!1);
  }, $[6] = discardChanges, $[7] = t3) : t3 = $[7];
  const handleConfirm = t3;
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => {
    setConfirmDialogOpen(!1);
  }, $[8] = t4) : t4 = $[8];
  const handleCancel = t4;
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    setConfirmDialogOpen(!0);
  }, $[9] = t5) : t5 = $[9];
  const handle = t5;
  let t6;
  bb0: {
    if (!version && !draft) {
      t6 = null;
      break bb0;
    }
    if (isPublished) {
      t6 = null;
      break bb0;
    }
    if (!isPermissionsLoading && !permissions?.granted) {
      let t72;
      $[10] !== t ? (t72 = t("action.discard-changes.label"), $[10] = t, $[11] = t72) : t72 = $[11];
      let t82;
      $[12] !== currentUser ? (t82 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "discard-changes", currentUser }), $[12] = currentUser, $[13] = t82) : t82 = $[13];
      let t92;
      $[14] !== t72 || $[15] !== t82 ? (t92 = {
        tone: "critical",
        icon: ResetIcon,
        disabled: !0,
        label: t72,
        title: t82
      }, $[14] = t72, $[15] = t82, $[16] = t92) : t92 = $[16], t6 = t92;
      break bb0;
    }
    const t7 = !!discardChanges.disabled || isPermissionsLoading, t8 = discardChanges.disabled && DISABLED_REASON_KEY$2[discardChanges.disabled] || "";
    let t9;
    $[17] !== t || $[18] !== t8 ? (t9 = t(t8), $[17] = t, $[18] = t8, $[19] = t9) : t9 = $[19];
    let t10;
    $[20] !== t ? (t10 = t("action.discard-changes.label"), $[20] = t, $[21] = t10) : t10 = $[21];
    let t11;
    $[22] !== handleConfirm || $[23] !== isConfirmDialogOpen || $[24] !== published ? (t11 = isConfirmDialogOpen && {
      type: "custom",
      component: /* @__PURE__ */ jsx(ConfirmDiscardDialog, { onCancel: handleCancel, onConfirm: handleConfirm, publishedExists: !!published })
    }, $[22] = handleConfirm, $[23] = isConfirmDialogOpen, $[24] = published, $[25] = t11) : t11 = $[25];
    let t12;
    $[26] !== t10 || $[27] !== t11 || $[28] !== t7 || $[29] !== t9 ? (t12 = {
      tone: "critical",
      icon: ResetIcon,
      disabled: t7,
      title: t9,
      label: t10,
      onHandle: handle,
      dialog: t11
    }, $[26] = t10, $[27] = t11, $[28] = t7, $[29] = t9, $[30] = t12) : t12 = $[30], t6 = t12;
  }
  return t6;
};
useDiscardChangesAction.action = "discardChanges";
useDiscardChangesAction.displayName = "DiscardChangesAction";
const DISABLED_REASON_KEY$1 = {
  NOTHING_TO_DUPLICATE: "action.duplicate.disabled.nothing-to-duplicate",
  NOT_READY: "action.duplicate.disabled.not-ready"
}, useDuplicateAction = (t0) => {
  const $ = c(31), {
    id,
    type,
    release,
    mapDocument,
    version
  } = t0, documentStore = useDocumentStore();
  let t1;
  $[0] !== version ? (t1 = version?._id && getVersionFromId(version._id), $[0] = version, $[1] = t1) : t1 = $[1];
  const bundleId = t1, {
    duplicate
  } = useDocumentOperation(id, type, bundleId), {
    navigateIntent
  } = useRouter(), [isDuplicating, setDuplicating] = useState(!1);
  let t2;
  $[2] !== id || $[3] !== release || $[4] !== type ? (t2 = {
    id,
    type,
    version: release,
    permission: "duplicate"
  }, $[2] = id, $[3] = release, $[4] = type, $[5] = t2) : t2 = $[5];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t2), {
    t
  } = useTranslation(structureLocaleNamespace), currentUser = useCurrentUser();
  let t3;
  $[6] !== documentStore.pair || $[7] !== duplicate || $[8] !== id || $[9] !== mapDocument || $[10] !== navigateIntent || $[11] !== type ? (t3 = async () => {
    const dupeId = uuid();
    setDuplicating(!0);
    const duplicateSuccess = firstValueFrom(documentStore.pair.operationEvents(id, type).pipe(filter(_temp$r)));
    duplicate.execute(dupeId, {
      mapDocument
    }), await duplicateSuccess, navigateIntent("edit", {
      id: dupeId,
      type
    }), setDuplicating(!1);
  }, $[6] = documentStore.pair, $[7] = duplicate, $[8] = id, $[9] = mapDocument, $[10] = navigateIntent, $[11] = type, $[12] = t3) : t3 = $[12];
  const handle = t3;
  let t4;
  bb0: {
    if (!isPermissionsLoading && !permissions?.granted) {
      let t52;
      $[13] !== t ? (t52 = t("action.duplicate.label"), $[13] = t, $[14] = t52) : t52 = $[14];
      let t62;
      $[15] !== currentUser ? (t62 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "duplicate-document", currentUser }), $[15] = currentUser, $[16] = t62) : t62 = $[16];
      let t72;
      $[17] !== t52 || $[18] !== t62 ? (t72 = {
        icon: CopyIcon,
        disabled: !0,
        label: t52,
        title: t62
      }, $[17] = t52, $[18] = t62, $[19] = t72) : t72 = $[19], t4 = t72;
      break bb0;
    }
    const t5 = isDuplicating || !!duplicate.disabled || isPermissionsLoading;
    let t6;
    $[20] !== isDuplicating || $[21] !== t ? (t6 = t(isDuplicating ? "action.duplicate.running.label" : "action.duplicate.label"), $[20] = isDuplicating, $[21] = t, $[22] = t6) : t6 = $[22];
    let t7;
    $[23] !== duplicate.disabled || $[24] !== t ? (t7 = duplicate.disabled ? t(DISABLED_REASON_KEY$1[duplicate.disabled]) : "", $[23] = duplicate.disabled, $[24] = t, $[25] = t7) : t7 = $[25];
    let t8;
    $[26] !== handle || $[27] !== t5 || $[28] !== t6 || $[29] !== t7 ? (t8 = {
      icon: CopyIcon,
      disabled: t5,
      label: t6,
      title: t7,
      onHandle: handle
    }, $[26] = handle, $[27] = t5, $[28] = t6, $[29] = t7, $[30] = t8) : t8 = $[30], t4 = t8;
  }
  return t4;
};
useDuplicateAction.action = "duplicate";
useDuplicateAction.displayName = "DuplicateAction";
function _temp$r(e) {
  return e.op === "duplicate" && e.type === "success";
}
const DocumentPublished = defineEvent({
  name: "Document Published",
  version: 1,
  description: 'User clicked the "Publish" button in the document pane'
}), PublishButtonClicked = defineEvent({
  name: "Publish Button Clicked",
  version: 1,
  description: "Logs when a publish operation is started, completed, or failed"
}), PublishButtonDisabledStart = defineEvent({
  name: "Publish Button Becomes Disabled - Started",
  version: 1,
  description: "Logs when the publish button becomes disabled"
}), PublishButtonDisabledComplete = defineEvent({
  name: "Publish Button Becomes Disabled - Completed",
  version: 1,
  description: "Logs when the publish button becomes enabled again"
}), DISABLED_REASON_TITLE_KEY = {
  LIVE_EDIT_ENABLED: "action.publish.live-edit.publish-disabled",
  ALREADY_PUBLISHED: "action.publish.already-published.no-time-ago.tooltip",
  NO_CHANGES: "action.publish.no-changes.tooltip",
  NOT_READY: "action.publish.disabled.not-ready"
}, PUBLISHED_STATE = {
  status: "published"
};
function getDisabledReason(reason, publishedAt, t) {
  return reason === "ALREADY_PUBLISHED" && publishedAt ? /* @__PURE__ */ jsx(AlreadyPublished, { publishedAt }) : t(DISABLED_REASON_TITLE_KEY[reason]);
}
function AlreadyPublished(t0) {
  const $ = c(6), {
    publishedAt
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = {
    useTemporalPhrase: !0
  }, $[0] = t1) : t1 = $[0];
  const timeSincePublished = useRelativeTime(publishedAt, t1);
  let t2;
  $[1] !== t || $[2] !== timeSincePublished ? (t2 = t("action.publish.already-published.tooltip", {
    timeSincePublished
  }), $[1] = t, $[2] = timeSincePublished, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text, { children: t2 }), $[4] = t2, $[5] = t3) : t3 = $[5], t3;
}
const usePublishAction = (props) => {
  const $ = c(102), {
    id,
    type,
    liveEdit,
    draft,
    published,
    release,
    version
  } = props, {
    selectedPerspective
  } = usePerspective(), [publishState, setPublishState] = useState(null);
  let t0;
  $[0] !== version ? (t0 = version?._id && getVersionFromId(version._id), $[0] = version, $[1] = t0) : t0 = $[1];
  const bundleId = t0, {
    publish
  } = useDocumentOperation(id, type, bundleId), {
    changesOpen,
    documentId,
    documentType,
    value
  } = useDocumentPane(), validationStatus = useValidationStatus(value._id, type, !release), syncState = useSyncState(id, type), editState = useEditState(documentId, documentType, "default", bundleId), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[2] !== editState?.draft || $[3] !== editState?.published || $[4] !== editState?.version ? (t1 = editState?.version || editState?.draft || editState?.published || {}, $[2] = editState?.draft, $[3] = editState?.published, $[4] = editState?.version, $[5] = t1) : t1 = $[5];
  const revision = t1._rev, toast = useToast();
  let t2;
  $[6] !== validationStatus.validation ? (t2 = validationStatus.validation.some(isValidationErrorMarker), $[6] = validationStatus.validation, $[7] = t2) : t2 = $[7];
  const hasValidationErrors = t2, [publishScheduled, setPublishScheduled] = useState(!1), isSyncing = syncState.isSyncing, isValidating = validationStatus.isValidating;
  let t3;
  $[8] !== id || $[9] !== type ? (t3 = {
    id,
    type,
    permission: "publish"
  }, $[8] = id, $[9] = type, $[10] = t3) : t3 = $[10];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t3), currentUser = useCurrentUser();
  let t4;
  $[11] !== hasValidationErrors || $[12] !== publish.disabled || $[13] !== published || $[14] !== t ? (t4 = publish.disabled ? getDisabledReason(publish.disabled, (published || {})._updatedAt, t) || "" : hasValidationErrors ? t("action.publish.validation-issues.tooltip") : "", $[11] = hasValidationErrors, $[12] = publish.disabled, $[13] = published, $[14] = t, $[15] = t4) : t4 = $[15];
  const title = t4, currentPublishRevision = published?._rev, telemetry = useTelemetry();
  let t5;
  $[16] !== currentPublishRevision || $[17] !== id || $[18] !== publish || $[19] !== telemetry ? (t5 = () => {
    publish.execute(), telemetry.log(PublishButtonClicked, {
      documentId: id,
      stage: "started"
    }), setPublishState({
      status: "publishing",
      publishRevision: currentPublishRevision
    });
  }, $[16] = currentPublishRevision, $[17] = id, $[18] = publish, $[19] = telemetry, $[20] = t5) : t5 = $[20];
  const doPublish = t5;
  let t6;
  $[21] !== doPublish || $[22] !== hasValidationErrors || $[23] !== isSyncing || $[24] !== publishScheduled || $[25] !== revision || $[26] !== t || $[27] !== toast || $[28] !== validationStatus.isValidating || $[29] !== validationStatus.revision ? (t6 = () => {
    const validationComplete = !validationStatus.isValidating && validationStatus.revision === revision;
    !publishScheduled || isSyncing || !validationComplete || (hasValidationErrors ? toast.push({
      title: t("action.publish.validation-issues-toast.title"),
      description: t("action.publish.validation-issues-toast.description"),
      status: "error"
    }) : doPublish(), setPublishScheduled(!1));
  }, $[21] = doPublish, $[22] = hasValidationErrors, $[23] = isSyncing, $[24] = publishScheduled, $[25] = revision, $[26] = t, $[27] = toast, $[28] = validationStatus.isValidating, $[29] = validationStatus.revision, $[30] = t6) : t6 = $[30];
  let t7;
  $[31] !== doPublish || $[32] !== hasValidationErrors || $[33] !== isSyncing || $[34] !== isValidating || $[35] !== publishScheduled || $[36] !== revision || $[37] !== t || $[38] !== toast || $[39] !== validationStatus.isValidating || $[40] !== validationStatus.revision ? (t7 = [isSyncing, doPublish, hasValidationErrors, publishScheduled, validationStatus.revision, revision, isValidating, validationStatus.isValidating, toast, t], $[31] = doPublish, $[32] = hasValidationErrors, $[33] = isSyncing, $[34] = isValidating, $[35] = publishScheduled, $[36] = revision, $[37] = t, $[38] = toast, $[39] = validationStatus.isValidating, $[40] = validationStatus.revision, $[41] = t7) : t7 = $[41], useEffect(t6, t7);
  let t8;
  $[42] !== currentPublishRevision || $[43] !== id || $[44] !== publishState || $[45] !== telemetry ? (t8 = () => {
    const didPublish = publishState?.status === "publishing" && currentPublishRevision !== publishState.publishRevision;
    didPublish && telemetry.log(PublishButtonClicked, {
      documentId: id,
      stage: "completed"
    });
    const nextState = didPublish ? PUBLISHED_STATE : null, timer2 = setTimeout(() => {
      publishState?.status === "publishing" && currentPublishRevision === publishState.publishRevision && telemetry.log(PublishButtonClicked, {
        documentId: id,
        stage: "failed"
      }), setPublishState(nextState);
    }, didPublish ? 200 : 4e3);
    return () => clearTimeout(timer2);
  }, $[42] = currentPublishRevision, $[43] = id, $[44] = publishState, $[45] = telemetry, $[46] = t8) : t8 = $[46];
  let t9;
  $[47] !== changesOpen || $[48] !== currentPublishRevision || $[49] !== id || $[50] !== publishState || $[51] !== telemetry ? (t9 = [changesOpen, publishState, currentPublishRevision, telemetry, id], $[47] = changesOpen, $[48] = currentPublishRevision, $[49] = id, $[50] = publishState, $[51] = telemetry, $[52] = t9) : t9 = $[52], useEffect(t8, t9);
  const isWaitingToPublish = !!((draft || version) && (publishScheduled || editState?.transactionSyncLock?.enabled || isPermissionsLoading));
  let t10;
  $[53] !== editState?.transactionSyncLock?.enabled || $[54] !== id || $[55] !== isWaitingToPublish || $[56] !== telemetry ? (t10 = () => {
    if (isWaitingToPublish)
      return telemetry.log(PublishButtonDisabledStart, {
        documentId: id,
        isRemoteEvent: editState?.transactionSyncLock?.enabled
      }), () => {
        telemetry.log(PublishButtonDisabledComplete, {
          documentId: id,
          isRemoteEvent: editState?.transactionSyncLock?.enabled
        });
      };
  }, $[53] = editState?.transactionSyncLock?.enabled, $[54] = id, $[55] = isWaitingToPublish, $[56] = telemetry, $[57] = t10) : t10 = $[57];
  const t11 = editState?.transactionSyncLock?.enabled;
  let t12;
  $[58] !== id || $[59] !== isWaitingToPublish || $[60] !== t11 || $[61] !== telemetry ? (t12 = [isWaitingToPublish, telemetry, id, t11], $[58] = id, $[59] = isWaitingToPublish, $[60] = t11, $[61] = telemetry, $[62] = t12) : t12 = $[62], useEffect(t10, t12);
  let t13;
  $[63] !== doPublish || $[64] !== draft?._createdAt || $[65] !== published || $[66] !== revision || $[67] !== syncState.isSyncing || $[68] !== telemetry || $[69] !== validationStatus.isValidating || $[70] !== validationStatus.revision ? (t13 = () => {
    telemetry.log(DocumentPublished, {
      publishedImmediately: !draft?._createdAt,
      previouslyPublished: !!published
    }), syncState.isSyncing || validationStatus.isValidating || validationStatus.revision !== revision ? setPublishScheduled(!0) : doPublish();
  }, $[63] = doPublish, $[64] = draft?._createdAt, $[65] = published, $[66] = revision, $[67] = syncState.isSyncing, $[68] = telemetry, $[69] = validationStatus.isValidating, $[70] = validationStatus.revision, $[71] = t13) : t13 = $[71];
  const handle = t13;
  let t14;
  bb0: {
    if (isPublishedPerspective(selectedPerspective)) {
      t14 = null;
      break bb0;
    }
    if (release && version) {
      t14 = null;
      break bb0;
    }
    if (liveEdit && !version) {
      t14 = null;
      break bb0;
    }
    if (published && !draft && !version) {
      let t152;
      $[72] !== t ? (t152 = t("action.publish.label"), $[72] = t, $[73] = t152) : t152 = $[73];
      const t162 = published?._updatedAt;
      let t172;
      $[74] !== t || $[75] !== t162 ? (t172 = getDisabledReason("ALREADY_PUBLISHED", t162, t), $[74] = t, $[75] = t162, $[76] = t172) : t172 = $[76];
      let t182;
      $[77] !== t152 || $[78] !== t172 ? (t182 = {
        tone: "default",
        icon: PublishIcon,
        label: t152,
        title: t172,
        disabled: !0
      }, $[77] = t152, $[78] = t172, $[79] = t182) : t182 = $[79], t14 = t182;
      break bb0;
    }
    if (!isPermissionsLoading && !permissions?.granted) {
      let t152;
      $[80] !== t ? (t152 = t("action.publish.label"), $[80] = t, $[81] = t152) : t152 = $[81];
      let t162;
      $[82] !== currentUser ? (t162 = /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "publish-document", currentUser }), $[82] = currentUser, $[83] = t162) : t162 = $[83];
      let t172;
      $[84] !== t152 || $[85] !== t162 ? (t172 = {
        tone: "default",
        icon: PublishIcon,
        label: t152,
        title: t162,
        disabled: !0
      }, $[84] = t152, $[85] = t162, $[86] = t172) : t172 = $[86], t14 = t172;
      break bb0;
    }
    const disabled = !!(publishScheduled || editState?.transactionSyncLock?.enabled || publishState?.status === "publishing" || publishState?.status === "published" || hasValidationErrors || publish.disabled), t15 = disabled || isPermissionsLoading;
    let t16;
    $[87] !== publishScheduled || $[88] !== publishState?.status || $[89] !== t ? (t16 = publishState?.status === "published" ? t("action.publish.published.label") : publishScheduled ? t("action.publish.validation-in-progress.label") : publishState?.status === "publishing" ? t("action.publish.running.label") : t("action.publish.draft.label"), $[87] = publishScheduled, $[88] = publishState?.status, $[89] = t, $[90] = t16) : t16 = $[90];
    let t17;
    $[91] !== publishScheduled || $[92] !== publishState?.status || $[93] !== t || $[94] !== title ? (t17 = publishScheduled ? t("action.publish.waiting") : publishState?.status === "published" || publishState?.status === "publishing" ? null : title, $[91] = publishScheduled, $[92] = publishState?.status, $[93] = t, $[94] = title, $[95] = t17) : t17 = $[95];
    const t18 = disabled || publishScheduled ? null : "Ctrl+Alt+P";
    let t19;
    $[96] !== handle || $[97] !== t15 || $[98] !== t16 || $[99] !== t17 || $[100] !== t18 ? (t19 = {
      disabled: t15,
      tone: "default",
      label: t16,
      icon: PublishIcon,
      title: t17,
      shortcut: t18,
      onHandle: handle
    }, $[96] = handle, $[97] = t15, $[98] = t16, $[99] = t17, $[100] = t18, $[101] = t19) : t19 = $[101], t14 = t19;
  }
  return t14;
};
usePublishAction.action = "publish";
usePublishAction.displayName = "PublishAction";
const DISABLED_REASON_KEY = {
  NOT_PUBLISHED: "action.unpublish.disabled.not-published",
  NOT_READY: "action.unpublish.disabled.not-ready",
  LIVE_EDIT_ENABLED: "action.unpublish.disabled.live-edit-enabled"
}, useUnpublishAction = (t0) => {
  const $ = c(22), {
    id,
    type,
    draft,
    liveEdit,
    release
  } = t0, {
    unpublish
  } = useDocumentOperation(id, type), [isConfirmDialogOpen, setConfirmDialogOpen] = useState(!1);
  let t1;
  $[0] !== id || $[1] !== type ? (t1 = {
    id,
    type,
    permission: "unpublish"
  }, $[0] = id, $[1] = type, $[2] = t1) : t1 = $[2];
  const [permissions, isPermissionsLoading] = useDocumentPairPermissions(t1), currentUser = useCurrentUser(), {
    t
  } = useTranslation(structureLocaleNamespace), {
    selectedPerspective
  } = usePerspective(), isDraft = selectedPerspective === "drafts";
  let t2;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setConfirmDialogOpen(!1);
  }, $[3] = t2) : t2 = $[3];
  const handleCancel = t2;
  let t3;
  $[4] !== unpublish ? (t3 = () => {
    setConfirmDialogOpen(!1), unpublish.execute();
  }, $[4] = unpublish, $[5] = t3) : t3 = $[5];
  const handleConfirm = t3;
  let t4;
  bb0: {
    if (isConfirmDialogOpen) {
      const t52 = draft?._id || id;
      let t62;
      $[6] !== handleConfirm || $[7] !== t52 || $[8] !== type ? (t62 = {
        type: "dialog",
        onClose: handleCancel,
        content: /* @__PURE__ */ jsx(ConfirmDeleteDialogContainer, { id: t52, type, action: "unpublish", onCancel: handleCancel, onConfirm: handleConfirm })
      }, $[6] = handleConfirm, $[7] = t52, $[8] = type, $[9] = t62) : t62 = $[9], t4 = t62;
      break bb0;
    }
    t4 = null;
  }
  const dialog = t4;
  let t5;
  $[10] !== currentUser || $[11] !== dialog || $[12] !== isDraft || $[13] !== isPermissionsLoading || $[14] !== liveEdit || $[15] !== permissions?.granted || $[16] !== release || $[17] !== t || $[18] !== unpublish.disabled ? (t5 = () => release || isDraft || liveEdit ? null : !isPermissionsLoading && !permissions?.granted ? {
    tone: "critical",
    icon: UnpublishIcon,
    label: "Unpublish",
    title: /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context: "unpublish-document", currentUser }),
    disabled: !0
  } : {
    tone: "critical",
    icon: UnpublishIcon,
    disabled: !!unpublish.disabled || isPermissionsLoading,
    label: t("action.unpublish.label"),
    title: unpublish.disabled ? t(DISABLED_REASON_KEY[unpublish.disabled]) : "",
    onHandle: () => setConfirmDialogOpen(!0),
    dialog
  }, $[10] = currentUser, $[11] = dialog, $[12] = isDraft, $[13] = isPermissionsLoading, $[14] = liveEdit, $[15] = permissions?.granted, $[16] = release, $[17] = t, $[18] = unpublish.disabled, $[19] = t5) : t5 = $[19];
  let t6;
  return $[20] !== t5 ? (t6 = t5(), $[20] = t5, $[21] = t6) : t6 = $[21], t6;
};
useUnpublishAction.action = "unpublish";
useUnpublishAction.displayName = "UnpublishAction";
const DocumentStatusBarActionsInner = memo(function(props) {
  const $ = c(39), {
    disabled,
    states
  } = props, {
    __internal_tasks
  } = useSource(), {
    editState
  } = useDocumentPane(), {
    params
  } = usePaneRouter(), showingRevision = !!params?.rev, {
    selectedReleaseId
  } = usePerspective();
  let firstActionState, menuActionStates;
  $[0] !== states ? ([firstActionState, ...menuActionStates] = states, $[0] = states, $[1] = firstActionState, $[2] = menuActionStates) : (firstActionState = $[1], menuActionStates = $[2]);
  const [buttonElement, setButtonElement] = useState(null), {
    isPaused
  } = usePausedScheduledDraft();
  let t0;
  bb0: {
    if (!firstActionState || !firstActionState.title && !firstActionState.shortcut) {
      t0 = null;
      break bb0;
    }
    let t12;
    $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = {
      maxWidth: 300
    }, $[3] = t12) : t12 = $[3];
    let t22;
    $[4] !== firstActionState.title ? (t22 = firstActionState.title && /* @__PURE__ */ jsx(Text, { size: 1, children: firstActionState.title }), $[4] = firstActionState.title, $[5] = t22) : t22 = $[5];
    let t32;
    $[6] !== firstActionState.shortcut ? (t32 = firstActionState.shortcut && /* @__PURE__ */ jsx(Hotkeys, { "data-testid": "document-status-bar-hotkeys", fontSize: 1, style: {
      marginTop: -4,
      marginBottom: -4
    }, keys: String(firstActionState.shortcut).split("+").map(_temp$q) }), $[6] = firstActionState.shortcut, $[7] = t32) : t32 = $[7];
    let t42;
    $[8] !== t22 || $[9] !== t32 ? (t42 = /* @__PURE__ */ jsxs(Flex, { style: t12, align: "center", gap: 3, children: [
      t22,
      t32
    ] }), $[8] = t22, $[9] = t32, $[10] = t42) : t42 = $[10], t0 = t42;
  }
  const tooltipContent = t0, shouldShowScheduleAsFirstActionButton = firstActionState?.action === "schedule" && isPaused;
  let t1;
  $[11] !== editState?.liveEdit || $[12] !== editState?.version || $[13] !== firstActionState || $[14] !== selectedReleaseId || $[15] !== shouldShowScheduleAsFirstActionButton || $[16] !== showingRevision ? (t1 = showingRevision ? !!firstActionState : selectedReleaseId ? firstActionState && (shouldShowScheduleAsFirstActionButton || !isSanityDefinedAction(firstActionState)) : firstActionState && (!editState?.liveEdit || editState?.version), $[11] = editState?.liveEdit, $[12] = editState?.version, $[13] = firstActionState, $[14] = selectedReleaseId, $[15] = shouldShowScheduleAsFirstActionButton, $[16] = showingRevision, $[17] = t1) : t1 = $[17];
  const showFirstActionButton = t1;
  let t2;
  $[18] !== firstActionState || $[19] !== menuActionStates || $[20] !== showFirstActionButton ? (t2 = showFirstActionButton ? menuActionStates : [firstActionState, ...menuActionStates].filter(Boolean), $[18] = firstActionState, $[19] = menuActionStates, $[20] = showFirstActionButton, $[21] = t2) : t2 = $[21];
  const sideMenuItems = t2, t3 = __internal_tasks && __internal_tasks.footerAction;
  let t4;
  $[22] !== disabled || $[23] !== firstActionState || $[24] !== showFirstActionButton || $[25] !== tooltipContent ? (t4 = showFirstActionButton && /* @__PURE__ */ jsx(LayerProvider, { zOffset: 200, children: /* @__PURE__ */ jsx(Tooltip, { disabled: !tooltipContent, content: tooltipContent, placement: "top", children: /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Button$1, { "data-testid": `action-${toLowerCaseNoSpaces(firstActionState.label)}`, disabled: disabled || !!firstActionState.disabled, icon: firstActionState.icon, onClick: firstActionState.onHandle, ref: setButtonElement, text: firstActionState.label, tone: firstActionState.tone || "primary" }) }) }) }), $[22] = disabled, $[23] = firstActionState, $[24] = showFirstActionButton, $[25] = tooltipContent, $[26] = t4) : t4 = $[26];
  let t5;
  $[27] !== disabled || $[28] !== sideMenuItems ? (t5 = sideMenuItems.length > 0 && /* @__PURE__ */ jsx(ActionMenuButton, { actionStates: sideMenuItems, disabled }), $[27] = disabled, $[28] = sideMenuItems, $[29] = t5) : t5 = $[29];
  let t6;
  $[30] !== buttonElement || $[31] !== firstActionState || $[32] !== showFirstActionButton ? (t6 = showFirstActionButton && firstActionState && firstActionState.dialog && /* @__PURE__ */ jsx(ActionStateDialog, { dialog: firstActionState.dialog, referenceElement: buttonElement }), $[30] = buttonElement, $[31] = firstActionState, $[32] = showFirstActionButton, $[33] = t6) : t6 = $[33];
  let t7;
  return $[34] !== t3 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t3,
    t4,
    t5,
    t6
  ] }), $[34] = t3, $[35] = t4, $[36] = t5, $[37] = t6, $[38] = t7) : t7 = $[38], t7;
}), DocumentStatusBarActions = memo(function() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(RenderActionCollectionState, { group: "default", children: _temp2$c }), $[0] = t0) : t0 = $[0], t0;
});
function RenderDocumentStatusBarActions(props) {
  const $ = c(6), {
    connectionState,
    documentId
  } = useDocumentPane();
  let t0;
  $[0] !== props.states ? (t0 = props.states.filter(_temp3$8), $[0] = props.states, $[1] = t0) : t0 = $[1];
  const states = t0;
  if (states.length === 0)
    return null;
  const t1 = connectionState !== "connected";
  let t2;
  return $[2] !== documentId || $[3] !== states || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(DocumentStatusBarActionsInner, { disabled: t1, states }, documentId), $[2] = documentId, $[3] = states, $[4] = t1, $[5] = t2) : t2 = $[5], t2;
}
function _temp3$8(state2) {
  return state2.action ? state2.action !== useHistoryRestoreAction.action : !0;
}
const HistoryStatusBarActions = memo(function() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(RenderActionCollectionState, { group: "default", children: _temp4$8 }), $[0] = t0) : t0 = $[0], t0;
});
function RenderHistoryStatusBarActions(t0) {
  const $ = c(8), {
    states
  } = t0, {
    connectionState,
    editState,
    revisionId: revision
  } = useDocumentPane();
  let t1;
  $[0] !== editState?.draft || $[1] !== editState?.published ? (t1 = editState?.draft || editState?.published || {}, $[0] = editState?.draft, $[1] = editState?.published, $[2] = t1) : t1 = $[2];
  const disabled = t1._rev === revision, t2 = connectionState !== "connected" || !!disabled;
  let t3;
  $[3] !== states ? (t3 = states.filter(_temp5$5).slice(-1), $[3] = states, $[4] = t3) : t3 = $[4];
  let t4;
  return $[5] !== t2 || $[6] !== t3 ? (t4 = /* @__PURE__ */ jsx(DocumentStatusBarActionsInner, { disabled: t2, states: t3 }), $[5] = t2, $[6] = t3, $[7] = t4) : t4 = $[7], t4;
}
function _temp5$5(state2) {
  return state2.action ? state2.action === useHistoryRestoreAction.action : !1;
}
function _temp$q(s) {
  return s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase();
}
function _temp2$c(t0) {
  const {
    states
  } = t0;
  return /* @__PURE__ */ jsx(RenderDocumentStatusBarActions, { states });
}
function _temp4$8(t0) {
  const {
    states
  } = t0;
  return /* @__PURE__ */ jsx(RenderHistoryStatusBarActions, { states });
}
const TIMELINE_ICON_COMPONENTS = {
  create: AddIcon,
  delete: TrashIcon,
  discardDraft: CloseIcon,
  initial: AddIcon,
  editDraft: EditIcon,
  editLive: EditIcon,
  publish: PublishIcon,
  unpublish: UnpublishIcon
};
function getTimelineEventIconComponent(type) {
  return TIMELINE_ICON_COMPONENTS[type];
}
function hideScrollbarOnExpand(isExpanded2) {
  if (isExpanded2) return;
  const listWrapper = document.getElementById(TIMELINE_LIST_WRAPPER_ID$1);
  if (listWrapper) {
    const firstChildren = listWrapper.children[0];
    if (!(firstChildren.scrollHeight > firstChildren.clientHeight)) {
      const currentStyle = getComputedStyle(firstChildren).overflowY;
      firstChildren.style.overflowY = "hidden", setTimeout(() => {
        firstChildren.style.overflowY = currentStyle;
      }, 0);
    }
  }
}
const FlipIcon = styled(ChevronLeftIcon).withConfig({
  displayName: "FlipIcon",
  componentId: "sc-13ovfi5-0"
})`transition:transform 200ms;&[data-expanded='true']{transform:rotate(-90deg);}`;
function ExpandableTimelineItemButton(t0) {
  const $ = c(14), {
    isExpanded: isExpanded2,
    onExpand
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== isExpanded2 || $[1] !== onExpand ? (t1 = (e) => {
    e.stopPropagation(), hideScrollbarOnExpand(isExpanded2), onExpand();
  }, $[0] = isExpanded2, $[1] = onExpand, $[2] = t1) : t1 = $[2];
  const handleExpandClick = t1;
  let t2;
  $[3] !== isExpanded2 ? (t2 = /* @__PURE__ */ jsx(FlipIcon, { "data-expanded": isExpanded2 }), $[3] = isExpanded2, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== isExpanded2 || $[6] !== t ? (t3 = t(isExpanded2 ? "timeline-item.menu.action-collapse" : "timeline-item.menu.action-expand"), $[5] = isExpanded2, $[6] = t, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t3 ? (t4 = {
    content: t3
  }, $[8] = t3, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== handleExpandClick || $[11] !== t2 || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button$1, { mode: "bleed", icon: t2, tooltipProps: t4, onClick: handleExpandClick }), $[10] = handleExpandClick, $[11] = t2, $[12] = t4, $[13] = t5) : t5 = $[13], t5;
}
const StackWrapper = styled(Stack).withConfig({
  displayName: "StackWrapper",
  componentId: "sc-1ai615s-0"
})`max-width:200px;`, ListWrapper = styled(Flex).withConfig({
  displayName: "ListWrapper",
  componentId: "sc-1ai615s-1"
})`max-height:${(props) => props.$maxHeight};min-width:244px;`, Root$3 = /* @__PURE__ */ styled(Box).withConfig({
  displayName: "Root",
  componentId: "sc-1ai615s-2"
})(({
  $visible
}) => css`
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;

    ${$visible && css`
      opacity: 1;
      pointer-events: auto;
    `}
  `), TIMELINE_ITEM_I18N_KEY_MAPPING = {
  initial: "timeline.operation.created-initial",
  create: "timeline.operation.created",
  publish: "timeline.operation.published",
  editLive: "timeline.operation.edited-live",
  editDraft: "timeline.operation.edited-draft",
  unpublish: "timeline.operation.unpublished",
  discardDraft: "timeline.operation.draft-discarded",
  delete: "timeline.operation.deleted"
};
function UserAvatarStack(t0) {
  const $ = c(9), {
    maxLength,
    userIds,
    size,
    withTooltip: t1
  } = t0, withTooltip = t1 === void 0 ? !0 : t1;
  let t2;
  if ($[0] !== userIds || $[1] !== withTooltip) {
    let t32;
    $[3] !== withTooltip ? (t32 = (userId) => /* @__PURE__ */ jsx(UserAvatar, { user: userId, withTooltip }, userId), $[3] = withTooltip, $[4] = t32) : t32 = $[4], t2 = userIds.map(t32), $[0] = userIds, $[1] = withTooltip, $[2] = t2;
  } else
    t2 = $[2];
  let t3;
  return $[5] !== maxLength || $[6] !== size || $[7] !== t2 ? (t3 = /* @__PURE__ */ jsx(AvatarStack, { maxLength, size, children: t2 }), $[5] = maxLength, $[6] = size, $[7] = t2, $[8] = t3) : t3 = $[8], t3;
}
const IconBox = /* @__PURE__ */ styled(Flex).withConfig({
  displayName: "IconBox",
  componentId: "sc-19iwr6i-0"
})((props) => {
  const theme = getTheme_v2(props.theme), color = props.$color;
  return css`
    --card-icon-color: ${theme.color.avatar[color].fg};
    background-color: ${theme.color.avatar[color].bg};
    box-shadow: 0 0 0 1px var(--card-bg-color);

    position: absolute;
    width: ${theme.avatar.sizes[0].size}px;
    height: ${theme.avatar.sizes[0].size}px;
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
  `;
}), TIMELINE_ITEM_EVENT_TONE = {
  initial: "blue",
  create: "blue",
  publish: "green",
  editLive: "green",
  editDraft: "yellow",
  unpublish: "orange",
  discardDraft: "orange",
  delete: "red",
  withinSelection: "magenta"
}, RELATIVE_TIME_OPTIONS$1 = {
  minimal: !0,
  useTemporalPhrase: !0
}, NameSkeleton = /* @__PURE__ */ styled(Skeleton).withConfig({
  displayName: "NameSkeleton",
  componentId: "sc-19iwr6i-1"
})((props) => {
  const theme = getTheme_v2(props.theme);
  return css`
    width: 6ch;
    height: ${theme.font.text.sizes[0].lineHeight}px;
  `;
}), UserLine = (t0) => {
  const $ = c(10), {
    userId
  } = t0, [user, loading] = useUser(userId);
  let t1;
  $[0] !== loading || $[1] !== user ? (t1 = /* @__PURE__ */ jsx(Box, { children: loading || !user ? /* @__PURE__ */ jsx(AvatarSkeleton, { animated: !0 }) : /* @__PURE__ */ jsx(UserAvatar, { user }) }), $[0] = loading, $[1] = user, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== loading || $[4] !== user ? (t2 = /* @__PURE__ */ jsx(Box, { children: loading || !user?.displayName ? /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(NameSkeleton, { animated: !0 }) }) : /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: user.displayName }) }), $[3] = loading, $[4] = user, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t1 || $[7] !== t2 || $[8] !== userId ? (t3 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, padding: 1, children: [
    t1,
    t2
  ] }, userId), $[6] = t1, $[7] = t2, $[8] = userId, $[9] = t3) : t3 = $[9], t3;
}, TooltipContent = (t0) => {
  const $ = c(9), {
    collaborators
  } = t0, {
    t
  } = useTranslation("studio");
  let t1;
  $[0] !== t ? (t1 = t("timeline.changes.title"), $[0] = t, $[1] = t1) : t1 = $[1];
  let t2;
  $[2] !== t1 ? (t2 = /* @__PURE__ */ jsx(Box, { padding: 1, paddingBottom: 2, children: /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t1 }) }), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== collaborators ? (t3 = collaborators.map(_temp$p), $[4] = collaborators, $[5] = t3) : t3 = $[5];
  let t4;
  return $[6] !== t2 || $[7] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Stack, { paddingBottom: 1, children: [
    t2,
    t3
  ] }), $[6] = t2, $[7] = t3, $[8] = t4) : t4 = $[8], t4;
};
function TimelineItem(t0) {
  const $ = c(55), {
    chunk,
    isSelected,
    onSelect,
    collaborators,
    optionsMenu
  } = t0, {
    t
  } = useTranslation("studio"), {
    type,
    endTimestamp: timestamp
  } = chunk;
  let t1;
  $[0] !== type ? (t1 = getTimelineEventIconComponent(type), $[0] = type, $[1] = t1) : t1 = $[1];
  const IconComponent = t1;
  let t2;
  $[2] !== chunk.authors ? (t2 = Array.from(chunk.authors), $[2] = chunk.authors, $[3] = t2) : t2 = $[3];
  const authorUserIds = t2;
  let t3;
  $[4] !== collaborators ? (t3 = collaborators ? Array.from(collaborators) : [], $[4] = collaborators, $[5] = t3) : t3 = $[5];
  const collaboratorsUsersIds = t3, isSelectable = type !== "delete";
  let t4;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = {
    dateStyle: "medium",
    timeStyle: "short"
  }, $[6] = t4) : t4 = $[6];
  const dateFormat = useDateTimeFormat(t4);
  let t5;
  $[7] !== timestamp ? (t5 = new Date(timestamp), $[7] = timestamp, $[8] = t5) : t5 = $[8];
  const updatedTimeAgo = useRelativeTime(t5 || "", RELATIVE_TIME_OPTIONS$1);
  let t6;
  if ($[9] !== dateFormat || $[10] !== timestamp) {
    const parsedDate = new Date(timestamp);
    t6 = dateFormat.format(parsedDate), $[9] = dateFormat, $[10] = timestamp, $[11] = t6;
  } else
    t6 = $[11];
  const formattedTimestamp = t6;
  let t7;
  $[12] !== chunk || $[13] !== isSelectable || $[14] !== onSelect ? (t7 = (evt) => {
    evt.preventDefault(), evt.stopPropagation(), isSelectable && onSelect(chunk);
  }, $[12] = chunk, $[13] = isSelectable, $[14] = onSelect, $[15] = t7) : t7 = $[15];
  const handleClick = t7;
  let t8;
  $[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    position: "relative"
  }, $[16] = t8) : t8 = $[16];
  let t9;
  $[17] !== authorUserIds ? (t9 = /* @__PURE__ */ jsx(UserAvatarStack, { maxLength: 3, userIds: authorUserIds, size: 2 }), $[17] = authorUserIds, $[18] = t9) : t9 = $[18];
  const t10 = TIMELINE_ITEM_EVENT_TONE[type];
  let t11;
  $[19] !== IconComponent ? (t11 = IconComponent && /* @__PURE__ */ jsx(IconComponent, {}), $[19] = IconComponent, $[20] = t11) : t11 = $[20];
  let t12;
  $[21] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text, { size: 0, children: t11 }), $[21] = t11, $[22] = t12) : t12 = $[22];
  let t13;
  $[23] !== t10 || $[24] !== t12 ? (t13 = /* @__PURE__ */ jsx(IconBox, { align: "center", justify: "center", $color: t10, children: t12 }), $[23] = t10, $[24] = t12, $[25] = t13) : t13 = $[25];
  let t14;
  $[26] !== t13 || $[27] !== t9 ? (t14 = /* @__PURE__ */ jsxs("div", { style: t8, children: [
    t9,
    t13
  ] }), $[26] = t13, $[27] = t9, $[28] = t14) : t14 = $[28];
  let t15;
  $[29] !== t || $[30] !== type ? (t15 = t(TIMELINE_ITEM_I18N_KEY_MAPPING[type]) || /* @__PURE__ */ jsx("code", { children: type }), $[29] = t, $[30] = type, $[31] = t15) : t15 = $[31];
  let t16;
  $[32] !== t15 ? (t16 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t15 }), $[32] = t15, $[33] = t16) : t16 = $[33];
  let t17;
  $[34] !== formattedTimestamp || $[35] !== timestamp || $[36] !== updatedTimeAgo ? (t17 = /* @__PURE__ */ jsx(Text, { as: "time", size: 1, muted: !0, dateTime: timestamp, title: formattedTimestamp, children: updatedTimeAgo }), $[34] = formattedTimestamp, $[35] = timestamp, $[36] = updatedTimeAgo, $[37] = t17) : t17 = $[37];
  let t18;
  $[38] !== t16 || $[39] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
    t16,
    t17
  ] }), $[38] = t16, $[39] = t17, $[40] = t18) : t18 = $[40];
  let t19;
  $[41] !== collaboratorsUsersIds ? (t19 = collaboratorsUsersIds.length > 0 && /* @__PURE__ */ jsx(Flex, { flex: 1, justify: "flex-end", align: "center", children: /* @__PURE__ */ jsx(Tooltip, { placement: "top", content: /* @__PURE__ */ jsx(TooltipContent, { collaborators: collaboratorsUsersIds }), portal: !0, children: /* @__PURE__ */ jsx(Box, { paddingLeft: 2, paddingY: 2, children: /* @__PURE__ */ jsx(UserAvatarStack, { maxLength: 3, userIds: collaboratorsUsersIds, size: 0, withTooltip: !1 }) }) }) }), $[41] = collaboratorsUsersIds, $[42] = t19) : t19 = $[42];
  let t20;
  $[43] !== t14 || $[44] !== t18 || $[45] !== t19 ? (t20 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    t14,
    t18,
    t19
  ] }), $[43] = t14, $[44] = t18, $[45] = t19, $[46] = t20) : t20 = $[46];
  let t21;
  $[47] !== chunk.id || $[48] !== handleClick || $[49] !== isSelected || $[50] !== t20 ? (t21 = /* @__PURE__ */ jsx(Card, { as: "button", onClick: handleClick, padding: 2, pressed: isSelected, radius: 2, "data-ui": "timelineItem", "data-testid": "timeline-item-button", "data-chunk-id": chunk.id, children: t20 }), $[47] = chunk.id, $[48] = handleClick, $[49] = isSelected, $[50] = t20, $[51] = t21) : t21 = $[51];
  let t22;
  return $[52] !== optionsMenu || $[53] !== t21 ? (t22 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 1, children: [
    t21,
    optionsMenu
  ] }), $[52] = optionsMenu, $[53] = t21, $[54] = t22) : t22 = $[54], t22;
}
function _temp$p(userId) {
  return /* @__PURE__ */ jsx(UserLine, { userId }, userId);
}
const isNonPublishChunk = (chunk) => chunk.type !== "publish", isPublishChunk = (chunk) => chunk.type === "publish";
function getPreviousPublishAction(chunks) {
  let previousPublish = null;
  for (let index = chunks.length - 1; index >= 0; index--) {
    const chunk = chunks[index];
    if (isPublishChunk(chunk)) {
      previousPublish = chunk;
      break;
    }
    if (chunk.type !== "editDraft")
      break;
  }
  return previousPublish;
}
function addChunksMetadata(chunks) {
  const result = [];
  for (const chunk of chunks) {
    if (isPublishChunk(chunk)) {
      result.push({
        ...chunk,
        type: "publish",
        children: [],
        collaborators: /* @__PURE__ */ new Set()
        // Initialize the collaborators array
      });
      continue;
    }
    if (isNonPublishChunk(chunk)) {
      const previousPublish = getPreviousPublishAction(result);
      if (chunk.type === "editDraft" && previousPublish?.type === "publish") {
        Array.from(chunk.authors).forEach((id) => {
          previousPublish.collaborators.add(id);
        }), previousPublish.children.push(chunk.id), result.push({
          ...chunk,
          parentId: previousPublish.id
        });
        continue;
      }
    }
    isNonPublishChunk(chunk) && result.push(chunk);
  }
  return result;
}
const TIMELINE_LIST_WRAPPER_ID$1 = "timeline-list-wrapper", Timeline = (t0) => {
  const $ = c(51), {
    chunks,
    hasMoreChunks,
    lastChunk: selectedChunk,
    onLoadMore,
    onSelect,
    listMaxHeight: t1
  } = t0, listMaxHeight = t1 === void 0 ? "calc(100vh - 280px)" : t1, [mounted, setMounted] = useState(!1), {
    t
  } = useTranslation("studio"), selectedChunkId = selectedChunk?.id;
  let t2;
  $[0] !== chunks ? (t2 = addChunksMetadata(chunks), $[0] = chunks, $[1] = t2) : t2 = $[1];
  const chunksWithMetadata = t2;
  let t3;
  $[2] !== chunksWithMetadata || $[3] !== selectedChunkId ? (t3 = () => {
    if (selectedChunkId) {
      const selected = chunksWithMetadata.find((chunk) => chunk.id === selectedChunkId);
      if (selected && isNonPublishChunk(selected) && selected.parentId)
        return /* @__PURE__ */ new Set([selected.parentId]);
    }
    return /* @__PURE__ */ new Set();
  }, $[2] = chunksWithMetadata, $[3] = selectedChunkId, $[4] = t3) : t3 = $[4];
  const [expandedParents, setExpandedParents] = useState(t3);
  let t4, t5;
  $[5] !== chunksWithMetadata || $[6] !== selectedChunkId ? (t4 = () => {
    if (selectedChunkId) {
      const selected_0 = chunksWithMetadata.find((chunk_0) => chunk_0.id === selectedChunkId);
      if (selected_0 && isNonPublishChunk(selected_0) && selected_0.parentId) {
        const parentId = selected_0.parentId;
        setExpandedParents((prev) => {
          if (prev.has(parentId))
            return prev;
          const next = new Set(prev);
          return next.add(parentId), next;
        });
      }
    }
  }, t5 = [chunksWithMetadata, selectedChunkId], $[5] = chunksWithMetadata, $[6] = selectedChunkId, $[7] = t4, $[8] = t5) : (t4 = $[7], t5 = $[8]), useEffect(t4, t5);
  let t6;
  if ($[9] !== chunksWithMetadata || $[10] !== expandedParents) {
    let t72;
    $[12] !== expandedParents ? (t72 = (chunk_1) => isPublishChunk(chunk_1) || !chunk_1.parentId ? !0 : expandedParents.has(chunk_1.parentId), $[12] = expandedParents, $[13] = t72) : t72 = $[13], t6 = chunksWithMetadata.filter(t72), $[9] = chunksWithMetadata, $[10] = expandedParents, $[11] = t6;
  } else
    t6 = $[11];
  const filteredChunks = t6;
  let t7;
  $[14] !== filteredChunks.length || $[15] !== hasMoreChunks || $[16] !== onLoadMore ? (t7 = () => {
    filteredChunks.length < 16 && hasMoreChunks && onLoadMore();
  }, $[14] = filteredChunks.length, $[15] = hasMoreChunks, $[16] = onLoadMore, $[17] = t7) : t7 = $[17];
  let t8;
  $[18] !== filteredChunks || $[19] !== hasMoreChunks || $[20] !== onLoadMore ? (t8 = [filteredChunks, hasMoreChunks, onLoadMore], $[18] = filteredChunks, $[19] = hasMoreChunks, $[20] = onLoadMore, $[21] = t8) : t8 = $[21], useEffect(t7, t8);
  let t9;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = (parentId_0) => () => setExpandedParents((prev_0) => {
    const next_0 = new Set(prev_0);
    return prev_0.has(parentId_0) ? next_0.delete(parentId_0) : next_0.add(parentId_0), next_0;
  }), $[22] = t9) : t9 = $[22];
  const handleExpandParent = t9;
  let t10;
  $[23] !== filteredChunks || $[24] !== selectedChunkId ? (t10 = selectedChunkId ? filteredChunks.findIndex((chunk_2) => chunk_2.id === selectedChunkId) : -1, $[23] = filteredChunks, $[24] = selectedChunkId, $[25] = t10) : t10 = $[25];
  const selectedIndex = t10;
  let t11;
  $[26] !== chunks || $[27] !== onSelect ? (t11 = (chunk_3) => {
    const timelineChunk = chunks.find((c2) => c2.id === chunk_3.id);
    timelineChunk ? onSelect(timelineChunk) : (console.error("TimelineItem: chunk not found"), onSelect(chunk_3));
  }, $[26] = chunks, $[27] = onSelect, $[28] = t11) : t11 = $[28];
  const handleSelectChunk = t11;
  let t12;
  $[29] !== expandedParents || $[30] !== filteredChunks.length || $[31] !== handleSelectChunk || $[32] !== hasMoreChunks || $[33] !== selectedChunkId ? (t12 = (chunk_4, t132) => {
    const {
      activeIndex
    } = t132;
    return /* @__PURE__ */ jsxs(Box, { paddingBottom: 1, paddingTop: activeIndex === 0 ? 1 : 0, paddingRight: 1, paddingLeft: isNonPublishChunk(chunk_4) && chunk_4.parentId ? 4 : 1, children: [
      /* @__PURE__ */ jsx(TimelineItem, { chunk: chunk_4, isSelected: selectedChunkId === chunk_4.id, onSelect: handleSelectChunk, collaborators: isPublishChunk(chunk_4) ? chunk_4.collaborators : void 0, optionsMenu: isPublishChunk(chunk_4) && chunk_4.children.length > 0 ? /* @__PURE__ */ jsx(ExpandableTimelineItemButton, { isExpanded: expandedParents.has(chunk_4.id), onExpand: handleExpandParent(chunk_4.id) }) : null }),
      activeIndex === filteredChunks.length - 1 && hasMoreChunks && /* @__PURE__ */ jsx(LoadingBlock, {})
    ] });
  }, $[29] = expandedParents, $[30] = filteredChunks.length, $[31] = handleSelectChunk, $[32] = hasMoreChunks, $[33] = selectedChunkId, $[34] = t12) : t12 = $[34];
  const renderItem = t12;
  let t13, t14;
  $[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t13 = () => setMounted(!0), t14 = [], $[35] = t13, $[36] = t14) : (t13 = $[35], t14 = $[36]), useEffect(t13, t14);
  const t15 = !selectedIndex || mounted;
  let t16;
  $[37] !== filteredChunks.length || $[38] !== t ? (t16 = filteredChunks.length === 0 && /* @__PURE__ */ jsxs(StackWrapper, { padding: 3, space: 3, children: [
    /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t("timeline.error.no-document-history-title") }),
    /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("timeline.error.no-document-history-description") })
  ] }), $[37] = filteredChunks.length, $[38] = t, $[39] = t16) : t16 = $[39];
  let t17;
  $[40] !== filteredChunks || $[41] !== listMaxHeight || $[42] !== onLoadMore || $[43] !== renderItem || $[44] !== selectedIndex || $[45] !== t ? (t17 = filteredChunks.length > 0 && /* @__PURE__ */ jsx(ListWrapper, { direction: "column", $maxHeight: listMaxHeight, id: TIMELINE_LIST_WRAPPER_ID$1, children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("timeline.list.aria-label"), autoFocus: "list", initialIndex: selectedIndex, initialScrollAlign: "center", itemHeight: 57, items: filteredChunks, onEndReached: onLoadMore, onEndReachedIndexOffset: 20, overscan: 5, renderItem, wrapAround: !1 }) }), $[40] = filteredChunks, $[41] = listMaxHeight, $[42] = onLoadMore, $[43] = renderItem, $[44] = selectedIndex, $[45] = t, $[46] = t17) : t17 = $[46];
  let t18;
  return $[47] !== t15 || $[48] !== t16 || $[49] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Root$3, { $visible: t15, "data-ui": "timeline", children: [
    t16,
    t17
  ] }), $[47] = t15, $[48] = t16, $[49] = t17, $[50] = t18) : t18 = $[50], t18;
};
function TimelineError(t0) {
  const $ = c(14), {
    versionError
  } = t0, {
    t
  } = useTranslation("studio");
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsx(TextWithTone, { tone: "critical", children: /* @__PURE__ */ jsx(ErrorOutlineIcon, {}) }), $[0] = t1) : t1 = $[0];
  let t2;
  $[1] !== t || $[2] !== versionError ? (t2 = t(versionError ? "timeline.error.load-document-changes-version-title" : "timeline.error.load-document-changes-title"), $[1] = t, $[2] = versionError, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== t2 ? (t3 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", weight: "medium", children: t2 }), $[4] = t2, $[5] = t3) : t3 = $[5];
  let t4;
  $[6] !== t || $[7] !== versionError ? (t4 = t(versionError ? "timeline.error.load-document-changes-version-description" : "timeline.error.load-document-changes-description"), $[6] = t, $[7] = versionError, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t4 ? (t5 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: "critical", children: t4 }), $[9] = t4, $[10] = t5) : t5 = $[10];
  let t6;
  return $[11] !== t3 || $[12] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, padding: 4, children: [
    t1,
    /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
      t3,
      t5
    ] })
  ] }), $[11] = t3, $[12] = t5, $[13] = t6) : t6 = $[13], t6;
}
const Root$2 = styled(Popover).withConfig({
  displayName: "Root",
  componentId: "sc-5dzvio-0"
})`overflow:hidden;overflow:clip;`, TIMELINE_MENU_PORTAL$1 = "timeline-menu";
function TimelineMenu(t0) {
  const $ = c(62), {
    chunk,
    mode,
    placement
  } = t0, {
    setTimelineRange,
    timelineError,
    ready,
    timelineStore
  } = useDocumentPane(), [open, setOpen] = useState(!1), [button, setButton] = useState(null), [popoverRef, setPopoverRef] = useState(null), toast = useToast(), chunks = useTimelineSelector(timelineStore, _temp$o), loading = useTimelineSelector(timelineStore, _temp2$b), hasMoreChunks = useTimelineSelector(timelineStore, _temp3$7), realRevChunk = useTimelineSelector(timelineStore, _temp4$7), sinceTime = useTimelineSelector(timelineStore, _temp5$4), {
    t
  } = useTranslation("studio");
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setOpen(!0);
  }, $[0] = t1) : t1 = $[0];
  const handleOpen = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setOpen(!1);
  }, $[1] = t2) : t2 = $[1];
  const handleClose = t2;
  let t3;
  $[2] !== button || $[3] !== open ? (t3 = (event) => {
    open && (event.key === "Escape" || event.key === "Tab") && (handleClose(), button?.focus());
  }, $[2] = button, $[3] = open, $[4] = t3) : t3 = $[4], useGlobalKeyDown(t3);
  let t4;
  $[5] !== button || $[6] !== popoverRef ? (t4 = () => [button, popoverRef], $[5] = button, $[6] = popoverRef, $[7] = t4) : t4 = $[7], useClickOutsideEvent(open && handleClose, t4);
  let t5;
  $[8] !== setTimelineRange || $[9] !== t || $[10] !== timelineStore || $[11] !== toast ? (t5 = (revChunk) => {
    const run = () => {
      const [sinceId, revId] = timelineStore?.findRangeForRev(revChunk) || [null, null];
      setTimelineRange(sinceId, revId);
    };
    try {
      run();
    } catch (t62) {
      const err = t62;
      toast.push({
        closable: !0,
        description: err.message,
        status: "error",
        title: t("timeline.error.unable-to-load-revision")
      });
    }
  }, $[8] = setTimelineRange, $[9] = t, $[10] = timelineStore, $[11] = toast, $[12] = t5) : t5 = $[12];
  const selectRev = t5;
  let t6;
  $[13] !== setTimelineRange || $[14] !== t || $[15] !== timelineStore || $[16] !== toast ? (t6 = (sinceChunk) => {
    const run_0 = () => {
      const [sinceId_0, revId_0] = timelineStore?.findRangeForSince(sinceChunk) || [null, null];
      setTimelineRange(sinceId_0, revId_0);
    };
    try {
      run_0();
    } catch (t72) {
      const err_0 = t72;
      toast.push({
        closable: !0,
        description: err_0.message,
        status: "error",
        title: t("timeline.error.unable-to-load-revision")
      });
    }
  }, $[13] = setTimelineRange, $[14] = t, $[15] = timelineStore, $[16] = toast, $[17] = t6) : t6 = $[17];
  const selectSince = t6;
  let t7;
  $[18] !== loading || $[19] !== timelineStore ? (t7 = () => {
    loading || timelineStore?.loadMore();
  }, $[18] = loading, $[19] = timelineStore, $[20] = t7) : t7 = $[20];
  const handleLoadMore = t7;
  let t8;
  bb0: {
    if (timelineError) {
      let t93;
      $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t93 = /* @__PURE__ */ jsx(TimelineError, {}), $[21] = t93) : t93 = $[21], t8 = t93;
      break bb0;
    }
    if (mode === "rev") {
      let t93;
      $[22] !== chunks || $[23] !== handleLoadMore || $[24] !== hasMoreChunks || $[25] !== realRevChunk || $[26] !== selectRev ? (t93 = /* @__PURE__ */ jsx(Timeline, { chunks, hasMoreChunks, lastChunk: realRevChunk, onLoadMore: handleLoadMore, onSelect: selectRev }), $[22] = chunks, $[23] = handleLoadMore, $[24] = hasMoreChunks, $[25] = realRevChunk, $[26] = selectRev, $[27] = t93) : t93 = $[27], t8 = t93;
      break bb0;
    }
    let t92;
    $[28] !== chunks || $[29] !== realRevChunk ? (t92 = realRevChunk ? chunks.filter((c2) => c2.index < realRevChunk.index) : chunks, $[28] = chunks, $[29] = realRevChunk, $[30] = t92) : t92 = $[30];
    const filteredChunks = t92;
    let t102;
    $[31] !== filteredChunks || $[32] !== handleLoadMore || $[33] !== hasMoreChunks || $[34] !== selectSince || $[35] !== sinceTime ? (t102 = /* @__PURE__ */ jsx(Timeline, { chunks: filteredChunks, hasMoreChunks, lastChunk: sinceTime, onLoadMore: handleLoadMore, onSelect: selectSince }), $[31] = filteredChunks, $[32] = handleLoadMore, $[33] = hasMoreChunks, $[34] = selectSince, $[35] = sinceTime, $[36] = t102) : t102 = $[36], t8 = t102;
  }
  const content = t8;
  let revLabel, t9;
  if ($[37] !== chunk || $[38] !== t) {
    const formatParams2 = {
      timestamp: {
        dateStyle: "medium",
        timeStyle: "short"
      }
    };
    revLabel = chunk ? t(TIMELINE_ITEM_I18N_KEY_MAPPING[chunk.type], {
      context: "timestamp",
      timestamp: new Date(chunk?.endTimestamp),
      formatParams: formatParams2
    }) : t("timeline.latest-revision"), t9 = chunk ? t("timeline.since", {
      timestamp: new Date(chunk?.endTimestamp),
      formatParams: formatParams2
    }) : t("timeline.since-version-missing"), $[37] = chunk, $[38] = t, $[39] = revLabel, $[40] = t9;
  } else
    revLabel = $[39], t9 = $[40];
  const buttonLabel = mode === "rev" ? revLabel : t9;
  let t10;
  $[41] !== popoverRef ? (t10 = {
    [TIMELINE_MENU_PORTAL$1]: popoverRef
  }, $[41] = popoverRef, $[42] = t10) : t10 = $[42];
  const portalElements = t10, t11 = open && content, t12 = open ? "timeline-menu-close-button" : "timeline-menu-open-button", t13 = !ready, t14 = open ? handleClose : handleOpen;
  let t15;
  $[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t15 = {
    maxWidth: "100%"
  }, $[43] = t15) : t15 = $[43];
  let t16;
  $[44] !== buttonLabel || $[45] !== ready || $[46] !== t ? (t16 = ready ? buttonLabel : t("timeline.loading-history"), $[44] = buttonLabel, $[45] = ready, $[46] = t, $[47] = t16) : t16 = $[47];
  let t17;
  $[48] !== open || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t16 ? (t17 = /* @__PURE__ */ jsx(Flex, { width: "fill", children: /* @__PURE__ */ jsx(Button$1, { "data-testid": t12, disabled: t13, mode: "ghost", onClick: t14, ref: setButton, selected: open, width: "fill", tooltipProps: null, justify: "space-between", style: t15, iconRight: ChevronDownIcon, text: t16 }) }), $[48] = open, $[49] = t12, $[50] = t13, $[51] = t14, $[52] = t16, $[53] = t17) : t17 = $[53];
  let t18;
  $[54] !== open || $[55] !== placement || $[56] !== t11 || $[57] !== t17 ? (t18 = /* @__PURE__ */ jsx(Root$2, { "data-testid": "timeline-menu", constrainSize: !0, content: t11, "data-ui": "versionMenu", open, placement, matchReferenceWidth: !0, portal: !0, ref: setPopoverRef, children: t17 }), $[54] = open, $[55] = placement, $[56] = t11, $[57] = t17, $[58] = t18) : t18 = $[58];
  let t19;
  return $[59] !== portalElements || $[60] !== t18 ? (t19 = /* @__PURE__ */ jsx(PortalProvider, { __unstable_elements: portalElements, children: t18 }), $[59] = portalElements, $[60] = t18, $[61] = t19) : t19 = $[61], t19;
}
function _temp5$4(state_3) {
  return state_3.sinceTime;
}
function _temp4$7(state_2) {
  return state_2.realRevChunk;
}
function _temp3$7(state_1) {
  return state_1.hasMoreChunks;
}
function _temp2$b(state_0) {
  return state_0.isLoading;
}
function _temp$o(state2) {
  return state2.chunks;
}
const StyledMotionPath = styled(motion.path).withConfig({
  displayName: "StyledMotionPath",
  componentId: "sc-1l2ln4p-0"
})`transform-origin:center;`, Circle = (props) => {
  const $ = c(2);
  let t0;
  return $[0] !== props ? (t0 = /* @__PURE__ */ jsx(motion.circle, { fill: "none", r: "8", cx: "12.5", cy: "12.5", strokeWidth: "1.2", ...props }), $[0] = props, $[1] = t0) : t0 = $[1], t0;
}, Arrows = (props) => {
  const $ = c(2);
  let t0;
  return $[0] !== props ? (t0 = /* @__PURE__ */ jsx(StyledMotionPath, { fill: "none", d: "M14 17.5619L11.5 20.5L14.5 23.0619M11 7.43811L13.5 4.50001L10.5 1.93811", ...props }), $[0] = props, $[1] = t0) : t0 = $[1], t0;
}, Checkmark = (props) => {
  const $ = c(2);
  let t0;
  return $[0] !== props ? (t0 = /* @__PURE__ */ jsx(motion.path, { d: "M9.5 12.1316L11.7414 14.5L16 10", ...props }), $[0] = props, $[1] = t0) : t0 = $[1], t0;
}, rotateAnimation = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`, RotateGroup = styled.g.withConfig({
  displayName: "RotateGroup",
  componentId: "sc-1l2ln4p-1"
})`transform-origin:center;&[data-rotate]{animation:${rotateAnimation} 1s ease-in-out infinite;}`, root = {
  syncing: {
    scale: 1,
    transition: {
      duration: 0
    }
  },
  saved: {
    scale: [1, 0.8, 1.2, 0.9, 1.1, 0.95, 1.05, 0.99, 1],
    transition: {
      duration: 0.5,
      delay: 0.2
    }
  },
  changes: {
    transition: {
      duration: 0
    }
  }
}, circle = {
  syncing: {
    strokeDasharray: "0, 0, 23, 3, 23, 3",
    strokeDashoffset: 10,
    opacity: 1,
    transition: {
      duration: 0
    }
  },
  saved: {
    strokeDasharray: "0, 0, 23, 0, 23, 0",
    strokeDashoffset: 10,
    opacity: 1,
    transition: {
      duration: 0.2
    }
  },
  changes: {
    strokeDasharray: "0, 60, 23, 0, 23, 0",
    strokeDashoffset: 0,
    opacity: 0,
    transition: {
      duration: 0.5
    }
  }
}, arrows = {
  syncing: {
    opacity: 1,
    transition: {
      duration: 0
    }
  },
  saved: {
    opacity: 0,
    transition: {
      duration: 0.2
    }
  },
  changes: {
    opacity: 0
  }
}, checkmark = {
  syncing: {
    pathLength: 0,
    transition: {
      duration: 0
    }
  },
  saved: {
    pathLength: 1,
    transition: {
      delay: 0.4,
      duration: 0.3
    }
  },
  changes: {
    pathLength: 0,
    transition: {
      duration: 0.2
    }
  }
};
function AnimatedStatusIcon(props) {
  const $ = c(13), {
    status
  } = props;
  if (!status)
    return null;
  const t0 = status === "changes" ? void 0 : "";
  let t1, t2;
  $[0] !== status ? (t1 = /* @__PURE__ */ jsx(Arrows, { variants: arrows, initial: status, animate: status }), t2 = /* @__PURE__ */ jsx(Circle, { variants: circle, initial: status, animate: status }), $[0] = status, $[1] = t1, $[2] = t2) : (t1 = $[1], t2 = $[2]);
  let t3;
  $[3] !== t0 || $[4] !== t1 || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsxs(RotateGroup, { "data-rotate": t0, children: [
    t1,
    t2
  ] }), $[3] = t0, $[4] = t1, $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== status ? (t4 = /* @__PURE__ */ jsx(Checkmark, { variants: checkmark, initial: status, animate: status }), $[7] = status, $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== status || $[10] !== t3 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", stroke: "currentColor", strokeWidth: "1.2", "data-sanity-icon": "animated-status-icon", children: /* @__PURE__ */ jsxs(motion.g, { variants: root, initial: status, animate: status, children: [
    t3,
    t4
  ] }) }), $[9] = status, $[10] = t3, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
const STATUS_DICTIONARY = {
  saved: {
    i18nKey: "status-bar.document-status-pulse.status.saved.text",
    tone: "positive"
  },
  syncing: {
    i18nKey: "status-bar.document-status-pulse.status.syncing.text",
    tone: "default"
  }
}, DocumentStatusPulse = (props) => {
  const $ = c(13), {
    status
  } = props, {
    t
  } = useTranslation(structureLocaleNamespace);
  if (status !== "saved" && status !== "syncing")
    return null;
  const currentStatus = STATUS_DICTIONARY[status];
  let t0;
  $[0] !== status ? (t0 = /* @__PURE__ */ jsx(AnimatedStatusIcon, { status }), $[0] = status, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== currentStatus.tone || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(TextWithTone, { size: 1, tone: currentStatus.tone, children: t0 }), $[2] = currentStatus.tone, $[3] = t0, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== currentStatus.i18nKey || $[6] !== t ? (t2 = t(currentStatus.i18nKey), $[5] = currentStatus.i18nKey, $[6] = t, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t2 }), $[8] = t2, $[9] = t3) : t3 = $[9];
  let t4;
  return $[10] !== t1 || $[11] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, "data-testid": "pane-footer-document-status-pulse", children: [
    t1,
    t3
  ] }), $[10] = t1, $[11] = t3, $[12] = t4) : t4 = $[12], t4;
}, RELATIVE_TIME_OPTIONS = {
  minimal: !0,
  useTemporalPhrase: !0
}, MotionButton = motion.create(Button), MotionBox = motion.create(Box);
function getDocumentStatusKey(timelineKey) {
  return timelineKey === "timeline.operation.published" ? "document-status.last-published" : timelineKey;
}
const ButtonSkeleton = () => {
  const $ = c(2);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx("div", { style: {
    margin: -5
  }, children: /* @__PURE__ */ jsx(AvatarSkeleton, { $size: 0, animated: !0 }) }), $[0] = t0) : t0 = $[0];
  let t1;
  return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, paddingLeft: 1, paddingRight: 2, paddingY: 2, children: [
    t0,
    /* @__PURE__ */ jsx(Skeleton, { animated: !0, style: {
      width: "80px",
      height: "15px"
    }, radius: 2 })
  ] }), $[1] = t1) : t1 = $[1], t1;
}, DocumentStatusButton = (t0) => {
  const $ = c(17), {
    author,
    translationKey,
    timestamp: t1
  } = t0, timestamp = t1 === void 0 ? "" : t1, {
    onHistoryOpen,
    inspector,
    onHistoryClose
  } = useDocumentPane(), {
    t
  } = useTranslation(), relativeTime = useRelativeTime(timestamp, RELATIVE_TIME_OPTIONS);
  let t2, t3, t4;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    opacity: 1
  }, t3 = {
    opacity: 0
  }, t4 = {
    opacity: 0
  }, $[0] = t2, $[1] = t3, $[2] = t4) : (t2 = $[0], t3 = $[1], t4 = $[2]);
  const t5 = inspector?.name === HISTORY_INSPECTOR_NAME ? onHistoryClose : onHistoryOpen;
  let t6;
  $[3] !== author ? (t6 = author && /* @__PURE__ */ jsx("div", { style: {
    margin: -5
  }, children: /* @__PURE__ */ jsx(UserAvatar, { user: author, size: 0 }) }), $[3] = author, $[4] = t6) : t6 = $[4];
  let t7;
  $[5] !== t || $[6] !== translationKey ? (t7 = t(translationKey), $[5] = t, $[6] = translationKey, $[7] = t7) : t7 = $[7];
  let t8;
  $[8] !== relativeTime || $[9] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Text, { muted: !0, size: 1, children: [
    t7,
    " ",
    relativeTime
  ] }), $[8] = relativeTime, $[9] = t7, $[10] = t8) : t8 = $[10];
  let t9;
  $[11] !== t6 || $[12] !== t8 ? (t9 = /* @__PURE__ */ jsxs(Flex, { align: "center", flex: "none", gap: 3, children: [
    t6,
    t8
  ] }), $[11] = t6, $[12] = t8, $[13] = t9) : t9 = $[13];
  let t10;
  return $[14] !== t5 || $[15] !== t9 ? (t10 = /* @__PURE__ */ jsx(MotionButton, { "data-testid": "pane-footer-document-status", animate: t2, initial: t3, exit: t4, mode: "bleed", onClick: t5, padding: 2, muted: !0, children: t9 }), $[14] = t5, $[15] = t9, $[16] = t10) : t10 = $[16], t10;
}, FallbackStatus = () => {
  const $ = c(6), {
    editState
  } = useDocumentPane(), {
    selectedPerspective
  } = usePerspective();
  let t0;
  $[0] !== editState || $[1] !== selectedPerspective ? (t0 = (function() {
    return isPublishedPerspective(selectedPerspective) && editState?.published?._updatedAt ? {
      translationKey: TIMELINE_ITEM_I18N_KEY_MAPPING$1.published.createDocumentVersion,
      timestamp: editState.published._updatedAt
    } : editState?.version?._updatedAt ? {
      translationKey: editState.version._updatedAt === editState.version._createdAt ? TIMELINE_ITEM_I18N_KEY_MAPPING$1.version.createDocumentVersion : TIMELINE_ITEM_I18N_KEY_MAPPING$1.version.editDocumentVersion,
      timestamp: editState.version._updatedAt
    } : editState?.draft?._updatedAt ? {
      translationKey: editState.draft._updatedAt === editState.draft._createdAt ? TIMELINE_ITEM_I18N_KEY_MAPPING$1.draft.createDocumentVersion : TIMELINE_ITEM_I18N_KEY_MAPPING$1.draft.editDocumentVersion,
      timestamp: editState.draft._updatedAt
    } : null;
  })(), $[0] = editState, $[1] = selectedPerspective, $[2] = t0) : t0 = $[2];
  const status = t0;
  if (!status)
    return null;
  let t1;
  return $[3] !== status.timestamp || $[4] !== status.translationKey ? (t1 = /* @__PURE__ */ jsx(DocumentStatusButton, { author: "", translationKey: status.translationKey, timestamp: status.timestamp }), $[3] = status.timestamp, $[4] = status.translationKey, $[5] = t1) : t1 = $[5], t1;
}, EventsStatus = () => {
  const $ = c(8), {
    events,
    loading
  } = useEvents(), event = events?.[0];
  if (!event && loading) {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(ButtonSkeleton, {}), $[0] = t02) : t02 = $[0], t02;
  }
  if (!event) {
    let t02;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(FallbackStatus, {}), $[1] = t02) : t02 = $[1], t02;
  }
  const t0 = event.author, t1 = TIMELINE_ITEM_I18N_KEY_MAPPING$1[event.documentVariantType][event.type];
  let t2;
  $[2] !== t1 ? (t2 = getDocumentStatusKey(t1), $[2] = t1, $[3] = t2) : t2 = $[3];
  let t3;
  return $[4] !== event.author || $[5] !== event.timestamp || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(DocumentStatusButton, { author: t0, translationKey: t2, timestamp: event.timestamp }), $[4] = event.author, $[5] = event.timestamp, $[6] = t2, $[7] = t3) : t3 = $[7], t3;
}, TimelineStatus = () => {
  const $ = c(10), {
    timelineStore
  } = useDocumentPane(), chunks = useTimelineSelector(timelineStore, _temp$n), loading = useTimelineSelector(timelineStore, _temp2$a), event = chunks?.[0];
  if (!event && loading) {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(ButtonSkeleton, {}), $[0] = t02) : t02 = $[0], t02;
  }
  if (!event) {
    let t02;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(FallbackStatus, {}), $[1] = t02) : t02 = $[1], t02;
  }
  let t0;
  $[2] !== event.authors ? (t0 = Array.from(event.authors), $[2] = event.authors, $[3] = t0) : t0 = $[3];
  const author = t0[0], t1 = TIMELINE_ITEM_I18N_KEY_MAPPING[event.type];
  let t2;
  $[4] !== t1 ? (t2 = getDocumentStatusKey(t1), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== author || $[7] !== event.endTimestamp || $[8] !== t2 ? (t3 = /* @__PURE__ */ jsx(DocumentStatusButton, { author, translationKey: t2, timestamp: event.endTimestamp }), $[6] = author, $[7] = event.endTimestamp, $[8] = t2, $[9] = t3) : t3 = $[9], t3;
}, SYNCING_TIMEOUT = 1e3, SAVED_TIMEOUT = 3e3;
function DocumentStatusLine() {
  const $ = c(18), {
    editState,
    value
  } = useDocumentPane(), {
    documentId,
    documentType
  } = useDocumentPaneInfo(), [status, setStatus] = useState(null), eventsEnabled = useSource().beta?.eventsAPI?.documents, syncState = useSyncState(documentId, documentType, editState?.release), lastUpdated = value?._updatedAt;
  let t0;
  $[0] !== status || $[1] !== syncState.isSyncing ? (t0 = () => {
    if (status === "syncing" && !syncState.isSyncing) {
      const timerId = setTimeout(() => setStatus("saved"), SYNCING_TIMEOUT);
      return () => clearTimeout(timerId);
    }
    if (status === "saved") {
      const timerId_0 = setTimeout(() => setStatus(null), SAVED_TIMEOUT);
      return () => clearTimeout(timerId_0);
    }
  }, $[0] = status, $[1] = syncState.isSyncing, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== lastUpdated || $[4] !== status || $[5] !== syncState.isSyncing ? (t1 = [status, lastUpdated, syncState.isSyncing], $[3] = lastUpdated, $[4] = status, $[5] = syncState.isSyncing, $[6] = t1) : t1 = $[6], useEffect(t0, t1);
  let t2;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setStatus(null);
  }, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== documentId ? (t3 = [documentId], $[8] = documentId, $[9] = t3) : t3 = $[9], useLayoutEffect(t2, t3);
  let t4;
  $[10] !== syncState.isSyncing ? (t4 = () => {
    syncState.isSyncing && setStatus("syncing");
  }, $[10] = syncState.isSyncing, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== lastUpdated || $[13] !== syncState.isSyncing ? (t5 = [syncState.isSyncing, lastUpdated], $[12] = lastUpdated, $[13] = syncState.isSyncing, $[14] = t5) : t5 = $[14], useLayoutEffect(t4, t5);
  let t6;
  return $[15] !== eventsEnabled || $[16] !== status ? (t6 = /* @__PURE__ */ jsx(AnimatePresence, { children: status ? /* @__PURE__ */ jsx(MotionBox, { paddingLeft: 2, animate: {
    opacity: 1
  }, initial: {
    opacity: 0
  }, exit: {
    opacity: 0
  }, children: /* @__PURE__ */ jsx(DocumentStatusPulse, { status: status || void 0 }) }) : /* @__PURE__ */ jsx(Fragment, { children: eventsEnabled ? /* @__PURE__ */ jsx(EventsStatus, {}) : /* @__PURE__ */ jsx(TimelineStatus, {}) }) }), $[15] = eventsEnabled, $[16] = status, $[17] = t6) : t6 = $[17], t6;
}
function _temp$n(state2) {
  return state2.chunks;
}
function _temp2$a(state_0) {
  return state_0.isLoading;
}
const StatusText = styled(Text).withConfig({
  displayName: "StatusText",
  componentId: "sc-15z6xze-0"
})`color:var(--card-muted-fg-color);em{color:var(--card-fg-color);font-weight:500;font-style:normal;}`;
function RevisionStatusLine() {
  const $ = c(9), {
    displayed,
    revisionNotFound
  } = useDocumentPane(), events = useContext(EventsContext), revision = events?.revision, revisionEvent = events?.events.find((ev) => ev.id === revision?.revisionId), {
    t
  } = useTranslation(), date = revisionEvent?.timestamp || displayed?._updatedAt || displayed?._createdAt, t0 = "revision", t1 = date ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "document-status.revision-from", values: {
    date: format(new Date(date), "MMM d, yyyy '@' pp")
  } }) : null;
  let t2;
  $[0] !== t1 ? (t2 = {
    name: t0,
    text: t1,
    tone: "caution"
  }, $[0] = t1, $[1] = t2) : t2 = $[1];
  const message = t2;
  let t3;
  $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(RestoreIcon, {}) }) }), $[2] = t3) : t3 = $[2];
  let t4;
  $[3] !== message || $[4] !== revisionNotFound || $[5] !== t ? (t4 = revisionNotFound ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "document-status.revision-not-found" }) : message.text, $[3] = message, $[4] = revisionNotFound, $[5] = t, $[6] = t4) : t4 = $[6];
  let t5;
  return $[7] !== t4 ? (t5 = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Flex, { flex: 1, gap: 3, padding: 2, children: [
    t3,
    /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(StatusText, { size: 1, textOverflow: "ellipsis", children: t4 }) })
  ] }) }), $[7] = t4, $[8] = t5) : t5 = $[8], t5;
}
function useResizeObserver(t0) {
  const $ = c(4), {
    element,
    onResize
  } = t0;
  let t1, t2;
  $[0] !== element || $[1] !== onResize ? (t1 = () => {
    if (!element)
      return;
    const observer = new ResizeObserver((entries) => {
      const entry = entries.find((e) => e.target === element);
      entry && onResize(entry);
    });
    return observer.observe(element), () => observer.disconnect();
  }, t2 = [element, onResize], $[0] = element, $[1] = onResize, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useLayoutEffect(t1, t2);
}
const CONTAINER_BREAKPOINT = 480, AnimatedCard = motion.create(Card);
function DocumentStatusBar(props) {
  const $ = c(17), {
    actionsBoxRef
  } = props, {
    editState,
    revisionNotFound
  } = useDocumentPane(), {
    params: t0
  } = usePaneRouter(), params = t0 === void 0 ? EMPTY_PARAMS$2 : t0, {
    selectedPerspective
  } = usePerspective(), showingRevision = !!params.rev, [collapsed, setCollapsed] = useState(null), [rootElement, setRootElement] = useState(null);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (event) => {
    setCollapsed(event.contentRect.width < CONTAINER_BREAKPOINT);
  }, $[0] = t1) : t1 = $[0];
  const handleResize = t1;
  let t2;
  $[1] !== rootElement ? (t2 = {
    element: rootElement,
    onResize: handleResize
  }, $[1] = rootElement, $[2] = t2) : t2 = $[2], useResizeObserver(t2);
  let t3;
  bb0: {
    const isReady = !!(editState?.ready && typeof collapsed == "boolean");
    if (selectedPerspective) {
      if (isPublishedPerspective(selectedPerspective)) {
        t3 = isReady && !!editState?.published;
        break bb0;
      }
      if (isReleaseDocument(selectedPerspective)) {
        t3 = isReady && !!editState?.version;
        break bb0;
      }
    }
    t3 = isReady;
  }
  const shouldRender = t3;
  let actions;
  if (showingRevision) {
    let t42;
    $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(HistoryStatusBarActions, {}), $[3] = t42) : t42 = $[3], actions = t42;
  } else {
    let t42;
    $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t42 = /* @__PURE__ */ jsx(DocumentStatusBarActions, {}), $[4] = t42) : t42 = $[4], actions = t42;
  }
  if (showingRevision && revisionNotFound)
    return null;
  const t4 = showingRevision ? "revision" : "published";
  let t5;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    opacity: 0.2
  }, $[5] = t5) : t5 = $[5];
  let t6;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    opacity: 1,
    transition: {
      duration: 0.3
    }
  }, $[6] = t6) : t6 = $[6];
  const t7 = showingRevision ? "caution" : void 0;
  let t8;
  $[7] !== actions || $[8] !== actionsBoxRef || $[9] !== collapsed || $[10] !== shouldRender || $[11] !== showingRevision ? (t8 = shouldRender && /* @__PURE__ */ jsxs(Flex, { align: "stretch", gap: 1, justify: "space-between", paddingLeft: showingRevision ? 0 : 1, paddingRight: showingRevision ? 0 : 1, children: [
    /* @__PURE__ */ jsxs(Flex, { align: "center", flex: 1, gap: collapsed ? 2 : 3, wrap: "wrap", paddingRight: 3, children: [
      /* @__PURE__ */ jsxs(Flex, { align: "center", children: [
        showingRevision ? /* @__PURE__ */ jsx(RevisionStatusLine, {}) : /* @__PURE__ */ jsx(DocumentStatusLine, {}),
        /* @__PURE__ */ jsx(SpacerButton, {})
      ] }),
      /* @__PURE__ */ jsx(DocumentBadges, {})
    ] }),
    /* @__PURE__ */ jsxs(Flex, { align: "flex-start", justify: "flex-end", ref: actionsBoxRef, style: {
      flexShrink: 0,
      marginLeft: "auto"
    }, children: [
      /* @__PURE__ */ jsx(SpacerButton, {}),
      actions
    ] })
  ] }), $[7] = actions, $[8] = actionsBoxRef, $[9] = collapsed, $[10] = shouldRender, $[11] = showingRevision, $[12] = t8) : t8 = $[12];
  let t9;
  return $[13] !== t4 || $[14] !== t7 || $[15] !== t8 ? (t9 = /* @__PURE__ */ jsx(AnimatedCard, { initial: t5, animate: t6, tone: t7, radius: 3, ref: setRootElement, sizing: "border", padding: 2, children: t8 }, t4), $[13] = t4, $[14] = t7, $[15] = t8, $[16] = t9) : t9 = $[16], t9;
}
const KeyboardShortcutResponder = memo(function(props) {
  const $ = c(26);
  let actionsBoxElement, activeIndex, children, id, onActionStart, onKeyDown, rest, rootRef, states, t0;
  $[0] !== props ? ({
    actionsBoxElement,
    activeIndex,
    as: t0,
    children,
    id,
    onActionStart,
    onKeyDown,
    rootRef,
    states,
    ...rest
  } = props, $[0] = props, $[1] = actionsBoxElement, $[2] = activeIndex, $[3] = children, $[4] = id, $[5] = onActionStart, $[6] = onKeyDown, $[7] = rest, $[8] = rootRef, $[9] = states, $[10] = t0) : (actionsBoxElement = $[1], activeIndex = $[2], children = $[3], id = $[4], onActionStart = $[5], onKeyDown = $[6], rest = $[7], rootRef = $[8], states = $[9], t0 = $[10]);
  const As = t0 === void 0 ? "div" : t0, activeAction = states[activeIndex];
  let t1;
  $[11] !== onActionStart || $[12] !== onKeyDown || $[13] !== states ? (t1 = (event) => {
    const matchingStates = states.filter((state2) => state2.shortcut && isHotkey(state2.shortcut, event)), matchingState = matchingStates[0];
    if (matchingStates.length > 1 && console.warn(`Keyboard shortcut conflict: More than one document action matches the shortcut "${matchingState.shortcut}"`), matchingState && !matchingState.disabled && matchingState.onHandle) {
      event.preventDefault(), matchingState.onHandle(), onActionStart(states.indexOf(matchingState));
      return;
    }
    onKeyDown && onKeyDown(event);
  }, $[11] = onActionStart, $[12] = onKeyDown, $[13] = states, $[14] = t1) : t1 = $[14];
  const handleKeyDown = t1;
  let t2;
  $[15] !== actionsBoxElement || $[16] !== activeAction ? (t2 = activeAction && activeAction.dialog && /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "paneFooter", children: /* @__PURE__ */ jsx(ActionStateDialog, { dialog: activeAction.dialog, referenceElement: actionsBoxElement }) }), $[15] = actionsBoxElement, $[16] = activeAction, $[17] = t2) : t2 = $[17];
  let t3;
  return $[18] !== As || $[19] !== children || $[20] !== handleKeyDown || $[21] !== id || $[22] !== rest || $[23] !== rootRef || $[24] !== t2 ? (t3 = /* @__PURE__ */ jsxs(As, { id, onKeyDown: handleKeyDown, tabIndex: -1, ...rest, ref: rootRef, children: [
    children,
    t2
  ] }), $[18] = As, $[19] = children, $[20] = handleKeyDown, $[21] = id, $[22] = rest, $[23] = rootRef, $[24] = t2, $[25] = t3) : t3 = $[25], t3;
}), DocumentActionShortcuts = memo((props) => {
  const $ = c(12);
  let actionsBoxElement, children, rest, t0;
  $[0] !== props ? ({
    actionsBoxElement,
    as: t0,
    children,
    ...rest
  } = props, $[0] = props, $[1] = actionsBoxElement, $[2] = children, $[3] = rest, $[4] = t0) : (actionsBoxElement = $[1], children = $[2], rest = $[3], t0 = $[4]);
  const as = t0 === void 0 ? "div" : t0, [activeIndex, setActiveIndex] = useState(-1);
  let t1;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (idx) => {
    setActiveIndex(idx);
  }, $[5] = t1) : t1 = $[5];
  const onActionStart = t1;
  let t2;
  return $[6] !== actionsBoxElement || $[7] !== activeIndex || $[8] !== as || $[9] !== children || $[10] !== rest ? (t2 = /* @__PURE__ */ jsx(RenderActionCollectionState, { children: (t3) => {
    const {
      states
    } = t3;
    return /* @__PURE__ */ jsx(KeyboardShortcutResponder, { ...rest, activeIndex, actionsBoxElement, as, onActionStart, states, children });
  } }), $[6] = actionsBoxElement, $[7] = activeIndex, $[8] = as, $[9] = children, $[10] = rest, $[11] = t2) : t2 = $[11], t2;
});
DocumentActionShortcuts.displayName = "Memo(DocumentActionShortcuts)";
const HiddenCheckmarkIcon = () => {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(CheckmarkIcon, { style: {
    visibility: "hidden"
  } }), $[0] = t0) : t0 = $[0], t0;
};
function getInspectorItems({
  currentInspector,
  hasValue,
  inspectors: inspectors2,
  inspectorMenuItems
}) {
  return inspectors2.map((inspector, index) => {
    const menuItem = inspectorMenuItems[index];
    return !menuItem || menuItem.hidden ? null : {
      action: `${INSPECT_ACTION_PREFIX}${inspector.name}`,
      group: menuItem.showAsAction ? void 0 : "inspectors",
      icon: menuItem.icon,
      disabled: !hasValue,
      selected: currentInspector?.name === inspector.name,
      shortcut: menuItem.hotkeys?.join("+"),
      showAsAction: menuItem.showAsAction,
      title: menuItem.title,
      tone: menuItem.tone
    };
  }).filter(Boolean);
}
function getInspectItem({
  hasValue,
  t
}) {
  return {
    action: "inspect",
    group: "inspectors",
    title: t("document-inspector.menu-item.title"),
    icon: JsonIcon,
    disabled: !hasValue,
    shortcut: "Ctrl+Alt+I"
  };
}
function getCompareVersionsItem({
  documentIdStack,
  t
}) {
  const disabled = typeof documentIdStack?.previousId > "u" && {
    reason: t("compare-versions.menu-item.disabled-reason")
  };
  return {
    action: "compareVersions",
    group: "inspectors",
    title: t("compare-versions.menu-item.title"),
    icon: TransferIcon,
    disabled
  };
}
function getInlineChangesItem({
  displayInlineChanges,
  t
}) {
  return {
    action: "toggleInlineChanges",
    group: "inspectors",
    title: t("toggle-inline-changes.menu-item.title"),
    // The simplest way to render no icon, while preserving an icon-sized space, is to render a
    // hidden icon.
    icon: displayInlineChanges ? CheckmarkIcon : HiddenCheckmarkIcon
  };
}
function getProductionPreviewItem({
  previewUrl,
  t
}) {
  return previewUrl ? {
    action: "production-preview",
    group: "links",
    title: t("production-preview.menu-item.title"),
    icon: EarthAmericasIcon,
    shortcut: "Ctrl+Alt+O"
  } : null;
}
function getMenuItems(params) {
  const inspectorItems = getInspectorItems(params), items = [
    // Get production preview item
    getProductionPreviewItem(params),
    getCompareVersionsItem(params),
    getInlineChangesItem(params)
  ].filter(Boolean);
  return [
    ...inspectorItems,
    // TODO: convert to inspector or document view?
    getInspectItem(params),
    ...items
  ];
}
function DocumentLayoutError(props) {
  const $ = c(23), {
    documentType,
    value,
    currentMinWidth,
    paneKey,
    minWidth
  } = props, {
    t
  } = useTranslation();
  let t0;
  $[0] !== documentType ? (t0 = {
    documentType
  }, $[0] = documentType, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== t || $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "panes.document-pane.document-unknown-type.title", values: t0 }), $[2] = t, $[3] = t0, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== documentType || $[6] !== t ? (t2 = documentType && /* @__PURE__ */ jsx(Text, { as: "p", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "panes.document-pane.document-unknown-type.text", values: {
    documentType
  } }) }), $[5] = documentType, $[6] = t, $[7] = t2) : t2 = $[7];
  let t3;
  $[8] !== documentType || $[9] !== t ? (t3 = !documentType && /* @__PURE__ */ jsx(Text, { as: "p", children: t("panes.document-pane.document-unknown-type.without-schema.text") }), $[8] = documentType, $[9] = t, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== value ? (t4 = isDev && value && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Text, { as: "p", children: "Here is the JSON representation of the document:" }),
    /* @__PURE__ */ jsx(Card, { padding: 3, overflow: "auto", radius: 2, shadow: 1, tone: "inherit", children: /* @__PURE__ */ jsx(Code, { language: "json", size: [1, 1, 2], children: JSON.stringify(value, null, 2) }) })
  ] }), $[11] = value, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== t2 || $[14] !== t3 || $[15] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    t2,
    t3,
    t4
  ] }), $[13] = t2, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== currentMinWidth || $[18] !== minWidth || $[19] !== paneKey || $[20] !== t1 || $[21] !== t5 ? (t6 = /* @__PURE__ */ jsx(ErrorPane, { currentMinWidth, flex: 2.5, minWidth, paneKey, title: t1, tone: "caution", children: t5 }), $[17] = currentMinWidth, $[18] = minWidth, $[19] = paneKey, $[20] = t1, $[21] = t5, $[22] = t6) : t6 = $[22], t6;
}
const DIALOG_PROVIDER_POSITION$1 = [
  // We use the `position: fixed` for dialogs on narrower screens (first two media breakpoints).
  "fixed",
  "fixed",
  // And we use the `position: absolute` strategy (within panes) on wide screens.
  "absolute"
];
function DocumentLayoutFooter(t0) {
  const $ = c(13), {
    documentPanelPortalElement,
    setFooterElement,
    setActionsBoxElement
  } = t0, zOffsets = useZIndex();
  let t1;
  $[0] !== documentPanelPortalElement ? (t1 = {
    [DOCUMENT_PANEL_PORTAL_ELEMENT]: documentPanelPortalElement
  }, $[0] = documentPanelPortalElement, $[1] = t1) : t1 = $[1];
  const portalElements = t1;
  let t2;
  $[2] !== setActionsBoxElement ? (t2 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(DocumentStatusBar, { actionsBoxRef: setActionsBoxElement }) }), $[2] = setActionsBoxElement, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== setFooterElement || $[5] !== t2 ? (t3 = /* @__PURE__ */ jsx(PaneFooter, { ref: setFooterElement, padding: 1, children: t2 }), $[4] = setFooterElement, $[5] = t2, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== t3 || $[8] !== zOffsets.portal ? (t4 = /* @__PURE__ */ jsx(DialogProvider, { position: DIALOG_PROVIDER_POSITION$1, zOffset: zOffsets.portal, children: t3 }), $[7] = t3, $[8] = zOffsets.portal, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== portalElements || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(PortalProvider, { __unstable_elements: portalElements, children: t4 }), $[10] = portalElements, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
}
const EMPTY_ARRAY$1 = [], DIALOG_PROVIDER_POSITION = [
  // We use the `position: fixed` for dialogs on narrower screens (first two media breakpoints).
  "fixed",
  "fixed",
  // And we use the `position: absolute` strategy (within panes) on wide screens.
  "absolute"
], StyledChangeConnectorRoot = styled(ChangeConnectorRoot).withConfig({
  displayName: "StyledChangeConnectorRoot",
  componentId: "sc-tn8aer-0"
})`flex:1;display:flex;flex-direction:column;min-height:0;min-width:0;`;
function DocumentLayout() {
  const $ = c(82), {
    changesOpen,
    displayed,
    documentId,
    documentType,
    editState,
    fieldActions,
    focusPath,
    inspectOpen,
    inspector,
    inspectors: inspectors2,
    onFocus,
    onHistoryOpen,
    onMenuAction,
    onPathOpen,
    paneKey,
    schemaType,
    value,
    previewUrl
  } = useDocumentPane(), {
    stickyParams
  } = useRouter(), {
    params: paneParams
  } = usePaneRouter(), {
    features
  } = useStructureTool(), {
    t
  } = useTranslation(structureLocaleNamespace), {
    collapsed: layoutCollapsed
  } = usePaneLayout(), zOffsets = useZIndex(), [rootElement, setRootElement] = useState(null), [footerElement, setFooterElement] = useState(null), [headerElement, setHeaderElement] = useState(null), [actionsBoxElement, setActionsBoxElement] = useState(null), [documentPanelPortalElement, setDocumentPanelPortalElement] = useState(null);
  let t0;
  $[0] !== focusPath || $[1] !== rootElement || $[2] !== value ? (t0 = {
    element: rootElement,
    focusPath,
    value
  }, $[0] = focusPath, $[1] = rootElement, $[2] = value, $[3] = t0) : t0 = $[3], useGlobalCopyPasteElementHandler(t0);
  let t1;
  $[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = [], $[4] = t1) : t1 = $[4];
  const [inspectorMenuItems, setInspectorMenuItems] = useState(t1);
  let t2;
  $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = [], $[5] = t2) : t2 = $[5];
  const [rootFieldActionNodes, setRootFieldActionNodes] = useState(t2), footerRect = useElementRect(footerElement), headerRect = useElementRect(headerElement), footerHeight = footerRect?.height, headerHeight = headerRect?.height, currentMinWidth = DOCUMENT_PANEL_INITIAL_MIN_WIDTH + (inspector ? DOCUMENT_INSPECTOR_MIN_WIDTH : 0), minWidth = DOCUMENT_PANEL_MIN_WIDTH + (inspector ? DOCUMENT_INSPECTOR_MIN_WIDTH : 0);
  let t3;
  $[6] !== inspector?.name || $[7] !== inspectors2 ? (t3 = inspectors2?.find((i) => i.name === inspector?.name), $[6] = inspector?.name, $[7] = inspectors2, $[8] = t3) : t3 = $[8];
  const currentInspector = t3;
  let t4;
  $[9] !== displayed || $[10] !== documentId || $[11] !== editState ? (t4 = {
    displayed,
    documentId,
    editState
  }, $[9] = displayed, $[10] = documentId, $[11] = editState, $[12] = t4) : t4 = $[12];
  const documentIdStack = useDocumentIdStack(t4), hasValue = !!value, t5 = stickyParams.displayInlineChanges === "true";
  let t6;
  $[13] !== currentInspector || $[14] !== documentIdStack || $[15] !== features || $[16] !== hasValue || $[17] !== inspectorMenuItems || $[18] !== inspectors2 || $[19] !== previewUrl || $[20] !== t || $[21] !== t5 ? (t6 = getMenuItems({
    currentInspector,
    hasValue,
    inspectorMenuItems,
    inspectors: inspectors2,
    previewUrl,
    documentIdStack,
    t,
    displayInlineChanges: t5
  }), $[13] = currentInspector, $[14] = documentIdStack, $[15] = features, $[16] = hasValue, $[17] = inspectorMenuItems, $[18] = inspectors2, $[19] = previewUrl, $[20] = t, $[21] = t5, $[22] = t6) : t6 = $[22];
  const menuItems = t6;
  let t7;
  $[23] !== menuItems || $[24] !== onMenuAction ? (t7 = (event) => {
    for (const item of menuItems)
      if (item.shortcut && isHotkey(item.shortcut, event)) {
        event.preventDefault(), event.stopPropagation(), onMenuAction(item);
        return;
      }
  }, $[23] = menuItems, $[24] = onMenuAction, $[25] = t7) : t7 = $[25];
  const handleKeyUp = t7;
  let t8;
  $[26] !== onFocus || $[27] !== onPathOpen ? (t8 = (path) => {
    onPathOpen(path), onFocus(path);
  }, $[26] = onFocus, $[27] = onPathOpen, $[28] = t8) : t8 = $[28];
  const onConnectorSetFocus = t8;
  if (!schemaType) {
    let t92;
    return $[29] !== currentMinWidth || $[30] !== documentType || $[31] !== minWidth || $[32] !== paneKey || $[33] !== value ? (t92 = /* @__PURE__ */ jsx(DocumentLayoutError, { currentMinWidth, documentType, minWidth, paneKey, value }), $[29] = currentMinWidth, $[30] = documentType, $[31] = minWidth, $[32] = paneKey, $[33] = value, $[34] = t92) : t92 = $[34], t92;
  }
  let t9;
  $[35] !== documentId || $[36] !== documentType || $[37] !== inspectors2 ? (t9 = inspectors2.length > 0 && /* @__PURE__ */ jsx(DocumentInspectorMenuItemsResolver, { documentId, documentType, inspectors: inspectors2, onMenuItems: setInspectorMenuItems }), $[35] = documentId, $[36] = documentType, $[37] = inspectors2, $[38] = t9) : t9 = $[38];
  let t10;
  $[39] !== documentId || $[40] !== documentType || $[41] !== fieldActions || $[42] !== schemaType ? (t10 = fieldActions.length > 0 && schemaType && /* @__PURE__ */ jsx(FieldActionsResolver, { actions: fieldActions, documentId, documentType, onActions: setRootFieldActionNodes, path: EMPTY_ARRAY$1, schemaType }), $[39] = documentId, $[40] = documentType, $[41] = fieldActions, $[42] = schemaType, $[43] = t10) : t10 = $[43];
  let t11;
  $[44] !== menuItems ? (t11 = /* @__PURE__ */ jsx(DocumentPanelHeader, { ref: setHeaderElement, menuItems }), $[44] = menuItems, $[45] = t11) : t11 = $[45];
  const t12 = layoutCollapsed ? void 0 : "fill", t13 = changesOpen && paneParams?.changesInspectorTab === "review", t14 = footerHeight || null, t15 = headerHeight || null;
  let t16;
  $[46] !== documentPanelPortalElement ? (t16 = /* @__PURE__ */ jsx(DocumentLayoutFooter, { documentPanelPortalElement, setFooterElement, setActionsBoxElement }), $[46] = documentPanelPortalElement, $[47] = t16) : t16 = $[47];
  let t17;
  $[48] !== inspectOpen || $[49] !== rootElement || $[50] !== t14 || $[51] !== t15 || $[52] !== t16 ? (t17 = /* @__PURE__ */ jsx(DocumentPanel, { footerHeight: t14, headerHeight: t15, isInspectOpen: inspectOpen, rootElement, setDocumentPanelPortalElement, footer: t16 }), $[48] = inspectOpen, $[49] = rootElement, $[50] = t14, $[51] = t15, $[52] = t16, $[53] = t17) : t17 = $[53];
  let t18;
  $[54] !== onConnectorSetFocus || $[55] !== onHistoryOpen || $[56] !== t13 || $[57] !== t17 ? (t18 = /* @__PURE__ */ jsx(StyledChangeConnectorRoot, { "data-testid": "change-connector-root", isReviewChangesOpen: t13, onOpenReviewChanges: onHistoryOpen, onSetFocus: onConnectorSetFocus, children: t17 }), $[54] = onConnectorSetFocus, $[55] = onHistoryOpen, $[56] = t13, $[57] = t17, $[58] = t18) : t18 = $[58];
  let t19;
  $[59] !== t12 || $[60] !== t18 ? (t19 = /* @__PURE__ */ jsx(Flex, { direction: "column", flex: 1, height: t12, children: t18 }), $[59] = t12, $[60] = t18, $[61] = t19) : t19 = $[61];
  let t20;
  $[62] !== t19 || $[63] !== zOffsets.paneDialog ? (t20 = /* @__PURE__ */ jsx(DialogProvider, { position: DIALOG_PROVIDER_POSITION, zOffset: zOffsets.paneDialog, children: t19 }), $[62] = t19, $[63] = zOffsets.paneDialog, $[64] = t20) : t20 = $[64];
  let t21;
  $[65] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t21 = /* @__PURE__ */ jsx(DocumentOperationResults, {}), $[65] = t21) : t21 = $[65];
  let t22;
  $[66] !== actionsBoxElement || $[67] !== currentMinWidth || $[68] !== handleKeyUp || $[69] !== minWidth || $[70] !== paneKey || $[71] !== t11 || $[72] !== t20 ? (t22 = /* @__PURE__ */ jsxs(DocumentActionShortcuts, { actionsBoxElement, as: Pane, currentMinWidth, "data-testid": "document-pane", flex: 2.5, id: paneKey, minWidth, onKeyUp: handleKeyUp, rootRef: setRootElement, children: [
    t11,
    t20,
    t21
  ] }), $[66] = actionsBoxElement, $[67] = currentMinWidth, $[68] = handleKeyUp, $[69] = minWidth, $[70] = paneKey, $[71] = t11, $[72] = t20, $[73] = t22) : t22 = $[73];
  let t23;
  $[74] !== rootFieldActionNodes || $[75] !== t22 ? (t23 = /* @__PURE__ */ jsx(DocumentActionsProvider, { children: /* @__PURE__ */ jsx(FieldActionsProvider, { actions: rootFieldActionNodes, path: EMPTY_ARRAY$1, children: t22 }) }), $[74] = rootFieldActionNodes, $[75] = t22, $[76] = t23) : t23 = $[76];
  let t24;
  return $[77] !== t10 || $[78] !== t23 || $[79] !== t9 || $[80] !== value ? (t24 = /* @__PURE__ */ jsxs(GetFormValueProvider, { value, children: [
    t9,
    t10,
    t23
  ] }), $[77] = t10, $[78] = t23, $[79] = t9, $[80] = value, $[81] = t24) : t24 = $[81], t24;
}
function useDocumentLayoutComponent() {
  const $ = c(1);
  let t0;
  return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    pick: pickDocumentLayoutComponent,
    defaultComponent: DocumentLayout
  }, $[0] = t0) : t0 = $[0], useMiddlewareComponents(t0);
}
const DocumentTitle = (t0) => {
  const $ = c(20), {
    isDeleted,
    displayed,
    ready,
    schemaType
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), isNewDocument2 = !displayed?._createdAt, t1 = !!displayed;
  let t2;
  $[0] !== displayed || $[1] !== schemaType || $[2] !== t1 ? (t2 = {
    enabled: t1,
    schemaType,
    value: displayed
  }, $[0] = displayed, $[1] = schemaType, $[2] = t1, $[3] = t2) : t2 = $[3];
  const {
    value,
    isLoading: previewValueIsLoading
  } = useValuePreview(t2);
  let t3;
  $[4] !== isDeleted || $[5] !== isNewDocument2 || $[6] !== schemaType?.name || $[7] !== schemaType?.title || $[8] !== t || $[9] !== value?.title ? (t3 = isDeleted ? "" : isNewDocument2 ? t("browser-document-title.new-document", {
    schemaType: schemaType?.title || schemaType?.name
  }) : value?.title || t("browser-document-title.untitled-document"), $[4] = isDeleted, $[5] = isNewDocument2, $[6] = schemaType?.name, $[7] = schemaType?.title, $[8] = t, $[9] = value?.title, $[10] = t3) : t3 = $[10];
  const documentTitle = t3, newTitle = useConstructDocumentTitle(documentTitle);
  let t4;
  $[11] !== newTitle || $[12] !== previewValueIsLoading || $[13] !== ready ? (t4 = () => {
    !ready || previewValueIsLoading || (document.title = newTitle);
  }, $[11] = newTitle, $[12] = previewValueIsLoading, $[13] = ready, $[14] = t4) : t4 = $[14];
  let t5;
  return $[15] !== documentTitle || $[16] !== newTitle || $[17] !== previewValueIsLoading || $[18] !== ready ? (t5 = [documentTitle, ready, newTitle, previewValueIsLoading], $[15] = documentTitle, $[16] = newTitle, $[17] = previewValueIsLoading, $[18] = ready, $[19] = t5) : t5 = $[19], useEffect(t4, t5), null;
}, PassthroughTitle = (props) => {
  const $ = c(5), {
    title
  } = props, newTitle = useConstructDocumentTitle(title);
  let t0;
  $[0] !== newTitle ? (t0 = () => {
    document.title = newTitle;
  }, $[0] = newTitle, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== newTitle || $[3] !== title ? (t1 = [newTitle, title], $[2] = newTitle, $[3] = title, $[4] = t1) : t1 = $[4], useEffect(t0, t1), null;
}, StructureTitle = (props) => {
  const $ = c(5), {
    resolvedPanes
  } = props;
  if (!resolvedPanes?.length)
    return null;
  const lastPane = resolvedPanes[resolvedPanes.length - 1];
  if (isLoadingPane(lastPane)) {
    let t02;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t02 = /* @__PURE__ */ jsx(PassthroughTitle, {}), $[0] = t02) : t02 = $[0], t02;
  }
  if (isDocumentPane(lastPane)) {
    if (lastPane?.title) {
      let t02;
      return $[1] !== lastPane.title ? (t02 = /* @__PURE__ */ jsx(PassthroughTitle, { title: lastPane.title }), $[1] = lastPane.title, $[2] = t02) : t02 = $[2], t02;
    }
    return null;
  }
  const t0 = lastPane?.title;
  let t1;
  return $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(PassthroughTitle, { title: t0 }), $[3] = t0, $[4] = t1) : t1 = $[4], t1;
};
function useConstructDocumentTitle(activeTitle) {
  const $ = c(3), structureToolBaseTitle = useStructureTool().structureContext.title;
  let t0;
  return $[0] !== activeTitle || $[1] !== structureToolBaseTitle ? (t0 = [activeTitle, structureToolBaseTitle].filter(_temp$m), $[0] = activeTitle, $[1] = structureToolBaseTitle, $[2] = t0) : t0 = $[2], t0.join(" | ");
}
function _temp$m(title) {
  return title;
}
function isDocumentPane(pane) {
  return pane !== LOADING_PANE && pane.type === "document";
}
function isLoadingPane(pane) {
  return pane === LOADING_PANE;
}
const EventsContextFallback = {
  revision: null
}, useDeletedDocumentLastRevision = () => {
  const $ = c(3), {
    revision
  } = useContext(EventsContext) || EventsContextFallback, t0 = revision?.document || null, t1 = revision?.loading || !1;
  let t2;
  return $[0] !== t0 || $[1] !== t1 ? (t2 = {
    lastRevisionDocument: t0,
    loading: t1
  }, $[0] = t0, $[1] = t1, $[2] = t2) : t2 = $[2], t2;
};
function useDocumentInitialLoadTelemetry(t0) {
  const $ = c(9), {
    ready,
    schemaTypeName,
    editState,
    hasRevisionParam
  } = t0, telemetry = useTelemetry(), t0Ref = useRef(null);
  let t1, t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    t0Ref.current = performance.now();
  }, t2 = [], $[0] = t1, $[1] = t2) : (t1 = $[0], t2 = $[1]), useEffect(t1, t2);
  const firedRef = useRef(!1);
  let t3, t4;
  $[2] !== editState || $[3] !== hasRevisionParam || $[4] !== ready || $[5] !== schemaTypeName || $[6] !== telemetry ? (t3 = () => {
    if (firedRef.current || !ready || t0Ref.current === null)
      return;
    firedRef.current = !0;
    const isNewDoc = editState?.ready === !0 && editState.draft === null && editState.published === null && editState.version === null;
    telemetry.log(DocumentInitialLoadMeasured, {
      durationMs: performance.now() - t0Ref.current,
      documentTypeName: schemaTypeName ?? "unknown",
      isNewDocument: isNewDoc,
      hasRevisionParam
    });
  }, t4 = [ready, telemetry, schemaTypeName, editState, hasRevisionParam], $[2] = editState, $[3] = hasRevisionParam, $[4] = ready, $[5] = schemaTypeName, $[6] = telemetry, $[7] = t3, $[8] = t4) : (t3 = $[7], t4 = $[8]), useEffect(t3, t4);
}
function getInitialValueTemplateOpts(templates, opts) {
  const payload = opts.panePayload || {}, structureNodeTemplate = opts.templateName;
  opts.urlTemplate && structureNodeTemplate && structureNodeTemplate !== opts.urlTemplate && console.warn(`Conflicting templates: URL says "${opts.urlTemplate}", structure node says "${structureNodeTemplate}". Using "${structureNodeTemplate}".`);
  const template = structureNodeTemplate || opts.urlTemplate, typeTemplates = templates.filter((t) => t.schemaType === opts.documentType), templateParams = {
    ...opts.templateParams,
    ...typeof payload == "object" ? payload || {} : {}
  };
  let templateName = template;
  return !template && typeTemplates.length === 1 && (templateName = typeTemplates[0].id), {
    templateName,
    templateParams
  };
}
const useDocumentPaneInitialValue = (t0) => {
  const $ = c(13), {
    paneOptions,
    documentType,
    documentId,
    params
  } = t0, templates = useTemplates(), paneRouter = usePaneRouter(), panePayload = useUnique(paneRouter.payload);
  let t1;
  $[0] !== documentType || $[1] !== paneOptions.template || $[2] !== paneOptions.templateParameters || $[3] !== panePayload || $[4] !== params.template || $[5] !== templates ? (t1 = getInitialValueTemplateOpts(templates, {
    documentType,
    templateName: paneOptions.template,
    templateParams: paneOptions.templateParameters,
    panePayload,
    urlTemplate: params.template
  }), $[0] = documentType, $[1] = paneOptions.template, $[2] = paneOptions.templateParameters, $[3] = panePayload, $[4] = params.template, $[5] = templates, $[6] = t1) : t1 = $[6];
  const {
    templateName,
    templateParams
  } = t1;
  let t2;
  $[7] !== documentId || $[8] !== documentType || $[9] !== params.version || $[10] !== templateName || $[11] !== templateParams ? (t2 = {
    documentId,
    documentType,
    templateName,
    templateParams,
    version: params.version
  }, $[7] = documentId, $[8] = documentType, $[9] = params.version, $[10] = templateName, $[11] = templateParams, $[12] = t2) : t2 = $[12];
  const initialValueRaw = useInitialValue(t2);
  return useUnique(initialValueRaw);
};
function useDocumentPaneInspector(t0) {
  const $ = c(54), {
    documentId,
    documentType,
    params,
    setParams
  } = t0, {
    features
  } = useStructureTool(), inspectorsResolver = useSource().document.inspectors;
  let t1;
  $[0] !== documentId || $[1] !== documentType || $[2] !== inspectorsResolver ? (t1 = inspectorsResolver({
    documentId,
    documentType
  }), $[0] = documentId, $[1] = documentType, $[2] = inspectorsResolver, $[3] = t1) : t1 = $[3];
  const inspectors2 = t1;
  let t2;
  $[4] !== params.inspect ? (t2 = () => params.inspect || null, $[4] = params.inspect, $[5] = t2) : t2 = $[5];
  const [inspectorName, setInspectorName] = useState(t2), inspectParamRef = useRef(params.inspect);
  let t3, t4;
  $[6] !== params.inspect ? (t3 = () => {
    inspectParamRef.current !== params.inspect && (inspectParamRef.current = params.inspect, setInspectorName(params.inspect || null));
  }, t4 = [params.inspect], $[6] = params.inspect, $[7] = t3, $[8] = t4) : (t3 = $[7], t4 = $[8]), useEffect(t3, t4);
  let t5;
  $[9] !== inspectorName || $[10] !== inspectors2 ? (t5 = inspectors2?.find((i) => i.name === inspectorName), $[9] = inspectorName, $[10] = inspectors2, $[11] = t5) : t5 = $[11];
  const currentInspector = t5;
  let t6;
  $[12] !== inspectors2 ? (t6 = inspectors2.find(_temp$l), $[12] = inspectors2, $[13] = t6) : t6 = $[13];
  const historyInspector = t6, changesOpen = currentInspector?.name === HISTORY_INSPECTOR_NAME;
  let t7;
  $[14] !== currentInspector || $[15] !== inspectors2 || $[16] !== params || $[17] !== setParams ? (t7 = (closeInspectorName) => {
    const inspector = closeInspectorName && inspectors2.find((i_1) => i_1.name === closeInspectorName);
    if (closeInspectorName && !inspector) {
      console.warn(`No inspector named "${closeInspectorName}"`);
      return;
    }
    if (currentInspector) {
      if (inspector) {
        const result = inspector.onClose?.({
          params
        }) ?? {
          params
        };
        setInspectorName(null), inspectParamRef.current = void 0, setParams({
          ...result.params,
          inspect: void 0
        });
        return;
      }
      if (currentInspector) {
        const result_0 = currentInspector.onClose?.({
          params
        }) ?? {
          params
        };
        setInspectorName(null), inspectParamRef.current = void 0, setParams({
          ...result_0.params,
          inspect: void 0
        });
      }
    }
  }, $[14] = currentInspector, $[15] = inspectors2, $[16] = params, $[17] = setParams, $[18] = t7) : t7 = $[18];
  const closeInspector = t7;
  let t8;
  $[19] !== currentInspector || $[20] !== inspectors2 || $[21] !== params || $[22] !== setParams ? (t8 = (nextInspectorName, paneParams) => {
    const nextInspector = inspectors2.find((i_2) => i_2.name === nextInspectorName);
    if (!nextInspector) {
      console.warn(`No inspector named "${nextInspectorName}"`);
      return;
    }
    if (currentInspector?.name === nextInspector.name) {
      setParams({
        ...params,
        ...paneParams,
        inspect: nextInspector.name
      });
      return;
    }
    let currentParams = params;
    currentInspector && (currentParams = (nextInspector.onClose?.({
      params: currentParams
    }) ?? {
      params: currentParams
    }).params);
    const result_1 = nextInspector.onOpen?.({
      params: currentParams
    }) ?? {
      params: currentParams
    };
    setInspectorName(nextInspector.name), inspectParamRef.current = nextInspector.name, setParams({
      ...result_1.params,
      ...paneParams,
      inspect: nextInspector.name
    });
  }, $[19] = currentInspector, $[20] = inspectors2, $[21] = params, $[22] = setParams, $[23] = t8) : t8 = $[23];
  const openInspector = t8;
  let t9;
  $[24] !== closeInspector || $[25] !== historyInspector ? (t9 = () => {
    historyInspector && closeInspector(historyInspector.name);
  }, $[24] = closeInspector, $[25] = historyInspector, $[26] = t9) : t9 = $[26];
  const handleHistoryClose = t9;
  let t10;
  $[27] !== features.reviewChanges || $[28] !== historyInspector || $[29] !== openInspector ? (t10 = () => {
    features.reviewChanges && historyInspector && openInspector(historyInspector.name, {
      changesInspectorTab: "review"
    });
  }, $[27] = features.reviewChanges, $[28] = historyInspector, $[29] = openInspector, $[30] = t10) : t10 = $[30];
  const handleHistoryOpen = t10, inspectOpen = params.inspect === "on";
  let t11;
  $[31] !== inspectOpen || $[32] !== params || $[33] !== setParams ? (t11 = (t122) => {
    setParams((t122 === void 0 ? !inspectOpen : t122) ? {
      ...params,
      inspect: "on"
    } : {
      ...params,
      inspect: void 0
    });
  }, $[31] = inspectOpen, $[32] = params, $[33] = setParams, $[34] = t11) : t11 = $[34];
  const toggleLegacyInspect = t11;
  let t12;
  $[35] !== toggleLegacyInspect ? (t12 = () => toggleLegacyInspect(!1), $[35] = toggleLegacyInspect, $[36] = t12) : t12 = $[36];
  const handleLegacyInspectClose = t12;
  let t13;
  $[37] !== closeInspector || $[38] !== inspectorName || $[39] !== inspectors2 || $[40] !== openInspector || $[41] !== toggleLegacyInspect ? (t13 = (item) => {
    if (item.action === "inspect")
      return toggleLegacyInspect(!0), !0;
    if (typeof item.action != "string")
      return !1;
    const nextInspectorName_0 = item.action.slice(INSPECT_ACTION_PREFIX.length), nextInspector_0 = inspectors2.find((i_3) => i_3.name === nextInspectorName_0);
    return nextInspector_0 ? (nextInspector_0.name === inspectorName ? closeInspector(nextInspector_0.name) : openInspector(nextInspector_0.name), !0) : !1;
  }, $[37] = closeInspector, $[38] = inspectorName, $[39] = inspectors2, $[40] = openInspector, $[41] = toggleLegacyInspect, $[42] = t13) : t13 = $[42];
  const handleInspectorAction = t13;
  let t14;
  return $[43] !== changesOpen || $[44] !== closeInspector || $[45] !== currentInspector || $[46] !== handleHistoryClose || $[47] !== handleHistoryOpen || $[48] !== handleInspectorAction || $[49] !== handleLegacyInspectClose || $[50] !== inspectOpen || $[51] !== inspectors2 || $[52] !== openInspector ? (t14 = {
    changesOpen,
    currentInspector,
    inspectors: inspectors2,
    closeInspector,
    openInspector,
    handleHistoryClose,
    handleHistoryOpen,
    handleInspectorAction,
    handleLegacyInspectClose,
    inspectOpen
  }, $[43] = changesOpen, $[44] = closeInspector, $[45] = currentInspector, $[46] = handleHistoryClose, $[47] = handleHistoryOpen, $[48] = handleInspectorAction, $[49] = handleLegacyInspectClose, $[50] = inspectOpen, $[51] = inspectors2, $[52] = openInspector, $[53] = t14) : t14 = $[53], t14;
}
function _temp$l(i_0) {
  return i_0.name === HISTORY_INSPECTOR_NAME;
}
const isSanityDocument = (value) => isRecord(value) && typeof value._id == "string" && typeof value._type == "string";
function usePreviewUrl(value) {
  const $ = c(6), {
    resolveProductionUrl
  } = useSource().document;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = new BehaviorSubject(void 0), $[0] = t0) : t0 = $[0];
  const subject = t0;
  let t1, t2;
  $[1] !== value ? (t1 = () => {
    subject.next(value);
  }, t2 = [subject, value], $[1] = value, $[2] = t1, $[3] = t2) : (t1 = $[2], t2 = $[3]), useEffect(t1, t2);
  let t3;
  return $[4] !== resolveProductionUrl ? (t3 = subject.asObservable().pipe(distinctUntilChanged$1(), debounceTime(500), switchMap((document2) => isSanityDocument(document2) ? from(resolveProductionUrl({
    document: document2
  })) : of(void 0)), distinctUntilChanged$1(), catchError$1(_temp$k)), $[4] = resolveProductionUrl, $[5] = t3) : t3 = $[5], useObservable(t3);
}
function _temp$k(err) {
  const message = isRecord(err) && typeof err.message == "string" ? err.message : "Unknown error";
  throw new Error(`An error was thrown while trying to get your preview url: ${message}`);
}
function DocumentPaneProvider(props) {
  const $ = c(250), {
    children,
    index,
    pane,
    paneKey,
    onFocusPath,
    onSetMaximizedPane,
    maximized: t0,
    forcedVersion,
    historyStore
  } = props, maximized = t0 === void 0 ? !1 : t0, {
    store: timelineStore,
    error: timelineError,
    ready: timelineReady,
    revisionDocument,
    onOlderRevision,
    sinceDocument,
    isPristine,
    revisionId,
    lastNonDeletedRevId
  } = historyStore, schema = useSchema(), {
    setDocumentMeta
  } = useCopyPaste(), {
    document: t1
  } = useSource(), {
    actions: documentActions2,
    badges: documentBadges2,
    unstable_fieldActions: fieldActionsResolver,
    unstable_languageFilter: languageFilterResolver,
    drafts: t2
  } = t1, {
    enabled: draftsEnabled
  } = t2, telemetry = useTelemetry(), router2 = useRouter(), paneRouter = usePaneRouter(), setPaneParams = paneRouter.setParams, {
    options,
    menuItemGroups: t3,
    title: t4,
    views: t5
  } = pane, menuItemGroups = t3 === void 0 ? DEFAULT_MENU_ITEM_GROUPS : t3, title = t4 === void 0 ? null : t4;
  let t6;
  $[0] !== t5 ? (t6 = t5 === void 0 ? [] : t5, $[0] = t5, $[1] = t6) : t6 = $[1];
  const viewsProp = t6, paneOptions = useUnique(options), documentIdRaw = paneOptions.id;
  let t7;
  $[2] !== documentIdRaw ? (t7 = getPublishedId(documentIdRaw), $[2] = documentIdRaw, $[3] = t7) : t7 = $[3];
  const documentId = t7, documentType = options.type, params = useUnique(paneRouter.params) || EMPTY_PARAMS$2, perspective = usePerspective(), {
    advancedVersionControl: t8,
    document: t9
  } = useWorkspace(), {
    enabled: advancedVersionControlEnabled
  } = t8, {
    drafts: t10
  } = t9, {
    enabled: isDraftModelEnabled
  } = t10;
  let t11;
  bb0: {
    if (forcedVersion) {
      t11 = forcedVersion;
      break bb0;
    }
    let t122;
    $[4] !== perspective.selectedPerspectiveName || $[5] !== perspective.selectedReleaseId ? (t122 = {
      selectedPerspectiveName: perspective.selectedPerspectiveName,
      selectedReleaseId: perspective.selectedReleaseId
    }, $[4] = perspective.selectedPerspectiveName, $[5] = perspective.selectedReleaseId, $[6] = t122) : t122 = $[6], t11 = t122;
  }
  const {
    selectedReleaseId,
    selectedPerspectiveName
  } = t11, {
    data: t12
  } = useActiveReleases(), releases = t12 === void 0 ? EMPTY_ARRAY$2 : t12, diffViewRouter = useDiffViewRouter();
  let t13;
  $[7] !== documentId || $[8] !== documentType || $[9] !== paneOptions || $[10] !== params ? (t13 = {
    paneOptions,
    documentId,
    documentType,
    params
  }, $[7] = documentId, $[8] = documentType, $[9] = paneOptions, $[10] = params, $[11] = t13) : t13 = $[11];
  const initialValue = useDocumentPaneInitialValue(t13), isInitialValueLoading = initialValue.loading;
  let t14;
  $[12] !== documentId || $[13] !== documentType || $[14] !== params || $[15] !== setPaneParams ? (t14 = {
    documentId,
    documentType,
    params,
    setParams: setPaneParams
  }, $[12] = documentId, $[13] = documentType, $[14] = params, $[15] = setPaneParams, $[16] = t14) : t14 = $[16];
  const {
    changesOpen,
    currentInspector,
    inspectors: inspectors2,
    closeInspector,
    openInspector,
    handleHistoryClose,
    handleHistoryOpen,
    handleInspectorAction,
    inspectOpen,
    handleLegacyInspectClose
  } = useDocumentPaneInspector(t14), [isDeleting, setIsDeleting] = useState(!1), {
    lastRevisionDocument
  } = useDeletedDocumentLastRevision();
  let t15;
  $[17] !== isPristine || $[18] !== timelineReady ? (t15 = (editState) => timelineReady ? !editState?.draft && !editState?.published && !editState?.version && !isPristine : !1, $[17] = isPristine, $[18] = timelineReady, $[19] = t15) : t15 = $[19];
  const getIsDeleted = t15;
  let t16;
  $[20] !== changesOpen || $[21] !== sinceDocument ? (t16 = (upstreamEditState) => {
    const upstream = selectUpstreamVersion(upstreamEditState);
    return changesOpen ? sinceDocument || upstream : upstream || null;
  }, $[20] = changesOpen, $[21] = sinceDocument, $[22] = t16) : t16 = $[22];
  const getComparisonValue = t16;
  let t17;
  $[23] !== documentType || $[24] !== schema ? (t17 = schema.get(documentType), $[23] = documentType, $[24] = schema, $[25] = t17) : t17 = $[25];
  const schemaType = t17;
  let t18;
  $[26] !== getIsDeleted || $[27] !== isDeleting || $[28] !== isDraftModelEnabled || $[29] !== params.rev || $[30] !== perspective.selectedPerspective || $[31] !== releases || $[32] !== schemaType || $[33] !== selectedReleaseId ? (t18 = (editState_0) => {
    const isDeleted = getIsDeleted(editState_0), seeingHistoryDocument = !!params.rev, currentRelease = releases.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === selectedReleaseId), isPaused = isPausedCardinalityOneRelease(currentRelease);
    return seeingHistoryDocument || isDeleting || isDeleted || !isPaused && !isPerspectiveWriteable({
      selectedPerspective: perspective.selectedPerspective,
      isDraftModelEnabled,
      schemaType
    }).result;
  }, $[26] = getIsDeleted, $[27] = isDeleting, $[28] = isDraftModelEnabled, $[29] = params.rev, $[30] = perspective.selectedPerspective, $[31] = releases, $[32] = schemaType, $[33] = selectedReleaseId, $[34] = t18) : t18 = $[34];
  const getIsReadOnly = t18;
  let t19;
  $[35] !== lastNonDeletedRevId || $[36] !== lastRevisionDocument || $[37] !== onOlderRevision || $[38] !== revisionDocument ? (t19 = (value) => onOlderRevision ? revisionDocument || {
    _id: value._id,
    _type: value._type
  } : !value._createdAt && !value._updatedAt && lastNonDeletedRevId && lastRevisionDocument ? lastRevisionDocument : value, $[35] = lastNonDeletedRevId, $[36] = lastRevisionDocument, $[37] = onOlderRevision, $[38] = revisionDocument, $[39] = t19) : t19 = $[39];
  const getDisplayed = t19;
  let t20;
  $[40] !== params.path ? (t20 = params.path ? fromString(params.path) : EMPTY_ARRAY$2, $[40] = params.path, $[41] = t20) : t20 = $[41];
  const t21 = router2.stickyParams.displayInlineChanges === "true";
  let t22;
  $[42] !== changesOpen || $[43] !== documentId || $[44] !== documentType || $[45] !== getComparisonValue || $[46] !== getDisplayed || $[47] !== getIsReadOnly || $[48] !== initialValue || $[49] !== onFocusPath || $[50] !== selectedPerspectiveName || $[51] !== t20 || $[52] !== t21 ? (t22 = {
    changesOpen,
    documentType,
    documentId,
    initialValue,
    comparisonValue: getComparisonValue,
    releaseId: selectedPerspectiveName,
    selectedPerspectiveName,
    initialFocusPath: t20,
    readOnly: getIsReadOnly,
    onFocusPath,
    getFormDocumentValue: getDisplayed,
    displayInlineChanges: t21
  }, $[42] = changesOpen, $[43] = documentId, $[44] = documentType, $[45] = getComparisonValue, $[46] = getDisplayed, $[47] = getIsReadOnly, $[48] = initialValue, $[49] = onFocusPath, $[50] = selectedPerspectiveName, $[51] = t20, $[52] = t21, $[53] = t22) : t22 = $[53];
  const {
    editState: editState_1,
    upstreamEditState: upstreamEditState_0,
    hasUpstreamVersion,
    connectionState,
    focusPath,
    onChange,
    validation,
    ready: formReady,
    value: value_0,
    formState,
    permissions,
    onPathOpen,
    isPermissionsLoading,
    formStateRef,
    onProgrammaticFocus,
    collapsedFieldSets,
    collapsedPaths,
    onBlur,
    onFocus,
    onSetActiveFieldGroup,
    onSetCollapsedPath,
    onSetCollapsedFieldSet,
    openPath
  } = useDocumentForm(t22);
  let t23;
  $[54] !== draftsEnabled || $[55] !== params || $[56] !== releases || $[57] !== selectedPerspectiveName || $[58] !== selectedReleaseId || $[59] !== value_0 ? (t23 = getDocumentVersionType(params, selectedReleaseId, value_0, selectedPerspectiveName, draftsEnabled, releases), $[54] = draftsEnabled, $[55] = params, $[56] = releases, $[57] = selectedPerspectiveName, $[58] = selectedReleaseId, $[59] = value_0, $[60] = t23) : t23 = $[60];
  const actionsVersionType = t23;
  let t24;
  $[61] !== actionsVersionType || $[62] !== documentId || $[63] !== documentType || $[64] !== selectedReleaseId ? (t24 = {
    schemaType: documentType,
    documentId,
    versionType: actionsVersionType,
    releaseId: selectedReleaseId
  }, $[61] = actionsVersionType, $[62] = documentId, $[63] = documentType, $[64] = selectedReleaseId, $[65] = t24) : t24 = $[65];
  const documentActionsContext = t24;
  let t25;
  $[66] !== documentActions2 || $[67] !== documentActionsContext ? (t25 = documentActions2(documentActionsContext), $[66] = documentActions2, $[67] = documentActionsContext, $[68] = t25) : t25 = $[68];
  const actions = t25;
  let t26;
  $[69] !== onPathOpen || $[70] !== params || $[71] !== setPaneParams ? (t26 = (path) => {
    onPathOpen(path);
    const nextPath = pathToString(path);
    params.path !== nextPath && setPaneParams({
      ...params,
      path: nextPath
    });
  }, $[69] = onPathOpen, $[70] = params, $[71] = setPaneParams, $[72] = t26) : t26 = $[72];
  const handlePathOpen = t26;
  let t27;
  $[73] !== documentBadges2 || $[74] !== documentId || $[75] !== documentType ? (t27 = documentBadges2({
    schemaType: documentType,
    documentId
  }), $[73] = documentBadges2, $[74] = documentId, $[75] = documentType, $[76] = t27) : t27 = $[76];
  const badges = t27;
  let t28;
  $[77] !== documentId || $[78] !== documentType || $[79] !== languageFilterResolver ? (t28 = languageFilterResolver({
    schemaType: documentType,
    documentId
  }), $[77] = documentId, $[78] = documentType, $[79] = languageFilterResolver, $[80] = t28) : t28 = $[80];
  const languageFilter = t28, views = useUnique(viewsProp), activeViewId = params.view || views[0] && views[0].id || null, previewUrl = usePreviewUrl(value_0);
  let t29;
  $[81] !== documentId || $[82] !== documentType || $[83] !== fieldActionsResolver || $[84] !== schemaType ? (t29 = schemaType ? fieldActionsResolver({
    documentId,
    documentType,
    schemaType
  }) : [], $[81] = documentId, $[82] = documentType, $[83] = fieldActionsResolver, $[84] = schemaType, $[85] = t29) : t29 = $[85];
  const fieldActions = t29, ready = formReady && (!params.rev || timelineReady || !!timelineError), t30 = schemaType?.name, t31 = !!params.rev;
  let t32;
  $[86] !== editState_1 || $[87] !== ready || $[88] !== t30 || $[89] !== t31 ? (t32 = {
    ready,
    schemaTypeName: t30,
    editState: editState_1,
    hasRevisionParam: t31
  }, $[86] = editState_1, $[87] = ready, $[88] = t30, $[89] = t31, $[90] = t32) : t32 = $[90], useDocumentInitialLoadTelemetry(t32);
  let t33;
  $[91] !== getDisplayed || $[92] !== value_0 ? (t33 = getDisplayed(value_0), $[91] = getDisplayed, $[92] = value_0, $[93] = t33) : t33 = $[93];
  const displayed = t33;
  let t34;
  $[94] !== displayed || $[95] !== documentId || $[96] !== editState_1 ? (t34 = {
    strict: !0,
    displayed,
    documentId,
    editState: editState_1
  }, $[94] = displayed, $[95] = documentId, $[96] = editState_1, $[97] = t34) : t34 = $[97];
  const {
    previousId
  } = useDocumentIdStack(t34);
  let t35;
  $[98] !== params || $[99] !== setPaneParams ? (t35 = (newSince, newRev) => {
    setPaneParams({
      ...params,
      since: newSince,
      rev: newRev || void 0
    });
  }, $[98] = params, $[99] = setPaneParams, $[100] = t35) : t35 = $[100];
  const setTimelineRange = t35;
  let t36;
  $[101] !== paneRouter ? (t36 = () => paneRouter.closeCurrent(), $[101] = paneRouter, $[102] = t36) : t36 = $[102];
  const handlePaneClose = t36;
  let t37;
  $[103] !== paneRouter ? (t37 = () => paneRouter.duplicateCurrent(), $[103] = paneRouter, $[104] = t37) : t37 = $[104];
  const handlePaneSplit = t37;
  let t38;
  $[105] !== router2 || $[106] !== telemetry ? (t38 = () => {
    const nextState = router2.stickyParams.displayInlineChanges !== "true";
    telemetry.log(nextState ? InlineChangesSwitchedOn : InlineChangesSwitchedOff), router2.navigate({
      stickyParams: {
        displayInlineChanges: String(nextState)
      }
    });
  }, $[105] = router2, $[106] = telemetry, $[107] = t38) : t38 = $[107];
  const toggleInlineChanges = t38;
  let t39;
  $[108] !== diffViewRouter || $[109] !== documentType || $[110] !== handleHistoryOpen || $[111] !== handleInspectorAction || $[112] !== previewUrl || $[113] !== previousId || $[114] !== toggleInlineChanges || $[115] !== value_0._id ? (t39 = async (item) => item.action === "production-preview" && previewUrl ? (window.open(previewUrl), !0) : item.action === "reviewChanges" ? (handleHistoryOpen(), !0) : ((item.action === "inspect" || typeof item.action == "string" && item.action.startsWith(INSPECT_ACTION_PREFIX)) && handleInspectorAction(item), item.action === "compareVersions" && typeof previousId < "u" ? (diffViewRouter.navigateDiffView({
    mode: "version",
    previousDocument: {
      type: documentType,
      id: previousId
    },
    nextDocument: {
      type: documentType,
      id: value_0._id
    }
  }), !0) : item.action === "toggleInlineChanges" ? (toggleInlineChanges(), !0) : !1), $[108] = diffViewRouter, $[109] = documentType, $[110] = handleHistoryOpen, $[111] = handleInspectorAction, $[112] = previewUrl, $[113] = previousId, $[114] = toggleInlineChanges, $[115] = value_0._id, $[116] = t39) : t39 = $[116];
  const handleMenuAction = t39;
  let t40, t41;
  $[117] !== documentId || $[118] !== documentType || $[119] !== onChange || $[120] !== schemaType || $[121] !== setDocumentMeta ? (t40 = () => {
    setDocumentMeta({
      documentId,
      documentType,
      schemaType,
      onChange
    });
  }, t41 = [documentId, documentType, schemaType, onChange, setDocumentMeta], $[117] = documentId, $[118] = documentType, $[119] = onChange, $[120] = schemaType, $[121] = setDocumentMeta, $[122] = t40, $[123] = t41) : (t40 = $[122], t41 = $[123]), useEffect(t40, t41);
  let t42;
  $[124] !== getComparisonValue || $[125] !== upstreamEditState_0 ? (t42 = getComparisonValue(upstreamEditState_0), $[124] = getComparisonValue, $[125] = upstreamEditState_0, $[126] = t42) : t42 = $[126];
  const compareValue = t42, isDeleted_1 = getIsDeleted(editState_1), revisionNotFound = onOlderRevision && !revisionDocument && ready;
  let t43;
  bb1: {
    if (editState_1.version && isGoingToUnpublish(editState_1.version)) {
      t43 = editState_1.published;
      break bb1;
    }
    t43 = displayed;
  }
  const currentDisplayed = t43, t44 = currentInspector || null;
  let t45;
  $[127] !== menuItemGroups ? (t45 = menuItemGroups || [], $[127] = menuItemGroups, $[128] = t45) : t45 = $[128];
  let t46;
  $[129] !== actions || $[130] !== activeViewId || $[131] !== badges || $[132] !== changesOpen || $[133] !== closeInspector || $[134] !== collapsedFieldSets || $[135] !== collapsedPaths || $[136] !== compareValue || $[137] !== connectionState || $[138] !== currentDisplayed || $[139] !== documentId || $[140] !== documentIdRaw || $[141] !== documentType || $[142] !== editState_1 || $[143] !== fieldActions || $[144] !== focusPath || $[145] !== formState || $[146] !== handleHistoryClose || $[147] !== handleHistoryOpen || $[148] !== handleLegacyInspectClose || $[149] !== handleMenuAction || $[150] !== handlePaneClose || $[151] !== handlePaneSplit || $[152] !== handlePathOpen || $[153] !== hasUpstreamVersion || $[154] !== index || $[155] !== inspectOpen || $[156] !== inspectors2 || $[157] !== isDeleted_1 || $[158] !== isDeleting || $[159] !== isInitialValueLoading || $[160] !== isPermissionsLoading || $[161] !== languageFilter || $[162] !== lastNonDeletedRevId || $[163] !== lastRevisionDocument || $[164] !== maximized || $[165] !== onBlur || $[166] !== onChange || $[167] !== onFocus || $[168] !== onSetActiveFieldGroup || $[169] !== onSetCollapsedFieldSet || $[170] !== onSetCollapsedPath || $[171] !== onSetMaximizedPane || $[172] !== openInspector || $[173] !== openPath || $[174] !== paneKey || $[175] !== permissions || $[176] !== previewUrl || $[177] !== ready || $[178] !== revisionId || $[179] !== revisionNotFound || $[180] !== schemaType || $[181] !== selectedReleaseId || $[182] !== setTimelineRange || $[183] !== t44 || $[184] !== t45 || $[185] !== timelineError || $[186] !== timelineStore || $[187] !== title || $[188] !== validation || $[189] !== value_0 || $[190] !== views ? (t46 = {
    actions,
    activeViewId,
    badges,
    changesOpen,
    closeInspector,
    collapsedFieldSets,
    collapsedPaths,
    compareValue,
    connectionState,
    displayed: currentDisplayed,
    documentId,
    documentIdRaw,
    documentType,
    editState: editState_1,
    fieldActions,
    focusPath,
    inspector: t44,
    inspectors: inspectors2,
    onBlur,
    onChange,
    onFocus,
    onPathOpen: handlePathOpen,
    onHistoryClose: handleHistoryClose,
    onHistoryOpen: handleHistoryOpen,
    onInspectClose: handleLegacyInspectClose,
    onMenuAction: handleMenuAction,
    onPaneClose: handlePaneClose,
    onPaneSplit: handlePaneSplit,
    onSetActiveFieldGroup,
    onSetCollapsedPath,
    onSetCollapsedFieldSet,
    onSetMaximizedPane,
    maximized,
    openInspector,
    openPath,
    index,
    inspectOpen,
    validation,
    menuItemGroups: t45,
    paneKey,
    previewUrl,
    ready,
    schemaType,
    hasUpstreamVersion,
    isPermissionsLoading,
    isInitialValueLoading,
    permissions,
    setTimelineRange,
    setIsDeleting,
    isDeleting,
    isDeleted: isDeleted_1,
    timelineError,
    timelineStore,
    title,
    value: value_0,
    selectedReleaseId,
    views,
    formState,
    unstable_languageFilter: languageFilter,
    revisionId,
    revisionNotFound,
    lastNonDeletedRevId,
    lastRevisionDocument
  }, $[129] = actions, $[130] = activeViewId, $[131] = badges, $[132] = changesOpen, $[133] = closeInspector, $[134] = collapsedFieldSets, $[135] = collapsedPaths, $[136] = compareValue, $[137] = connectionState, $[138] = currentDisplayed, $[139] = documentId, $[140] = documentIdRaw, $[141] = documentType, $[142] = editState_1, $[143] = fieldActions, $[144] = focusPath, $[145] = formState, $[146] = handleHistoryClose, $[147] = handleHistoryOpen, $[148] = handleLegacyInspectClose, $[149] = handleMenuAction, $[150] = handlePaneClose, $[151] = handlePaneSplit, $[152] = handlePathOpen, $[153] = hasUpstreamVersion, $[154] = index, $[155] = inspectOpen, $[156] = inspectors2, $[157] = isDeleted_1, $[158] = isDeleting, $[159] = isInitialValueLoading, $[160] = isPermissionsLoading, $[161] = languageFilter, $[162] = lastNonDeletedRevId, $[163] = lastRevisionDocument, $[164] = maximized, $[165] = onBlur, $[166] = onChange, $[167] = onFocus, $[168] = onSetActiveFieldGroup, $[169] = onSetCollapsedFieldSet, $[170] = onSetCollapsedPath, $[171] = onSetMaximizedPane, $[172] = openInspector, $[173] = openPath, $[174] = paneKey, $[175] = permissions, $[176] = previewUrl, $[177] = ready, $[178] = revisionId, $[179] = revisionNotFound, $[180] = schemaType, $[181] = selectedReleaseId, $[182] = setTimelineRange, $[183] = t44, $[184] = t45, $[185] = timelineError, $[186] = timelineStore, $[187] = title, $[188] = validation, $[189] = value_0, $[190] = views, $[191] = t46) : t46 = $[191];
  const documentPane = t46;
  let t47;
  $[192] !== menuItemGroups ? (t47 = menuItemGroups || [], $[192] = menuItemGroups, $[193] = t47) : t47 = $[193];
  let t48;
  $[194] !== actions || $[195] !== badges || $[196] !== documentId || $[197] !== documentIdRaw || $[198] !== documentType || $[199] !== fieldActions || $[200] !== handlePaneClose || $[201] !== handlePaneSplit || $[202] !== index || $[203] !== languageFilter || $[204] !== maximized || $[205] !== onSetMaximizedPane || $[206] !== paneKey || $[207] !== schemaType || $[208] !== t47 || $[209] !== title || $[210] !== views ? (t48 = {
    actions,
    badges,
    documentId,
    documentIdRaw,
    documentType,
    fieldActions,
    index,
    menuItemGroups: t47,
    maximized,
    onPaneClose: handlePaneClose,
    onPaneSplit: handlePaneSplit,
    onSetMaximizedPane,
    paneKey,
    schemaType,
    title,
    views,
    unstable_languageFilter: languageFilter
  }, $[194] = actions, $[195] = badges, $[196] = documentId, $[197] = documentIdRaw, $[198] = documentType, $[199] = fieldActions, $[200] = handlePaneClose, $[201] = handlePaneSplit, $[202] = index, $[203] = languageFilter, $[204] = maximized, $[205] = onSetMaximizedPane, $[206] = paneKey, $[207] = schemaType, $[208] = t47, $[209] = title, $[210] = views, $[211] = t48) : t48 = $[211];
  const documentPaneInfo = t48, pathRef = useRef(void 0), paramPath = params.path;
  let t49;
  $[212] !== formStateRef || $[213] !== onProgrammaticFocus || $[214] !== openPath ? (t49 = (urlPath) => {
    const currentOpenPathString = pathToString(openPath);
    if (urlPath !== pathRef.current && urlPath !== currentOpenPathString) {
      const pathFromUrl = resolveKeyedPath(formStateRef.current?.value, fromString(urlPath));
      onProgrammaticFocus(pathFromUrl);
    }
  }, $[212] = formStateRef, $[213] = onProgrammaticFocus, $[214] = openPath, $[215] = t49) : t49 = $[215];
  const syncPathFromUrl = useEffectEvent(t49);
  let t50;
  $[216] !== paramPath || $[217] !== ready || $[218] !== syncPathFromUrl ? (t50 = () => {
    ready && paramPath && syncPathFromUrl(paramPath), pathRef.current = paramPath;
  }, $[216] = paramPath, $[217] = ready, $[218] = syncPathFromUrl, $[219] = t50) : t50 = $[219];
  let t51;
  $[220] !== paramPath || $[221] !== ready ? (t51 = [paramPath, ready], $[220] = paramPath, $[221] = ready, $[222] = t51) : t51 = $[222], useEffect(t50, t51);
  const isDivergencesEnabled = advancedVersionControlEnabled && !!(formState && schemaType);
  let t52;
  $[223] !== editState_1 || $[224] !== formState || $[225] !== isDivergencesEnabled || $[226] !== schemaType || $[227] !== upstreamEditState_0 || $[228] !== value_0._id ? (t52 = isDivergencesEnabled && formState && schemaType ? {
    enabled: !0,
    upstreamEditState: upstreamEditState_0,
    editState: editState_1,
    subjectId: value_0._id,
    schemaType,
    formState
  } : {
    enabled: !1
  }, $[223] = editState_1, $[224] = formState, $[225] = isDivergencesEnabled, $[226] = schemaType, $[227] = upstreamEditState_0, $[228] = value_0._id, $[229] = t52) : t52 = $[229];
  const divergencesProps = t52;
  let t53;
  $[230] !== onProgrammaticFocus ? (t53 = /* @__PURE__ */ jsx(DivergenceAutofocus, { onProgrammaticFocus }), $[230] = onProgrammaticFocus, $[231] = t53) : t53 = $[231];
  let t54;
  $[232] !== displayed || $[233] !== isDeleted_1 || $[234] !== ready || $[235] !== schemaType ? (t54 = /* @__PURE__ */ jsx(DocumentTitle, { isDeleted: isDeleted_1, displayed, ready, schemaType }), $[232] = displayed, $[233] = isDeleted_1, $[234] = ready, $[235] = schemaType, $[236] = t54) : t54 = $[236];
  let t55;
  $[237] !== children ? (t55 = /* @__PURE__ */ jsx(ParseErrorsProvider, { children }), $[237] = children, $[238] = t55) : t55 = $[238];
  let t56;
  $[239] !== divergencesProps || $[240] !== t53 || $[241] !== t54 || $[242] !== t55 ? (t56 = /* @__PURE__ */ jsxs(DivergencesProvider, { ...divergencesProps, children: [
    t53,
    t54,
    t55
  ] }), $[239] = divergencesProps, $[240] = t53, $[241] = t54, $[242] = t55, $[243] = t56) : t56 = $[243];
  let t57;
  $[244] !== documentPane || $[245] !== t56 ? (t57 = /* @__PURE__ */ jsx(DocumentPaneContext.Provider, { value: documentPane, children: t56 }), $[244] = documentPane, $[245] = t56, $[246] = t57) : t57 = $[246];
  let t58;
  return $[247] !== documentPaneInfo || $[248] !== t57 ? (t58 = /* @__PURE__ */ jsx(DocumentPaneInfoContext.Provider, { value: documentPaneInfo, children: t57 }), $[247] = documentPaneInfo, $[248] = t57, $[249] = t58) : t58 = $[249], t58;
}
function getDocumentVersionType(params, selectedReleaseId, value, selectedPerspectiveName, draftsEnabled, releases) {
  let version;
  switch (!0) {
    case !!params?.rev:
      version = "revision";
      break;
    case (selectedReleaseId && isVersionId(value._id)): {
      const releaseDocument = releases.find((r) => getReleaseIdFromReleaseDocumentId(r._id) === selectedReleaseId);
      releaseDocument && isCardinalityOneRelease(releaseDocument) ? version = "scheduled-draft" : version = "version";
      break;
    }
    case selectedPerspectiveName === "published":
      version = "published";
      break;
    case draftsEnabled:
      version = "draft";
      break;
    default:
      version = "published";
  }
  return version;
}
const DivergenceAutofocus = (t0) => {
  const $ = c(8), {
    onProgrammaticFocus
  } = t0, divergenceNavigator = useDocumentDivergences(), focusedDivergence = divergenceNavigator.enabled ? divergenceNavigator.state.focusedDivergence : void 0;
  let t1;
  $[0] !== divergenceNavigator.enabled || $[1] !== divergenceNavigator.state || $[2] !== onProgrammaticFocus ? (t1 = () => {
    divergenceNavigator.enabled && typeof divergenceNavigator.state.focusedDivergence < "u" && onProgrammaticFocus(fromString(divergenceNavigator.state.focusedDivergence));
  }, $[0] = divergenceNavigator.enabled, $[1] = divergenceNavigator.state, $[2] = onProgrammaticFocus, $[3] = t1) : t1 = $[3];
  const focusDivergentPath = useEffectEvent(t1);
  let t2;
  $[4] !== focusDivergentPath ? (t2 = () => {
    focusDivergentPath();
  }, $[4] = focusDivergentPath, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== focusedDivergence ? (t3 = [focusedDivergence], $[6] = focusedDivergence, $[7] = t3) : t3 = $[7], useEffect(t2, t3), null;
}, DocumentEventsPane = (props) => {
  const $ = c(35), {
    params: t0
  } = usePaneRouter(), params = t0 === void 0 ? EMPTY_PARAMS$2 : t0, options = usePaneOptions(props.pane.options, params), schema = useSchema(), documentType = options.type, liveEdit = !!schema.get(options.type)?.liveEdit, {
    selectedPerspectiveName,
    selectedReleaseId,
    selectedPerspective
  } = usePerspective(), {
    data: archivedReleases
  } = useArchivedReleases();
  let t1;
  $[0] !== options.id ? (t1 = getPublishedId(options.id), $[0] = options.id, $[1] = t1) : t1 = $[1];
  const editState = useEditState(t1, documentType, "default", selectedReleaseId), showingPublishedOnDraft = liveEdit && selectedPerspective === "drafts" && !editState?.draft, {
    rev,
    since
  } = params, historyVersion = params.historyVersion;
  let t2;
  bb0: {
    if (showingPublishedOnDraft) {
      let t32;
      $[2] !== options.id ? (t32 = getPublishedId(options.id), $[2] = options.id, $[3] = t32) : t32 = $[3], t2 = t32;
      break bb0;
    }
    if (historyVersion && archivedReleases.some((release) => getReleaseIdFromReleaseDocumentId(release._id) === historyVersion)) {
      let t32;
      $[4] !== historyVersion || $[5] !== options.id ? (t32 = getVersionId(options.id, historyVersion), $[4] = historyVersion, $[5] = options.id, $[6] = t32) : t32 = $[6], t2 = t32;
      break bb0;
    }
    if (typeof selectedPerspectiveName > "u") {
      let t32;
      $[7] !== options.id ? (t32 = getDraftId(options.id), $[7] = options.id, $[8] = t32) : t32 = $[8], t2 = t32;
      break bb0;
    }
    if (selectedPerspectiveName === "published") {
      let t32;
      $[9] !== options.id ? (t32 = getPublishedId(options.id), $[9] = options.id, $[10] = t32) : t32 = $[10], t2 = t32;
      break bb0;
    }
    if (selectedPerspectiveName.length !== 0) {
      let t32;
      $[11] !== options.id || $[12] !== selectedPerspectiveName ? (t32 = getVersionId(options.id, selectedPerspectiveName), $[11] = options.id, $[12] = selectedPerspectiveName, $[13] = t32) : t32 = $[13], t2 = t32;
      break bb0;
    }
    t2 = options.id;
  }
  const documentId = t2;
  let t3;
  $[14] !== documentId || $[15] !== options.type || $[16] !== rev || $[17] !== since ? (t3 = {
    documentId,
    documentType: options.type,
    rev,
    since
  }, $[14] = documentId, $[15] = options.type, $[16] = rev, $[17] = since, $[18] = t3) : t3 = $[18];
  const eventsStore = useEventsStore(t3), t4 = eventsStore.error, t5 = eventsStore.revision?.revisionId || null, t6 = !!(rev && !eventsStore.revision?.loading), t7 = eventsStore.revision?.document || null, t8 = eventsStore.sinceRevision?.document || null, t9 = !eventsStore.loading, t10 = eventsStore.events.length === 0;
  let t11;
  $[19] !== eventsStore.error || $[20] !== eventsStore.lastNonDeletedRevId || $[21] !== t10 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9 ? (t11 = {
    error: t4,
    revisionId: t5,
    onOlderRevision: t6,
    revisionDocument: t7,
    sinceDocument: t8,
    ready: t9,
    isPristine: t10,
    lastNonDeletedRevId: eventsStore.lastNonDeletedRevId
  }, $[19] = eventsStore.error, $[20] = eventsStore.lastNonDeletedRevId, $[21] = t10, $[22] = t5, $[23] = t6, $[24] = t7, $[25] = t8, $[26] = t9, $[27] = t11) : t11 = $[27];
  const historyStoreProps = t11, value = eventsStore;
  let t12;
  $[28] !== historyStoreProps || $[29] !== historyVersion || $[30] !== props ? (t12 = historyVersion ? /* @__PURE__ */ jsx(PerspectiveProvider, { selectedPerspectiveName: historyVersion, excludedPerspectives: EMPTY_ARRAY$2, children: /* @__PURE__ */ jsx(DocumentPaneProvider, { ...props, historyStore: historyStoreProps }) }) : /* @__PURE__ */ jsx(DocumentPaneProvider, { ...props, historyStore: historyStoreProps }), $[28] = historyStoreProps, $[29] = historyVersion, $[30] = props, $[31] = t12) : t12 = $[31];
  let t13;
  return $[32] !== t12 || $[33] !== value ? (t13 = /* @__PURE__ */ jsx(EventsProvider, { value, children: t12 }), $[32] = t12, $[33] = value, $[34] = t13) : t13 = $[34], t13;
}, DocumentPaneWithLegacyTimelineStore = (props) => {
  const $ = c(20), {
    pane
  } = props, paneRouter = usePaneRouter(), options = usePaneOptions(pane.options, paneRouter.params), params = paneRouter.params || EMPTY_PARAMS$2, [timelineError, setTimelineError] = useState(null);
  let t0;
  $[0] !== options.id ? (t0 = getPublishedId(options.id), $[0] = options.id, $[1] = t0) : t0 = $[1];
  let t1;
  $[2] !== options.type || $[3] !== params.rev || $[4] !== params.since || $[5] !== t0 ? (t1 = {
    documentId: t0,
    documentType: options.type,
    onError: setTimelineError,
    rev: params.rev,
    since: params.since
  }, $[2] = options.type, $[3] = params.rev, $[4] = params.since, $[5] = t0, $[6] = t1) : t1 = $[6];
  const store = useTimelineStore(t1), onOlderRevision = useTimelineSelector(store, _temp$j), revTime = useTimelineSelector(store, _temp2$9), sinceAttributes = useTimelineSelector(store, _temp3$6), timelineDisplayed = useTimelineSelector(store, _temp4$6), timelineReady = useTimelineSelector(store, _temp5$3), isPristine = useTimelineSelector(store, _temp6$3), lastNonDeletedRevId = useTimelineSelector(store, _temp7$2), t2 = revTime?.id || null, t3 = timelineDisplayed, t4 = sinceAttributes, t5 = !!isPristine;
  let t6;
  $[7] !== lastNonDeletedRevId || $[8] !== onOlderRevision || $[9] !== store || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== timelineError || $[15] !== timelineReady ? (t6 = {
    store,
    error: timelineError,
    revisionId: t2,
    onOlderRevision,
    revisionDocument: t3,
    sinceDocument: t4,
    ready: timelineReady,
    isPristine: t5,
    lastNonDeletedRevId
  }, $[7] = lastNonDeletedRevId, $[8] = onOlderRevision, $[9] = store, $[10] = t2, $[11] = t3, $[12] = t4, $[13] = t5, $[14] = timelineError, $[15] = timelineReady, $[16] = t6) : t6 = $[16];
  const historyStoreProps = t6;
  let t7;
  return $[17] !== historyStoreProps || $[18] !== props ? (t7 = /* @__PURE__ */ jsx(DocumentPaneProvider, { ...props, historyStore: historyStoreProps }), $[17] = historyStoreProps, $[18] = props, $[19] = t7) : t7 = $[19], t7;
};
function _temp$j(state2) {
  return state2.onOlderRevision;
}
function _temp2$9(state_0) {
  return state_0.revTime;
}
function _temp3$6(state_1) {
  return state_1.sinceAttributes;
}
function _temp4$6(state_2) {
  return state_2.timelineDisplayed;
}
function _temp5$3(state_3) {
  return state_3.timelineReady;
}
function _temp6$3(state_4) {
  return state_4.isPristine;
}
function _temp7$2(state_5) {
  return state_5.lastNonDeletedRevId;
}
function DocumentPerspectiveProvider(t0) {
  const $ = c(4), {
    children
  } = t0, paneRouter = usePaneRouter(), {
    excludedPerspectives
  } = usePerspective(), {
    scheduledDraft
  } = paneRouter.params;
  if (scheduledDraft) {
    let t1;
    return $[0] !== children || $[1] !== excludedPerspectives || $[2] !== scheduledDraft ? (t1 = /* @__PURE__ */ jsx(PerspectiveProvider, { selectedPerspectiveName: scheduledDraft, excludedPerspectives, children }), $[0] = children, $[1] = excludedPerspectives, $[2] = scheduledDraft, $[3] = t1) : t1 = $[3], t1;
  }
  return children;
}
const DocumentPaneProviderWrapper = memo((props) => {
  const $ = c(9), source = useSource(), {
    setParams,
    params
  } = usePaneRouter();
  let t0;
  $[0] !== params || $[1] !== setParams ? (t0 = (releaseId) => {
    setParams({
      ...params,
      scheduledDraft: releaseId
    }, {
      perspective: ""
    });
  }, $[0] = params, $[1] = setParams, $[2] = t0) : t0 = $[2];
  const handleSetScheduledDraftPerspective = t0;
  let t1;
  $[3] !== props || $[4] !== source.beta?.eventsAPI?.documents ? (t1 = source.beta?.eventsAPI?.documents ? /* @__PURE__ */ jsx(DocumentEventsPane, { ...props }) : /* @__PURE__ */ jsx(DocumentPaneWithLegacyTimelineStore, { ...props }), $[3] = props, $[4] = source.beta?.eventsAPI?.documents, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== handleSetScheduledDraftPerspective || $[7] !== t1 ? (t2 = /* @__PURE__ */ jsx(DocumentPerspectiveProvider, { children: /* @__PURE__ */ jsx(SingleDocReleaseProvider, { onSetScheduledDraftPerspective: handleSetScheduledDraftPerspective, children: t1 }) }), $[6] = handleSetScheduledDraftPerspective, $[7] = t1, $[8] = t2) : t2 = $[8], t2;
});
DocumentPaneProviderWrapper.displayName = "Memo(DocumentPaneProviderWrapper)";
function useResetHistoryParams() {
  const $ = c(10), {
    params: t0,
    setParams
  } = usePaneRouter(), params = t0 === void 0 ? EMPTY_PARAMS$2 : t0, {
    selectedPerspectiveName
  } = usePerspective(), isMounted = useRef(!1);
  let t1;
  $[0] !== params || $[1] !== setParams ? (t1 = (_perspective) => {
    ["since", "historyVersion", "rev", "preserveRev"].some((param) => params[param]) && setParams({
      ...params,
      rev: params.preserveRev === "true" ? params.rev : void 0,
      preserveRev: void 0,
      since: void 0,
      historyVersion: void 0
    });
  }, $[0] = params, $[1] = setParams, $[2] = t1) : t1 = $[2];
  const updateHistoryParams = useEffectEvent(t1);
  let t2;
  $[3] !== selectedPerspectiveName || $[4] !== updateHistoryParams ? (t2 = () => {
    isMounted.current && updateHistoryParams(selectedPerspectiveName);
  }, $[3] = selectedPerspectiveName, $[4] = updateHistoryParams, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== selectedPerspectiveName ? (t3 = [selectedPerspectiveName], $[6] = selectedPerspectiveName, $[7] = t3) : t3 = $[7], useEffect(t2, t3);
  let t4, t5;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = () => (isMounted.current = !0, () => {
    isMounted.current = !1;
  }), t5 = [], $[8] = t4, $[9] = t5) : (t4 = $[8], t5 = $[9]), useEffect(t4, t5);
}
const DocumentPane = memo(function(props) {
  const $ = c(5), {
    name: parentSourceName
  } = useSource(), t0 = props.pane.source || parentSourceName;
  let t1;
  $[0] !== props ? (t1 = /* @__PURE__ */ jsx(CopyPasteProvider, { children: /* @__PURE__ */ jsx(DocumentPaneInner, { ...props }) }), $[0] = props, $[1] = t1) : t1 = $[1];
  let t2;
  return $[2] !== t0 || $[3] !== t1 ? (t2 = /* @__PURE__ */ jsx(SourceProvider, { name: t0, children: t1 }), $[2] = t0, $[3] = t1, $[4] = t2) : t2 = $[4], t2;
});
function DocumentPaneInner(props) {
  const $ = c(57), {
    pane,
    paneKey
  } = props, {
    resolveNewDocumentOptions
  } = useSource().document, {
    selectedPerspectiveName
  } = usePerspective(), paneRouter = usePaneRouter(), options = usePaneOptions(pane.options, paneRouter.params), {
    documentType,
    isLoaded: isDocumentLoaded
  } = useDocumentType(options.id, options.type);
  useResetHistoryParams();
  const DocumentLayout2 = useDocumentLayoutComponent();
  let t0;
  $[0] !== options.id || $[1] !== options.type || $[2] !== resolveNewDocumentOptions ? (t0 = resolveNewDocumentOptions({
    type: "document",
    documentId: options.id,
    schemaType: options.type
  }), $[0] = options.id, $[1] = options.type, $[2] = resolveNewDocumentOptions, $[3] = t0) : t0 = $[3];
  const templateItems = t0;
  let t1;
  $[4] !== templateItems ? (t1 = {
    templateItems
  }, $[4] = templateItems, $[5] = t1) : t1 = $[5];
  const [templatePermissions, isTemplatePermissionsLoading] = useTemplatePermissions(t1), isLoaded = isDocumentLoaded && !isTemplatePermissionsLoading;
  let t2;
  $[6] !== documentType || $[7] !== isLoaded || $[8] !== options || $[9] !== props ? (t2 = isLoaded && documentType && options.type !== documentType ? mergeDocumentType(props, options, documentType) : props, $[6] = documentType, $[7] = isLoaded, $[8] = options, $[9] = props, $[10] = t2) : t2 = $[10];
  const providerProps = t2, {
    ReferenceChildLink: ReferenceChildLink2,
    handleEditReference,
    groupIndex,
    routerPanesState
  } = paneRouter;
  let t3;
  $[11] !== groupIndex || $[12] !== routerPanesState ? (t3 = routerPanesState[groupIndex + 1]?.[0].params || {}, $[11] = groupIndex, $[12] = routerPanesState, $[13] = t3) : t3 = $[13];
  const childParams = t3, routerPanesStateLength = routerPanesState.length, {
    parentRefPath
  } = childParams;
  let t4;
  $[14] !== groupIndex || $[15] !== parentRefPath || $[16] !== routerPanesStateLength ? (t4 = parentRefPath ? {
    path: fromString(parentRefPath),
    state: groupIndex >= routerPanesStateLength - 1 ? "none" : groupIndex >= routerPanesStateLength - 2 ? "selected" : "pressed"
  } : {
    path: [],
    state: "none"
  }, $[14] = groupIndex, $[15] = parentRefPath, $[16] = routerPanesStateLength, $[17] = t4) : t4 = $[17];
  const activePath = t4, {
    t
  } = useTranslation(structureLocaleNamespace);
  if (options.type === "*" && !isLoaded) {
    let t52;
    $[18] !== t ? (t52 = t("panes.document-pane.document-not-found.loading"), $[18] = t, $[19] = t52) : t52 = $[19];
    let t62;
    return $[20] !== paneKey || $[21] !== t52 ? (t62 = /* @__PURE__ */ jsx(LoadingPane, { flex: 2.5, minWidth: 320, paneKey, title: t52 }), $[20] = paneKey, $[21] = t52, $[22] = t62) : t62 = $[22], t62;
  }
  if (!documentType) {
    let t52;
    $[23] !== t ? (t52 = t("panes.document-pane.document-not-found.title"), $[23] = t, $[24] = t52) : t52 = $[24];
    let t62;
    $[25] !== options.id ? (t62 = {
      id: options.id
    }, $[25] = options.id, $[26] = t62) : t62 = $[26];
    let t72;
    $[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t72 = {
      Code: _temp$i
    }, $[27] = t72) : t72 = $[27];
    let t82;
    $[28] !== t || $[29] !== t62 ? (t82 = /* @__PURE__ */ jsx(Stack, { space: 4, children: /* @__PURE__ */ jsx(Text, { as: "p", children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "panes.document-pane.document-not-found.text", values: t62, components: t72 }) }) }), $[28] = t, $[29] = t62, $[30] = t82) : t82 = $[30];
    let t92;
    return $[31] !== paneKey || $[32] !== t52 || $[33] !== t82 ? (t92 = /* @__PURE__ */ jsx(ErrorPane, { flex: 2.5, minWidth: 320, paneKey, title: t52, children: t82 }), $[31] = paneKey, $[32] = t52, $[33] = t82, $[34] = t92) : t92 = $[34], t92;
  }
  const t5 = `${documentType}-${options.id}-${selectedPerspectiveName || ""}`;
  let t6;
  $[35] !== DocumentLayout2 || $[36] !== options.id || $[37] !== options.type ? (t6 = /* @__PURE__ */ jsx(DocumentLayout2, { documentId: options.id, documentType: options.type }), $[35] = DocumentLayout2, $[36] = options.id, $[37] = options.type, $[38] = t6) : t6 = $[38];
  let t7;
  $[39] !== options.id || $[40] !== options.type || $[41] !== t6 ? (t7 = /* @__PURE__ */ jsx(CommentsWrapper, { documentId: options.id, documentType: options.type, children: t6 }), $[39] = options.id, $[40] = options.type, $[41] = t6, $[42] = t7) : t7 = $[42];
  let t8;
  $[43] !== options.id || $[44] !== options.type || $[45] !== t7 ? (t8 = /* @__PURE__ */ jsx(DiffViewDocumentLayout, { documentId: options.id, documentType: options.type, children: t7 }), $[43] = options.id, $[44] = options.type, $[45] = t7, $[46] = t8) : t8 = $[46];
  let t9;
  $[47] !== ReferenceChildLink2 || $[48] !== activePath || $[49] !== handleEditReference || $[50] !== t8 || $[51] !== templatePermissions ? (t9 = /* @__PURE__ */ jsx(ReferenceInputOptionsProvider, { EditReferenceLinkComponent: ReferenceChildLink2, onEditReference: handleEditReference, initialValueTemplateItems: templatePermissions, activePath, children: t8 }), $[47] = ReferenceChildLink2, $[48] = activePath, $[49] = handleEditReference, $[50] = t8, $[51] = templatePermissions, $[52] = t9) : t9 = $[52];
  let t10;
  return $[53] !== providerProps || $[54] !== t5 || $[55] !== t9 ? (t10 = /* @__PURE__ */ jsx(DocumentPaneProviderWrapper, { ...providerProps, children: t9 }, t5), $[53] = providerProps, $[54] = t5, $[55] = t9, $[56] = t10) : t10 = $[56], t10;
}
function _temp$i(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("code", { children });
}
function usePaneOptions(options, t0) {
  const $ = c(8);
  let t1;
  $[0] !== t0 ? (t1 = t0 === void 0 ? {} : t0, $[0] = t0, $[1] = t1) : t1 = $[1];
  const params = t1, templates = useTemplates();
  let t2;
  bb0: {
    if (options.type && options.type !== "*") {
      t2 = options;
      break bb0;
    }
    const templateName = options.template || params.template;
    let t3;
    $[2] !== templateName || $[3] !== templates ? (t3 = templateName ? templates.find((t) => t.id === templateName) : void 0, $[2] = templateName, $[3] = templates, $[4] = t3) : t3 = $[4];
    const documentType = t3?.schemaType;
    if (!documentType) {
      t2 = options;
      break bb0;
    }
    let t4;
    $[5] !== documentType || $[6] !== options ? (t4 = {
      ...options,
      type: documentType
    }, $[5] = documentType, $[6] = options, $[7] = t4) : t4 = $[7], t2 = t4;
  }
  return t2;
}
function mergeDocumentType(props, options, documentType) {
  return {
    ...props,
    pane: {
      ...props.pane,
      options: {
        ...options,
        type: documentType
      }
    }
  };
}
const BackLink = forwardRef(function(props, ref) {
  const $ = c(9), {
    routerPanesState,
    groupIndex
  } = useContext(PaneRouterContext);
  let t0;
  $[0] !== groupIndex || $[1] !== routerPanesState ? (t0 = routerPanesState.slice(0, groupIndex), $[0] = groupIndex, $[1] = routerPanesState, $[2] = t0) : t0 = $[2];
  const panes = t0;
  let t1;
  $[3] !== panes ? (t1 = {
    panes
  }, $[3] = panes, $[4] = t1) : t1 = $[4];
  const state2 = t1;
  let t2;
  return $[5] !== props || $[6] !== ref || $[7] !== state2 ? (t2 = /* @__PURE__ */ jsx(StateLink, { ...props, ref, state: state2 }), $[5] = props, $[6] = ref, $[7] = state2, $[8] = t2) : t2 = $[8], t2;
}), ChildLink = forwardRef(function(props, ref) {
  const $ = c(19);
  let childId, childParameters, childPayload, rest;
  $[0] !== props ? ({
    childId,
    childPayload,
    childParameters,
    ...rest
  } = props, $[0] = props, $[1] = childId, $[2] = childParameters, $[3] = childPayload, $[4] = rest) : (childId = $[1], childParameters = $[2], childPayload = $[3], rest = $[4]);
  const {
    routerPanesState,
    groupIndex
  } = useContext(PaneRouterContext);
  let t0;
  if ($[5] !== childId || $[6] !== childParameters || $[7] !== childPayload || $[8] !== groupIndex || $[9] !== routerPanesState) {
    let t12;
    $[11] !== childId || $[12] !== childParameters || $[13] !== childPayload ? (t12 = [{
      id: childId,
      params: childParameters,
      payload: childPayload
    }], $[11] = childId, $[12] = childParameters, $[13] = childPayload, $[14] = t12) : t12 = $[14], t0 = {
      panes: [...routerPanesState.slice(0, groupIndex + 1), t12]
    }, $[5] = childId, $[6] = childParameters, $[7] = childPayload, $[8] = groupIndex, $[9] = routerPanesState, $[10] = t0;
  } else
    t0 = $[10];
  let t1;
  return $[15] !== ref || $[16] !== rest || $[17] !== t0 ? (t1 = /* @__PURE__ */ jsx(StateLink, { ...rest, ref, state: t0 }), $[15] = ref, $[16] = rest, $[17] = t0, $[18] = t1) : t1 = $[18], t1;
}), ParameterizedLink = forwardRef(function(props, ref) {
  const $ = c(20), {
    routerPanesState: currentPanes,
    groupIndex,
    siblingIndex
  } = useContext(PaneRouterContext);
  let params, payload, rest;
  $[0] !== props ? ({
    params,
    payload,
    ...rest
  } = props, $[0] = props, $[1] = params, $[2] = payload, $[3] = rest) : (params = $[1], payload = $[2], rest = $[3]);
  const nextParams = useUnique(params), nextPayload = useUnique(payload), currentGroup = currentPanes[groupIndex], currentSibling = currentGroup[siblingIndex], t0 = nextParams ?? currentSibling.params, t1 = nextPayload ?? currentSibling.payload;
  let t2;
  $[4] !== currentSibling || $[5] !== t0 || $[6] !== t1 ? (t2 = {
    ...currentSibling,
    params: t0,
    payload: t1
  }, $[4] = currentSibling, $[5] = t0, $[6] = t1, $[7] = t2) : t2 = $[7];
  const nextSibling = t2;
  let t3;
  $[8] !== currentGroup || $[9] !== nextSibling || $[10] !== siblingIndex ? (t3 = [...currentGroup.slice(0, siblingIndex), nextSibling, ...currentGroup.slice(siblingIndex + 1)], $[8] = currentGroup, $[9] = nextSibling, $[10] = siblingIndex, $[11] = t3) : t3 = $[11];
  const nextGroup = t3;
  let t4;
  $[12] !== currentPanes || $[13] !== groupIndex || $[14] !== nextGroup ? (t4 = {
    panes: [...currentPanes.slice(0, groupIndex), nextGroup, ...currentPanes.slice(groupIndex + 1)]
  }, $[12] = currentPanes, $[13] = groupIndex, $[14] = nextGroup, $[15] = t4) : t4 = $[15];
  const nextState = t4;
  let t5;
  return $[16] !== nextState || $[17] !== ref || $[18] !== rest ? (t5 = /* @__PURE__ */ jsx(StateLink, { ref, ...rest, state: nextState }), $[16] = nextState, $[17] = ref, $[18] = rest, $[19] = t5) : t5 = $[19], t5;
}), ReferenceChildLink = forwardRef(function(t0, ref) {
  const $ = c(24);
  let children, documentId, documentType, parentRefPath, rest, template;
  $[0] !== t0 ? ({
    documentId,
    documentType,
    parentRefPath,
    children,
    template,
    ...rest
  } = t0, $[0] = t0, $[1] = children, $[2] = documentId, $[3] = documentType, $[4] = parentRefPath, $[5] = rest, $[6] = template) : (children = $[1], documentId = $[2], documentType = $[3], parentRefPath = $[4], rest = $[5], template = $[6]);
  let t1;
  $[7] !== documentId ? (t1 = getPublishedId(documentId), $[7] = documentId, $[8] = t1) : t1 = $[8];
  const t2 = template?.params;
  let t3;
  $[9] !== parentRefPath ? (t3 = toString(parentRefPath), $[9] = parentRefPath, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== template ? (t4 = template && {
    template: template?.id
  }, $[11] = template, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== documentType || $[14] !== t3 || $[15] !== t4 ? (t5 = {
    type: documentType,
    parentRefPath: t3,
    ...t4
  }, $[13] = documentType, $[14] = t3, $[15] = t4, $[16] = t5) : t5 = $[16];
  let t6;
  return $[17] !== children || $[18] !== ref || $[19] !== rest || $[20] !== t1 || $[21] !== t2 || $[22] !== t5 ? (t6 = /* @__PURE__ */ jsx(ChildLink, { ...rest, ref, childId: t1, childPayload: t2, childParameters: t5, children }), $[17] = children, $[18] = ref, $[19] = rest, $[20] = t1, $[21] = t2, $[22] = t5, $[23] = t6) : t6 = $[23], t6;
}), emptyArray = [];
function PaneRouterProvider(props) {
  const $ = c(60), {
    children,
    flatIndex,
    index,
    params,
    payload,
    siblingIndex
  } = props, {
    navigate,
    navigateIntent,
    resolvePathFromState
  } = useRouter(), routerState = useRouterState(), {
    panes,
    expand
  } = usePaneLayout(), routerPaneGroups = routerState?.panes || emptyArray, lastPane = panes?.[panes.length - 2], groupIndex = index - 1;
  let t0;
  $[0] !== groupIndex || $[1] !== routerPaneGroups || $[2] !== routerState || $[3] !== siblingIndex ? (t0 = (modifier) => {
    const currentGroup = routerPaneGroups[groupIndex] || [], currentItem = currentGroup[siblingIndex], nextGroup = modifier(currentGroup, currentItem), nextPanes = [...routerPaneGroups.slice(0, groupIndex), nextGroup, ...routerPaneGroups.slice(groupIndex + 1)];
    return {
      ...routerState,
      panes: nextPanes
    };
  }, $[0] = groupIndex, $[1] = routerPaneGroups, $[2] = routerState, $[3] = siblingIndex, $[4] = t0) : t0 = $[4];
  const createNextRouterState = t0;
  let t1;
  $[5] !== createNextRouterState || $[6] !== navigate ? (t1 = (modifier_0, stickyParams) => {
    const nextRouterState_0 = createNextRouterState(modifier_0);
    return setTimeout(() => navigate(nextRouterState_0, stickyParams ? {
      stickyParams
    } : void 0), 0), nextRouterState_0;
  }, $[5] = createNextRouterState, $[6] = navigate, $[7] = t1) : t1 = $[7];
  const modifyCurrentGroup = t1;
  let t2;
  $[8] !== createNextRouterState || $[9] !== resolvePathFromState || $[10] !== siblingIndex ? (t2 = (nextParams) => {
    const nextRouterState_1 = createNextRouterState((siblings, item) => [...siblings.slice(0, siblingIndex), {
      ...item,
      params: nextParams
    }, ...siblings.slice(siblingIndex + 1)]);
    return resolvePathFromState(nextRouterState_1);
  }, $[8] = createNextRouterState, $[9] = resolvePathFromState, $[10] = siblingIndex, $[11] = t2) : t2 = $[11];
  const createPathWithParams = t2;
  let t3;
  $[12] !== modifyCurrentGroup || $[13] !== siblingIndex ? (t3 = (nextPayload) => {
    modifyCurrentGroup((siblings_0, item_0) => [...siblings_0.slice(0, siblingIndex), {
      ...item_0,
      payload: nextPayload
    }, ...siblings_0.slice(siblingIndex + 1)]);
  }, $[12] = modifyCurrentGroup, $[13] = siblingIndex, $[14] = t3) : t3 = $[14];
  const setPayload = t3;
  let t4;
  $[15] !== modifyCurrentGroup || $[16] !== siblingIndex ? (t4 = (nextParams_0, stickyParams_0) => {
    modifyCurrentGroup((siblings_1, item_1) => [...siblings_1.slice(0, siblingIndex), {
      ...item_1,
      params: nextParams_0
    }, ...siblings_1.slice(siblingIndex + 1)], stickyParams_0);
  }, $[15] = modifyCurrentGroup, $[16] = siblingIndex, $[17] = t4) : t4 = $[17];
  const setParams = t4;
  let t5;
  $[18] !== groupIndex || $[19] !== navigate || $[20] !== routerPaneGroups ? (t5 = (t62) => {
    const {
      id,
      parentRefPath,
      type,
      template,
      version
    } = t62;
    navigate({
      panes: [...routerPaneGroups.slice(0, groupIndex + 1), [{
        id,
        params: {
          template: template.id,
          parentRefPath: toString(parentRefPath),
          type,
          version
        },
        payload: template.params
      }]]
    });
  }, $[18] = groupIndex, $[19] = navigate, $[20] = routerPaneGroups, $[21] = t5) : t5 = $[21];
  const handleEditReference = t5, t6 = routerPaneGroups[groupIndex] ? routerPaneGroups[groupIndex].length > 1 : !1, t7 = routerPaneGroups[groupIndex] ? routerPaneGroups[groupIndex].length : 0, t8 = flatIndex ? BackLink : void 0;
  let t10, t9;
  $[22] !== modifyCurrentGroup ? (t9 = (t112) => {
    const opts = t112 === void 0 ? {} : t112;
    modifyCurrentGroup(() => [{
      id: opts.id || "",
      payload: opts.payload,
      params: opts.params || {}
    }]);
  }, t10 = () => {
    modifyCurrentGroup(_temp$h);
  }, $[22] = modifyCurrentGroup, $[23] = t10, $[24] = t9) : (t10 = $[23], t9 = $[24]);
  let t11;
  $[25] !== expand || $[26] !== groupIndex || $[27] !== lastPane || $[28] !== navigate || $[29] !== routerPaneGroups ? (t11 = (t122) => {
    (t122 === void 0 || t122) && lastPane && expand(lastPane.element), navigate({
      panes: routerPaneGroups.slice(0, groupIndex)
    });
  }, $[25] = expand, $[26] = groupIndex, $[27] = lastPane, $[28] = navigate, $[29] = routerPaneGroups, $[30] = t11) : t11 = $[30];
  let t12;
  $[31] !== modifyCurrentGroup || $[32] !== siblingIndex ? (t12 = (options) => {
    modifyCurrentGroup((siblings_3, item_3) => {
      const duplicatedItem = {
        ...item_3,
        payload: options?.payload || item_3.payload,
        params: options?.params || item_3.params
      };
      return [...siblings_3.slice(0, siblingIndex), duplicatedItem, ...siblings_3.slice(siblingIndex)];
    });
  }, $[31] = modifyCurrentGroup, $[32] = siblingIndex, $[33] = t12) : t12 = $[33];
  let t13;
  $[34] !== params || $[35] !== setParams ? (t13 = (viewId) => {
    const restParams = omit(params, "view");
    return setParams(viewId ? {
      ...restParams,
      view: viewId
    } : restParams);
  }, $[34] = params, $[35] = setParams, $[36] = t13) : t13 = $[36];
  let t14;
  $[37] !== createPathWithParams || $[38] !== flatIndex || $[39] !== groupIndex || $[40] !== handleEditReference || $[41] !== navigateIntent || $[42] !== params || $[43] !== payload || $[44] !== routerPaneGroups || $[45] !== setParams || $[46] !== setPayload || $[47] !== siblingIndex || $[48] !== t10 || $[49] !== t11 || $[50] !== t12 || $[51] !== t13 || $[52] !== t6 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9 ? (t14 = {
    index: flatIndex,
    groupIndex,
    siblingIndex,
    payload,
    params,
    hasGroupSiblings: t6,
    groupLength: t7,
    routerPanesState: routerPaneGroups,
    ChildLink,
    BackLink: t8,
    ReferenceChildLink,
    handleEditReference,
    ParameterizedLink,
    replaceCurrent: t9,
    closeCurrent: t10,
    closeCurrentAndAfter: t11,
    duplicateCurrent: t12,
    setView: t13,
    setParams,
    setPayload,
    createPathWithParams,
    navigateIntent
  }, $[37] = createPathWithParams, $[38] = flatIndex, $[39] = groupIndex, $[40] = handleEditReference, $[41] = navigateIntent, $[42] = params, $[43] = payload, $[44] = routerPaneGroups, $[45] = setParams, $[46] = setPayload, $[47] = siblingIndex, $[48] = t10, $[49] = t11, $[50] = t12, $[51] = t13, $[52] = t6, $[53] = t7, $[54] = t8, $[55] = t9, $[56] = t14) : t14 = $[56];
  const ctx = t14;
  let t15;
  return $[57] !== children || $[58] !== ctx ? (t15 = /* @__PURE__ */ jsx(PaneRouterContext.Provider, { value: ctx, children }), $[57] = children, $[58] = ctx, $[59] = t15) : t15 = $[59], t15;
}
function _temp$h(siblings_2, item_2) {
  return siblings_2.length > 1 ? siblings_2.filter((sibling) => sibling !== item_2) : siblings_2;
}
function UnknownPane(props) {
  const $ = c(14), {
    isSelected,
    pane,
    paneKey
  } = props;
  let t0;
  $[0] !== pane ? (t0 = isRecord(pane) && pane.type || null, $[0] = pane, $[1] = t0) : t0 = $[1];
  const type = t0, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[2] !== t ? (t1 = t("panes.unknown-pane-type.title"), $[2] = t, $[3] = t1) : t1 = $[3];
  let t2;
  $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx(PaneHeader$1, { title: t1 }), $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] !== t || $[7] !== type ? (t3 = /* @__PURE__ */ jsx(PaneContent, { children: /* @__PURE__ */ jsx(Box, { padding: 4, children: typeof type == "string" ? /* @__PURE__ */ jsx(Text, { as: "p", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "panes.unknown-pane-type.unknown-type.text", values: {
    type
  } }) }) : /* @__PURE__ */ jsx(Text, { as: "p", muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "panes.unknown-pane-type.missing-type.text" }) }) }) }), $[6] = t, $[7] = type, $[8] = t3) : t3 = $[8];
  let t4;
  return $[9] !== isSelected || $[10] !== paneKey || $[11] !== t2 || $[12] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Pane, { id: paneKey, selected: isSelected, children: [
    t2,
    t3
  ] }), $[9] = isSelected, $[10] = paneKey, $[11] = t2, $[12] = t3, $[13] = t4) : t4 = $[13], t4;
}
const paneMap = {
  component: lazy(() => import("./index2.js")),
  document: lazy(() => import("./pane.js")),
  documentList: lazy(() => import("./pane2.js")),
  list: lazy(() => import("./index3.js"))
}, StructureToolPane = memo(function(props) {
  const $ = c(25), {
    active,
    childItemId,
    groupIndex,
    index,
    itemId,
    pane,
    paneKey,
    params,
    payload,
    path,
    selected,
    siblingIndex,
    maximized,
    onSetMaximizedPane
  } = props, PaneComponent = paneMap[pane.type] || UnknownPane;
  let t0;
  $[0] !== paneKey || $[1] !== path || $[2] !== selected ? (t0 = /* @__PURE__ */ jsx(LoadingPane, { paneKey, path, selected }), $[0] = paneKey, $[1] = path, $[2] = selected, $[3] = t0) : t0 = $[3];
  const t1 = childItemId || "";
  let t2;
  $[4] !== PaneComponent || $[5] !== active || $[6] !== index || $[7] !== itemId || $[8] !== maximized || $[9] !== onSetMaximizedPane || $[10] !== pane || $[11] !== paneKey || $[12] !== selected || $[13] !== t1 ? (t2 = /* @__PURE__ */ jsx(PaneComponent, { childItemId: t1, index, itemId, isActive: active, isSelected: selected, paneKey, pane, maximized, onSetMaximizedPane }), $[4] = PaneComponent, $[5] = active, $[6] = index, $[7] = itemId, $[8] = maximized, $[9] = onSetMaximizedPane, $[10] = pane, $[11] = paneKey, $[12] = selected, $[13] = t1, $[14] = t2) : t2 = $[14];
  let t3;
  $[15] !== t0 || $[16] !== t2 ? (t3 = /* @__PURE__ */ jsx(Suspense, { fallback: t0, children: t2 }), $[15] = t0, $[16] = t2, $[17] = t3) : t3 = $[17];
  let t4;
  return $[18] !== groupIndex || $[19] !== index || $[20] !== params || $[21] !== payload || $[22] !== siblingIndex || $[23] !== t3 ? (t4 = /* @__PURE__ */ jsx(PaneRouterProvider, { flatIndex: index, index: groupIndex, params, payload, siblingIndex, children: t3 }), $[18] = groupIndex, $[19] = index, $[20] = params, $[21] = payload, $[22] = siblingIndex, $[23] = t3, $[24] = t4) : t4 = $[24], t4;
}, ({
  params: prevParams = {},
  payload: prevPayload = null,
  ...prev
}, {
  params: nextParams = {},
  payload: nextPayload = null,
  ...next
}) => {
  if (!isEqual(prevParams, nextParams) || !isEqual(prevPayload, nextPayload)) return !1;
  const keys = /* @__PURE__ */ new Set([...Object.keys(prev), ...Object.keys(next)]);
  for (const key of keys)
    if (prev[key] !== next[key]) return !1;
  return !0;
});
function DocTitle(props) {
  const $ = c(10), {
    document: documentValue
  } = props, schemaType = useSchema().get(documentValue._type), {
    t
  } = useTranslation(structureLocaleNamespace), {
    title
  } = useDocumentTitle();
  if (!schemaType) {
    let t02;
    $[0] !== documentValue._type || $[1] !== t ? (t02 = t("doc-title.unknown-schema-type.text", {
      schemaType: documentValue._type
    }), $[0] = documentValue._type, $[1] = t, $[2] = t02) : t02 = $[2];
    let t12;
    return $[3] !== t02 ? (t12 = /* @__PURE__ */ jsx("code", { children: t02 }), $[3] = t02, $[4] = t12) : t12 = $[4], t12;
  }
  let t0;
  $[5] !== t || $[6] !== title ? (t0 = title || /* @__PURE__ */ jsx("span", { style: {
    color: "var(--card-muted-fg-color)"
  }, children: t("doc-title.fallback.text") }), $[5] = t, $[6] = title, $[7] = t0) : t0 = $[7];
  let t1;
  return $[8] !== t0 ? (t1 = /* @__PURE__ */ jsx(Fragment, { children: t0 }), $[8] = t0, $[9] = t1) : t1 = $[9], t1;
}
const ChevronWrapper = styled(Box).withConfig({
  displayName: "ChevronWrapper",
  componentId: "sc-1ldyu0k-0"
})`margin-left:auto;`, CrossDatasetReferencesDetails = styled.details.withConfig({
  displayName: "CrossDatasetReferencesDetails",
  componentId: "sc-1ldyu0k-1"
})`flex:none;&[open] ${ChevronWrapper}{transform:rotate(180deg);}`, CrossDatasetReferencesSummary = styled.summary.withConfig({
  displayName: "CrossDatasetReferencesSummary",
  componentId: "sc-1ldyu0k-2"
})`list-style:none;&::-webkit-details-marker{display:none;}`, Table = styled.table.withConfig({
  displayName: "Table",
  componentId: "sc-1ldyu0k-3"
})`width:100%;text-align:left;padding:0 ${({
  theme
}) => rem(theme.sanity.space[2])};border-collapse:collapse;th{padding:${({
  theme
}) => rem(theme.sanity.space[1])};}td{padding:0 ${({
  theme
}) => rem(theme.sanity.space[1])};}tr > *:last-child{text-align:right;}`, DocumentIdFlex = styled(Flex).withConfig({
  displayName: "DocumentIdFlex",
  componentId: "sc-1ldyu0k-4"
})`min-height:33px;`, OtherReferenceCount = (props) => {
  const $ = c(13), {
    t
  } = useTranslation(structureLocaleNamespace), difference = props.totalCount - props.references.length;
  if (!difference)
    return null;
  let t0;
  $[0] !== difference || $[1] !== t ? (t0 = t("confirm-delete-dialog.other-reference-count.title", {
    count: difference
  }), $[0] = difference, $[1] = t, $[2] = t0) : t0 = $[2];
  let t1;
  $[3] !== t0 ? (t1 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: t0 }), $[3] = t0, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t ? (t2 = t("confirm-delete-dialog.other-reference-count.tooltip"), $[5] = t, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(InfoOutlineIcon, {}) }), $[7] = t3) : t3 = $[7];
  let t4;
  $[8] !== t2 ? (t4 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "top", content: t2, children: t3 }), $[8] = t2, $[9] = t4) : t4 = $[9];
  let t5;
  return $[10] !== t1 || $[11] !== t4 ? (t5 = /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsxs(Inline, { space: 2, children: [
    t1,
    t4
  ] }) }), $[10] = t1, $[11] = t4, $[12] = t5) : t5 = $[12], t5;
};
function PaneItemPreview(props) {
  const $ = c(30), {
    icon,
    layout,
    presence,
    schemaType,
    sortOrder,
    value
  } = props, versionsInfo = useDocumentVersionInfo(value._id), {
    perspectiveStack
  } = usePerspective();
  let t0;
  bb0: {
    if (!sortOrder) {
      t0 = void 0;
      break bb0;
    }
    let t12;
    $[0] !== sortOrder.by ? (t12 = {
      ordering: {
        title: "",
        name: "",
        by: sortOrder.by
      }
    }, $[0] = sortOrder.by, $[1] = t12) : t12 = $[1], t0 = t12;
  }
  const viewOptions = t0;
  let t1;
  $[2] !== perspectiveStack || $[3] !== props.documentPreviewStore || $[4] !== schemaType || $[5] !== value._id || $[6] !== viewOptions ? (t1 = getPreviewStateObservable(props.documentPreviewStore, schemaType, value._id, perspectiveStack, viewOptions), $[2] = perspectiveStack, $[3] = props.documentPreviewStore, $[4] = schemaType, $[5] = value._id, $[6] = viewOptions, $[7] = t1) : t1 = $[7];
  const previewStateObservable = t1;
  let t2;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = {
    snapshot: null,
    isLoading: !0,
    original: null
  }, $[8] = t2) : t2 = $[8];
  const {
    snapshot,
    original,
    isLoading: previewIsLoading
  } = useObservable(previewStateObservable, t2), isLoading = previewIsLoading;
  let t3;
  $[9] !== isLoading || $[10] !== presence || $[11] !== versionsInfo.draft || $[12] !== versionsInfo.published || $[13] !== versionsInfo.versions ? (t3 = isLoading ? null : /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, children: [
    presence && presence.length > 0 && /* @__PURE__ */ jsx(DocumentPreviewPresence, { presence }),
    /* @__PURE__ */ jsx(DocumentStatusIndicator, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions })
  ] }) }), $[9] = isLoading, $[10] = presence, $[11] = versionsInfo.draft, $[12] = versionsInfo.published, $[13] = versionsInfo.versions, $[14] = t3) : t3 = $[14];
  const status = t3;
  let t4;
  $[15] !== versionsInfo.draft || $[16] !== versionsInfo.published || $[17] !== versionsInfo.versions ? (t4 = /* @__PURE__ */ jsx(DocumentStatus, { draft: versionsInfo.draft, published: versionsInfo.published, versions: versionsInfo.versions }), $[15] = versionsInfo.draft, $[16] = versionsInfo.published, $[17] = versionsInfo.versions, $[18] = t4) : t4 = $[18];
  const tooltip = t4;
  let t5;
  $[19] !== original || $[20] !== snapshot || $[21] !== value ? (t5 = getPreviewValueWithFallback({
    snapshot,
    original,
    fallback: value
  }), $[19] = original, $[20] = snapshot, $[21] = value, $[22] = t5) : t5 = $[22];
  let t6;
  return $[23] !== icon || $[24] !== isLoading || $[25] !== layout || $[26] !== status || $[27] !== t5 || $[28] !== tooltip ? (t6 = /* @__PURE__ */ jsx(SanityDefaultPreview, { ...t5, isPlaceholder: isLoading, icon, layout, status, tooltip }), $[23] = icon, $[24] = isLoading, $[25] = layout, $[26] = status, $[27] = t5, $[28] = tooltip, $[29] = t6) : t6 = $[29], t6;
}
const EMPTY_ARRAY = [];
function ReferencePreviewLink(props) {
  const $ = c(16), {
    onClick,
    type,
    value
  } = props, t0 = value?._id;
  let t1;
  $[0] !== t0 ? (t1 = getPublishedId(t0), $[0] = t0, $[1] = t1) : t1 = $[1];
  const documentPresence = useDocumentPresence(t1), documentPreviewStore = useDocumentPreviewStore(), {
    ReferenceChildLink: ReferenceChildLink2
  } = usePaneRouter();
  let t2;
  $[2] !== ReferenceChildLink2 || $[3] !== type?.name || $[4] !== value?._id ? (t2 = function(linkProps) {
    return /* @__PURE__ */ jsx(ReferenceChildLink2, { documentId: value?._id, documentType: type?.name, parentRefPath: EMPTY_ARRAY, ...linkProps });
  }, $[2] = ReferenceChildLink2, $[3] = type?.name, $[4] = value?._id, $[5] = t2) : t2 = $[5];
  const t3 = t2, t4 = type?.icon, t5 = documentPresence?.length > 0 ? documentPresence : EMPTY_ARRAY;
  let t6;
  $[6] !== documentPreviewStore || $[7] !== t4 || $[8] !== t5 || $[9] !== type || $[10] !== value ? (t6 = /* @__PURE__ */ jsx(PaneItemPreview, { documentPreviewStore, icon: t4, layout: "compact", presence: t5, schemaType: type, value }), $[6] = documentPreviewStore, $[7] = t4, $[8] = t5, $[9] = type, $[10] = value, $[11] = t6) : t6 = $[11];
  let t7;
  return $[12] !== onClick || $[13] !== t3 || $[14] !== t6 ? (t7 = /* @__PURE__ */ jsx(PreviewCard, { __unstable_focusRing: !0, as: t3, "data-as": "a", onClick, radius: 2, children: t6 }), $[12] = onClick, $[13] = t3, $[14] = t6, $[15] = t7) : t7 = $[15], t7;
}
const EllipsisText = styled(Text).withConfig({
  displayName: "EllipsisText",
  componentId: "sc-1meclkc-0"
})`max-width:120px;`, VersionItemPreview = (t0) => {
  const $ = c(43), {
    versionId,
    schemaType
  } = t0, {
    t
  } = useTranslation(), documentPreviewStore = useDocumentPreviewStore();
  let t1;
  $[0] !== versionId ? (t1 = getDocumentVariantType(versionId), $[0] = versionId, $[1] = t1) : t1 = $[1];
  const documentVariant = t1, {
    data: releases
  } = useActiveReleases();
  let t2;
  if ($[2] !== documentPreviewStore || $[3] !== documentVariant || $[4] !== schemaType || $[5] !== versionId) {
    const perspectiveStack = [documentVariant === "version" ? getVersionFromId(versionId) : documentVariant === "published" ? "published" : "drafts"];
    t2 = getPreviewStateObservable(documentPreviewStore, schemaType, getPublishedId(versionId), perspectiveStack), $[2] = documentPreviewStore, $[3] = documentVariant, $[4] = schemaType, $[5] = versionId, $[6] = t2;
  } else
    t2 = $[6];
  const previewStateObservable = t2;
  let t3;
  $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    snapshot: null,
    isLoading: !0,
    original: null
  }, $[7] = t3) : t3 = $[7];
  const {
    snapshot,
    original,
    isLoading: previewIsLoading
  } = useObservable(previewStateObservable, t3);
  let t4;
  bb0: {
    if (documentVariant !== "version") {
      t4 = void 0;
      break bb0;
    }
    let t52;
    if ($[8] !== releases || $[9] !== versionId) {
      let t62;
      $[11] !== versionId ? (t62 = (r) => getReleaseIdFromReleaseDocumentId(r._id) === getVersionFromId(versionId), $[11] = versionId, $[12] = t62) : t62 = $[12], t52 = releases.find(t62), $[8] = releases, $[9] = versionId, $[10] = t52;
    } else
      t52 = $[10];
    t4 = t52;
  }
  const release = t4;
  let t5;
  bb1: {
    if (documentVariant === "version") {
      t5 = void 0;
      break bb1;
    }
    let t62;
    $[13] !== documentVariant || $[14] !== t ? (t62 = t(documentVariant === "published" ? "release.chip.published" : "release.chip.draft"), $[13] = documentVariant, $[14] = t, $[15] = t62) : t62 = $[15], t5 = t62;
  }
  const systemTitle = t5;
  let t6;
  $[16] !== documentVariant || $[17] !== release ? (t6 = release ? getReleaseTone(release) : documentVariant === "published" ? "positive" : "caution", $[16] = documentVariant, $[17] = release, $[18] = t6) : t6 = $[18];
  const tone = t6;
  let t7;
  $[19] !== original || $[20] !== schemaType.name || $[21] !== snapshot || $[22] !== versionId ? (t7 = getPreviewValueWithFallback({
    snapshot,
    original,
    fallback: {
      _id: versionId,
      _type: schemaType.name
    }
  }), $[19] = original, $[20] = schemaType.name, $[21] = snapshot, $[22] = versionId, $[23] = t7) : t7 = $[23];
  let t8;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = {
    backgroundColor: "transparent"
  }, $[24] = t8) : t8 = $[24];
  const t9 = documentVariant === "version" && release ? release : documentVariant;
  let t10;
  $[25] !== t9 ? (t10 = /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(ReleaseAvatarIcon, { release: t9 }) }), $[25] = t9, $[26] = t10) : t10 = $[26];
  let t11;
  $[27] !== documentVariant || $[28] !== release?.metadata?.title || $[29] !== systemTitle || $[30] !== versionId ? (t11 = documentVariant === "version" ? /* @__PURE__ */ jsx(ReleaseTitle, { title: release?.metadata?.title, fallback: getVersionFromId(versionId), children: _temp$g }) : /* @__PURE__ */ jsx(EllipsisText, { size: 1, weight: "medium", textOverflow: "ellipsis", children: systemTitle }), $[27] = documentVariant, $[28] = release?.metadata?.title, $[29] = systemTitle, $[30] = versionId, $[31] = t11) : t11 = $[31];
  let t12;
  $[32] !== t10 || $[33] !== t11 ? (t12 = /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 2, paddingY: 2, paddingRight: 3, paddingLeft: 2, children: [
    t10,
    t11
  ] }), $[32] = t10, $[33] = t11, $[34] = t12) : t12 = $[34];
  let t13;
  $[35] !== t12 || $[36] !== tone ? (t13 = /* @__PURE__ */ jsx(Card, { border: !0, radius: "full", children: /* @__PURE__ */ jsx(Card, { radius: "full", tone, style: t8, children: t12 }) }), $[35] = t12, $[36] = tone, $[37] = t13) : t13 = $[37];
  let t14;
  return $[38] !== previewIsLoading || $[39] !== schemaType.icon || $[40] !== t13 || $[41] !== t7 ? (t14 = /* @__PURE__ */ jsx(SanityDefaultPreview, { ...t7, isPlaceholder: previewIsLoading, icon: schemaType.icon, layout: "default", status: t13 }), $[38] = previewIsLoading, $[39] = schemaType.icon, $[40] = t13, $[41] = t7, $[42] = t14) : t14 = $[42], t14;
}, VersionsPreviewList = (t0) => {
  const $ = c(8), {
    documentType,
    documentVersions
  } = t0, schema = useSchema();
  let t1;
  $[0] !== documentType || $[1] !== schema ? (t1 = schema.get(documentType), $[0] = documentType, $[1] = schema, $[2] = t1) : t1 = $[2];
  const schemaType = t1;
  if (!schemaType)
    throw new Error(`Schema type ${documentType} not found`);
  let t2;
  $[3] !== documentVersions || $[4] !== schemaType ? (t2 = documentVersions?.map((version) => /* @__PURE__ */ jsx(VersionItemPreview, { versionId: version, schemaType }, version)), $[3] = documentVersions, $[4] = schemaType, $[5] = t2) : t2 = $[5];
  let t3;
  return $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(Card, { border: !0, padding: 1, radius: 2, children: /* @__PURE__ */ jsx(Stack, { children: t2 }) }), $[6] = t2, $[7] = t3) : t3 = $[7], t3;
};
function _temp$g(t0) {
  const {
    displayTitle
  } = t0;
  return /* @__PURE__ */ jsx(EllipsisText, { size: 1, weight: "medium", textOverflow: "ellipsis", children: displayTitle });
}
function ConfirmDeleteDialogBody(t0) {
  const $ = c(66), {
    crossDatasetReferences,
    internalReferences,
    documentTitle,
    totalCount,
    action,
    datasetNames,
    hasUnknownDatasetNames,
    documentId,
    documentType,
    onReferenceLinkClick,
    documentVersions
  } = t0, schema = useSchema(), toast = useToast(), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== onReferenceLinkClick || $[1] !== schema || $[2] !== t ? (t1 = (item) => {
    const type = schema.get(item._type);
    return type ? /* @__PURE__ */ jsx(ReferencePreviewLink, { type, value: item, onClick: onReferenceLinkClick }) : /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(SanityDefaultPreview, { icon: UnknownIcon, title: t("confirm-delete-dialog.preview-item.preview-unavailable.title"), subtitle: t("confirm-delete-dialog.preview-item.preview-unavailable.subtitle", {
      documentId: item._id
    }), layout: "default" }) });
  }, $[0] = onReferenceLinkClick, $[1] = schema, $[2] = t, $[3] = t1) : t1 = $[3];
  const renderPreviewItem = t1;
  let t2;
  $[4] !== action || $[5] !== documentTitle || $[6] !== documentType || $[7] !== documentVersions || $[8] !== t ? (t2 = () => /* @__PURE__ */ jsxs(Stack, { space: 4, children: [
    /* @__PURE__ */ jsx(Text, { as: "p", size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "confirm-delete-dialog.confirmation.text", context: action, components: {
      DocumentTitle: () => /* @__PURE__ */ jsx("strong", { children: documentTitle })
    } }) }),
    action === "delete" && /* @__PURE__ */ jsx(VersionsPreviewList, { documentType, documentVersions })
  ] }), $[4] = action, $[5] = documentTitle, $[6] = documentType, $[7] = documentVersions, $[8] = t, $[9] = t2) : t2 = $[9];
  const confirmationMessage = t2;
  if (internalReferences?.totalCount === 0 && crossDatasetReferences?.totalCount === 0) {
    let t32;
    return $[10] !== confirmationMessage ? (t32 = confirmationMessage(), $[10] = confirmationMessage, $[11] = t32) : t32 = $[11], t32;
  }
  let t3;
  $[12] !== hasUnknownDatasetNames ? (t3 = hasUnknownDatasetNames ? ["unavailable"] : [], $[12] = hasUnknownDatasetNames, $[13] = t3) : t3 = $[13];
  let t4;
  $[14] !== datasetNames || $[15] !== t3 ? (t4 = [...datasetNames, ...t3], $[14] = datasetNames, $[15] = t3, $[16] = t4) : t4 = $[16];
  const normalizedDatasetNames = t4, t5 = normalizedDatasetNames.length, t6 = normalizedDatasetNames.join(", "), t7 = hasUnknownDatasetNames && normalizedDatasetNames.length ? "unavailable" : "";
  let t8;
  $[17] !== normalizedDatasetNames.length || $[18] !== t || $[19] !== t6 || $[20] !== t7 ? (t8 = t("confirm-delete-dialog.cdr-summary.subtitle", {
    count: t5,
    datasets: t6,
    context: t7
  }), $[17] = normalizedDatasetNames.length, $[18] = t, $[19] = t6, $[20] = t7, $[21] = t8) : t8 = $[21];
  const datasetSubtitle = t8;
  let t9;
  $[22] !== confirmationMessage ? (t9 = confirmationMessage(), $[22] = confirmationMessage, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t10 = /* @__PURE__ */ jsx(Card, { borderTop: !0, padding: 1 }), $[24] = t10) : t10 = $[24];
  let t11;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = /* @__PURE__ */ jsx(Text, { "aria-hidden": "true", size: 1, children: /* @__PURE__ */ jsx(WarningOutlineIcon, {}) }), $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== documentTitle ? (t12 = {
    DocumentTitle: () => documentTitle
  }, $[26] = documentTitle, $[27] = t12) : t12 = $[27];
  let t13;
  $[28] !== totalCount ? (t13 = {
    count: totalCount
  }, $[28] = totalCount, $[29] = t13) : t13 = $[29];
  let t14;
  $[30] !== t || $[31] !== t12 || $[32] !== t13 ? (t14 = /* @__PURE__ */ jsxs("div", { children: [
    t10,
    /* @__PURE__ */ jsx(Card, { padding: 3, radius: 2, tone: "caution", flex: "none", children: /* @__PURE__ */ jsxs(Flex, { children: [
      t11,
      /* @__PURE__ */ jsx(Box, { flex: 1, marginLeft: 3, children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "confirm-delete-dialog.referring-document-count.text", components: t12, t, values: t13 }) }) })
    ] }) })
  ] }), $[30] = t, $[31] = t12, $[32] = t13, $[33] = t14) : t14 = $[33];
  let t15;
  $[34] !== documentTitle ? (t15 = {
    DocumentTitle: () => documentTitle
  }, $[34] = documentTitle, $[35] = t15) : t15 = $[35];
  let t16;
  $[36] !== action || $[37] !== t || $[38] !== t15 ? (t16 = /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "confirm-delete-dialog.referring-documents-descriptor.text", t, context: action, components: t15 }) }) }), $[36] = action, $[37] = t, $[38] = t15, $[39] = t16) : t16 = $[39];
  let t17;
  $[40] !== internalReferences || $[41] !== renderPreviewItem ? (t17 = internalReferences.totalCount > 0 && /* @__PURE__ */ jsxs(Stack, { as: "ul", space: 2, "data-testid": "internal-references", children: [
    internalReferences?.references.map((item_0) => /* @__PURE__ */ jsx(Box, { as: "li", children: renderPreviewItem(item_0) }, item_0._id)),
    internalReferences.totalCount > internalReferences.references.length && /* @__PURE__ */ jsx(Box, { as: "li", padding: 3, children: /* @__PURE__ */ jsx(OtherReferenceCount, { ...internalReferences }) })
  ] }), $[40] = internalReferences, $[41] = renderPreviewItem, $[42] = t17) : t17 = $[42];
  let t18;
  $[43] !== crossDatasetReferences || $[44] !== datasetSubtitle || $[45] !== documentId || $[46] !== internalReferences.totalCount || $[47] !== normalizedDatasetNames.length || $[48] !== t || $[49] !== toast ? (t18 = crossDatasetReferences.totalCount > 0 && /* @__PURE__ */ jsxs(CrossDatasetReferencesDetails, { "data-testid": "cross-dataset-references", style: {
    borderTop: internalReferences.totalCount > 0 ? "1px solid var(--card-shadow-outline-color)" : void 0
  }, children: [
    /* @__PURE__ */ jsx(CrossDatasetReferencesSummary, { children: /* @__PURE__ */ jsx(Card, { as: "a", marginTop: internalReferences.totalCount > 0 ? 2 : 0, radius: 2, shadow: 1, paddingY: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 3, paddingX: 3, paddingY: 1, children: [
      /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(DocumentsIcon, {}) }),
      /* @__PURE__ */ jsxs(Stack, { space: 2, children: [
        /* @__PURE__ */ jsx(Text, { textOverflow: "ellipsis", size: 1, children: t("confirm-delete-dialog.cdr-summary.title", {
          count: normalizedDatasetNames.length,
          documentCount: t("confirm-delete-dialog.cdr-summary.document-count", {
            count: crossDatasetReferences.totalCount
          })
        }) }),
        /* @__PURE__ */ jsx(Text, { title: datasetSubtitle, textOverflow: "ellipsis", size: 1, muted: !0, children: datasetSubtitle })
      ] }),
      /* @__PURE__ */ jsx(ChevronWrapper, { children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ChevronDownIcon, {}) }) })
    ] }) }) }),
    /* @__PURE__ */ jsxs(Box, { overflow: "auto", paddingTop: 2, children: [
      /* @__PURE__ */ jsxs(Table, { children: [
        /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
          /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, style: {
            minWidth: "5rem"
          }, weight: "medium", children: t("confirm-delete-dialog.cdr-table.project-id.label") }) }),
          /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, weight: "medium", children: t("confirm-delete-dialog.cdr-table.dataset.label") }) }),
          /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, weight: "medium", children: t("confirm-delete-dialog.cdr-table.document-id.label") }) })
        ] }) }),
        /* @__PURE__ */ jsx("tbody", { children: crossDatasetReferences.references.filter(_temp$f).map((t192, index) => {
          const {
            projectId,
            datasetName,
            documentId: referenceId
          } = t192;
          return /* @__PURE__ */ jsxs("tr", { children: [
            /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx(Text, { size: 1, children: projectId }) }),
            /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx(Text, { size: 1, children: datasetName || "unavailable" }) }),
            /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsxs(DocumentIdFlex, { align: "center", gap: 2, justify: "flex-end", children: [
              /* @__PURE__ */ jsx(Text, { textOverflow: "ellipsis", size: 1, children: referenceId || "unavailable" }),
              referenceId && /* @__PURE__ */ jsx(Button$1, { mode: "bleed", icon: CopyIcon, tooltipProps: {
                content: t("confirm-delete-dialog.cdr-table.copy-id-button.tooltip")
              }, onClick: () => {
                navigator.clipboard.writeText(referenceId).catch(() => {
                  toast.push({
                    status: "error",
                    title: t("confirm-delete-dialog.cdr-table.id-copied-toast.title-failed")
                  });
                });
              } })
            ] }) })
          ] }, `${documentId}-${index}`);
        }) })
      ] }),
      /* @__PURE__ */ jsx(OtherReferenceCount, { ...crossDatasetReferences })
    ] })
  ] }), $[43] = crossDatasetReferences, $[44] = datasetSubtitle, $[45] = documentId, $[46] = internalReferences.totalCount, $[47] = normalizedDatasetNames.length, $[48] = t, $[49] = toast, $[50] = t18) : t18 = $[50];
  let t19;
  $[51] !== t17 || $[52] !== t18 ? (t19 = /* @__PURE__ */ jsx(Card, { radius: 2, shadow: 1, flex: "auto", padding: 1, children: /* @__PURE__ */ jsxs(Flex, { direction: "column", children: [
    t17,
    t18
  ] }) }), $[51] = t17, $[52] = t18, $[53] = t19) : t19 = $[53];
  let t20;
  $[54] !== documentTitle ? (t20 = {
    DocumentTitle: () => documentTitle
  }, $[54] = documentTitle, $[55] = t20) : t20 = $[55];
  let t21;
  $[56] !== action || $[57] !== t || $[58] !== t20 ? (t21 = /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "confirm-delete-dialog.referential-integrity-disclaimer.text", t, context: action, components: t20 }) }) }), $[56] = action, $[57] = t, $[58] = t20, $[59] = t21) : t21 = $[59];
  let t22;
  return $[60] !== t14 || $[61] !== t16 || $[62] !== t19 || $[63] !== t21 || $[64] !== t9 ? (t22 = /* @__PURE__ */ jsxs(Flex, { direction: "column", gap: 4, children: [
    t9,
    t14,
    t16,
    t19,
    t21
  ] }), $[60] = t14, $[61] = t16, $[62] = t19, $[63] = t21, $[64] = t9, $[65] = t22) : t22 = $[65], t22;
}
function _temp$f(reference) {
  return "projectId" in reference;
}
function isClientError(e) {
  return typeof e != "object" || !e ? !1 : "statusCode" in e && "response" in e;
}
const POLL_INTERVAL = 5e3;
let visiblePoll$;
const getVisiblePoll$ = () => (visiblePoll$ || (visiblePoll$ = fromEvent(document, "visibilitychange").pipe(
  // add empty emission to have this fire on creation
  startWith$1(null),
  map$1(() => document.visibilityState === "visible"),
  distinctUntilChanged$1(),
  switchMap((visible) => visible ? (
    // using timer instead of interval since timer will emit on creation
    timer(0, POLL_INTERVAL)
  ) : EMPTY),
  shareReplay({
    refCount: !0,
    bufferSize: 1
  })
)), visiblePoll$);
function getDocumentExistence(documentId, {
  versionedClient
}) {
  const draftId = getDraftId(documentId), publishedId = getPublishedId(documentId), requestOptions = {
    uri: versionedClient.getDataUrl("doc", `${draftId},${publishedId}`),
    json: !0,
    query: {
      excludeContent: "true"
    },
    tag: "use-referring-documents.document-existence"
  };
  return versionedClient.observable.request(requestOptions).pipe(map$1(({
    omitted
  }) => {
    const nonExistant = omitted.filter((doc) => doc.reason === "existence");
    if (nonExistant.length !== 2)
      return nonExistant.length === 0 || nonExistant.some((doc) => doc.id === draftId) ? publishedId : draftId;
  }));
}
function fetchCrossDatasetReferences(documentId, context) {
  const {
    versionedClient
  } = context;
  return getVisiblePoll$().pipe(switchMap(() => getDocumentExistence(documentId, context)), switchMap((checkDocumentId) => {
    if (!checkDocumentId)
      return of({
        totalCount: 0,
        references: []
      });
    const currentDataset = versionedClient.config().dataset;
    return versionedClient.observable.request({
      url: `/data/references/${currentDataset}/documents/${checkDocumentId}/to?excludeInternalReferences=true&excludePaths=true`,
      tag: "use-referring-documents.external"
    }).pipe(catchError$1((e) => {
      if (isClientError(e) && e.statusCode === 404)
        return of({
          totalCount: 0,
          references: []
        });
      throw e;
    }));
  }));
}
const useInternalReferences = createHookFromObservableFactory(([documentId, documentStore]) => documentStore.listenQuery({
  fetch: '{"references":*[references($documentId)][0...100]{_id,_type},"totalCount":count(*[references($documentId)])}',
  listen: "*[references($documentId)]"
}, {
  documentId
}, {
  tag: "use-referring-documents",
  transitions: ["appear", "disappear"],
  throttleTime: 5e3
})), useCrossDatasetReferences = createHookFromObservableFactory(([documentId, versionedClient]) => getVisiblePoll$().pipe(switchMap(() => fetchCrossDatasetReferences(documentId, {
  versionedClient
}))));
function useReferringDocuments(documentId) {
  const $ = c(24), versionedClient = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), documentStore = useDocumentStore();
  let t0;
  $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1];
  const publishedId = t0;
  let t1;
  $[2] !== documentStore || $[3] !== publishedId ? (t1 = [publishedId, documentStore], $[2] = documentStore, $[3] = publishedId, $[4] = t1) : t1 = $[4];
  const [internalReferences, isInternalReferencesLoading] = useInternalReferences(t1);
  let t2;
  $[5] !== publishedId || $[6] !== versionedClient ? (t2 = [publishedId, versionedClient], $[5] = publishedId, $[6] = versionedClient, $[7] = t2) : t2 = $[7];
  const [crossDatasetReferences, isCrossDatasetReferencesLoading] = useCrossDatasetReferences(t2);
  let t3;
  $[8] !== crossDatasetReferences?.references ? (t3 = () => Array.from(new Set(crossDatasetReferences?.references.map(_temp$e).filter(Boolean))).sort(), $[8] = crossDatasetReferences?.references, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t3 ? (t4 = t3(), $[10] = t3, $[11] = t4) : t4 = $[11];
  const projectIds = t4;
  let t5;
  $[12] !== crossDatasetReferences?.references ? (t5 = Array.from(new Set(crossDatasetReferences?.references.map(_temp2$8).filter(_temp3$5))).sort(), $[12] = crossDatasetReferences?.references, $[13] = t5) : t5 = $[13];
  const datasetNames = t5;
  let t6;
  $[14] !== crossDatasetReferences?.references ? (t6 = () => !!crossDatasetReferences?.references.some(_temp4$5), $[14] = crossDatasetReferences?.references, $[15] = t6) : t6 = $[15];
  const hasUnknownDatasetNames = t6(), t7 = (internalReferences?.totalCount || 0) + (crossDatasetReferences?.totalCount || 0), t8 = isInternalReferencesLoading || isCrossDatasetReferencesLoading;
  let t9;
  return $[16] !== crossDatasetReferences || $[17] !== datasetNames || $[18] !== hasUnknownDatasetNames || $[19] !== internalReferences || $[20] !== projectIds || $[21] !== t7 || $[22] !== t8 ? (t9 = {
    totalCount: t7,
    projectIds,
    datasetNames,
    hasUnknownDatasetNames,
    internalReferences,
    crossDatasetReferences,
    isLoading: t8
  }, $[16] = crossDatasetReferences, $[17] = datasetNames, $[18] = hasUnknownDatasetNames, $[19] = internalReferences, $[20] = projectIds, $[21] = t7, $[22] = t8, $[23] = t9) : t9 = $[23], t9;
}
function _temp4$5(crossDatasetReference_1) {
  return typeof crossDatasetReference_1.datasetName != "string";
}
function _temp3$5(datasetName) {
  return !!datasetName && datasetName !== "";
}
function _temp2$8(crossDatasetReference_0) {
  return crossDatasetReference_0?.datasetName || "";
}
function _temp$e(crossDatasetReference) {
  return crossDatasetReference.projectId;
}
const DialogBody = styled(Box).withConfig({
  displayName: "DialogBody",
  componentId: "sc-jawiy-0"
})`box-sizing:border-box;`, LoadingContainer = styled(Flex).attrs({
  align: "center",
  direction: "column",
  justify: "center"
}).withConfig({
  displayName: "LoadingContainer",
  componentId: "sc-jawiy-1"
})`height:110px;`;
function ConfirmDeleteDialog(t0) {
  const $ = c(51), {
    id,
    type,
    action: t1,
    onCancel,
    onConfirm
  } = t0, action = t1 === void 0 ? "delete" : t1, {
    t
  } = useTranslation(structureLocaleNamespace), dialogId = `deletion-confirmation-${useId()}`, {
    internalReferences,
    crossDatasetReferences,
    isLoading,
    totalCount,
    projectIds,
    datasetNames,
    hasUnknownDatasetNames
  } = useReferringDocuments(id);
  let t2;
  $[0] !== id || $[1] !== type ? (t2 = {
    _id: id,
    _type: type
  }, $[0] = id, $[1] = type, $[2] = t2) : t2 = $[2];
  const t3 = t2;
  let t4;
  $[3] !== t3 ? (t4 = /* @__PURE__ */ jsx(DocTitle, { document: t3 }), $[3] = t3, $[4] = t4) : t4 = $[4];
  const documentTitle = t4, showConfirmButton = !isLoading;
  let t5;
  $[5] !== id ? (t5 = getPublishedId(id), $[5] = id, $[6] = t5) : t5 = $[6];
  let t6;
  $[7] !== t5 ? (t6 = {
    documentId: t5
  }, $[7] = t5, $[8] = t6) : t6 = $[8];
  const {
    data: documentVersions,
    loading: versionsLoading
  } = useDocumentVersions(t6);
  let t7;
  $[9] !== documentVersions || $[10] !== onConfirm ? (t7 = () => {
    onConfirm(documentVersions);
  }, $[9] = documentVersions, $[10] = onConfirm, $[11] = t7) : t7 = $[11];
  const handleConfirm = t7;
  let t8;
  $[12] !== action || $[13] !== t ? (t8 = t("confirm-delete-dialog.header.text", {
    context: action
  }), $[12] = action, $[13] = t, $[14] = t8) : t8 = $[14];
  let t9;
  $[15] !== t ? (t9 = t("confirm-delete-dialog.cancel-button.text"), $[15] = t, $[16] = t9) : t9 = $[16];
  let t10;
  $[17] !== onCancel || $[18] !== t9 ? (t10 = {
    onClick: onCancel,
    text: t9
  }, $[17] = onCancel, $[18] = t9, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== action || $[21] !== handleConfirm || $[22] !== showConfirmButton || $[23] !== t || $[24] !== totalCount ? (t11 = showConfirmButton ? {
    text: totalCount > 0 ? t("confirm-delete-dialog.confirm-anyway-button.text", {
      context: action
    }) : t("confirm-delete-dialog.confirm-button.text", {
      context: action
    }),
    onClick: handleConfirm
  } : void 0, $[20] = action, $[21] = handleConfirm, $[22] = showConfirmButton, $[23] = t, $[24] = totalCount, $[25] = t11) : t11 = $[25];
  let t12;
  $[26] !== t10 || $[27] !== t11 ? (t12 = {
    cancelButton: t10,
    confirmButton: t11
  }, $[26] = t10, $[27] = t11, $[28] = t12) : t12 = $[28];
  let t13;
  $[29] !== action || $[30] !== crossDatasetReferences || $[31] !== datasetNames || $[32] !== documentTitle || $[33] !== documentVersions || $[34] !== hasUnknownDatasetNames || $[35] !== id || $[36] !== internalReferences || $[37] !== isLoading || $[38] !== onCancel || $[39] !== projectIds || $[40] !== t || $[41] !== totalCount || $[42] !== type || $[43] !== versionsLoading ? (t13 = /* @__PURE__ */ jsx(DialogBody, { children: crossDatasetReferences && internalReferences && !isLoading && !versionsLoading ? /* @__PURE__ */ jsx(ConfirmDeleteDialogBody, { crossDatasetReferences, internalReferences, documentTitle, isLoading, totalCount, action, projectIds, datasetNames, hasUnknownDatasetNames, onReferenceLinkClick: onCancel, documentId: id, documentType: type, documentVersions }) : /* @__PURE__ */ jsx(LoadingContainer, { "data-testid": "loading-container", children: /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: t("confirm-delete-dialog.loading.text") }) }) }), $[29] = action, $[30] = crossDatasetReferences, $[31] = datasetNames, $[32] = documentTitle, $[33] = documentVersions, $[34] = hasUnknownDatasetNames, $[35] = id, $[36] = internalReferences, $[37] = isLoading, $[38] = onCancel, $[39] = projectIds, $[40] = t, $[41] = totalCount, $[42] = type, $[43] = versionsLoading, $[44] = t13) : t13 = $[44];
  let t14;
  return $[45] !== dialogId || $[46] !== onCancel || $[47] !== t12 || $[48] !== t13 || $[49] !== t8 ? (t14 = /* @__PURE__ */ jsx(Dialog, { width: 1, id: dialogId, header: t8, footer: t12, onClose: onCancel, onClickOutside: onCancel, children: t13 }), $[45] = dialogId, $[46] = onCancel, $[47] = t12, $[48] = t13, $[49] = t8, $[50] = t14) : t14 = $[50], t14;
}
function ConfirmDeleteDialogContainer(props) {
  const $ = c(6), {
    t
  } = useTranslation(structureLocaleNamespace), id = useId(), [error, setError] = useState(null);
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = () => setError(null), $[0] = t0) : t0 = $[0];
  const handleRetry = t0;
  let t1;
  return $[1] !== error || $[2] !== id || $[3] !== props || $[4] !== t ? (t1 = error ? /* @__PURE__ */ jsx(Dialog, { id: `dialog-error-${id}`, "data-testid": "confirm-delete-error-dialog", header: t("confirm-delete-dialog.error.title.text"), footer: {
    confirmButton: {
      text: t("confirm-delete-dialog.error.retry-button.text"),
      onClick: handleRetry,
      tone: "default"
    }
  }, onClose: props.onCancel, children: /* @__PURE__ */ jsx(Box, { padding: 4, children: /* @__PURE__ */ jsx(Text, { size: 1, children: t("confirm-delete-dialog.error.message.text") }) }) }) : /* @__PURE__ */ jsx(ErrorBoundary, { onCatch: setError, children: /* @__PURE__ */ jsx(ConfirmDeleteDialog, { ...props }) }), $[1] = error, $[2] = id, $[3] = props, $[4] = t, $[5] = t1) : t1 = $[5], t1;
}
const IntentButton = forwardRef(function(props, ref) {
  const $ = c(10);
  let intent, restProps;
  $[0] !== props ? ({
    intent,
    ...restProps
  } = props, $[0] = props, $[1] = intent, $[2] = restProps) : (intent = $[1], restProps = $[2]);
  let t0;
  $[3] !== intent ? (t0 = forwardRef(function(linkProps, linkRef) {
    return /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: intent.type, params: intent.params, ref: linkRef, searchParams: intent.searchParams });
  }), $[3] = intent, $[4] = t0) : t0 = $[4];
  const Link2 = t0;
  let t1;
  return $[5] !== Link2 || $[6] !== props.disabled || $[7] !== ref || $[8] !== restProps ? (t1 = props.disabled ? /* @__PURE__ */ jsx(Button$1, { ...restProps, as: "a", role: "link", "aria-disabled": "true" }) : /* @__PURE__ */ jsx(Button$1, { ...restProps, as: Link2, "data-as": "a", ref }), $[5] = Link2, $[6] = props.disabled, $[7] = ref, $[8] = restProps, $[9] = t1) : t1 = $[9], t1;
});
function InsufficientPermissionsMessageTooltip(t0) {
  const $ = c(12), {
    reveal,
    context,
    loading,
    children
  } = t0, currentUser = useCurrentUser(), {
    t
  } = useTranslation(structureLocaleNamespace);
  if (!reveal) {
    let t12;
    return $[0] !== children ? (t12 = /* @__PURE__ */ jsx(Fragment, { children }), $[0] = children, $[1] = t12) : t12 = $[1], t12;
  }
  let t1;
  $[2] !== context || $[3] !== currentUser || $[4] !== loading || $[5] !== t ? (t1 = loading ? t("insufficient-permissions-message-tooltip.loading-text") : /* @__PURE__ */ jsx(InsufficientPermissionsMessage, { context, currentUser }), $[2] = context, $[3] = currentUser, $[4] = loading, $[5] = t, $[6] = t1) : t1 = $[6];
  let t2;
  $[7] !== children ? (t2 = /* @__PURE__ */ jsx("div", { children }), $[7] = children, $[8] = t2) : t2 = $[8];
  let t3;
  return $[9] !== t1 || $[10] !== t2 ? (t3 = /* @__PURE__ */ jsx(Tooltip, { content: t1, portal: !0, children: t2 }), $[9] = t1, $[10] = t2, $[11] = t3) : t3 = $[11], t3;
}
const POPOVER_PROPS = {
  constrainSize: !0,
  placement: "bottom",
  portal: !0
}, getIntent = (templates, item, version) => {
  const typeName = templates.find((t) => t.id === item.templateId)?.schemaType;
  if (!typeName) return null;
  const baseParams = {
    template: item.templateId,
    type: typeName,
    version,
    id: item.initialDocumentId
  };
  return {
    type: "create",
    params: item.parameters ? [baseParams, item.parameters] : baseParams,
    searchParams: version ? [["perspective", version]] : void 0
  };
};
function PaneHeaderCreateButton(t0) {
  const $ = c(59), {
    templateItems
  } = t0, templates = useTemplates(), {
    selectedReleaseId
  } = usePerspective(), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== templateItems || $[1] !== templates ? (t1 = [...templateItems, ...templates], $[0] = templateItems, $[1] = templates, $[2] = t1) : t1 = $[2];
  const getI18nText = useGetI18nText(t1);
  let t2;
  $[3] !== templateItems ? (t2 = {
    templateItems
  }, $[3] = templateItems, $[4] = t2) : t2 = $[4];
  const [templatePermissions, isTemplatePermissionsLoading] = useTemplatePermissions(t2), nothingGranted = !isTemplatePermissionsLoading && templatePermissions?.length !== 0 && templatePermissions?.every(_temp$d);
  let t3;
  bb0: {
    if (!templatePermissions) {
      let t43;
      $[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t43 = {}, $[5] = t43) : t43 = $[5], t3 = t43;
      break bb0;
    }
    let t42;
    $[6] !== templatePermissions ? (t42 = templatePermissions.reduce(_temp2$7, {}), $[6] = templatePermissions, $[7] = t42) : t42 = $[7], t3 = t42;
  }
  const permissionsById = t3;
  if (templateItems.length === 0)
    return null;
  if (nothingGranted) {
    let t42;
    $[8] !== t ? (t42 = t("pane-header.disabled-created-button.aria-label"), $[8] = t, $[9] = t42) : t42 = $[9];
    let t52;
    $[10] !== t42 ? (t52 = /* @__PURE__ */ jsx(Button$1, { "aria-label": t42, icon: AddIcon, "data-testid": "action-intent-button", disabled: !0, mode: "bleed", tooltipProps: null }), $[10] = t42, $[11] = t52) : t52 = $[11];
    let t62;
    return $[12] !== isTemplatePermissionsLoading || $[13] !== t52 ? (t62 = /* @__PURE__ */ jsx(InsufficientPermissionsMessageTooltip, { context: "create-document-type", reveal: !0, loading: isTemplatePermissionsLoading, children: t52 }), $[12] = isTemplatePermissionsLoading, $[13] = t52, $[14] = t62) : t62 = $[14], t62;
  }
  if (templateItems.length === 1) {
    const firstItem = templateItems[0], disabled = !permissionsById[firstItem.id]?.granted;
    let t42;
    $[15] !== firstItem || $[16] !== selectedReleaseId || $[17] !== templates ? (t42 = getIntent(templates, firstItem, selectedReleaseId), $[15] = firstItem, $[16] = selectedReleaseId, $[17] = templates, $[18] = t42) : t42 = $[18];
    const intent = t42;
    if (!intent)
      return null;
    let t52;
    $[19] !== firstItem || $[20] !== getI18nText ? (t52 = getI18nText(firstItem), $[19] = firstItem, $[20] = getI18nText, $[21] = t52) : t52 = $[21];
    const t62 = t52.title;
    let t72;
    $[22] !== t ? (t72 = t("pane-header.create-new-button.tooltip"), $[22] = t, $[23] = t72) : t72 = $[23];
    let t82;
    $[24] !== t72 ? (t82 = {
      content: t72
    }, $[24] = t72, $[25] = t82) : t82 = $[25];
    let t9;
    $[26] !== disabled || $[27] !== intent || $[28] !== t52.title || $[29] !== t82 ? (t9 = /* @__PURE__ */ jsx(IntentButton, { "aria-label": t62, icon: AddIcon, intent, mode: "bleed", disabled, "data-testid": "action-intent-button", tooltipProps: t82 }), $[26] = disabled, $[27] = intent, $[28] = t52.title, $[29] = t82, $[30] = t9) : t9 = $[30];
    let t10;
    return $[31] !== disabled || $[32] !== isTemplatePermissionsLoading || $[33] !== t9 ? (t10 = /* @__PURE__ */ jsx(InsufficientPermissionsMessageTooltip, { reveal: disabled, loading: isTemplatePermissionsLoading, context: "create-document-type", children: t9 }), $[31] = disabled, $[32] = isTemplatePermissionsLoading, $[33] = t9, $[34] = t10) : t10 = $[34], t10;
  }
  let t4;
  $[35] !== t ? (t4 = t("pane-header.create-new-button.tooltip"), $[35] = t, $[36] = t4) : t4 = $[36];
  let t5;
  $[37] !== t4 ? (t5 = /* @__PURE__ */ jsx(Button$1, { icon: AddIcon, mode: "bleed", "data-testid": "multi-action-intent-button", tooltipProps: {
    content: t4
  } }), $[37] = t4, $[38] = t5) : t5 = $[38];
  let t6;
  if ($[39] !== getI18nText || $[40] !== isTemplatePermissionsLoading || $[41] !== permissionsById || $[42] !== selectedReleaseId || $[43] !== t || $[44] !== templateItems || $[45] !== templates) {
    let t72;
    $[47] !== getI18nText || $[48] !== isTemplatePermissionsLoading || $[49] !== permissionsById || $[50] !== selectedReleaseId || $[51] !== t || $[52] !== templates ? (t72 = (item, itemIndex) => {
      const disabled_0 = !permissionsById[item.id]?.granted, intent_0 = getIntent(templates, item, selectedReleaseId), template = templates.find((i) => i.id === item.templateId);
      if (!template || !intent_0)
        return null;
      const Link2 = forwardRef((linkProps, linkRef) => disabled_0 ? /* @__PURE__ */ jsx("button", { type: "button", disabled: !0, ...linkProps, ref: linkRef }) : /* @__PURE__ */ jsx(IntentLink, { ...linkProps, intent: intent_0.type, params: intent_0.params, searchParams: intent_0.searchParams, ref: linkRef }));
      Link2.displayName = "Link";
      const {
        title
      } = getI18nText({
        ...item,
        title: item.title || getI18nText(template).title
      });
      return /* @__PURE__ */ jsx(InsufficientPermissionsMessageTooltip, { context: "create-document-type", reveal: disabled_0, loading: isTemplatePermissionsLoading, children: /* @__PURE__ */ jsx(MenuItem$1, { as: Link2, "data-as": disabled_0 ? "button" : "a", icon: item.icon, text: title, "aria-label": disabled_0 ? t("pane-header.disabled-created-button.aria-label") : title, disabled: disabled_0, "data-testid": `action-intent-button-${itemIndex}` }) }, item.id);
    }, $[47] = getI18nText, $[48] = isTemplatePermissionsLoading, $[49] = permissionsById, $[50] = selectedReleaseId, $[51] = t, $[52] = templates, $[53] = t72) : t72 = $[53], t6 = templateItems.map(t72), $[39] = getI18nText, $[40] = isTemplatePermissionsLoading, $[41] = permissionsById, $[42] = selectedReleaseId, $[43] = t, $[44] = templateItems, $[45] = templates, $[46] = t6;
  } else
    t6 = $[46];
  let t7;
  $[54] !== t6 ? (t7 = /* @__PURE__ */ jsx(Menu, { children: t6 }), $[54] = t6, $[55] = t7) : t7 = $[55];
  let t8;
  return $[56] !== t5 || $[57] !== t7 ? (t8 = /* @__PURE__ */ jsx(MenuButton, { button: t5, id: "create-menu", menu: t7, popover: POPOVER_PROPS }), $[56] = t5, $[57] = t7, $[58] = t8) : t8 = $[58], t8;
}
function _temp2$7(acc, permission_0) {
  return acc[permission_0.id] = permission_0, acc;
}
function _temp$d(permission) {
  return !permission.granted;
}
function isNonNullable(value) {
  return value != null;
}
const hashObject = (value) => {
  const sortObject = (v) => typeof v != "object" || !v ? v : Array.isArray(v) ? v.map(sortObject) : Object.entries(v).sort(([keyA], [keyB]) => keyA.localeCompare(keyB, "en"));
  return JSON.stringify(sortObject(((v) => JSON.parse(JSON.stringify(v)))(value)));
}, PaneHeaderActions = memo(function(props) {
  const $ = c(28), {
    initialValueTemplateItems: t0,
    menuItems: t1,
    menuItemGroups: t2,
    actionHandlers: t3
  } = props, initialValueTemplateItemsFromStructure = t0 === void 0 ? EMPTY_ARRAY$2 : t0, menuItems = t1 === void 0 ? EMPTY_ARRAY$2 : t1, menuItemGroups = t2 === void 0 ? EMPTY_ARRAY$2 : t2, actionHandlers = t3 === void 0 ? EMPTY_OBJECT : t3, templates = useTemplates();
  let t4;
  $[0] !== actionHandlers ? (t4 = (item) => {
    if (item.id) {
      const toggleHandler = actionHandlers.setMenuItemState;
      if (toggleHandler && toggleHandler({
        _menuItemId: item.id,
        ...item.params
      }), !item.action || item.action === "setMenuItemState")
        return !!toggleHandler;
    }
    if (typeof item.action == "string" && !(item.action in actionHandlers))
      return console.warn("No handler for action:", item.action), !1;
    const handler = typeof item.action == "function" ? item.action : typeof item.action == "string" ? actionHandlers[item.action] : null;
    if (handler) {
      const paramsWithId = item.id ? {
        ...item.params,
        _menuItemId: item.id,
        isSelected: !item.selected
      } : {
        ...item.params,
        isSelected: !item.selected
      };
      return handler(paramsWithId), !0;
    }
    return !1;
  }, $[0] = actionHandlers, $[1] = t4) : t4 = $[1];
  const handleAction = t4;
  let t5;
  $[2] !== handleAction || $[3] !== menuItemGroups || $[4] !== menuItems ? (t5 = resolveMenuNodes({
    actionHandler: handleAction,
    menuItemGroups,
    menuItems: menuItems.filter(_temp$c)
  }), $[2] = handleAction, $[3] = menuItemGroups, $[4] = menuItems, $[5] = t5) : t5 = $[5];
  const menuNodes = t5;
  let t6;
  $[6] !== menuNodes ? (t6 = menuNodes.filter(isMenuNodeButton), $[6] = menuNodes, $[7] = t6) : t6 = $[7];
  const actionNodes = t6;
  let t7;
  $[8] !== menuNodes ? (t7 = menuNodes.filter(isNotMenuNodeButton), $[8] = menuNodes, $[9] = t7) : t7 = $[9];
  const contextMenuNodes = t7;
  let t8;
  if ($[10] !== menuItems || $[11] !== templates) {
    let t92;
    $[13] !== templates ? (t92 = (item_1, menuItemIndex) => {
      if (item_1.intent?.type !== "create")
        return null;
      const {
        params
      } = item_1.intent;
      if (!params)
        return null;
      const intentParams = Array.isArray(params) ? params[0] : params, templateParams = Array.isArray(params) ? params[1] : void 0, templateId = intentParams.template || intentParams.type;
      if (!templateId)
        return null;
      const template = templates.find((t) => t.id === templateId);
      if (!template)
        return null;
      const initialDocumentId = intentParams.id;
      return {
        item: item_1,
        template,
        templateParams,
        menuItemIndex,
        initialDocumentId
      };
    }, $[13] = templates, $[14] = t92) : t92 = $[14], t8 = menuItems.map(t92).filter(isNonNullable).map(_temp2$6), $[10] = menuItems, $[11] = templates, $[12] = t8;
  } else
    t8 = $[12];
  const initialValueTemplateItemFromMenuItems = t8;
  let t9;
  $[15] !== initialValueTemplateItemFromMenuItems || $[16] !== initialValueTemplateItemsFromStructure ? (t9 = uniqBy([...initialValueTemplateItemFromMenuItems, ...initialValueTemplateItemsFromStructure], _temp3$4), $[15] = initialValueTemplateItemFromMenuItems, $[16] = initialValueTemplateItemsFromStructure, $[17] = t9) : t9 = $[17];
  const combinedInitialValueTemplates = t9;
  let t10;
  $[18] !== combinedInitialValueTemplates ? (t10 = /* @__PURE__ */ jsx(PaneHeaderCreateButton, { templateItems: combinedInitialValueTemplates }), $[18] = combinedInitialValueTemplates, $[19] = t10) : t10 = $[19];
  let t11;
  $[20] !== actionNodes ? (t11 = actionNodes.map(_temp4$4), $[20] = actionNodes, $[21] = t11) : t11 = $[21];
  let t12;
  $[22] !== contextMenuNodes ? (t12 = contextMenuNodes.length > 0 && /* @__PURE__ */ jsx(PaneContextMenuButton, { nodes: contextMenuNodes }), $[22] = contextMenuNodes, $[23] = t12) : t12 = $[23];
  let t13;
  return $[24] !== t10 || $[25] !== t11 || $[26] !== t12 ? (t13 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t10,
    t11,
    t12
  ] }), $[24] = t10, $[25] = t11, $[26] = t12, $[27] = t13) : t13 = $[27], t13;
});
function _temp$c(item_0) {
  return item_0.intent?.type !== "create";
}
function _temp2$6(t0) {
  const {
    initialDocumentId: initialDocumentId_0,
    item: item_2,
    template: template_0,
    menuItemIndex: menuItemIndex_0,
    templateParams: templateParams_0
  } = t0;
  return {
    id: `menuItem${menuItemIndex_0}`,
    initialDocumentId: initialDocumentId_0,
    templateId: template_0.id,
    type: "initialValueTemplateItem",
    title: item_2.title || template_0.title,
    i18n: item_2.i18n || template_0.i18n,
    icon: item_2.icon,
    description: template_0.description,
    parameters: templateParams_0,
    schemaType: template_0.schemaType
  };
}
function _temp3$4(item_3) {
  return hashObject([item_3.initialDocumentId, item_3.templateId, item_3.parameters]);
}
function _temp4$4(node) {
  return /* @__PURE__ */ jsx(PaneHeaderActionButton, { node }, node.key);
}
function MissingSchemaType(props) {
  const $ = c(16), {
    t
  } = useTranslation(structureLocaleNamespace), {
    layout,
    value
  } = props;
  let t0;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    Code: "code"
  }, $[0] = t0) : t0 = $[0];
  let t1;
  $[1] !== value._type ? (t1 = {
    documentType: value._type
  }, $[1] = value._type, $[2] = t1) : t1 = $[2];
  let t2;
  $[3] !== t || $[4] !== t1 ? (t2 = /* @__PURE__ */ jsx("em", { children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "pane-item.missing-schema-type.title", components: t0, values: t1 }) }), $[3] = t, $[4] = t1, $[5] = t2) : t2 = $[5];
  let t3;
  $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    Code: "code"
  }, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== value._id ? (t4 = {
    documentId: value._id
  }, $[7] = value._id, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] !== t || $[10] !== t4 ? (t5 = /* @__PURE__ */ jsx(Translate, { t, i18nKey: "pane-item.missing-schema-type.subtitle", components: t3, values: t4 }), $[9] = t, $[10] = t4, $[11] = t5) : t5 = $[11];
  let t6;
  return $[12] !== layout || $[13] !== t2 || $[14] !== t5 ? (t6 = /* @__PURE__ */ jsx(SanityDefaultPreview, { title: t2, subtitle: t5, media: _temp$b, layout }), $[12] = layout, $[13] = t2, $[14] = t5, $[15] = t6) : t6 = $[15], t6;
}
function _temp$b() {
  return /* @__PURE__ */ jsx(WarningOutlineIcon, {});
}
function getIconWithFallback(icon, schemaType, defaultIcon) {
  return icon === !1 ? !1 : icon || schemaType && schemaType.icon || defaultIcon || !1;
}
function PaneItem(props) {
  const $ = c(43), {
    icon,
    id,
    layout: t0,
    pressed,
    schemaType,
    selected,
    sortOrder,
    title,
    value,
    margin,
    marginBottom,
    marginTop
  } = props, layout = t0 === void 0 ? "default" : t0, schema = useSchema(), documentPreviewStore = useDocumentPreviewStore(), {
    ChildLink: ChildLink2
  } = usePaneRouter(), documentPresence = useDocumentPresence(id), hasSchemaType = !!(schemaType && schemaType.name && schema.get(schemaType.name)), [clicked, setClicked] = useState(!1);
  let t1;
  bb0: {
    if (value && isSanityDocument$1(value)) {
      if (!schemaType || !hasSchemaType) {
        let t24;
        $[0] !== value ? (t24 = /* @__PURE__ */ jsx(MissingSchemaType, { value }), $[0] = value, $[1] = t24) : t24 = $[1], t1 = t24;
        break bb0;
      }
      let t23;
      $[2] !== icon || $[3] !== schemaType ? (t23 = getIconWithFallback(icon, schemaType, DocumentIcon), $[2] = icon, $[3] = schemaType, $[4] = t23) : t23 = $[4];
      let t33;
      $[5] !== documentPresence || $[6] !== documentPreviewStore || $[7] !== layout || $[8] !== schemaType || $[9] !== sortOrder || $[10] !== t23 || $[11] !== value ? (t33 = /* @__PURE__ */ jsx(PaneItemPreview, { documentPreviewStore, icon: t23, layout, schemaType, sortOrder, value, presence: documentPresence }), $[5] = documentPresence, $[6] = documentPreviewStore, $[7] = layout, $[8] = schemaType, $[9] = sortOrder, $[10] = t23, $[11] = value, $[12] = t33) : t33 = $[12], t1 = t33;
      break bb0;
    }
    let t22;
    $[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = {
      opacity: 0.5
    }, $[13] = t22) : t22 = $[13];
    let t32;
    $[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t32 = /* @__PURE__ */ jsx(Box, { style: t22, children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }) }), $[14] = t32) : t32 = $[14];
    let t42;
    $[15] !== icon || $[16] !== schemaType ? (t42 = getIconWithFallback(icon, schemaType, FolderIcon), $[15] = icon, $[16] = schemaType, $[17] = t42) : t42 = $[17];
    let t52;
    $[18] !== t42 || $[19] !== title ? (t52 = /* @__PURE__ */ jsx(SanityDefaultPreview, { status: t32, icon: t42, layout: "compact", title }), $[18] = t42, $[19] = title, $[20] = t52) : t52 = $[20], t1 = t52;
  }
  const preview = t1;
  let t2;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = (e) => {
    if (e.metaKey) {
      setClicked(!1);
      return;
    }
    setClicked(!0);
  }, $[21] = t2) : t2 = $[21];
  const handleClick = t2;
  let t3;
  $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = () => setClicked(!1), $[22] = t3) : t3 = $[22];
  let t4;
  $[23] !== selected ? (t4 = [selected], $[23] = selected, $[24] = t4) : t4 = $[24], useEffect(t3, t4);
  const [preloading, setPreload] = useState(!1), timeoutRef = useRef(null);
  let t5;
  $[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = () => {
    timeoutRef.current = setTimeout(() => startTransition(() => setPreload(!0)), 400);
  }, $[25] = t5) : t5 = $[25];
  const handleMouseEnter = t5;
  let t6;
  $[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = () => {
    timeoutRef.current && clearTimeout(timeoutRef.current), startTransition(() => setPreload(!1));
  }, $[26] = t6) : t6 = $[26];
  const handleMouseLeave = t6, t7 = `pane-item-${title}`, t8 = ChildLink2, t9 = selected || clicked;
  let t10;
  $[27] !== id || $[28] !== preloading || $[29] !== schemaType || $[30] !== value ? (t10 = preloading && schemaType?.name && value && isSanityDocument$1(value) && /* @__PURE__ */ jsx(PreloadDocumentPane, { documentId: id, documentType: schemaType.name }), $[27] = id, $[28] = preloading, $[29] = schemaType, $[30] = value, $[31] = t10) : t10 = $[31];
  let t11;
  return $[32] !== id || $[33] !== margin || $[34] !== marginBottom || $[35] !== marginTop || $[36] !== pressed || $[37] !== preview || $[38] !== t10 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9 ? (t11 = /* @__PURE__ */ jsxs(PreviewCard, { "data-testid": t7, __unstable_focusRing: !0, as: t8, childId: id, "data-as": "a", margin, marginBottom, marginTop, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, pressed, radius: 2, selected: t9, sizing: "border", tabIndex: -1, tone: "inherit", children: [
    preview,
    t10
  ] }), $[32] = id, $[33] = margin, $[34] = marginBottom, $[35] = marginTop, $[36] = pressed, $[37] = preview, $[38] = t10, $[39] = t7, $[40] = t8, $[41] = t9, $[42] = t11) : t11 = $[42], t11;
}
function PreloadDocumentPane(props) {
  const $ = c(2), {
    documentId,
    documentType
  } = props;
  let t0;
  return $[0] !== documentId ? (t0 = getPublishedId(documentId), $[0] = documentId, $[1] = t0) : t0 = $[1], useEditState(t0, documentType), null;
}
PreloadDocumentPane.displayName = "PreloadDocumentPane";
const RenderActionCollectionState = memo((props) => {
  const $ = c(4), {
    children,
    group
  } = props, states = useContext(DocumentActionsStateContext);
  if (states === null)
    throw new Error("DocumentActionsStateContext is not set. This should not happen.");
  let t0;
  if ($[0] !== children || $[1] !== group || $[2] !== states) {
    const filteredStates = group ? states.filter((state2) => (state2.group || ["default"]).includes(group)) : states;
    t0 = children({
      states: filteredStates
    }), $[0] = children, $[1] = group, $[2] = states, $[3] = t0;
  } else
    t0 = $[3];
  return t0;
});
RenderActionCollectionState.displayName = "Memo(RenderActionCollectionState)";
const RenderBadgeCollectionState = memo((props) => {
  const $ = c(4), {
    badges,
    children,
    badgeProps
  } = props;
  let t0;
  return $[0] !== badgeProps || $[1] !== badges || $[2] !== children ? (t0 = /* @__PURE__ */ jsx(GetHookCollectionState, { hooks: badges, args: badgeProps, children }), $[0] = badgeProps, $[1] = badges, $[2] = children, $[3] = t0) : t0 = $[3], t0;
});
RenderBadgeCollectionState.displayName = "Memo(RenderBadgeCollectionState)";
const INITIAL_STATE$1 = {
  documents: [],
  loading: !0
};
async function resolveRawFilterCallback(filterResolver, {
  document: document2,
  getClient
}) {
  const resolvedFilter = await filterResolver({
    document: document2,
    getClient
  });
  return typeof resolvedFilter == "string" ? {
    filter: resolvedFilter,
    filterParams: void 0
  } : resolvedFilter;
}
function getIncomingReferences({
  documentId,
  documentPreviewStore,
  type,
  filter: filterQueryRaw,
  filterParams: filterParamsRaw,
  getClient
}) {
  const publishedId = getPublishedId(documentId);
  return (typeof filterQueryRaw == "function" ? documentPreviewStore.unstable_observeDocument(documentId).pipe(distinctUntilChanged((a, b) => a?._rev === b?._rev), switchMap$1((document2) => resolveRawFilterCallback(filterQueryRaw, {
    document: document2,
    getClient
  })), map((resolvedFilter) => ({
    filter: resolvedFilter.filter,
    filterParams: resolvedFilter.filterParams || filterParamsRaw
  }))) : of({
    filter: filterQueryRaw,
    filterParams: filterParamsRaw
  })).pipe(distinctUntilChanged((a, b) => a.filter === b.filter && JSON.stringify(a.filterParams) === JSON.stringify(b.filterParams)), switchMap$1(({
    filter: filterQuery,
    filterParams
  }) => documentPreviewStore.unstable_observeDocumentIdSet(`references("${publishedId}") ${type ? `&& _type == "${type}"` : ""} ${filterQuery ? `&& ${filterQuery}` : ""}`, filterParams, {
    insert: "append"
  }).pipe(
    map((state2) => state2.documentIds),
    mergeMapArray((id) => documentPreviewStore.unstable_observeDocument(id).pipe(filter(Boolean), map((doc) => doc))),
    // Remove duplicates due to different versions of the same document.
    map((documents) => {
      const seenPublishedId = [];
      return documents.filter((doc) => {
        const pId = getPublishedId(doc._id);
        return seenPublishedId.includes(pId) ? !1 : (seenPublishedId.push(pId), !0);
      });
    }),
    map((documents) => ({
      documents,
      loading: !1
    })),
    startWith(INITIAL_STATE$1)
  )));
}
const INCOMING_REFERENCES_ITEM_HEIGHT = 51, INCOMING_REFERENCES_MAX_VISIBLE_ITEMS = 10, IncomingReferencesListContainer = styled(Box).withConfig({
  displayName: "IncomingReferencesListContainer",
  componentId: "sc-17ysjqh-0"
})`height:${({
  $itemCount
}) => Math.min($itemCount, INCOMING_REFERENCES_MAX_VISIBLE_ITEMS) * INCOMING_REFERENCES_ITEM_HEIGHT}px;`;
function CrossDatasetIncomingReferenceDocumentPreview(t0) {
  const $ = c(26), {
    type,
    document: document2
  } = t0;
  let t1;
  $[0] !== document2.id || $[1] !== document2.type || $[2] !== type ? (t1 = type?.studioUrl?.({
    id: document2.id,
    type: document2.type
  }), $[0] = document2.id, $[1] = document2.type, $[2] = type, $[3] = t1) : t1 = $[3];
  const studioUrl = t1, t2 = document2.id, t3 = studioUrl ? "a" : "div", t4 = studioUrl ? 3 : 0;
  let t5;
  $[4] !== studioUrl ? (t5 = studioUrl ? {
    href: studioUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    as: "a"
  } : {}, $[4] = studioUrl, $[5] = t5) : t5 = $[5];
  const t6 = document2.availability, t7 = !!studioUrl, t8 = !!studioUrl;
  let t9;
  $[6] !== document2.preview || $[7] !== type ? (t9 = type ? {
    type: type.type,
    title: document2.preview.published?.title,
    icon: _temp$a,
    preview: type.preview
  } : void 0, $[6] = document2.preview, $[7] = type, $[8] = t9) : t9 = $[8];
  let t10;
  $[9] !== document2.availability || $[10] !== document2.dataset || $[11] !== document2.id || $[12] !== document2.preview || $[13] !== document2.projectId || $[14] !== t7 || $[15] !== t8 || $[16] !== t9 ? (t10 = /* @__PURE__ */ jsx(CrossDatasetReferencePreview, { availability: t6, hasStudioUrl: t7, showStudioUrlIcon: t8, preview: document2.preview, refType: t9, projectId: document2.projectId, dataset: document2.dataset, id: document2.id, showTypeLabel: !1 }), $[9] = document2.availability, $[10] = document2.dataset, $[11] = document2.id, $[12] = document2.preview, $[13] = document2.projectId, $[14] = t7, $[15] = t8, $[16] = t9, $[17] = t10) : t10 = $[17];
  let t11;
  $[18] !== t10 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 ? (t11 = /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(PreviewCard, { "data-as": t3, flex: 1, radius: 2, paddingRight: t4, tone: "inherit", __unstable_focusRing: !0, tabIndex: 0, ...t5, children: t10 }) }), $[18] = t10, $[19] = t3, $[20] = t4, $[21] = t5, $[22] = t11) : t11 = $[22];
  let t12;
  return $[23] !== document2.id || $[24] !== t11 ? (t12 = /* @__PURE__ */ jsx(Flex, { gap: 1, align: "center", children: t11 }, t2), $[23] = document2.id, $[24] = t11, $[25] = t12) : t12 = $[25], t12;
}
function _temp$a() {
  return null;
}
const INITIAL_STATE = {
  documents: [],
  loading: !0
};
function getCrossDatasetIncomingReferences({
  documentId,
  type,
  client,
  documentPreviewStore
}) {
  return fetchCrossDatasetReferences(documentId, {
    versionedClient: client
  }).pipe(
    map((result) => result ? type?.dataset ? result.references.filter((ref) => ref.datasetName === type.dataset && ref.documentId) : result.references.filter((ref) => ref.documentId && ref.datasetName) : []),
    // Now that we have all the references from the dataset the user defined, we need to get the document type from the documentId
    mergeMapArray((document2) => documentPreviewStore.observeDocumentTypeFromId(getPublishedId(document2.documentId), {
      dataset: document2.datasetName,
      projectId: document2.projectId
    }).pipe(map((documentType) => ({
      ...document2,
      documentType
    })))),
    mergeMapArray((document2) => {
      if (!document2.documentType) return of(null);
      if (!type)
        return of({
          type: document2.documentType,
          id: document2.documentId,
          preview: {
            published: {
              _id: document2.documentId,
              title: `Document Id: ${document2.documentId}`,
              subtitle: `Dataset: ${document2.datasetName} - Project Id: ${document2.projectId}`,
              media: /* @__PURE__ */ jsx(DocumentIcon, {})
            }
          },
          availability: {
            available: !0,
            reason: "READABLE"
          },
          projectId: document2.projectId,
          dataset: document2.datasetName
        });
      if (document2.documentType !== type.type) return of(null);
      const previewPaths = getPreviewPaths(type.preview) || [];
      return documentPreviewStore.observePaths({
        _id: getPublishedId(document2.documentId)
      }, previewPaths, {
        dataset: document2.datasetName,
        projectId: document2.projectId
      }).pipe(map((result) => {
        const previewValue = prepareForPreview(result, {
          type: type.type,
          title: type.title || "",
          icon: () => /* @__PURE__ */ jsx(DocumentIcon, {}),
          preview: type.preview
        });
        return {
          type: document2.documentType,
          id: document2.documentId,
          preview: {
            published: {
              ...previewValue,
              media: previewValue.media ?? /* @__PURE__ */ jsx(DocumentIcon, {})
            }
          },
          availability: {
            available: !0,
            reason: "READABLE"
          },
          projectId: document2.projectId,
          dataset: document2.datasetName
        };
      }));
    }),
    map((documents) => ({
      documents: documents.filter(isNonNullable$1),
      loading: !1
    })),
    startWith(INITIAL_STATE)
  );
}
const IncomingReferenceDocumentActionsInner = (t0) => {
  const $ = c(20), {
    states,
    document: document2,
    setIsExecutingAction,
    isExecutingAction
  } = t0, [actionIndex, setActionIndex] = useState(-1), [referenceElement, setReferenceElement] = useState(null), currentAction = states[actionIndex];
  if (!states.length)
    return null;
  let t1;
  $[0] !== isExecutingAction ? (t1 = /* @__PURE__ */ jsx(ContextMenuButton, { loading: isExecutingAction }), $[0] = isExecutingAction, $[1] = t1) : t1 = $[1];
  const t2 = `${document2._id}-menuButton`;
  let t3;
  if ($[2] !== setIsExecutingAction || $[3] !== states) {
    let t42;
    $[5] !== setIsExecutingAction ? (t42 = (action, index) => /* @__PURE__ */ jsx(MenuItem$1, { text: action.label, icon: action.icon, tone: action.tone, disabled: !!action.disabled, onClick: async () => {
      setActionIndex(index), setIsExecutingAction(!0), await action.onHandle?.(), setIsExecutingAction(!1);
    } }, action.label), $[5] = setIsExecutingAction, $[6] = t42) : t42 = $[6], t3 = states.map(t42), $[2] = setIsExecutingAction, $[3] = states, $[4] = t3;
  } else
    t3 = $[4];
  let t4;
  $[7] !== t3 ? (t4 = /* @__PURE__ */ jsx(Menu, { children: t3 }), $[7] = t3, $[8] = t4) : t4 = $[8];
  let t5;
  $[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t5 = {
    portal: !0,
    tone: "default"
  }, $[9] = t5) : t5 = $[9];
  let t6;
  $[10] !== t1 || $[11] !== t2 || $[12] !== t4 ? (t6 = /* @__PURE__ */ jsx(Box, { ref: setReferenceElement, children: /* @__PURE__ */ jsx(MenuButton, { button: t1, id: t2, menu: t4, popover: t5 }) }), $[10] = t1, $[11] = t2, $[12] = t4, $[13] = t6) : t6 = $[13];
  let t7;
  $[14] !== currentAction || $[15] !== referenceElement ? (t7 = currentAction && currentAction.dialog && /* @__PURE__ */ jsx(LegacyLayerProvider, { zOffset: "pane", children: /* @__PURE__ */ jsx(ActionStateDialog, { dialog: currentAction.dialog, referenceElement }) }), $[14] = currentAction, $[15] = referenceElement, $[16] = t7) : t7 = $[16];
  let t8;
  return $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t6,
    t7
  ] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}, IncomingReferenceDocumentActions = (props) => {
  const $ = c(11), {
    document: document2,
    actions,
    setIsExecutingAction,
    isExecutingAction
  } = props, {
    getClient
  } = useSource();
  let t0;
  $[0] !== document2 || $[1] !== isExecutingAction || $[2] !== setIsExecutingAction ? (t0 = (t12) => {
    const {
      states
    } = t12;
    return /* @__PURE__ */ jsx(IncomingReferenceDocumentActionsInner, { states, document: document2, setIsExecutingAction, isExecutingAction }, document2._id);
  }, $[0] = document2, $[1] = isExecutingAction, $[2] = setIsExecutingAction, $[3] = t0) : t0 = $[3];
  const renderActions = t0;
  let t1;
  $[4] !== document2 || $[5] !== getClient ? (t1 = {
    document: document2,
    getClient
  }, $[4] = document2, $[5] = getClient, $[6] = t1) : t1 = $[6];
  let t2;
  return $[7] !== actions || $[8] !== renderActions || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(GetHookCollectionState, { hooks: actions, args: t1, children: renderActions }), $[7] = actions, $[8] = renderActions, $[9] = t1, $[10] = t2) : t2 = $[10], t2;
};
function IncomingReferencePreview(props) {
  const $ = c(17), {
    onClick,
    type,
    value,
    path
  } = props, t0 = value?._id;
  let t1;
  $[0] !== t0 ? (t1 = getPublishedId(t0), $[0] = t0, $[1] = t1) : t1 = $[1];
  const documentPresence = useDocumentPresence(t1), documentPreviewStore = useDocumentPreviewStore(), {
    ChildLink: ChildLink2
  } = usePaneRouter();
  let t2;
  $[2] !== ChildLink2 || $[3] !== path || $[4] !== type.name || $[5] !== value?._id ? (t2 = function(linkProps) {
    return /* @__PURE__ */ jsx(ChildLink2, { childId: getPublishedId(value?._id), childParameters: {
      type: type.name,
      path: pathToString(path)
    }, ...linkProps });
  }, $[2] = ChildLink2, $[3] = path, $[4] = type.name, $[5] = value?._id, $[6] = t2) : t2 = $[6];
  const t3 = t2, t4 = type.icon || !1;
  let t5;
  $[7] !== documentPresence || $[8] !== documentPreviewStore || $[9] !== t4 || $[10] !== type || $[11] !== value ? (t5 = /* @__PURE__ */ jsx(PaneItemPreview, { documentPreviewStore, icon: t4, layout: "default", presence: documentPresence, schemaType: type, value }), $[7] = documentPresence, $[8] = documentPreviewStore, $[9] = t4, $[10] = type, $[11] = value, $[12] = t5) : t5 = $[12];
  let t6;
  return $[13] !== onClick || $[14] !== t3 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(PreviewCard, { __unstable_focusRing: !0, as: t3, "data-as": "a", onClick, radius: 2, children: t5 }), $[13] = onClick, $[14] = t3, $[15] = t5, $[16] = t6) : t6 = $[16], t6;
}
const Root$1 = motion.create(Flex), variants = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  actionInProgress: {
    opacity: [0.5, 1, 0.5],
    transition: {
      duration: 1.8,
      repeat: 1 / 0,
      ease: "easeInOut"
    }
  }
}, ErrorCard = (t0) => {
  const $ = c(2), {
    message
  } = t0;
  let t1;
  return $[0] !== message ? (t1 = /* @__PURE__ */ jsx(Card, { border: !0, radius: 2, padding: 1, tone: "critical", children: /* @__PURE__ */ jsx(Box, { paddingY: 4, paddingX: 3, children: /* @__PURE__ */ jsx(Text, { size: 1, children: message }) }) }), $[0] = message, $[1] = t1) : t1 = $[1], t1;
}, IncomingReferenceDocument$1 = (props) => {
  const $ = c(33), {
    document: document2,
    referenceToId,
    actions
  } = props;
  let t0;
  $[0] !== document2 || $[1] !== referenceToId ? (t0 = getReferencePaths(document2, referenceToId), $[0] = document2, $[1] = referenceToId, $[2] = t0) : t0 = $[2];
  const referencePaths = t0, [isExecutingAction, setIsExecutingAction] = useState(!1), id = document2._id, schema = useSchema(), {
    navigate
  } = useRouter(), {
    routerPanesState,
    groupIndex
  } = usePaneRouter(), type = document2?._type, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[3] !== groupIndex || $[4] !== id || $[5] !== navigate || $[6] !== referencePaths[0] || $[7] !== referencePaths.length || $[8] !== routerPanesState || $[9] !== type ? (t1 = () => {
    if (!referencePaths.length)
      throw new Error("No reference paths found");
    navigate({
      panes: [...routerPanesState.slice(0, groupIndex + 1), [{
        id: getPublishedId(id),
        params: {
          type,
          path: pathToString(referencePaths[0])
        }
      }]]
    });
  }, $[3] = groupIndex, $[4] = id, $[5] = navigate, $[6] = referencePaths[0], $[7] = referencePaths.length, $[8] = routerPanesState, $[9] = type, $[10] = t1) : t1 = $[10];
  const handleClick = t1;
  let t2;
  $[11] !== schema || $[12] !== type ? (t2 = schema.get(type), $[11] = schema, $[12] = type, $[13] = t2) : t2 = $[13];
  const schemaType = t2;
  if (!schemaType) {
    let t32;
    $[14] !== t || $[15] !== type ? (t32 = t("incoming-references-input.schema-type-not-found", {
      type
    }), $[14] = t, $[15] = type, $[16] = t32) : t32 = $[16];
    let t42;
    return $[17] !== t32 ? (t42 = /* @__PURE__ */ jsx(ErrorCard, { message: t32 }), $[17] = t32, $[18] = t42) : t42 = $[18], t42;
  }
  const t3 = isExecutingAction ? "actionInProgress" : "animate";
  let t4;
  $[19] !== document2 || $[20] !== handleClick || $[21] !== referencePaths[0] || $[22] !== referencePaths.length || $[23] !== schemaType ? (t4 = /* @__PURE__ */ jsx(Box, { flex: 1, children: referencePaths.length > 0 ? /* @__PURE__ */ jsx(IncomingReferencePreview, { type: schemaType, value: document2, onClick: handleClick, path: referencePaths[0] }) : /* @__PURE__ */ jsx(SanityDefaultPreview, { icon: schemaType.icon, layout: "default", isPlaceholder: !0 }) }), $[19] = document2, $[20] = handleClick, $[21] = referencePaths[0], $[22] = referencePaths.length, $[23] = schemaType, $[24] = t4) : t4 = $[24];
  let t5;
  $[25] !== actions || $[26] !== document2 || $[27] !== isExecutingAction ? (t5 = actions && actions?.length > 0 && /* @__PURE__ */ jsx(IncomingReferenceDocumentActions, { document: document2, actions, isExecutingAction, setIsExecutingAction }), $[25] = actions, $[26] = document2, $[27] = isExecutingAction, $[28] = t5) : t5 = $[28];
  let t6;
  return $[29] !== t3 || $[30] !== t4 || $[31] !== t5 ? (t6 = /* @__PURE__ */ jsxs(Root$1, { initial: "initial", animate: t3, gap: 1, align: "center", variants, children: [
    t4,
    t5
  ] }), $[29] = t3, $[30] = t4, $[31] = t5, $[32] = t6) : t6 = $[32], t6;
}, randomIdCache = /* @__PURE__ */ new WeakMap();
function assignId(obj) {
  const cachedValue = randomIdCache.get(obj);
  if (cachedValue) return cachedValue;
  const id = nanoid();
  return randomIdCache.set(obj, id), id;
}
const PARTIAL_PAGE_LIMIT = 100, FULL_LIST_LIMIT = 2e3, DEFAULT_ORDERING = {
  by: [{
    field: "_updatedAt",
    direction: "desc"
  }]
}, EMPTY_RECORD = {}, RootBox = styled(Box).withConfig({
  displayName: "RootBox",
  componentId: "sc-1xocekz-0"
})`position:relative;opacity:${(props) => props.$opacity || 1};transition:opacity 0.4s;`, CommandListBox = styled(Box).withConfig({
  displayName: "CommandListBox",
  componentId: "sc-1xocekz-1"
})`position:absolute;left:0;right:0;top:0;bottom:0;`, SKELETON_ITEMS = [...Array(30).keys()];
function LoadingView(props) {
  const $ = c(4), {
    layout
  } = props;
  let t0;
  $[0] !== layout ? (t0 = SKELETON_ITEMS.map((num) => /* @__PURE__ */ jsx(SanityDefaultPreview, { isPlaceholder: !0, layout }, num)), $[0] = layout, $[1] = t0) : t0 = $[1];
  let t1;
  return $[2] !== t0 ? (t1 = /* @__PURE__ */ jsx(Stack, { paddingX: 3, paddingY: 2, paddingTop: 0, space: 1, children: t0 }), $[2] = t0, $[3] = t1) : t1 = $[3], t1;
}
function DocumentListPaneContent(props) {
  const $ = c(67), {
    childItemId,
    error,
    isRetrying,
    autoRetry,
    filterIsSimpleTypeConstraint,
    hasMaxItems,
    hasSearchQuery,
    isActive,
    isLazyLoading,
    muted,
    isLoading,
    isConnected,
    retryCount,
    canRetry,
    items,
    layout,
    loadingVariant,
    onEndReached,
    onRetry,
    paneTitle,
    searchInputElement,
    showIcons,
    sortOrder
  } = props, schema = useSchema(), {
    collapsed: layoutCollapsed
  } = usePaneLayout(), {
    collapsed,
    index
  } = usePane(), [shouldRender, setShouldRender] = useState(!collapsed), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[0] !== onEndReached || $[1] !== shouldRender ? (t0 = () => {
    shouldRender && onEndReached();
  }, $[0] = onEndReached, $[1] = shouldRender, $[2] = t0) : t0 = $[2];
  const handleEndReached = t0;
  let t1;
  $[3] !== collapsed ? (t1 = () => {
    if (collapsed)
      return;
    const timer2 = setTimeout(() => {
      setShouldRender(!0);
    }, 0);
    return () => {
      clearTimeout(timer2);
    };
  }, $[3] = collapsed, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== collapsed || $[6] !== items ? (t2 = [collapsed, items], $[5] = collapsed, $[6] = items, $[7] = t2) : t2 = $[7], useEffect(t1, t2);
  let t3;
  $[8] !== childItemId || $[9] !== hasMaxItems || $[10] !== isActive || $[11] !== isLazyLoading || $[12] !== items.length || $[13] !== layout || $[14] !== schema || $[15] !== showIcons || $[16] !== sortOrder || $[17] !== t ? (t3 = (item, t42) => {
    const {
      activeIndex
    } = t42, publishedId = getPublishedId(item._id), isSelected = childItemId === publishedId, pressed = !isActive && isSelected, selected = isActive && isSelected, isLastItem = activeIndex === items.length - 1, showSpinner = isLastItem && isLazyLoading, showMaxItemsMessage = isLastItem && hasMaxItems;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(PaneItem, { icon: showIcons ? void 0 : !1, id: publishedId, layout, marginBottom: 1, pressed, schemaType: schema.get(item._type), selected, sortOrder, value: item }),
      showSpinner && /* @__PURE__ */ jsx(LoadingBlock, {}),
      showMaxItemsMessage && /* @__PURE__ */ jsx(Box, { marginY: 1, paddingX: 3, paddingY: 4, children: /* @__PURE__ */ jsx(Text, { align: "center", muted: !0, size: 1, children: t("panes.document-list-pane.max-items.text", {
        limit: FULL_LIST_LIMIT
      }) }) })
    ] });
  }, $[8] = childItemId, $[9] = hasMaxItems, $[10] = isActive, $[11] = isLazyLoading, $[12] = items.length, $[13] = layout, $[14] = schema, $[15] = showIcons, $[16] = sortOrder, $[17] = t, $[18] = t3) : t3 = $[18];
  const renderItem = t3;
  let t4;
  bb0: {
    if (hasSearchQuery) {
      let t53;
      $[19] !== t ? (t53 = t("panes.document-list-pane.no-documents.text"), $[19] = t, $[20] = t53) : t53 = $[20];
      let t63;
      $[21] !== t53 ? (t63 = /* @__PURE__ */ jsx(Flex, { align: "center", direction: "column", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(Container$1, { width: 1, children: /* @__PURE__ */ jsx(Box, { paddingX: 4, paddingY: 5, children: /* @__PURE__ */ jsx(Text, { align: "center", muted: !0, children: t53 }) }) }) }), $[21] = t53, $[22] = t63) : t63 = $[22], t4 = t63;
      break bb0;
    }
    let t52;
    $[23] !== filterIsSimpleTypeConstraint || $[24] !== t ? (t52 = t(filterIsSimpleTypeConstraint ? "panes.document-list-pane.no-documents-of-type.text" : "panes.document-list-pane.no-matching-documents.text"), $[23] = filterIsSimpleTypeConstraint, $[24] = t, $[25] = t52) : t52 = $[25];
    let t62;
    $[26] !== t52 ? (t62 = /* @__PURE__ */ jsx(Flex, { align: "center", direction: "column", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(Container$1, { width: 1, children: /* @__PURE__ */ jsx(Box, { paddingX: 4, paddingY: 5, children: /* @__PURE__ */ jsx(Text, { align: "center", muted: !0, children: t52 }) }) }) }), $[26] = t52, $[27] = t62) : t62 = $[27], t4 = t62;
  }
  const noDocumentsContent = t4;
  let t5;
  bb1: {
    if (!shouldRender) {
      t5 = null;
      break bb1;
    }
    const isOnline = window.navigator.onLine;
    if (error) {
      let t63;
      $[28] !== t ? (t63 = t("panes.document-list-pane.error.title"), $[28] = t, $[29] = t63) : t63 = $[29];
      let t73;
      $[30] !== t63 ? (t73 = /* @__PURE__ */ jsx(Heading, { as: "h3", children: t63 }), $[30] = t63, $[31] = t73) : t73 = $[31];
      let t82;
      $[32] !== error || $[33] !== t ? (t82 = isDev ? /* @__PURE__ */ jsx(Translate, { t, i18nKey: "panes.document-list-pane.error.text.dev", values: {
        error: error.message
      }, components: {
        Code: _temp$9
      } }) : t(isOnline ? "panes.document-list-pane.error.text" : "panes.document-list-pane.error.text.offline"), $[32] = error, $[33] = t, $[34] = t82) : t82 = $[34];
      let t9;
      $[35] !== t82 ? (t9 = /* @__PURE__ */ jsx(Text, { as: "p", children: t82 }), $[35] = t82, $[36] = t9) : t9 = $[36];
      const t10 = isOnline && canRetry ? onRetry : void 0;
      let t11;
      $[37] !== error || $[38] !== isRetrying || $[39] !== t10 ? (t11 = /* @__PURE__ */ jsx(ErrorActions, { error, eventId: null, onRetry: t10, isRetrying }), $[37] = error, $[38] = isRetrying, $[39] = t10, $[40] = t11) : t11 = $[40];
      let t12;
      $[41] !== autoRetry || $[42] !== canRetry || $[43] !== isRetrying || $[44] !== retryCount || $[45] !== t ? (t12 = canRetry ? /* @__PURE__ */ jsx(Text, { as: "p", muted: !0, size: 1, children: isRetrying ? t("panes.document-list-pane.error.retrying", {
        count: retryCount
      }) : autoRetry ? t("panes.document-list-pane.error.will-retry-automatically", {
        count: retryCount
      }) : t("panes.document-list-pane.error.max-retries-attempted", {
        count: retryCount
      }) }) : null, $[41] = autoRetry, $[42] = canRetry, $[43] = isRetrying, $[44] = retryCount, $[45] = t, $[46] = t12) : t12 = $[46];
      let t13;
      $[47] !== t11 || $[48] !== t12 || $[49] !== t73 || $[50] !== t9 ? (t13 = /* @__PURE__ */ jsx(Flex, { align: "center", direction: "column", height: "fill", justify: "center", children: /* @__PURE__ */ jsx(Container$1, { width: 1, children: /* @__PURE__ */ jsxs(Stack, { paddingX: 4, paddingY: 5, space: 4, children: [
        t73,
        t9,
        t11,
        t12
      ] }) }) }), $[47] = t11, $[48] = t12, $[49] = t73, $[50] = t9, $[51] = t13) : t13 = $[51], t5 = t13;
      break bb1;
    }
    if (isConnected && !isLoading && items.length === 0) {
      t5 = noDocumentsContent;
      break bb1;
    }
    if (loadingVariant === "initial" && isLoading) {
      let t63;
      $[52] !== layout ? (t63 = /* @__PURE__ */ jsx(Delay, { ms: 300, children: /* @__PURE__ */ jsx(LoadingView, { layout }) }), $[52] = layout, $[53] = t63) : t63 = $[53], t5 = t63;
      break bb1;
    }
    if (loadingVariant === "spinner" && isLoading) {
      t5 = null;
      break bb1;
    }
    const key = `${index}-${collapsed}`, t62 = muted ? 0.8 : 1;
    let t72;
    $[54] !== handleEndReached || $[55] !== items || $[56] !== key || $[57] !== paneTitle || $[58] !== renderItem || $[59] !== searchInputElement ? (t72 = /* @__PURE__ */ jsx(CommandListBox, { children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: paneTitle, canReceiveFocus: !0, inputElement: searchInputElement, itemHeight: 51, items, onEndReached: handleEndReached, onlyShowSelectionWhenActive: !0, overscan: 10, paddingBottom: 1, paddingX: 3, renderItem, wrapAround: !1 }, key) }), $[54] = handleEndReached, $[55] = items, $[56] = key, $[57] = paneTitle, $[58] = renderItem, $[59] = searchInputElement, $[60] = t72) : t72 = $[60];
    let t8;
    $[61] !== t62 || $[62] !== t72 ? (t8 = /* @__PURE__ */ jsx(RootBox, { overflow: "hidden", height: "fill", $opacity: t62, children: t72 }), $[61] = t62, $[62] = t72, $[63] = t8) : t8 = $[63], t5 = t8;
  }
  const mainContent = t5, t6 = layoutCollapsed || loadingVariant === "initial" ? "hidden" : "auto";
  let t7;
  return $[64] !== mainContent || $[65] !== t6 ? (t7 = /* @__PURE__ */ jsx(PaneContent, { "data-testid": "document-list-pane", overflow: t6, children: mainContent }), $[64] = mainContent, $[65] = t6, $[66] = t7) : t7 = $[66], t7;
}
function _temp$9(t0) {
  const {
    children
  } = t0;
  return /* @__PURE__ */ jsx("code", { children });
}
function toStaticSortOrder(sortOrder) {
  return {
    by: sortOrder.by.map(({
      field,
      direction,
      mapWith,
      nulls
    }) => ({
      field,
      direction,
      ...mapWith !== void 0 && {
        mapWith
      },
      ...nulls !== void 0 && {
        nulls
      }
    }))
  };
}
function fromStaticSortOrder(staticSortOrder, schemaType) {
  return staticSortOrder && {
    by: (Array.isArray(staticSortOrder.by) ? staticSortOrder.by : []).map((entry) => ({
      ...entry,
      ...schemaType ? {
        schemaType
      } : {}
    }))
  };
}
function removePublishedWithDrafts(documents) {
  return collate(documents).map((entry) => {
    const doc = entry.draft || entry.published || entry.versions[0], hasDraft = !!entry.draft;
    return {
      ...doc,
      hasPublished: !!entry.published,
      hasDraft
    };
  });
}
function applyOrderingFunctions(order, schemaType) {
  const orderBy = order.by.map((by) => {
    if (by.mapWith)
      return by;
    const fieldType = tryResolveSchemaTypeForPath(schemaType, by.field);
    return fieldType ? fieldExtendsType(fieldType, "datetime") ? {
      ...by,
      mapWith: "dateTime"
    } : fieldType.jsonType === "string" ? {
      ...by,
      mapWith: "lower"
    } : by : by;
  });
  return orderBy.every((item, index) => item === order.by[index]) ? order : {
    ...order,
    by: orderBy
  };
}
const BUILT_IN_SORT_FIELDS = /* @__PURE__ */ new Set(["_id", "_type", "_rev", "_createdAt", "_updatedAt"]);
function validateSortOrder(sortOrder, schemaType, fallback) {
  return schemaType ? sortOrder.by.every((entry) => BUILT_IN_SORT_FIELDS.has(entry.field) || !!tryResolveSchemaTypeForPath(schemaType, entry.field)) ? sortOrder : fallback : sortOrder;
}
function tryResolveSchemaTypeForPath(baseType, path) {
  const pathSegments = PathUtils.fromString(path);
  let current = baseType;
  for (const segment of pathSegments) {
    if (!current)
      return;
    if (typeof segment == "string") {
      if (current = getFieldTypeByName(current, segment), current && isReferenceSchemaType(current)) {
        const [refType, otherRefType] = current.to || [];
        if (otherRefType || !refType)
          return;
        current = refType;
      }
      continue;
    }
    if (!(isKeySegment(segment) || isIndexSegment(segment)) || !isArraySchemaType(current) || current.of.length !== 1)
      return;
    const memberType = current.of[0];
    if (!isReferenceSchemaType(memberType)) {
      current = memberType;
      continue;
    }
    const refTargets = memberType.to || [];
    if (refTargets.length !== 1)
      return;
    current = refTargets[0];
  }
  return current;
}
function getFieldTypeByName(type, fieldName) {
  if (!("fields" in type))
    return;
  const fieldType = type.fields.find((field) => field.name === fieldName);
  return fieldType ? fieldType.type : void 0;
}
function fieldExtendsType(field, ofType) {
  let current = field.type;
  for (; current; ) {
    if (current.name === ofType || !current.type && current.jsonType === ofType)
      return !0;
    current = current.type;
  }
  return !1;
}
function findTypes(node) {
  switch (node.type) {
    case "OpCall": {
      const {
        left,
        right
      } = node;
      switch (node.op) {
        // e.g. `a == b`
        case "==":
          return left.type === "AccessAttribute" && left.name === "_type" && !left.base ? right.type !== "Value" || typeof right.value != "string" ? null : /* @__PURE__ */ new Set([right.value]) : right.type === "AccessAttribute" && right.name === "_type" && !right.base ? left.type !== "Value" || typeof left.value != "string" ? null : /* @__PURE__ */ new Set([left.value]) : null;
        // e.g. `a in b`
        case "in": {
          if (left.type !== "AccessAttribute" || left.name !== "_type" || left.base || right.type !== "Array") return null;
          const types = /* @__PURE__ */ new Set();
          for (const element of right.elements) {
            if (element.isSplat || element.value.type !== "Value" || typeof element.value.value != "string") return null;
            types.add(element.value.value);
          }
          return types.size ? types : null;
        }
        default:
          return null;
      }
    }
    // groups can just be unwrapped, the AST preserves the order
    case "Group":
      return findTypes(node.base);
    // e.g. `_type == 'a' || _type == 'b'`
    // with Or nodes, if we can't determine the types for either the left or
    // right hand side then we can't determine the types for any
    // e.g. `_type == 'a' || isActive`
    // — can't determine types because `isActive` could be true on another types
    case "Or": {
      const left = findTypes(node.left);
      if (!left) return null;
      const right = findTypes(node.right);
      return right ? /* @__PURE__ */ new Set([...left, ...right]) : null;
    }
    // e.g. `_type == 'a' && isActive`
    // with And nodes, we can determine the types as long as we can determine
    // the types for one side. We can't determine the types if both are `null`.
    case "And": {
      const left = findTypes(node.left), right = findTypes(node.right);
      return !left && !right ? null : /* @__PURE__ */ new Set([...left || [], ...right || []]);
    }
    default:
      return null;
  }
}
function findStaticTypesInFilter(filter2, params = {}) {
  try {
    const types = findTypes(parse(filter2, {
      params
    }));
    return types ? Array.from(types).sort() : null;
  } catch {
    return null;
  }
}
const DocumentListLoadTimeMeasured = defineEvent({
  name: "Document List Load Time Measured",
  version: 1,
  description: "Time from document list search subscription to first result",
  maxSampleRate: 3e4
}), swr = createSWR({
  maxSize: 100
});
function listenSearchQuery(options) {
  const {
    client,
    schema,
    sort,
    perspective,
    limit,
    params,
    filter: groqFilter,
    searchQuery,
    staticTypeNames,
    maxFieldDepth,
    searchStrategy
  } = options, sortBy = sort.by, events$ = defer(() => client.listen(`*[${groqFilter}]`, params, {
    events: ["welcome", "mutation", "reconnect"],
    includeAllVersions: !0,
    includeResult: !1,
    visibility: "query",
    tag: "listen-search-query"
  })).pipe(mergeMap((ev, i) => {
    const isFirst = i === 0;
    return isFirst && ev.type === "reconnect" ? throwError(() => new Error("Failed to establish EventSource connection")) : isFirst && ev.type !== "welcome" ? throwError(() => new Error(`Received unexpected type of first event "${ev.type}"`)) : of(ev);
  }), share()), [welcome$, mutationAndReconnect$] = partition(events$, (ev) => ev.type === "welcome"), swrKey = JSON.stringify({
    fiilter: groqFilter,
    limit,
    params,
    searchQuery,
    perspective,
    sort: toStaticSortOrder(sort),
    staticTypeNames
  });
  return merge(welcome$, mutationAndReconnect$.pipe(throttleTime(1e3, asyncScheduler, {
    leading: !0,
    trailing: !0
  }))).pipe(exhaustMapWithTrailing((event) => (staticTypeNames ? of(staticTypeNames) : client.observable.fetch(`array::unique(*[${groqFilter}][]._type)`, params)).pipe(mergeMap((typeNames) => {
    const types = getSearchableTypes(schema, staticTypeNames || []).filter((type) => {
      if (typeNames.includes(type.name)) {
        for (const entry of sort.by)
          entry.field && compileFieldPath(type, entry.field, {
            strict: !0
          });
        return !0;
      }
      return !1;
    }), search = createSearch(types, client, {
      filter: groqFilter,
      params,
      strategy: searchStrategy,
      maxDepth: maxFieldDepth
    }), doFetch = () => search({
      query: searchQuery || "",
      types
    }, {
      comments: [`findability-source: ${searchQuery ? "list-query" : "list"}`],
      limit,
      skipSortByScore: !0,
      sort: sortBy,
      perspective
    }).pipe(map((result) => (
      // eslint-disable-next-line max-nested-callbacks
      result.hits.map(({
        hit
      }) => hit)
    )), map((hits) => ({
      type: "result",
      documents: hits
    })));
    return event.type === "mutation" && event.visibility !== "query" ? timer(1200).pipe(mergeMap(doFetch)) : event.type === "reconnect" ? of(event) : doFetch();
  }))), scan((acc, event) => ({
    connected: event.type !== "reconnect",
    documents: event.type === "result" ? event.documents : acc?.documents || []
  }), null), filter((v) => v !== null), swr(swrKey), map(({
    fromCache,
    value
  }) => ({
    fromCache,
    ...value
  })));
}
const INITIAL_QUERY_STATE = {
  error: null,
  isRetrying: !1,
  retryCount: 0,
  autoRetry: !1,
  canRetry: !1,
  isLoading: !0,
  isLoadingFullList: !1,
  fromCache: !1,
  items: []
};
function isRetriableError(error) {
  return error instanceof ChannelError ? !1 : error instanceof ServerError ? !0 : error instanceof ClientError ? error.statusCode === 403 : !0;
}
function useDocumentList(opts) {
  const $ = c(36), {
    client,
    filter: searchFilter,
    params: paramsProp,
    sortOrder,
    searchQuery,
    perspective
  } = opts, {
    strategy: searchStrategy
  } = useWorkspace().search, schema = useSchema(), maxFieldDepth = useSearchMaxFieldDepth(), telemetry = useTelemetry();
  let t0;
  $[0] !== paramsProp || $[1] !== searchFilter ? (t0 = findStaticTypesInFilter(searchFilter, paramsProp), $[0] = paramsProp, $[1] = searchFilter, $[2] = t0) : t0 = $[2];
  const typeNameFromFilter = t0, [t1] = useState(_temp$8), [onRetry$, onRetry] = t1, [t2] = useState(_temp2$5), [onFetchFullList$, onLoadFullList] = t2, t3 = searchQuery || "", t4 = sortOrder || DEFAULT_ORDERING;
  let t5;
  if ($[3] !== client || $[4] !== maxFieldDepth || $[5] !== onFetchFullList$ || $[6] !== onRetry$ || $[7] !== paramsProp || $[8] !== perspective || $[9] !== schema || $[10] !== searchFilter || $[11] !== searchQuery || $[12] !== searchStrategy || $[13] !== t3 || $[14] !== t4 || $[15] !== telemetry || $[16] !== typeNameFromFilter) {
    const listenSearchQueryArgs = {
      client,
      filter: searchFilter,
      limit: PARTIAL_PAGE_LIMIT,
      params: paramsProp,
      schema,
      perspective,
      searchQuery: t3,
      sort: t4,
      staticTypeNames: typeNameFromFilter,
      maxFieldDepth,
      searchStrategy
    };
    let t62;
    $[18] !== searchQuery || $[19] !== telemetry ? (t62 = (durationMs, data) => {
      telemetry.log(DocumentListLoadTimeMeasured, {
        durationMs,
        searchStringLength: (searchQuery || "").length,
        returnedDocuments: data.documents.length,
        fromCache: data.fromCache
      });
    }, $[18] = searchQuery, $[19] = telemetry, $[20] = t62) : t62 = $[20];
    const partialList$ = listenSearchQuery(listenSearchQueryArgs).pipe(measureFirstMatch(_temp3$3, t62), shareReplay({
      refCount: !0,
      bufferSize: 1
    })), fullList$ = onFetchFullList$.pipe(withLatestFrom(partialList$), filter$1(_temp4$3), take(1), mergeMap$1(() => concat(of({
      type: "loadFullList"
    }), listenSearchQuery({
      ...listenSearchQueryArgs,
      limit: FULL_LIST_LIMIT
    }).pipe(map$1(_temp5$2)))), share$1());
    let t7;
    $[21] !== onRetry$ ? (t7 = (lastError, retryCount, caught$) => {
      const error = safeError(lastError), isOnline = window.navigator.onLine, canRetry = isOnline && isRetriableError(lastError), autoRetry = retryCount < 10, retries = merge(isOnline ? onRetry$ : fromEvent(window, "online"), isOnline && autoRetry ? timer(retryCount * 1e3) : NEVER).pipe(take(1), switchMap(() => merge(of({
        type: "error",
        error,
        retrying: !0,
        autoRetry,
        canRetry,
        retryCount
      }), caught$)));
      return concat(of({
        type: "error",
        error,
        retrying: !1,
        autoRetry,
        canRetry,
        retryCount
      }), retries);
    }, $[21] = onRetry$, $[22] = t7) : t7 = $[22], t5 = merge(partialList$.pipe(map$1(_temp6$2), takeUntil(fullList$)), fullList$).pipe(catchWithCount(t7), scan(_temp7$1, INITIAL_QUERY_STATE)), $[3] = client, $[4] = maxFieldDepth, $[5] = onFetchFullList$, $[6] = onRetry$, $[7] = paramsProp, $[8] = perspective, $[9] = schema, $[10] = searchFilter, $[11] = searchQuery, $[12] = searchStrategy, $[13] = t3, $[14] = t4, $[15] = telemetry, $[16] = typeNameFromFilter, $[17] = t5;
  } else
    t5 = $[17];
  const queryResults$ = t5, {
    error: error_0,
    items,
    isLoading,
    fromCache,
    connected,
    canRetry: canRetry_0,
    isLoadingFullList,
    isRetrying,
    autoRetry: autoRetry_0,
    retryCount: retryCount_0
  } = useObservable(queryResults$, INITIAL_QUERY_STATE);
  let t6;
  return $[23] !== autoRetry_0 || $[24] !== canRetry_0 || $[25] !== connected || $[26] !== error_0 || $[27] !== fromCache || $[28] !== isLoading || $[29] !== isLoadingFullList || $[30] !== isRetrying || $[31] !== items || $[32] !== onLoadFullList || $[33] !== onRetry || $[34] !== retryCount_0 ? (t6 = {
    error: error_0,
    onRetry,
    isLoading,
    items,
    isRetrying,
    canRetry: canRetry_0,
    retryCount: retryCount_0,
    autoRetry: autoRetry_0,
    connected,
    fromCache,
    onLoadFullList,
    isLoadingFullList
  }, $[23] = autoRetry_0, $[24] = canRetry_0, $[25] = connected, $[26] = error_0, $[27] = fromCache, $[28] = isLoading, $[29] = isLoadingFullList, $[30] = isRetrying, $[31] = items, $[32] = onLoadFullList, $[33] = onRetry, $[34] = retryCount_0, $[35] = t6) : t6 = $[35], t6;
}
function _temp7$1(prev, event_0) {
  if (event_0.type === "error")
    return {
      ...prev,
      error: event_0.error,
      retryCount: event_0.retryCount,
      isRetrying: event_0.retrying,
      autoRetry: event_0.autoRetry,
      canRetry: event_0.canRetry
    };
  if (event_0.type === "result")
    return {
      ...prev,
      error: null,
      isRetrying: !1,
      fromCache: event_0.result.fromCache,
      connected: event_0.result.connected,
      isLoading: !1,
      items: removePublishedWithDrafts(event_0.result.documents),
      isLoadingFullList: !1
    };
  if (event_0.type === "loadFullList")
    return {
      ...prev,
      error: null,
      isLoadingFullList: !0
    };
  throw new Error(`Unexpected event type: ${event_0.type}`);
}
function _temp6$2(result_1) {
  return {
    type: "result",
    result: result_1
  };
}
function _temp5$2(result_0) {
  return {
    type: "result",
    result: result_0
  };
}
function _temp4$3(t0) {
  const [, result] = t0;
  return result?.documents.length === PARTIAL_PAGE_LIMIT;
}
function _temp3$3(event) {
  return event.connected;
}
function _temp2$5() {
  return observableCallback();
}
function _temp$8() {
  return observableCallback();
}
const nonErrorThrownWarning = "[WARNING: This was thrown as a non-error. Only Error instances should be thrown]";
function safeError(thrown) {
  return thrown instanceof Error ? thrown : typeof thrown == "object" && thrown !== null ? "message" in thrown && typeof thrown.message == "string" ? new Error(`${thrown.message} ${nonErrorThrownWarning}`) : new Error(`${String(thrown)} ${nonErrorThrownWarning}`) : new Error(`${String(thrown)} ${nonErrorThrownWarning}`);
}
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.4;
  }
`, AnimatedSpinnerIcon = styled(SpinnerIcon).withConfig({
  displayName: "AnimatedSpinnerIcon",
  componentId: "sc-1nmsicq-0"
})`animation:${rotate} 500ms linear infinite;`, SubtleSpinnerIcon = styled(SpinnerIcon).withConfig({
  displayName: "SubtleSpinnerIcon",
  componentId: "sc-1nmsicq-1"
})`animation:${rotate} 1500ms linear infinite;opacity:0.4;`, DelayedSubtleSpinnerIcon = styled(SpinnerIcon).withConfig({
  displayName: "DelayedSubtleSpinnerIcon",
  componentId: "sc-1nmsicq-2"
})`animation:${rotate} 1500ms linear infinite,${fadeIn} 1000ms linear;opacity:0.4;`, DocumentListPane = memo(function(props) {
  const $ = c(70), {
    childItemId,
    isActive,
    pane,
    paneKey,
    sortOrder: sortOrderRaw,
    layout
  } = props, schema = useSchema(), releases = useActiveReleases(), {
    perspectiveStack
  } = usePerspective(), {
    displayOptions,
    options
  } = pane, {
    apiVersion,
    filter: filter2
  } = options, params = useShallowUnique(options.params || EMPTY_RECORD);
  let t0;
  bb0: {
    let t110;
    $[0] !== filter2 || $[1] !== params ? (t110 = findStaticTypesInFilter(filter2, params), $[0] = filter2, $[1] = params, $[2] = t110) : t110 = $[2];
    const staticTypes = t110;
    if (staticTypes?.length === 1) {
      t0 = staticTypes[0];
      break bb0;
    }
    t0 = null;
  }
  const typeName = t0, showIcons = displayOptions?.showIcons !== !1, {
    t
  } = useTranslation(structureLocaleNamespace), {
    title
  } = useI18nText(pane), [searchQuery, setSearchQuery] = useState(""), [searchInputValue, setSearchInputValue] = useState(""), [searchInputElement, setSearchInputElement] = useState(null);
  let t1;
  $[3] !== schema || $[4] !== sortOrderRaw || $[5] !== typeName ? (t1 = typeName && sortOrderRaw ? applyOrderingFunctions(sortOrderRaw, schema.get(typeName)) : sortOrderRaw, $[3] = schema, $[4] = sortOrderRaw, $[5] = typeName, $[6] = t1) : t1 = $[6];
  const sortOrder = useUnique(t1), t2 = apiVersion || DEFAULT_STUDIO_CLIENT_OPTIONS.apiVersion;
  let t3;
  $[7] !== t2 ? (t3 = {
    ...DEFAULT_STUDIO_CLIENT_OPTIONS,
    apiVersion: t2
  }, $[7] = t2, $[8] = t3) : t3 = $[8];
  const client = useClient(t3);
  let t4;
  $[9] !== searchQuery ? (t4 = searchQuery?.trim(), $[9] = searchQuery, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== client || $[12] !== filter2 || $[13] !== params || $[14] !== perspectiveStack || $[15] !== sortOrder || $[16] !== t4 ? (t5 = {
    client,
    filter: filter2,
    perspective: perspectiveStack,
    params,
    searchQuery: t4,
    sortOrder
  }, $[11] = client, $[12] = filter2, $[13] = params, $[14] = perspectiveStack, $[15] = sortOrder, $[16] = t4, $[17] = t5) : t5 = $[17];
  const {
    error,
    isLoadingFullList,
    isLoading: documentListIsLoading,
    items,
    fromCache,
    isRetrying,
    autoRetry,
    canRetry,
    retryCount,
    connected,
    onLoadFullList,
    onRetry
  } = useDocumentList(t5), isLoading = documentListIsLoading || releases.loading;
  let t6;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = (event$) => event$.pipe(map(_temp$7), tap$1(setSearchInputValue), debounce(_temp2$4), tap$1(setSearchQuery)), $[18] = t6) : t6 = $[18];
  const handleQueryChange = useObservableEvent(t6);
  let t7;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t7 = () => {
    setSearchQuery(""), setSearchInputValue("");
  }, $[19] = t7) : t7 = $[19];
  const handleClearSearch = t7;
  let t8;
  $[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t8 = (event_0) => {
    event_0.key === "Escape" && handleClearSearch();
  }, $[20] = t8) : t8 = $[20];
  const handleSearchKeyDown = t8, [enableSearchSpinner, setEnableSearchSpinner] = useState();
  let t10, t9;
  $[21] !== enableSearchSpinner || $[22] !== isLoading || $[23] !== paneKey ? (t9 = () => {
    !enableSearchSpinner && !isLoading && setEnableSearchSpinner(paneKey);
  }, t10 = [enableSearchSpinner, isLoading, paneKey], $[21] = enableSearchSpinner, $[22] = isLoading, $[23] = paneKey, $[24] = t10, $[25] = t9) : (t10 = $[24], t9 = $[25]), useEffect(t9, t10);
  let t11;
  $[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t11 = () => {
    handleClearSearch(), setEnableSearchSpinner();
  }, $[26] = t11) : t11 = $[26];
  let t12;
  $[27] !== paneKey ? (t12 = [paneKey, handleClearSearch], $[27] = paneKey, $[28] = t12) : t12 = $[28], useEffect(t11, t12);
  let t13;
  bb1: {
    if (connected && isLoading && enableSearchSpinner === paneKey) {
      t13 = "spinner";
      break bb1;
    }
    if (connected && fromCache) {
      t13 = "subtle";
      break bb1;
    }
    t13 = "initial";
  }
  const loadingVariant = t13;
  let t14;
  bb2: {
    if (loadingVariant === "spinner") {
      t14 = AnimatedSpinnerIcon;
      break bb2;
    }
    if (searchInputValue && loadingVariant === "subtle") {
      t14 = SubtleSpinnerIcon;
      break bb2;
    }
    t14 = SearchIcon;
  }
  const textInputIcon = t14;
  useReconnectingToast(!connected);
  let t15;
  $[29] !== t ? (t15 = t("panes.document-list-pane.search-input.aria-label"), $[29] = t, $[30] = t15) : t15 = $[30];
  const t16 = !!searchQuery;
  let t17;
  $[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t17 = [2, 2, 1], $[31] = t17) : t17 = $[31];
  const t18 = !connected || loadingVariant === "subtle" && !searchInputValue ? DelayedSubtleSpinnerIcon : null;
  let t19;
  $[32] !== t ? (t19 = t("panes.document-list-pane.search-input.placeholder"), $[32] = t, $[33] = t19) : t19 = $[33];
  let t20;
  $[34] !== handleQueryChange || $[35] !== searchInputValue || $[36] !== t15 || $[37] !== t16 || $[38] !== t18 || $[39] !== t19 || $[40] !== textInputIcon ? (t20 = /* @__PURE__ */ jsx(Box, { paddingX: 3, paddingBottom: 3, children: /* @__PURE__ */ jsx(TextInput, { "aria-label": t15, autoComplete: "off", border: !1, clearButton: t16, fontSize: t17, icon: textInputIcon, iconRight: t18, onChange: handleQueryChange, onClear: handleClearSearch, onKeyDown: handleSearchKeyDown, padding: 2, placeholder: t19, radius: 2, ref: setSearchInputElement, spellCheck: !1, value: searchInputValue }) }), $[34] = handleQueryChange, $[35] = searchInputValue, $[36] = t15, $[37] = t16, $[38] = t18, $[39] = t19, $[40] = textInputIcon, $[41] = t20) : t20 = $[41];
  const t21 = !!typeName, t22 = items.length === FULL_LIST_LIMIT, t23 = !!searchQuery, t24 = loadingVariant === "subtle";
  let t25;
  $[42] !== autoRetry || $[43] !== canRetry || $[44] !== childItemId || $[45] !== connected || $[46] !== error || $[47] !== isActive || $[48] !== isLoading || $[49] !== isLoadingFullList || $[50] !== isRetrying || $[51] !== items || $[52] !== layout || $[53] !== loadingVariant || $[54] !== onLoadFullList || $[55] !== onRetry || $[56] !== paneKey || $[57] !== retryCount || $[58] !== searchInputElement || $[59] !== showIcons || $[60] !== sortOrder || $[61] !== t21 || $[62] !== t22 || $[63] !== t23 || $[64] !== t24 || $[65] !== title ? (t25 = /* @__PURE__ */ jsx(DocumentListPaneContent, { childItemId, error, filterIsSimpleTypeConstraint: t21, hasMaxItems: t22, hasSearchQuery: t23, isActive, isLazyLoading: isLoadingFullList, isLoading, autoRetry, canRetry, retryCount, isRetrying, isConnected: connected, items, layout, muted: t24, loadingVariant, onEndReached: onLoadFullList, onRetry, paneTitle: title, searchInputElement, showIcons, sortOrder }, paneKey), $[42] = autoRetry, $[43] = canRetry, $[44] = childItemId, $[45] = connected, $[46] = error, $[47] = isActive, $[48] = isLoading, $[49] = isLoadingFullList, $[50] = isRetrying, $[51] = items, $[52] = layout, $[53] = loadingVariant, $[54] = onLoadFullList, $[55] = onRetry, $[56] = paneKey, $[57] = retryCount, $[58] = searchInputElement, $[59] = showIcons, $[60] = sortOrder, $[61] = t21, $[62] = t22, $[63] = t23, $[64] = t24, $[65] = title, $[66] = t25) : t25 = $[66];
  let t26;
  return $[67] !== t20 || $[68] !== t25 ? (t26 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t20,
    t25
  ] }), $[67] = t20, $[68] = t25, $[69] = t26) : t26 = $[69], t26;
});
function _temp$7(event) {
  return event.target.value;
}
function _temp2$4(value) {
  return value === "" ? of("") : timer(300);
}
const PaneHeader = memo((t0) => {
  const $ = c(33), {
    contentAfter,
    customMenuItemState: t1,
    index,
    initialValueTemplates: t2,
    menuItemGroups: t3,
    menuItems: t4,
    setLayout,
    setSortOrder,
    setCustomMenuItemState,
    title
  } = t0;
  let t5;
  $[0] !== t1 ? (t5 = t1 === void 0 ? {} : t1, $[0] = t1, $[1] = t5) : t5 = $[1];
  const customMenuItemState = t5;
  let t6;
  $[2] !== t2 ? (t6 = t2 === void 0 ? [] : t2, $[2] = t2, $[3] = t6) : t6 = $[3];
  const initialValueTemplates = t6;
  let t7;
  $[4] !== t3 ? (t7 = t3 === void 0 ? [] : t3, $[4] = t3, $[5] = t7) : t7 = $[5];
  const menuItemGroups = t7;
  let t8;
  $[6] !== t4 ? (t8 = t4 === void 0 ? [] : t4, $[6] = t4, $[7] = t8) : t8 = $[7];
  const menuItems = t8, {
    features
  } = useStructureTool(), {
    collapsed,
    isLast
  } = usePane(), tabIndex = isLast && !collapsed ? -1 : 0;
  let t9;
  $[8] !== setLayout ? (t9 = (t102) => {
    const {
      layout: value
    } = t102;
    setLayout(value);
  }, $[8] = setLayout, $[9] = t9) : t9 = $[9];
  let t10;
  $[10] !== setSortOrder ? (t10 = (sort) => {
    setSortOrder(sort);
  }, $[10] = setSortOrder, $[11] = t10) : t10 = $[11];
  let t11;
  $[12] !== customMenuItemState || $[13] !== setCustomMenuItemState ? (t11 = (params) => {
    const id = params._menuItemId, value_0 = params.value ?? !0;
    if (customMenuItemState[id] === value_0) {
      const newState = Object.fromEntries(Object.entries(customMenuItemState).filter((t122) => {
        const [key] = t122;
        return key !== id;
      }));
      setCustomMenuItemState(newState);
    } else
      setCustomMenuItemState({
        ...customMenuItemState,
        [id]: value_0
      });
  }, $[12] = customMenuItemState, $[13] = setCustomMenuItemState, $[14] = t11) : t11 = $[14];
  let t12;
  $[15] !== t10 || $[16] !== t11 || $[17] !== t9 ? (t12 = {
    setLayout: t9,
    setSortOrder: t10,
    setMenuItemState: t11
  }, $[15] = t10, $[16] = t11, $[17] = t9, $[18] = t12) : t12 = $[18];
  const actionHandlers = t12;
  let t13;
  $[19] !== actionHandlers || $[20] !== initialValueTemplates || $[21] !== menuItemGroups || $[22] !== menuItems ? (t13 = /* @__PURE__ */ jsx(PaneHeaderActions, { initialValueTemplateItems: initialValueTemplates, actionHandlers, menuItemGroups, menuItems }), $[19] = actionHandlers, $[20] = initialValueTemplates, $[21] = menuItemGroups, $[22] = menuItems, $[23] = t13) : t13 = $[23];
  let t14;
  $[24] !== features.backButton || $[25] !== index ? (t14 = features.backButton && index > 0 && /* @__PURE__ */ jsx(Button$1, { as: BackLink, "data-as": "a", icon: ArrowLeftIcon, mode: "bleed", tooltipProps: {
    content: "Back"
  } }), $[24] = features.backButton, $[25] = index, $[26] = t14) : t14 = $[26];
  let t15;
  return $[27] !== contentAfter || $[28] !== t13 || $[29] !== t14 || $[30] !== tabIndex || $[31] !== title ? (t15 = /* @__PURE__ */ jsx(TooltipDelayGroupProvider, { children: /* @__PURE__ */ jsx(PaneHeader$1, { actions: t13, backButton: t14, contentAfter, tabIndex, title }) }), $[27] = contentAfter, $[28] = t13, $[29] = t14, $[30] = tabIndex, $[31] = title, $[32] = t15) : t15 = $[32], t15;
});
PaneHeader.displayName = "Memo(PaneHeader)";
const addIdsToMenuItems = (menuItems) => menuItems?.map((item) => item.id ? item : {
  ...item,
  id: assignId(item)
}), addSelectedStateToMenuItems = (options) => {
  const {
    menuItems,
    sortOrderRaw,
    layout,
    customMenuItemState = {},
    schemaType,
    disabledSortReason
  } = options;
  return menuItems?.map((item) => {
    if (item.params?.layout)
      return {
        ...item,
        selected: layout === item.params?.layout
      };
    if (item?.params?.by) {
      const itemSortOrder = {
        by: item.params.by
      }, isInvalidSortOrder = validateSortOrder(itemSortOrder, schemaType, DEFAULT_ORDERING) !== itemSortOrder, staticSortBy = toStaticSortOrder({
        by: sortOrderRaw?.by ?? EMPTY_ARRAY$2
      }).by, itemSortBy = toStaticSortOrder({
        by: item?.params?.by ?? EMPTY_ARRAY$2
      }).by;
      return {
        ...item,
        selected: isEqual(staticSortBy, itemSortBy),
        ...isInvalidSortOrder && {
          disabled: {
            reason: disabledSortReason
          }
        }
      };
    }
    if (item.id && item.id in customMenuItemState) {
      const storedValue = customMenuItemState[item.id], itemValue = item.params?.value ?? !0;
      return {
        ...item,
        selected: isEqual(storedValue, itemValue)
      };
    }
    return {
      ...item,
      selected: item.selected ?? !1
    };
  });
};
function useShallowUnique(value) {
  const [previous, setPrevious] = useState(value);
  return shallowEquals(previous, value) ? previous : (setPrevious(value), value);
}
const PaneContainer = memo(function(props) {
  const $ = c(55), {
    index,
    isSelected,
    pane,
    paneKey
  } = props, {
    name: parentSourceName
  } = useSource(), {
    defaultLayout: t0,
    initialValueTemplates: t1,
    menuItemGroups,
    menuItems,
    options
  } = pane, defaultLayout = t0 === void 0 ? "default" : t0, initialValueTemplates = t1 === void 0 ? EMPTY_ARRAY$2 : t1, {
    defaultOrdering: t2,
    filter: filter2
  } = options, defaultOrdering = t2 === void 0 ? EMPTY_ARRAY$2 : t2, params = useShallowUnique(options.params || EMPTY_RECORD), sourceName = pane.source;
  let t3;
  bb0: {
    let t42;
    $[0] !== filter2 || $[1] !== params ? (t42 = findStaticTypesInFilter(filter2, params), $[0] = filter2, $[1] = params, $[2] = t42) : t42 = $[2];
    const staticTypes = t42;
    if (staticTypes?.length === 1) {
      t3 = staticTypes[0];
      break bb0;
    }
    t3 = null;
  }
  const typeName = t3, [layout, setLayout] = useStructureToolSetting("layout", typeName ?? pane.id, defaultLayout), {
    title
  } = useI18nText(pane);
  let t4;
  $[3] !== defaultOrdering ? (t4 = defaultOrdering?.length > 0 ? {
    by: defaultOrdering
  } : DEFAULT_ORDERING, $[3] = defaultOrdering, $[4] = t4) : t4 = $[4];
  const defaultSortOrder = t4, [storedSortOrderRaw, setStoredSortOrder] = useStructureToolSetting("sort-order", typeName ?? pane.id, defaultSortOrder), schema = useSchema();
  let t5;
  $[5] !== schema || $[6] !== typeName ? (t5 = typeName ? schema.get(typeName) : void 0, $[5] = schema, $[6] = typeName, $[7] = t5) : t5 = $[7];
  const schemaType = t5, {
    t
  } = useTranslation(structureLocaleNamespace);
  let t6;
  $[8] !== schemaType || $[9] !== storedSortOrderRaw ? (t6 = fromStaticSortOrder(storedSortOrderRaw, schemaType), $[8] = schemaType, $[9] = storedSortOrderRaw, $[10] = t6) : t6 = $[10];
  const sortOrderRaw = t6;
  let t7;
  bb1: {
    if (!sortOrderRaw) {
      t7 = sortOrderRaw;
      break bb1;
    }
    let t82;
    $[11] !== defaultSortOrder || $[12] !== schemaType || $[13] !== sortOrderRaw ? (t82 = validateSortOrder(sortOrderRaw, schemaType, defaultSortOrder), $[11] = defaultSortOrder, $[12] = schemaType, $[13] = sortOrderRaw, $[14] = t82) : t82 = $[14], t7 = t82;
  }
  const validatedSortOrder = t7;
  let t8;
  $[15] !== defaultSortOrder || $[16] !== schemaType || $[17] !== setStoredSortOrder ? (t8 = async (newSortOrder) => {
    const validated = validateSortOrder(newSortOrder, schemaType, defaultSortOrder);
    await setStoredSortOrder(toStaticSortOrder(validated));
  }, $[15] = defaultSortOrder, $[16] = schemaType, $[17] = setStoredSortOrder, $[18] = t8) : t8 = $[18];
  const handleSetSortOrder = t8;
  let t9;
  $[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = {}, $[19] = t9) : t9 = $[19];
  const [customMenuItemState, setCustomMenuItemState] = useState(t9);
  let t10;
  $[20] !== menuItems ? (t10 = addIdsToMenuItems(menuItems), $[20] = menuItems, $[21] = t10) : t10 = $[21];
  const menuItemsWithIds = t10;
  let t11;
  $[22] !== t ? (t11 = t("panes.document-list-pane.sort-order.disabled-reason"), $[22] = t, $[23] = t11) : t11 = $[23];
  const disabledSortReason = t11;
  let t12;
  $[24] !== customMenuItemState || $[25] !== disabledSortReason || $[26] !== layout || $[27] !== menuItemsWithIds || $[28] !== schemaType || $[29] !== validatedSortOrder ? (t12 = addSelectedStateToMenuItems({
    menuItems: menuItemsWithIds,
    sortOrderRaw: validatedSortOrder,
    layout,
    customMenuItemState,
    schemaType,
    disabledSortReason
  }), $[24] = customMenuItemState, $[25] = disabledSortReason, $[26] = layout, $[27] = menuItemsWithIds, $[28] = schemaType, $[29] = validatedSortOrder, $[30] = t12) : t12 = $[30];
  const menuItemsWithSelectedState = t12, t13 = sourceName || parentSourceName;
  let t14;
  $[31] !== pane.source ? (t14 = _DEBUG, $[31] = pane.source, $[32] = t14) : t14 = $[32];
  let t15;
  $[33] !== customMenuItemState || $[34] !== handleSetSortOrder || $[35] !== index || $[36] !== initialValueTemplates || $[37] !== menuItemGroups || $[38] !== menuItemsWithSelectedState || $[39] !== setLayout || $[40] !== title ? (t15 = /* @__PURE__ */ jsx(PaneHeader, { customMenuItemState, index, initialValueTemplates, menuItemGroups, menuItems: menuItemsWithSelectedState, setLayout, setSortOrder: handleSetSortOrder, setCustomMenuItemState, title }), $[33] = customMenuItemState, $[34] = handleSetSortOrder, $[35] = index, $[36] = initialValueTemplates, $[37] = menuItemGroups, $[38] = menuItemsWithSelectedState, $[39] = setLayout, $[40] = title, $[41] = t15) : t15 = $[41];
  let t16;
  $[42] !== layout || $[43] !== props || $[44] !== validatedSortOrder ? (t16 = /* @__PURE__ */ jsx(DocumentListPane, { ...props, sortOrder: validatedSortOrder, layout }), $[42] = layout, $[43] = props, $[44] = validatedSortOrder, $[45] = t16) : t16 = $[45];
  let t17;
  $[46] !== isSelected || $[47] !== paneKey || $[48] !== t14 || $[49] !== t15 || $[50] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Pane, { "data-ui": "DocumentListPane", id: paneKey, minWidth: 320, currentMaxWidth: 350, maxWidth: 640, selected: isSelected, children: [
    t14,
    t15,
    t16
  ] }), $[46] = isSelected, $[47] = paneKey, $[48] = t14, $[49] = t15, $[50] = t16, $[51] = t17) : t17 = $[51];
  let t18;
  return $[52] !== t13 || $[53] !== t17 ? (t18 = /* @__PURE__ */ jsx(SourceProvider, { name: t13, children: t17 }), $[52] = t13, $[53] = t17, $[54] = t18) : t18 = $[54], t18;
});
PaneContainer.displayName = "Memo(PaneContainer)";
const useLiveEditBadge = (props) => {
  const {
    liveEditSchemaType,
    version
  } = props;
  return liveEditSchemaType && !version ? {
    label: "Live",
    color: "danger"
  } : null;
};
useLiveEditBadge.displayName = "LiveEditBadge";
const state = {
  activePanes: []
};
function setActivePanes(panes) {
  state.activePanes = panes;
}
function getIntentState(intent, params, routerState, payload) {
  const panes = routerState?.panes || [], activePanes = state.activePanes || [], editDocumentId = params.id || uuid();
  for (let i = activePanes.length - 1; i >= 0; i--) {
    const pane = activePanes[i];
    if (typeof pane == "object" && (pane.canHandleIntent?.(intent, params, {
      pane,
      index: i
    }) || // see `resolveIntent.ts` for more info
    pane.type === "documentList" && pane.schemaTypeName === params.type && pane.options.filter === "_type == $type")) {
      const paneParams = getPaneParams(intent, params);
      return {
        panes: panes.slice(0, i).concat([[{
          id: editDocumentId,
          params: paneParams,
          payload
        }]])
      };
    }
  }
  return {
    intent,
    params,
    payload
  };
}
function getPaneParams(intent, {
  template,
  version,
  inspect,
  comment,
  task,
  scheduledDraft
}) {
  switch (intent) {
    case "create":
      return {
        template,
        version
      };
    case "edit":
      return {
        inspect,
        comment,
        task,
        scheduledDraft
      };
    default:
      return EMPTY_PARAMS$1;
  }
}
const Scroller$3 = styled(ScrollContainer).withConfig({
  displayName: "Scroller",
  componentId: "sc-jiqgdv-0"
})`height:100%;overflow:auto;position:relative;scroll-behavior:smooth;`, Grid$1 = styled(Box).withConfig({
  displayName: "Grid",
  componentId: "sc-jiqgdv-1"
})`&:not([hidden]){display:grid;}grid-template-columns:48px 1fr;align-items:center;gap:0.25em;`;
function ChangesInspector(t0) {
  const $ = c(39), {
    showChanges
  } = t0, {
    documentId,
    schemaType,
    timelineError,
    timelineStore,
    value
  } = useDocumentPane(), {
    selectedReleaseId
  } = usePerspective(), [scrollRef, setScrollRef] = useState(null), rev = useTimelineSelector(timelineStore, _temp$6), diff = useTimelineSelector(timelineStore, _temp2$3), onOlderRevision = useTimelineSelector(timelineStore, _temp3$2), selectionState = useTimelineSelector(timelineStore, _temp4$2), sinceTime = useTimelineSelector(timelineStore, _temp5$1), loading = selectionState === "loading", isComparingCurrent = !onOlderRevision, {
    t: structureT
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== diff || $[1] !== documentId || $[2] !== isComparingCurrent || $[3] !== schemaType || $[4] !== value ? (t1 = {
    documentId,
    schemaType,
    FieldWrapper: _temp6$1,
    rootDiff: diff,
    isComparingCurrent,
    value,
    showFromValue: !0
  }, $[0] = diff, $[1] = documentId, $[2] = isComparingCurrent, $[3] = schemaType, $[4] = value, $[5] = t1) : t1 = $[5];
  const documentContext = t1;
  if (selectedReleaseId) {
    let t22;
    return $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t22 = /* @__PURE__ */ jsx(Flex, { "data-testid": "review-changes-pane", direction: "column", height: "fill", children: /* @__PURE__ */ jsx(Card, { flex: 1, padding: 2, paddingTop: 0, children: /* @__PURE__ */ jsx(TimelineError, { versionError: !0 }) }) }), $[6] = t22) : t22 = $[6], t22;
  }
  let t2;
  $[7] !== structureT ? (t2 = structureT("changes.from.label"), $[7] = structureT, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: t2 }), $[9] = t2, $[10] = t3) : t3 = $[10];
  let t4;
  $[11] !== sinceTime ? (t4 = /* @__PURE__ */ jsx(TimelineMenu, { mode: "since", chunk: sinceTime, placement: "bottom-start" }), $[11] = sinceTime, $[12] = t4) : t4 = $[12];
  let t5;
  $[13] !== structureT ? (t5 = structureT("changes.to.label"), $[13] = structureT, $[14] = t5) : t5 = $[14];
  let t6;
  $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: t5 }), $[15] = t5, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== rev ? (t7 = /* @__PURE__ */ jsx(TimelineMenu, { chunk: rev, mode: "rev", placement: "bottom-end" }), $[17] = rev, $[18] = t7) : t7 = $[18];
  let t8;
  $[19] !== t3 || $[20] !== t4 || $[21] !== t6 || $[22] !== t7 ? (t8 = /* @__PURE__ */ jsx(Box, { padding: 3, children: /* @__PURE__ */ jsxs(Grid$1, { paddingX: 2, paddingBottom: 2, children: [
    t3,
    t4,
    t6,
    t7
  ] }) }), $[19] = t3, $[20] = t4, $[21] = t6, $[22] = t7, $[23] = t8) : t8 = $[23];
  let t9;
  $[24] !== diff || $[25] !== documentContext || $[26] !== loading || $[27] !== schemaType || $[28] !== showChanges || $[29] !== timelineError ? (t9 = showChanges && /* @__PURE__ */ jsx(Content$1, { diff, documentContext, error: timelineError, loading, schemaType }), $[24] = diff, $[25] = documentContext, $[26] = loading, $[27] = schemaType, $[28] = showChanges, $[29] = timelineError, $[30] = t9) : t9 = $[30];
  let t10;
  $[31] !== t9 ? (t10 = /* @__PURE__ */ jsx(Scroller$3, { "data-ui": "Scroller", ref: setScrollRef, children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingX: 3, height: "fill", children: t9 }) }), $[31] = t9, $[32] = t10) : t10 = $[32];
  let t11;
  $[33] !== scrollRef || $[34] !== t10 ? (t11 = /* @__PURE__ */ jsx(Card, { flex: 1, paddingX: 2, paddingY: 2, children: /* @__PURE__ */ jsx(BoundaryElementProvider, { element: scrollRef, children: t10 }) }), $[33] = scrollRef, $[34] = t10, $[35] = t11) : t11 = $[35];
  let t12;
  return $[36] !== t11 || $[37] !== t8 ? (t12 = /* @__PURE__ */ jsxs(Flex, { "data-testid": "review-changes-pane", direction: "column", height: "fill", overflow: "hidden", children: [
    t8,
    t11
  ] }), $[36] = t11, $[37] = t8, $[38] = t12) : t12 = $[38], t12;
}
function _temp6$1(props) {
  return /* @__PURE__ */ jsx(ChangeFieldWrapper, { ...props, hasRevertHover: !1 });
}
function _temp5$1(state_3) {
  return state_3.sinceTime;
}
function _temp4$2(state_2) {
  return state_2.selectionState;
}
function _temp3$2(state_1) {
  return state_1.onOlderRevision;
}
function _temp2$3(state_0) {
  return state_0.diff;
}
function _temp$6(state2) {
  return state2.revTime;
}
function Content$1(t0) {
  const $ = c(9), {
    error,
    diff,
    documentContext,
    loading,
    schemaType
  } = t0;
  if (error) {
    let t12;
    return $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(NoChanges, {}), $[0] = t12) : t12 = $[0], t12;
  }
  if (loading) {
    let t12;
    return $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[1] = t12) : t12 = $[1], t12;
  }
  if (!diff) {
    let t12;
    return $[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(NoChanges, {}), $[2] = t12) : t12 = $[2], t12;
  }
  let t1;
  $[3] !== diff || $[4] !== schemaType ? (t1 = /* @__PURE__ */ jsx(ChangeList, { diff, schemaType }), $[3] = diff, $[4] = schemaType, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== documentContext || $[7] !== t1 ? (t2 = /* @__PURE__ */ jsx(DocumentChangeContext.Provider, { value: documentContext, children: t1 }), $[6] = documentContext, $[7] = t1, $[8] = t2) : t2 = $[8], t2;
}
const getIsSelectable = (event) => !isDeleteDocumentVersionEvent(event) && !isDeleteDocumentGroupEvent(event) && !isUnpublishDocumentEvent(event) && !isScheduleDocumentVersionEvent(event) && !isUnscheduleDocumentVersionEvent(event);
function EventTimelineItem(t0) {
  const $ = c(27), {
    event,
    isSelected,
    onSelect,
    optionsMenu
  } = t0, {
    t
  } = useTranslation("studio");
  let t1;
  $[0] !== event ? (t1 = getIsSelectable(event), $[0] = event, $[1] = t1) : t1 = $[1];
  const isSelectable = t1;
  let t2;
  $[2] !== event || $[3] !== isSelectable || $[4] !== onSelect ? (t2 = (evt) => {
    evt.preventDefault(), evt.stopPropagation(), isSelectable && onSelect(event);
  }, $[2] = event, $[3] = isSelectable, $[4] = onSelect, $[5] = t2) : t2 = $[5];
  const handleClick = t2;
  let t3;
  $[6] !== isSelectable || $[7] !== t ? (t3 = isSelectable ? "" : t("changes.not-selectable"), $[6] = isSelectable, $[7] = t, $[8] = t3) : t3 = $[8];
  const t4 = isSelectable ? "button" : "div", t5 = isSelectable ? "pointer" : "default";
  let t6;
  $[9] !== t5 ? (t6 = {
    cursor: t5,
    width: "100%"
  }, $[9] = t5, $[10] = t6) : t6 = $[10];
  let t7;
  $[11] !== event ? (t7 = /* @__PURE__ */ jsx(Event, { event, showChangesBy: "tooltip" }), $[11] = event, $[12] = t7) : t7 = $[12];
  let t8;
  $[13] !== event.timestamp || $[14] !== handleClick || $[15] !== isSelected || $[16] !== t4 || $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsx(Card, { as: t4, onClick: handleClick, padding: 2, pressed: isSelected, radius: 2, "data-ui": "timelineItem", "data-testid": "timeline-item-button", "data-chunk-timestamp": event.timestamp, style: t6, children: t7 }), $[13] = event.timestamp, $[14] = handleClick, $[15] = isSelected, $[16] = t4, $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== isSelectable || $[21] !== t3 || $[22] !== t8 ? (t9 = /* @__PURE__ */ jsx(Tooltip, { content: t3, disabled: isSelectable, children: t8 }), $[20] = isSelectable, $[21] = t3, $[22] = t8, $[23] = t9) : t9 = $[23];
  let t10;
  return $[24] !== optionsMenu || $[25] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Flex, { gap: 1, children: [
    t9,
    optionsMenu
  ] }), $[24] = optionsMenu, $[25] = t9, $[26] = t10) : t10 = $[26], t10;
}
function PublishedEventMenu(t0) {
  const $ = c(47), {
    event
  } = t0, {
    t
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation(), portalContext = usePortal(), {
    params,
    setParams
  } = usePaneRouter(), setPerspective = useSetPerspective(), {
    document: document2
  } = useWorkspace(), {
    drafts: t1
  } = document2, {
    enabled: isDraftModelEnabled
  } = t1;
  let t2;
  $[0] !== event.id || $[1] !== event.versionId || $[2] !== event.versionRevisionId || $[3] !== params || $[4] !== setParams ? (t2 = () => {
    setParams({
      ...params,
      rev: event.versionRevisionId || "@lastPublished",
      since: void 0,
      historyEvent: event.id,
      historyVersion: getVersionFromId(event.versionId)
    });
  }, $[0] = event.id, $[1] = event.versionId, $[2] = event.versionRevisionId, $[3] = params, $[4] = setParams, $[5] = t2) : t2 = $[5];
  const handleOpenReleaseDocument = t2;
  let t3;
  $[6] !== event.versionRevisionId || $[7] !== isDraftModelEnabled || $[8] !== params || $[9] !== setParams || $[10] !== setPerspective ? (t3 = () => {
    setParams({
      ...params,
      rev: event.versionRevisionId,
      preserveRev: "true",
      since: void 0
    }), setTimeout(() => {
      setPerspective(isDraftModelEnabled ? "drafts" : "published");
    }, 100);
  }, $[6] = event.versionRevisionId, $[7] = isDraftModelEnabled, $[8] = params, $[9] = setParams, $[10] = setPerspective, $[11] = t3) : t3 = $[11];
  const handleOpenDraftDocument = t3, releaseTitle = event.release?.metadata?.title;
  let t4;
  $[12] !== tCore ? (t4 = tCore("release.placeholder-untitled-release"), $[12] = tCore, $[13] = t4) : t4 = $[13];
  const releaseFallback = t4;
  let t5;
  $[14] !== event.release ? (t5 = (t62) => {
    const {
      children
    } = t62;
    return /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: event.release ? isReleaseDocument(event.release) ? getReleaseTone(event.release) : "default" : void 0, children });
  }, $[14] = event.release, $[15] = t5) : t5 = $[15];
  const VersionBadge = t5;
  let t6;
  $[16] !== event.release ? (t6 = event.release && !isReleaseDocument(event.release), $[16] = event.release, $[17] = t6) : t6 = $[17];
  const isMenuDisabled = t6, t7 = `timeline-item-menu-button-${event.versionId}`;
  let t8;
  $[18] !== t ? (t8 = t("timeline-item.menu-button.aria-label"), $[18] = t, $[19] = t8) : t8 = $[19];
  let t9;
  $[20] !== event.release || $[21] !== isMenuDisabled || $[22] !== t ? (t9 = isMenuDisabled ? t("timeline-item.not-found-release.tooltip", {
    releaseId: event.release?._id ? getReleaseIdFromReleaseDocumentId(event.release._id) : void 0
  }) : t("timeline-item.menu-button.tooltip"), $[20] = event.release, $[21] = isMenuDisabled, $[22] = t, $[23] = t9) : t9 = $[23];
  let t10;
  $[24] !== t9 ? (t10 = {
    content: t9
  }, $[24] = t9, $[25] = t10) : t10 = $[25];
  let t11;
  $[26] !== isMenuDisabled || $[27] !== t10 || $[28] !== t8 ? (t11 = /* @__PURE__ */ jsx(ContextMenuButton, { "aria-label": t8, tooltipProps: t10, disabled: isMenuDisabled }), $[26] = isMenuDisabled, $[27] = t10, $[28] = t8, $[29] = t11) : t11 = $[29];
  let t12;
  $[30] !== VersionBadge || $[31] !== event.release || $[32] !== event.versionRevisionId || $[33] !== handleOpenDraftDocument || $[34] !== handleOpenReleaseDocument || $[35] !== releaseFallback || $[36] !== releaseTitle || $[37] !== t ? (t12 = /* @__PURE__ */ jsx(Menu, { padding: 1, children: event.release ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IntentLink, { intent: RELEASES_INTENT, params: {
      id: getReleaseIdFromReleaseDocumentId(event.release._id)
    }, style: {
      textDecoration: "none"
    }, children: /* @__PURE__ */ jsx(MenuItem, { padding: 3, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "flex-start", children: /* @__PURE__ */ jsx(Text, { size: 1, style: {
      textDecoration: "none"
    }, children: /* @__PURE__ */ jsx(ReleaseTitle, { title: releaseTitle, fallback: releaseFallback, children: (t132) => {
      const {
        displayTitle
      } = t132;
      return /* @__PURE__ */ jsx(Translate, { components: {
        VersionBadge: (t142) => {
          const {
            children: children_0
          } = t142;
          return /* @__PURE__ */ jsx(VersionBadge, { children: children_0 });
        }
      }, i18nKey: "events.open.release", values: {
        releaseTitle: displayTitle
      }, t });
    } }) }) }) }) }),
    /* @__PURE__ */ jsx(MenuItem, { onClick: handleOpenReleaseDocument, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "flex-start", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(ReleaseTitle, { title: releaseTitle, fallback: releaseFallback, children: (t152) => {
      const {
        displayTitle: displayTitle_0
      } = t152;
      return /* @__PURE__ */ jsx(Translate, { components: {
        VersionBadge: (t162) => {
          const {
            children: children_1
          } = t162;
          return /* @__PURE__ */ jsx(VersionBadge, { children: children_1 });
        }
      }, i18nKey: "events.inspect.release", values: {
        releaseTitle: displayTitle_0
      }, t });
    } }) }) }) })
  ] }) : /* @__PURE__ */ jsx(MenuItem, { onClick: handleOpenDraftDocument, disabled: !event.versionRevisionId, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { components: {
    VersionBadge: _temp$5
  }, i18nKey: "events.open.draft", t }) }) }) }) }), $[30] = VersionBadge, $[31] = event.release, $[32] = event.versionRevisionId, $[33] = handleOpenDraftDocument, $[34] = handleOpenReleaseDocument, $[35] = releaseFallback, $[36] = releaseTitle, $[37] = t, $[38] = t12) : t12 = $[38];
  const t13 = portalContext.elements?.[TIMELINE_MENU_PORTAL$1] ? TIMELINE_MENU_PORTAL$1 : !0;
  let t14;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t14 = ["bottom-end", "bottom-start"], $[39] = t14) : t14 = $[39];
  let t15;
  $[40] !== t13 ? (t15 = {
    portal: t13,
    placement: "bottom",
    fallbackPlacements: t14
  }, $[40] = t13, $[41] = t15) : t15 = $[41];
  let t16;
  return $[42] !== t11 || $[43] !== t12 || $[44] !== t15 || $[45] !== t7 ? (t16 = /* @__PURE__ */ jsx(MenuButton, { id: t7, button: t11, menu: t12, popover: t15 }), $[42] = t11, $[43] = t12, $[44] = t15, $[45] = t7, $[46] = t16) : t16 = $[46], t16;
}
function _temp$5(t0) {
  const {
    children: children_2
  } = t0;
  return /* @__PURE__ */ jsx(VersionInlineBadge, { $tone: "caution", children: children_2 });
}
const TimelineItemWrapper = motion.create(Box), CHILDREN_ITEMS_VARIANTS = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, ITEM_HEIGHT = 57, TIMELINE_LIST_WRAPPER_ID = "timeline-list-wrapper", EventsTimeline = (t0) => {
  const $ = c(38), {
    events: allEvents,
    hasMoreEvents,
    selectedEventId,
    onLoadMore,
    onSelect,
    listMaxHeight: t1,
    fetchEventChildren
  } = t0, listMaxHeight = t1 === void 0 ? "calc(100vh - 280px)" : t1, [mounted, setMounted] = useState(!1), {
    t
  } = useTranslation("studio");
  let t2;
  $[0] !== allEvents || $[1] !== selectedEventId ? (t2 = () => {
    if (selectedEventId) {
      const selectedEvent = allEvents.find((event) => event.id === selectedEventId);
      if (selectedEvent && "parentId" in selectedEvent && selectedEvent.parentId)
        return /* @__PURE__ */ new Set([selectedEvent.parentId]);
    }
    return /* @__PURE__ */ new Set();
  }, $[0] = allEvents, $[1] = selectedEventId, $[2] = t2) : t2 = $[2];
  const [expandedParents, setExpandedParents] = useState(t2);
  let t3;
  $[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = /* @__PURE__ */ new Set(), $[3] = t3) : t3 = $[3];
  const [expandingParents, setExpandingParents] = useState(t3);
  let t4;
  $[4] !== allEvents || $[5] !== expandedParents ? (t4 = allEvents.filter((event_0) => isCreateDocumentVersionEvent(event_0) && event_0.parentId ? allEvents[allEvents.length - 1].id === event_0.id ? !0 : expandedParents.has(event_0.parentId) : isEditDocumentVersionEvent(event_0) && event_0.parentId ? expandedParents.has(event_0.parentId) : !0), $[4] = allEvents, $[5] = expandedParents, $[6] = t4) : t4 = $[6];
  const events = t4;
  let t5;
  $[7] !== fetchEventChildren ? (t5 = (event_1) => async () => {
    const parentId = event_1.id;
    let isExpanding = !1;
    setExpandedParents((prev) => {
      const next = new Set(prev);
      return prev.has(parentId) ? next.delete(parentId) : (isExpanding = !0, next.add(parentId)), next;
    }), isExpanding && (setExpandingParents((prev_0) => {
      const next_0 = new Set(prev_0);
      return next_0.add(parentId), next_0;
    }), await fetchEventChildren(event_1), setExpandingParents((prev_1) => {
      const next_1 = new Set(prev_1);
      return next_1.delete(parentId), next_1;
    }));
  }, $[7] = fetchEventChildren, $[8] = t5) : t5 = $[8];
  const handleExpandParent = t5;
  let t6;
  $[9] !== onSelect ? (t6 = (event_2) => {
    onSelect(event_2);
  }, $[9] = onSelect, $[10] = t6) : t6 = $[10];
  const handleSelectChunk = t6;
  let t7;
  $[11] !== expandedParents || $[12] !== handleExpandParent ? (t7 = (event_3) => {
    const documentVariantType = getDocumentVariantType(event_3.documentId);
    return isPublishDocumentVersionEvent(event_3) && documentVariantType === "published" ? /* @__PURE__ */ jsx(PublishedEventMenu, { event: event_3 }) : isPublishDocumentVersionEvent(event_3) && documentVariantType === "draft" && event_3.creationEvent || isDeleteDocumentVersionEvent(event_3) && event_3.creationEvent ? /* @__PURE__ */ jsx(ExpandableTimelineItemButton, { isExpanded: expandedParents.has(event_3.id), onExpand: handleExpandParent(event_3) }) : null;
  }, $[11] = expandedParents, $[12] = handleExpandParent, $[13] = t7) : t7 = $[13];
  const renderOptionsMenu = t7;
  let t8;
  $[14] !== events.length || $[15] !== expandingParents || $[16] !== handleSelectChunk || $[17] !== hasMoreEvents || $[18] !== renderOptionsMenu || $[19] !== selectedEventId ? (t8 = (event_4, t92) => {
    const {
      activeIndex
    } = t92, showExpandingLoader = isCreateDocumentVersionEvent(event_4) && event_4.parentId && expandingParents.has(event_4.parentId), isLastEvent_0 = activeIndex === events.length - 1;
    return showExpandingLoader ? /* @__PURE__ */ jsx(TimelineItemWrapper, { animate: {
      opacity: 1
    }, initial: {
      opacity: 0
    }, transition: {
      duration: 0.2,
      delay: 0.2
    }, children: /* @__PURE__ */ jsx(Flex, { align: "center", justify: "center", style: {
      height: ITEM_HEIGHT
    }, children: /* @__PURE__ */ jsx(Spinner, {}) }) }) : /* @__PURE__ */ jsxs(TimelineItemWrapper, { paddingBottom: 1, paddingRight: 1, animate: "animate", exit: "exit", initial: "initial", variants: "parentId" in event_4 ? CHILDREN_ITEMS_VARIANTS : void 0, paddingLeft: (isEditDocumentVersionEvent(event_4) || isCreateDocumentVersionEvent(event_4)) && event_4.parentId && !isLastEvent_0 ? 4 : 1, children: [
      /* @__PURE__ */ jsx(EventTimelineItem, { event: event_4, isSelected: event_4.id === selectedEventId, onSelect: handleSelectChunk, optionsMenu: renderOptionsMenu(event_4) }),
      isLastEvent_0 && hasMoreEvents && /* @__PURE__ */ jsx(LoadingBlock, {})
    ] }, event_4.timestamp);
  }, $[14] = events.length, $[15] = expandingParents, $[16] = handleSelectChunk, $[17] = hasMoreEvents, $[18] = renderOptionsMenu, $[19] = selectedEventId, $[20] = t8) : t8 = $[20];
  const renderItem = t8;
  let t10, t9;
  $[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t9 = () => setMounted(!0), t10 = [], $[21] = t10, $[22] = t9) : (t10 = $[21], t9 = $[22]), useEffect(t9, t10);
  let t11;
  if ($[23] !== events || $[24] !== selectedEventId) {
    let t122;
    $[26] !== selectedEventId ? (t122 = (event_5) => event_5.id === selectedEventId, $[26] = selectedEventId, $[27] = t122) : t122 = $[27], t11 = events.findIndex(t122), $[23] = events, $[24] = selectedEventId, $[25] = t11;
  } else
    t11 = $[25];
  const selectedIndex = t11, t12 = !selectedIndex || mounted;
  let t13;
  $[28] !== events || $[29] !== listMaxHeight || $[30] !== onLoadMore || $[31] !== renderItem || $[32] !== selectedIndex || $[33] !== t ? (t13 = events.length > 0 ? /* @__PURE__ */ jsx(ListWrapper, { direction: "column", $maxHeight: listMaxHeight, id: TIMELINE_LIST_WRAPPER_ID, children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("timeline.list.aria-label"), autoFocus: "list", initialIndex: selectedIndex, initialScrollAlign: "center", itemHeight: ITEM_HEIGHT, items: events, onEndReached: onLoadMore, onEndReachedIndexOffset: 20, overscan: 5, renderItem, wrapAround: !1 }) }) : /* @__PURE__ */ jsxs(Stack, { padding: 3, space: 3, children: [
    /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t("timeline.error.no-document-history-title") }),
    /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("timeline.error.no-document-history-description") })
  ] }), $[28] = events, $[29] = listMaxHeight, $[30] = onLoadMore, $[31] = renderItem, $[32] = selectedIndex, $[33] = t, $[34] = t13) : t13 = $[34];
  let t14;
  return $[35] !== t12 || $[36] !== t13 ? (t14 = /* @__PURE__ */ jsx(Root$3, { $visible: t12, "data-ui": "timeline", children: t13 }), $[35] = t12, $[36] = t13, $[37] = t14) : t14 = $[37], t14;
};
EventsTimeline.displayName = "EventsTimeline";
const Root = styled(Popover).withConfig({
  displayName: "Root",
  componentId: "sc-mrgvta-0"
})`overflow:hidden;overflow:clip;`, TIMELINE_MENU_PORTAL = "timeline-menu", formatParams = {
  timestamp: {
    dateStyle: "medium",
    timeStyle: "short"
  }
};
function EventsTimelineMenu(t0) {
  const $ = c(58), {
    event,
    events,
    mode,
    placement
  } = t0, {
    setTimelineRange
  } = useDocumentPane(), [open, setOpen] = useState(!1), [button, setButton] = useState(null), [popoverRef, setPopoverRef] = useState(null), toast = useToast(), {
    nextCursor,
    loading,
    error: eventsError,
    findRangeForRevision,
    findRangeForSince,
    loadMoreEvents,
    expandEvent
  } = useEvents(), {
    t
  } = useTranslation("studio");
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
    setOpen(!0);
  }, $[0] = t1) : t1 = $[0];
  const handleOpen = t1;
  let t2;
  $[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t2 = () => {
    setOpen(!1);
  }, $[1] = t2) : t2 = $[1];
  const handleClose = t2;
  let t3;
  $[2] !== button || $[3] !== open ? (t3 = (e) => {
    open && (e.key === "Escape" || e.key === "Tab") && (handleClose(), button?.focus());
  }, $[2] = button, $[3] = open, $[4] = t3) : t3 = $[4], useGlobalKeyDown(t3);
  let t4;
  $[5] !== button || $[6] !== popoverRef ? (t4 = () => [button, popoverRef], $[5] = button, $[6] = popoverRef, $[7] = t4) : t4 = $[7], useClickOutsideEvent(open && handleClose, t4);
  let t5;
  $[8] !== findRangeForRevision || $[9] !== setTimelineRange || $[10] !== t || $[11] !== toast ? (t5 = (revEvent) => {
    const run = () => {
      if (isDeleteDocumentVersionEvent(revEvent) || isDeleteDocumentGroupEvent(revEvent) || isUnpublishDocumentEvent(revEvent) || isScheduleDocumentVersionEvent(revEvent) || isUnscheduleDocumentVersionEvent(revEvent)) {
        console.error("Event is not selectable");
        return;
      }
      const [since, rev] = findRangeForRevision(revEvent?.id);
      setTimelineRange(since, rev), handleClose();
    };
    try {
      run();
    } catch (t62) {
      const err = t62;
      toast.push({
        closable: !0,
        description: err.message,
        status: "error",
        title: t("timeline.error.unable-to-load-revision")
      });
    }
  }, $[8] = findRangeForRevision, $[9] = setTimelineRange, $[10] = t, $[11] = toast, $[12] = t5) : t5 = $[12];
  const selectRev = t5;
  let t6;
  $[13] !== findRangeForSince || $[14] !== setTimelineRange || $[15] !== t || $[16] !== toast ? (t6 = (sinceEvent) => {
    try {
      const [since_0, rev_0] = findRangeForSince(sinceEvent.id);
      setTimelineRange(since_0, rev_0), handleClose();
    } catch (t72) {
      const err_0 = t72;
      toast.push({
        closable: !0,
        description: err_0.message,
        status: "error",
        title: t("timeline.error.unable-to-load-revision")
      });
    }
  }, $[13] = findRangeForSince, $[14] = setTimelineRange, $[15] = t, $[16] = toast, $[17] = t6) : t6 = $[17];
  const selectSince = t6;
  let t7;
  $[18] !== loadMoreEvents || $[19] !== loading || $[20] !== nextCursor ? (t7 = () => {
    !loading && nextCursor && loadMoreEvents();
  }, $[18] = loadMoreEvents, $[19] = loading, $[20] = nextCursor, $[21] = t7) : t7 = $[21];
  const handleLoadMore = t7;
  let t8;
  bb0: {
    if (eventsError) {
      let t93;
      $[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t93 = /* @__PURE__ */ jsx(TimelineError, {}), $[22] = t93) : t93 = $[22], t8 = t93;
      break bb0;
    }
    const t92 = !!nextCursor, t102 = event?.id, t112 = mode === "rev" ? selectRev : selectSince;
    let t122;
    $[23] !== events || $[24] !== expandEvent || $[25] !== handleLoadMore || $[26] !== t102 || $[27] !== t112 || $[28] !== t92 ? (t122 = /* @__PURE__ */ jsx(EventsTimeline, { events, fetchEventChildren: expandEvent, hasMoreEvents: t92, selectedEventId: t102, onLoadMore: handleLoadMore, onSelect: t112 }), $[23] = events, $[24] = expandEvent, $[25] = handleLoadMore, $[26] = t102, $[27] = t112, $[28] = t92, $[29] = t122) : t122 = $[29], t8 = t122;
  }
  const content = t8;
  let t9;
  $[30] !== event || $[31] !== t ? (t9 = event ? t(TIMELINE_ITEM_I18N_KEY_MAPPING$1[event.documentVariantType][event.type], {
    context: "timestamp",
    timestamp: new Date(event.timestamp),
    formatParams
  }) : t("timeline.latest-revision"), $[30] = event, $[31] = t, $[32] = t9) : t9 = $[32];
  const revLabel = t9;
  let t10;
  $[33] !== event || $[34] !== events || $[35] !== t ? (t10 = event ? t(TIMELINE_ITEM_I18N_KEY_MAPPING$1[event.documentVariantType][event.type], {
    context: "timestamp",
    timestamp: new Date(event.timestamp),
    formatParams
  }) : events.length > 0 ? t("timeline.since-version-missing") : t("timeline.no-previous-events"), $[33] = event, $[34] = events, $[35] = t, $[36] = t10) : t10 = $[36];
  const buttonLabel = mode === "rev" ? revLabel : t10;
  let t11;
  $[37] !== popoverRef ? (t11 = {
    [TIMELINE_MENU_PORTAL]: popoverRef
  }, $[37] = popoverRef, $[38] = t11) : t11 = $[38];
  const portalElements = t11, t12 = open && content, t13 = open ? "timeline-menu-close-button" : "timeline-menu-open-button", t14 = loading || !events.length, t15 = open ? handleClose : handleOpen;
  let t16;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t16 = {
    maxWidth: "100%"
  }, $[39] = t16) : t16 = $[39];
  let t17;
  $[40] !== buttonLabel || $[41] !== loading || $[42] !== t ? (t17 = loading ? t("timeline.loading-history") : buttonLabel, $[40] = buttonLabel, $[41] = loading, $[42] = t, $[43] = t17) : t17 = $[43];
  let t18;
  $[44] !== open || $[45] !== t13 || $[46] !== t14 || $[47] !== t15 || $[48] !== t17 ? (t18 = /* @__PURE__ */ jsx(Flex, { width: "fill", children: /* @__PURE__ */ jsx(Button$1, { "data-testid": t13, disabled: t14, mode: "ghost", onClick: t15, ref: setButton, selected: open, width: "fill", tooltipProps: null, justify: "space-between", style: t16, iconRight: ChevronDownIcon, text: t17 }) }), $[44] = open, $[45] = t13, $[46] = t14, $[47] = t15, $[48] = t17, $[49] = t18) : t18 = $[49];
  let t19;
  $[50] !== open || $[51] !== placement || $[52] !== t12 || $[53] !== t18 ? (t19 = /* @__PURE__ */ jsx(Root, { "data-testid": "timeline-menu", constrainSize: !0, content: t12, "data-ui": "versionMenu", open, placement, matchReferenceWidth: !0, portal: !0, ref: setPopoverRef, children: t18 }), $[50] = open, $[51] = placement, $[52] = t12, $[53] = t18, $[54] = t19) : t19 = $[54];
  let t20;
  return $[55] !== portalElements || $[56] !== t19 ? (t20 = /* @__PURE__ */ jsx(PortalProvider, { __unstable_elements: portalElements, children: t19 }), $[55] = portalElements, $[56] = t19, $[57] = t20) : t20 = $[57], t20;
}
const Scroller$2 = styled(ScrollContainer).withConfig({
  displayName: "Scroller",
  componentId: "sc-qjtu5v-0"
})`height:100%;overflow:auto;position:relative;scroll-behavior:smooth;`, Grid = styled(Box).withConfig({
  displayName: "Grid",
  componentId: "sc-qjtu5v-1"
})`&:not([hidden]){display:grid;}grid-template-columns:48px 1fr;align-items:center;gap:0.25em;`, SpinnerContainer = styled(Flex).withConfig({
  displayName: "SpinnerContainer",
  componentId: "sc-qjtu5v-2"
})`width:100%;position:absolute;bottom:-4px;`, DIFF_INITIAL_VALUE = {
  diff: null,
  loading: !0,
  error: null
}, CompareWithPublishedView = () => {
  const $ = c(31), {
    documentId,
    schemaType,
    editState,
    displayed
  } = useDocumentPane(), {
    selectedPerspective,
    selectedPerspectiveName,
    selectedReleaseId
  } = usePerspective(), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t0;
  $[0] !== displayed || $[1] !== editState?.published ? (t0 = diffInput(wrap(editState?.published ?? {}, {
    author: ""
  }), wrap(displayed ?? {}, {
    author: ""
  })), $[0] = displayed, $[1] = editState?.published, $[2] = t0) : t0 = $[2];
  const rootDiff = t0;
  if (selectedReleaseId && !editState?.version || selectedPerspective === "drafts" && !editState?.draft || selectedPerspectiveName === "published" || !displayed?._rev)
    return null;
  let t1;
  $[3] !== t ? (t1 = t("events.compare-with-published.title"), $[3] = t, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t1 }), $[5] = t1, $[6] = t2) : t2 = $[6];
  let t3;
  $[7] !== selectedPerspective ? (t3 = isReleaseDocument(selectedPerspective) ? selectedPerspective.metadata?.title : "draft", $[7] = selectedPerspective, $[8] = t3) : t3 = $[8];
  let t4;
  $[9] !== t3 ? (t4 = {
    version: t3
  }, $[9] = t3, $[10] = t4) : t4 = $[10];
  let t5;
  $[11] !== t || $[12] !== t4 ? (t5 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "events.compare-with-published.description", t, values: t4 }) }), $[11] = t, $[12] = t4, $[13] = t5) : t5 = $[13];
  let t6;
  $[14] !== t2 || $[15] !== t5 ? (t6 = /* @__PURE__ */ jsx(Card, { borderBottom: !0, paddingBottom: 3, children: /* @__PURE__ */ jsxs(Stack, { space: 3, paddingTop: 1, children: [
    t2,
    t5
  ] }) }), $[14] = t2, $[15] = t5, $[16] = t6) : t6 = $[16];
  let t7;
  $[17] !== displayed || $[18] !== documentId || $[19] !== rootDiff || $[20] !== schemaType ? (t7 = {
    documentId,
    schemaType,
    rootDiff,
    isComparingCurrent: !0,
    FieldWrapper: _temp$4,
    value: displayed,
    showFromValue: !0
  }, $[17] = displayed, $[18] = documentId, $[19] = rootDiff, $[20] = schemaType, $[21] = t7) : t7 = $[21];
  let t8;
  $[22] !== rootDiff || $[23] !== schemaType ? (t8 = /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(ChangeList, { diff: rootDiff, schemaType }) }), $[22] = rootDiff, $[23] = schemaType, $[24] = t8) : t8 = $[24];
  let t9;
  $[25] !== t7 || $[26] !== t8 ? (t9 = /* @__PURE__ */ jsx(DocumentChangeContext.Provider, { value: t7, children: t8 }), $[25] = t7, $[26] = t8, $[27] = t9) : t9 = $[27];
  let t10;
  return $[28] !== t6 || $[29] !== t9 ? (t10 = /* @__PURE__ */ jsxs(Stack, { space: 2, marginBottom: 3, children: [
    t6,
    t9
  ] }), $[28] = t6, $[29] = t9, $[30] = t10) : t10 = $[30], t10;
};
function EventsInspector(t0) {
  const $ = c(83), {
    showChanges
  } = t0, {
    documentId,
    schemaType,
    timelineError,
    value,
    formState
  } = useDocumentPane(), [scrollRef, setScrollRef] = useState(null), {
    events,
    revision,
    sinceRevision,
    getChangesList
  } = useEvents(), isComparingCurrent = !revision?.revisionId;
  let t1;
  $[0] !== getChangesList ? (t1 = getChangesList(), $[0] = getChangesList, $[1] = t1) : t1 = $[1];
  const changesList$ = t1, {
    diff,
    loading: diffLoading,
    error: diffError
  } = useObservable(changesList$, DIFF_INITIAL_VALUE), {
    t
  } = useTranslation("studio");
  let t2;
  $[2] !== diff || $[3] !== documentId || $[4] !== formState?.readOnly || $[5] !== isComparingCurrent || $[6] !== schemaType || $[7] !== value ? (t2 = () => ({
    documentId,
    schemaType,
    FieldWrapper: _temp2$2,
    rootDiff: diff,
    isComparingCurrent: isComparingCurrent && !formState?.readOnly,
    value,
    showFromValue: !0
  }), $[2] = diff, $[3] = documentId, $[4] = formState?.readOnly, $[5] = isComparingCurrent, $[6] = schemaType, $[7] = value, $[8] = t2) : t2 = $[8];
  let t3;
  $[9] !== t2 ? (t3 = t2(), $[9] = t2, $[10] = t3) : t3 = $[10];
  const documentContext = t3;
  let t4;
  bb0: {
    if (!events) {
      let t53;
      $[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t53 = [null, null], $[11] = t53) : t53 = $[11], t4 = t53;
      break bb0;
    }
    let t52;
    $[12] !== events || $[13] !== sinceRevision?.revisionId ? (t52 = events.find((e) => e.id === sinceRevision?.revisionId) || null, $[12] = events, $[13] = sinceRevision?.revisionId, $[14] = t52) : t52 = $[14];
    let t62;
    $[15] !== events || $[16] !== revision?.revisionId ? (t62 = events.find((e_0) => e_0.id === revision?.revisionId) || events[0], $[15] = events, $[16] = revision?.revisionId, $[17] = t62) : t62 = $[17];
    let t72;
    $[18] !== t52 || $[19] !== t62 ? (t72 = [t52, t62], $[18] = t52, $[19] = t62, $[20] = t72) : t72 = $[20], t4 = t72;
  }
  const [sinceEvent, toEvent] = t4;
  let t5;
  bb1: {
    if (!toEvent) {
      let t63;
      $[21] !== events ? (t63 = events.slice(1), $[21] = events, $[22] = t63) : t63 = $[22], t5 = t63;
      break bb1;
    }
    let t62;
    if ($[23] !== events || $[24] !== toEvent) {
      let t72;
      $[26] !== toEvent ? (t72 = (event) => "parentId" in toEvent && "parentId" in event && event.parentId === toEvent.parentId || "parentId" in event && toEvent.id === event.parentId ? {
        ...event,
        parentId: void 0
      } : event, $[26] = toEvent, $[27] = t72) : t72 = $[27], t62 = events.slice(events.indexOf(toEvent) + 1).map(t72), $[23] = events, $[24] = toEvent, $[25] = t62;
    } else
      t62 = $[25];
    t5 = t62;
  }
  const sinceEvents = t5;
  if (!events.length) {
    let t62;
    $[28] !== t ? (t62 = t("timeline.error.no-document-history-title"), $[28] = t, $[29] = t62) : t62 = $[29];
    let t72;
    $[30] !== t62 ? (t72 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: t62 }), $[30] = t62, $[31] = t72) : t72 = $[31];
    let t82;
    $[32] !== t ? (t82 = t("timeline.error.no-document-history-description"), $[32] = t, $[33] = t82) : t82 = $[33];
    let t92;
    $[34] !== t82 ? (t92 = /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t82 }), $[34] = t82, $[35] = t92) : t92 = $[35];
    let t102;
    return $[36] !== t72 || $[37] !== t92 ? (t102 = /* @__PURE__ */ jsx(Box, { paddingX: 2, children: /* @__PURE__ */ jsxs(Stack, { padding: 3, space: 3, children: [
      t72,
      t92
    ] }) }), $[36] = t72, $[37] = t92, $[38] = t102) : t102 = $[38], t102;
  }
  let t6;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t6 = {
    position: "relative"
  }, $[39] = t6) : t6 = $[39];
  let t7;
  $[40] !== t ? (t7 = t("changes.inspector.from-label"), $[40] = t, $[41] = t7) : t7 = $[41];
  let t8;
  $[42] !== t7 ? (t8 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: t7 }), $[42] = t7, $[43] = t8) : t8 = $[43];
  const t9 = sinceEvent || null;
  let t10;
  $[44] !== sinceEvents || $[45] !== t9 ? (t10 = /* @__PURE__ */ jsx(EventsTimelineMenu, { event: t9, events: sinceEvents, mode: "since", placement: "bottom-start" }), $[44] = sinceEvents, $[45] = t9, $[46] = t10) : t10 = $[46];
  let t11;
  $[47] !== t ? (t11 = t("changes.inspector.to-label"), $[47] = t, $[48] = t11) : t11 = $[48];
  let t12;
  $[49] !== t11 ? (t12 = /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: t11 }), $[49] = t11, $[50] = t12) : t12 = $[50];
  const t13 = toEvent || null;
  let t14;
  $[51] !== events || $[52] !== t13 ? (t14 = /* @__PURE__ */ jsx(EventsTimelineMenu, { event: t13, events, mode: "rev", placement: "bottom-end" }), $[51] = events, $[52] = t13, $[53] = t14) : t14 = $[53];
  let t15;
  $[54] !== t10 || $[55] !== t12 || $[56] !== t14 || $[57] !== t8 ? (t15 = /* @__PURE__ */ jsxs(Grid, { paddingX: 2, paddingBottom: 2, children: [
    t8,
    t10,
    t12,
    t14
  ] }), $[54] = t10, $[55] = t12, $[56] = t14, $[57] = t8, $[58] = t15) : t15 = $[58];
  let t16;
  $[59] !== diffLoading || $[60] !== t ? (t16 = diffLoading && /* @__PURE__ */ jsx(motion.div, { animate: {
    opacity: 1
  }, initial: {
    opacity: 0
  }, transition: {
    delay: 0.2,
    duration: 0.2
  }, children: /* @__PURE__ */ jsxs(SpinnerContainer, { justify: "center", align: "center", gap: 2, children: [
    /* @__PURE__ */ jsx(Text, { muted: !0, size: 0, children: t("changes.loading-changes") }),
    /* @__PURE__ */ jsx(Spinner, { size: 0 })
  ] }) }), $[59] = diffLoading, $[60] = t, $[61] = t16) : t16 = $[61];
  let t17;
  $[62] !== t15 || $[63] !== t16 ? (t17 = /* @__PURE__ */ jsxs(Box, { padding: 3, style: t6, children: [
    t15,
    t16
  ] }), $[62] = t15, $[63] = t16, $[64] = t17) : t17 = $[64];
  let t18;
  $[65] !== diffError || $[66] !== documentContext || $[67] !== revision?.loading || $[68] !== schemaType || $[69] !== showChanges || $[70] !== sinceEvent || $[71] !== sinceRevision?.loading || $[72] !== timelineError || $[73] !== toEvent?.id ? (t18 = showChanges && /* @__PURE__ */ jsx(Content, { documentContext, error: timelineError || diffError, loading: revision?.loading || sinceRevision?.loading || !1, schemaType, sameRevisionSelected: sinceEvent?.id === toEvent?.id, sinceEvent }), $[65] = diffError, $[66] = documentContext, $[67] = revision?.loading, $[68] = schemaType, $[69] = showChanges, $[70] = sinceEvent, $[71] = sinceRevision?.loading, $[72] = timelineError, $[73] = toEvent?.id, $[74] = t18) : t18 = $[74];
  let t19;
  $[75] !== t18 ? (t19 = /* @__PURE__ */ jsx(Scroller$2, { "data-ui": "Scroller", ref: setScrollRef, children: /* @__PURE__ */ jsx(Box, { flex: 1, paddingX: 3, height: "fill", children: t18 }) }), $[75] = t18, $[76] = t19) : t19 = $[76];
  let t20;
  $[77] !== scrollRef || $[78] !== t19 ? (t20 = /* @__PURE__ */ jsx(Card, { flex: 1, paddingX: 2, paddingY: 2, children: /* @__PURE__ */ jsx(BoundaryElementProvider, { element: scrollRef, children: t19 }) }), $[77] = scrollRef, $[78] = t19, $[79] = t20) : t20 = $[79];
  let t21;
  return $[80] !== t17 || $[81] !== t20 ? (t21 = /* @__PURE__ */ jsxs(Flex, { "data-testid": "review-changes-pane", direction: "column", height: "fill", overflow: "hidden", children: [
    t17,
    t20
  ] }), $[80] = t17, $[81] = t20, $[82] = t21) : t21 = $[82], t21;
}
function _temp2$2(props) {
  return props.path.length > 0 ? /* @__PURE__ */ jsx(ChangeFieldWrapper, { ...props }) : props.children;
}
function Content(t0) {
  const $ = c(15), {
    error,
    documentContext,
    loading,
    schemaType,
    sameRevisionSelected,
    sinceEvent
  } = t0;
  if (error) {
    let t12;
    $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(CompareWithPublishedView, {}), $[0] = t12) : t12 = $[0];
    let t22;
    $[1] !== error || $[2] !== sinceEvent?.type ? (t22 = sinceEvent?.type !== "historyCleared" && /* @__PURE__ */ jsx(ChangesError, { error }), $[1] = error, $[2] = sinceEvent?.type, $[3] = t22) : t22 = $[3];
    let t3;
    return $[4] !== t22 ? (t3 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t12,
      t22
    ] }), $[4] = t22, $[5] = t3) : t3 = $[5], t3;
  }
  if (loading) {
    let t12;
    return $[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(LoadingBlock, { showText: !0 }), $[6] = t12) : t12 = $[6], t12;
  }
  if (sameRevisionSelected) {
    let t12;
    return $[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(SameRevisionSelected, {}), $[7] = t12) : t12 = $[7], t12;
  }
  if (!documentContext.rootDiff) {
    let t12;
    return $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t12 = /* @__PURE__ */ jsx(motion.div, { animate: {
      opacity: 1
    }, initial: {
      opacity: 0
    }, transition: {
      delay: 0.2,
      duration: 0.2
    }, children: /* @__PURE__ */ jsx(NoChanges, {}) }), $[8] = t12) : t12 = $[8], t12;
  }
  let t1;
  $[9] !== documentContext.rootDiff || $[10] !== schemaType ? (t1 = /* @__PURE__ */ jsx(Box, { paddingY: 1, children: /* @__PURE__ */ jsx(ChangeList, { diff: documentContext.rootDiff, schemaType }) }), $[9] = documentContext.rootDiff, $[10] = schemaType, $[11] = t1) : t1 = $[11];
  let t2;
  return $[12] !== documentContext || $[13] !== t1 ? (t2 = /* @__PURE__ */ jsx(DocumentChangeContext.Provider, { value: documentContext, children: t1 }), $[12] = documentContext, $[13] = t1, $[14] = t2) : t2 = $[14], t2;
}
function SameRevisionSelected() {
  const $ = c(12), {
    t
  } = useTranslation("");
  let t0, t1, t2;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t0 = {
    opacity: 1
  }, t1 = {
    opacity: 0
  }, t2 = {
    delay: 0.2,
    duration: 0.2
  }, $[0] = t0, $[1] = t1, $[2] = t2) : (t0 = $[0], t1 = $[1], t2 = $[2]);
  let t3;
  $[3] !== t ? (t3 = t("changes.same-revision-selected-title"), $[3] = t, $[4] = t3) : t3 = $[4];
  let t4;
  $[5] !== t3 ? (t4 = /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", as: "h3", children: t3 }), $[5] = t3, $[6] = t4) : t4 = $[6];
  let t5;
  $[7] !== t ? (t5 = /* @__PURE__ */ jsx(Text, { as: "p", size: 1, muted: !0, children: /* @__PURE__ */ jsx(Translate, { i18nKey: "changes.same-revision-selected-description", t }) }), $[7] = t, $[8] = t5) : t5 = $[8];
  let t6;
  return $[9] !== t4 || $[10] !== t5 ? (t6 = /* @__PURE__ */ jsx(motion.div, { animate: t0, initial: t1, transition: t2, children: /* @__PURE__ */ jsxs(Stack, { space: 3, paddingTop: 2, children: [
    t4,
    t5
  ] }) }), $[9] = t4, $[10] = t5, $[11] = t6) : t6 = $[11], t6;
}
function _temp$4(props) {
  return props.children;
}
const Scroller$1 = styled(ScrollContainer).withConfig({
  displayName: "Scroller",
  componentId: "sc-1f5fnfo-0"
})`height:100%;overflow:auto;position:relative;scroll-behavior:smooth;`;
function EventsSelector(t0) {
  const $ = c(21), {
    showList
  } = t0, [scrollRef, setScrollRef] = useState(null), [listHeight, setListHeight] = useState(0), {
    setTimelineRange
  } = useDocumentPane();
  let t1;
  $[0] !== listHeight ? (t1 = (el) => {
    !listHeight && el && (setListHeight(el.clientHeight ? el.clientHeight - 1 : 0), setScrollRef(el));
  }, $[0] = listHeight, $[1] = t1) : t1 = $[1];
  const getScrollerRef = t1, {
    events,
    nextCursor,
    loading,
    error,
    revision,
    loadMoreEvents,
    findRangeForRevision,
    expandEvent
  } = useEvents(), {
    t
  } = useTranslation("studio"), toast = useToast();
  let t2;
  $[2] !== findRangeForRevision || $[3] !== setTimelineRange || $[4] !== t || $[5] !== toast ? (t2 = (event) => {
    const run = () => {
      if (isDeleteDocumentVersionEvent(event) || isDeleteDocumentGroupEvent(event) || isUnpublishDocumentEvent(event) || isScheduleDocumentVersionEvent(event) || isUnscheduleDocumentVersionEvent(event)) {
        console.error("Event is not selectable");
        return;
      }
      const [since, rev] = findRangeForRevision(event.id);
      setTimelineRange(since, rev);
    };
    try {
      run();
    } catch (t32) {
      const err = t32;
      toast.push({
        closable: !0,
        description: err.message,
        status: "error",
        title: t("timeline.error.unable-to-load-revision")
      });
    }
  }, $[2] = findRangeForRevision, $[3] = setTimelineRange, $[4] = t, $[5] = toast, $[6] = t2) : t2 = $[6];
  const selectRev = t2, initialLoad = loading && !events.length;
  let t3;
  return $[7] !== error || $[8] !== events || $[9] !== expandEvent || $[10] !== getScrollerRef || $[11] !== initialLoad || $[12] !== listHeight || $[13] !== loadMoreEvents || $[14] !== loading || $[15] !== nextCursor || $[16] !== revision?.revisionId || $[17] !== scrollRef || $[18] !== selectRev || $[19] !== showList ? (t3 = /* @__PURE__ */ jsx(Flex, { "data-testid": "review-changes-pane", direction: "column", height: "fill", children: /* @__PURE__ */ jsx(Card, { flex: 1, padding: 2, paddingTop: 0, children: error ? /* @__PURE__ */ jsx(TimelineError, {}) : /* @__PURE__ */ jsx(BoundaryElementProvider, { element: scrollRef, children: /* @__PURE__ */ jsxs(Scroller$1, { "data-ui": "Scroller", ref: getScrollerRef, children: [
    listHeight && showList && !initialLoad ? /* @__PURE__ */ jsx(EventsTimeline, { events, fetchEventChildren: expandEvent, hasMoreEvents: !!nextCursor, selectedEventId: revision?.revisionId || events[0]?.id, onLoadMore: loadMoreEvents, onSelect: selectRev, listMaxHeight: `${listHeight}px` }) : null,
    loading && /* @__PURE__ */ jsx(LoadingBlock, {})
  ] }) }) }) }), $[7] = error, $[8] = events, $[9] = expandEvent, $[10] = getScrollerRef, $[11] = initialLoad, $[12] = listHeight, $[13] = loadMoreEvents, $[14] = loading, $[15] = nextCursor, $[16] = revision?.revisionId, $[17] = scrollRef, $[18] = selectRev, $[19] = showList, $[20] = t3) : t3 = $[20], t3;
}
const Scroller = styled(ScrollContainer).withConfig({
  displayName: "Scroller",
  componentId: "sc-1ey5vbx-0"
})`height:100%;overflow:auto;position:relative;scroll-behavior:smooth;`;
function HistorySelector(t0) {
  const $ = c(20), {
    showList
  } = t0, {
    timelineError,
    setTimelineRange,
    timelineStore
  } = useDocumentPane(), {
    selectedReleaseId
  } = usePerspective(), [scrollRef, setScrollRef] = useState(null), [listHeight, setListHeight] = useState(0);
  let t1;
  $[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t1 = (el) => {
    el?.clientHeight && (setListHeight(el.clientHeight - 1), setScrollRef(el));
  }, $[0] = t1) : t1 = $[0];
  const getScrollerRef = t1, chunks = useTimelineSelector(timelineStore, _temp$3), realRevChunk = useTimelineSelector(timelineStore, _temp2$1), hasMoreChunks = useTimelineSelector(timelineStore, _temp3$1), loading = useTimelineSelector(timelineStore, _temp4$1), {
    t
  } = useTranslation("studio"), toast = useToast();
  let t2;
  $[1] !== setTimelineRange || $[2] !== t || $[3] !== timelineStore || $[4] !== toast ? (t2 = (revChunk) => {
    const run = () => {
      const [sinceId, revId] = timelineStore?.findRangeForRev(revChunk) || [null, null];
      setTimelineRange(sinceId, revId);
    };
    try {
      run();
    } catch (t32) {
      const err = t32;
      toast.push({
        closable: !0,
        description: err.message,
        status: "error",
        title: t("timeline.error.unable-to-load-revision")
      });
    }
  }, $[1] = setTimelineRange, $[2] = t, $[3] = timelineStore, $[4] = toast, $[5] = t2) : t2 = $[5];
  const selectRev = t2;
  let t3;
  $[6] !== loading || $[7] !== timelineStore ? (t3 = () => {
    loading || timelineStore?.loadMore();
  }, $[6] = loading, $[7] = timelineStore, $[8] = t3) : t3 = $[8];
  const handleLoadMore = t3;
  let t4;
  return $[9] !== chunks || $[10] !== handleLoadMore || $[11] !== hasMoreChunks || $[12] !== listHeight || $[13] !== realRevChunk || $[14] !== scrollRef || $[15] !== selectRev || $[16] !== selectedReleaseId || $[17] !== showList || $[18] !== timelineError ? (t4 = /* @__PURE__ */ jsx(Flex, { "data-testid": "review-changes-pane", direction: "column", height: "fill", children: /* @__PURE__ */ jsx(Card, { flex: 1, padding: 2, paddingTop: 0, children: timelineError || selectedReleaseId ? /* @__PURE__ */ jsx(TimelineError, { versionError: !!selectedReleaseId }) : /* @__PURE__ */ jsx(BoundaryElementProvider, { element: scrollRef, children: /* @__PURE__ */ jsx(Scroller, { "data-ui": "Scroller", ref: getScrollerRef, children: listHeight && showList ? /* @__PURE__ */ jsx(Timeline, { chunks, hasMoreChunks, lastChunk: realRevChunk, onLoadMore: handleLoadMore, onSelect: selectRev, listMaxHeight: `${listHeight}px` }) : null }) }) }) }), $[9] = chunks, $[10] = handleLoadMore, $[11] = hasMoreChunks, $[12] = listHeight, $[13] = realRevChunk, $[14] = scrollRef, $[15] = selectRev, $[16] = selectedReleaseId, $[17] = showList, $[18] = timelineError, $[19] = t4) : t4 = $[19], t4;
}
function _temp4$1(state_2) {
  return state_2.isLoading;
}
function _temp3$1(state_1) {
  return state_1.hasMoreChunks;
}
function _temp2$1(state_0) {
  return state_0.realRevChunk;
}
function _temp$3(state2) {
  return state2.chunks;
}
const FadeInFlex$1 = styled(Flex).withConfig({
  displayName: "FadeInFlex",
  componentId: "sc-a5131c-0"
})`opacity:0;transition:opacity 200ms;&[data-ready]{opacity:1;}`, TABS = ["history", "review"], isValidTab = (tab) => (
  // @ts-expect-error TS doesn't understand the type guard
  tab && TABS.includes(tab)
);
function ChangesTabs(props) {
  const $ = c(73), {
    params,
    setParams
  } = usePaneRouter(), source = useSource(), [parentRef, setParentRef] = useState(null), {
    t
  } = useTranslation(structureLocaleNamespace), {
    t: tCore
  } = useTranslation(), isReady = params?.inspect === HISTORY_INSPECTOR_NAME, {
    selectedPerspective
  } = usePerspective();
  let t0;
  $[0] !== params ? (t0 = isValidTab(params?.changesInspectorTab) ? params.changesInspectorTab : TABS[0], $[0] = params, $[1] = t0) : t0 = $[1];
  const paneRouterTab = t0;
  let t1;
  $[2] !== params || $[3] !== setParams ? (t1 = (tab) => setParams({
    ...params,
    changesInspectorTab: tab,
    since: tab === "history" ? void 0 : params?.since
  }), $[2] = params, $[3] = setParams, $[4] = t1) : t1 = $[4];
  const setPaneRouterTab = t1, t2 = isReady ? "" : void 0;
  let t3;
  $[5] !== t ? (t3 = t("changes.tab.history"), $[5] = t, $[6] = t3) : t3 = $[6];
  let t4;
  $[7] !== setPaneRouterTab ? (t4 = () => setPaneRouterTab("history"), $[7] = setPaneRouterTab, $[8] = t4) : t4 = $[8];
  const t5 = paneRouterTab === "history";
  let t6;
  $[9] !== t3 || $[10] !== t4 || $[11] !== t5 ? (t6 = /* @__PURE__ */ jsx(Tab, { "aria-controls": "history-panel", id: "history-tab", label: t3, onClick: t4, selected: t5 }), $[9] = t3, $[10] = t4, $[11] = t5, $[12] = t6) : t6 = $[12];
  let t7;
  $[13] !== t ? (t7 = t("changes.tab.review-changes"), $[13] = t, $[14] = t7) : t7 = $[14];
  let t8;
  $[15] !== setPaneRouterTab ? (t8 = () => setPaneRouterTab("review"), $[15] = setPaneRouterTab, $[16] = t8) : t8 = $[16];
  const t9 = paneRouterTab === "review";
  let t10;
  $[17] !== t7 || $[18] !== t8 || $[19] !== t9 ? (t10 = /* @__PURE__ */ jsx(Tab, { "aria-controls": "review-changes-panel", id: "changes-tab", label: t7, onClick: t8, selected: t9 }), $[17] = t7, $[18] = t8, $[19] = t9, $[20] = t10) : t10 = $[20];
  let t11;
  $[21] !== t10 || $[22] !== t6 ? (t11 = /* @__PURE__ */ jsxs(TabList, { space: 1, flex: 1, children: [
    t6,
    t10
  ] }), $[21] = t10, $[22] = t6, $[23] = t11) : t11 = $[23];
  let t12;
  $[24] !== t ? (t12 = t("changes.action.close-label"), $[24] = t, $[25] = t12) : t12 = $[25];
  const t13 = props.onClose;
  let t14;
  $[26] !== t ? (t14 = t("document-inspector.close-button.tooltip"), $[26] = t, $[27] = t14) : t14 = $[27];
  let t15;
  $[28] !== t14 ? (t15 = {
    content: t14
  }, $[28] = t14, $[29] = t15) : t15 = $[29];
  let t16;
  $[30] !== props.onClose || $[31] !== t12 || $[32] !== t15 ? (t16 = /* @__PURE__ */ jsx(Button$1, { "aria-label": t12, icon: CloseIcon, mode: "bleed", onClick: t13, tooltipProps: t15 }), $[30] = props.onClose, $[31] = t12, $[32] = t15, $[33] = t16) : t16 = $[33];
  let t17;
  $[34] !== t11 || $[35] !== t16 ? (t17 = /* @__PURE__ */ jsx(Card, { paddingBottom: 1, children: /* @__PURE__ */ jsxs(Flex, { align: "center", padding: 3, gap: 2, children: [
    t11,
    t16
  ] }) }), $[34] = t11, $[35] = t16, $[36] = t17) : t17 = $[36];
  let t18;
  $[37] !== t ? (t18 = /* @__PURE__ */ jsx(Box, { flex: 1, padding: 1, children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Translate, { t, i18nKey: "changes.banner.tooltip" }) }) }), $[37] = t, $[38] = t18) : t18 = $[38];
  let t19;
  $[39] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t19 = /* @__PURE__ */ jsx(Text, { size: 0, muted: !0, children: /* @__PURE__ */ jsx(InfoOutlineIcon, { fontSize: 1 }) }), $[39] = t19) : t19 = $[39];
  let t20;
  $[40] !== parentRef || $[41] !== t18 ? (t20 = /* @__PURE__ */ jsx(Tooltip, { portal: !0, placement: "bottom-end", boundaryElement: parentRef, content: t18, children: t19 }), $[40] = parentRef, $[41] = t18, $[42] = t20) : t20 = $[42];
  let t21;
  $[43] !== selectedPerspective || $[44] !== t || $[45] !== tCore ? (t21 = perspectiveLabel(selectedPerspective, {
    t,
    tCore
  }), $[43] = selectedPerspective, $[44] = t, $[45] = tCore, $[46] = t21) : t21 = $[46];
  let t22;
  $[47] !== t21 ? (t22 = {
    perspective: t21
  }, $[47] = t21, $[48] = t22) : t22 = $[48];
  let t23;
  $[49] !== t || $[50] !== t22 ? (t23 = /* @__PURE__ */ jsx(Text, { size: 0, muted: !0, children: /* @__PURE__ */ jsx(Translate, { t, values: t22, i18nKey: "changes.banner.description" }) }), $[49] = t, $[50] = t22, $[51] = t23) : t23 = $[51];
  let t24;
  $[52] !== t20 || $[53] !== t23 ? (t24 = /* @__PURE__ */ jsx(Card, { padding: 2, marginBottom: 3, marginX: 3, tone: "neutral", border: !0, radius: 3, children: /* @__PURE__ */ jsxs(Flex, { gap: 2, align: "flex-start", children: [
    t20,
    t23
  ] }) }), $[52] = t20, $[53] = t23, $[54] = t24) : t24 = $[54];
  const t25 = paneRouterTab !== "history";
  let t26;
  $[55] !== paneRouterTab || $[56] !== source.beta?.eventsAPI?.documents ? (t26 = source.beta?.eventsAPI?.documents ? /* @__PURE__ */ jsx(EventsSelector, { showList: paneRouterTab === "history" }) : /* @__PURE__ */ jsx(HistorySelector, { showList: paneRouterTab === "history" }), $[55] = paneRouterTab, $[56] = source.beta?.eventsAPI?.documents, $[57] = t26) : t26 = $[57];
  let t27;
  $[58] !== t25 || $[59] !== t26 ? (t27 = /* @__PURE__ */ jsx(TabPanel, { "aria-labelledby": "history-tab", height: "fill", hidden: t25, id: "history-panel", children: t26 }), $[58] = t25, $[59] = t26, $[60] = t27) : t27 = $[60];
  const t28 = paneRouterTab !== "review";
  let t29;
  $[61] !== paneRouterTab || $[62] !== source.beta?.eventsAPI?.documents ? (t29 = source.beta?.eventsAPI?.documents ? /* @__PURE__ */ jsx(Fragment, { children: paneRouterTab === "review" ? /* @__PURE__ */ jsx(EventsInspector, { showChanges: paneRouterTab === "review" }) : null }) : /* @__PURE__ */ jsx(ChangesInspector, { showChanges: paneRouterTab === "review" }), $[61] = paneRouterTab, $[62] = source.beta?.eventsAPI?.documents, $[63] = t29) : t29 = $[63];
  let t30;
  $[64] !== t28 || $[65] !== t29 ? (t30 = /* @__PURE__ */ jsx(TabPanel, { "aria-labelledby": "review-tab", hidden: t28, id: "review-panel", height: "fill", children: t29 }), $[64] = t28, $[65] = t29, $[66] = t30) : t30 = $[66];
  let t31;
  return $[67] !== t17 || $[68] !== t2 || $[69] !== t24 || $[70] !== t27 || $[71] !== t30 ? (t31 = /* @__PURE__ */ jsxs(FadeInFlex$1, { direction: "column", padding: 0, height: "fill", "data-ready": t2, ref: setParentRef, children: [
    t17,
    t24,
    t27,
    t30
  ] }), $[67] = t17, $[68] = t2, $[69] = t24, $[70] = t27, $[71] = t30, $[72] = t31) : t31 = $[72], t31;
}
function perspectiveLabel(perspective, {
  t,
  tCore
}) {
  return isReleaseDocument(perspective) ? perspective.metadata.title || tCore("release.placeholder-untitled-release") : perspective === "drafts" ? t("compare-versions.status.draft") : perspective === "published" ? t("compare-versions.status.published") : perspective;
}
const changesInspector = {
  name: HISTORY_INSPECTOR_NAME,
  useMenuItem: () => {
    const {
      features
    } = useStructureTool(), {
      t
    } = useTranslation();
    return {
      hidden: !features.reviewChanges,
      icon: RestoreIcon,
      title: t("changes.title")
    };
  },
  component: ChangesTabs,
  onClose: ({
    params
  }) => ({
    params: {
      ...params,
      since: void 0,
      rev: void 0,
      changesInspectorTab: void 0,
      historyVersion: void 0
    }
  }),
  onOpen: ({
    params
  }) => ({
    params: {
      ...params,
      since: "@lastPublished"
    }
  })
}, FadeInFlex = motion.create(Flex), IncomingReferenceDocument = (props) => {
  const $ = c(25), {
    t
  } = useTranslation(structureLocaleNamespace), {
    document: document2,
    referenceToId
  } = props;
  let t0;
  $[0] !== document2 || $[1] !== referenceToId ? (t0 = getReferencePaths(document2, referenceToId), $[0] = document2, $[1] = referenceToId, $[2] = t0) : t0 = $[2];
  const referencePaths = t0, id = document2._id, schema = useSchema(), {
    navigate
  } = useRouter(), {
    routerPanesState,
    groupIndex
  } = usePaneRouter(), type = document2?._type;
  let t1;
  $[3] !== groupIndex || $[4] !== id || $[5] !== navigate || $[6] !== referencePaths || $[7] !== routerPanesState || $[8] !== type ? (t1 = () => {
    type && navigate({
      panes: [...routerPanesState.slice(0, groupIndex + 1), [{
        id: getPublishedId(id),
        params: {
          type,
          path: pathToString(referencePaths[0])
        }
      }]]
    });
  }, $[3] = groupIndex, $[4] = id, $[5] = navigate, $[6] = referencePaths, $[7] = routerPanesState, $[8] = type, $[9] = t1) : t1 = $[9];
  const handleClick = t1;
  let t2;
  $[10] !== document2._type || $[11] !== schema ? (t2 = schema.get(document2._type), $[10] = document2._type, $[11] = schema, $[12] = t2) : t2 = $[12];
  const schemaType = t2;
  if (!schemaType) {
    let t32;
    $[13] !== document2._type || $[14] !== t ? (t32 = t("incoming-references-pane.schema-type-not-found", {
      type: document2._type
    }), $[13] = document2._type, $[14] = t, $[15] = t32) : t32 = $[15];
    let t42;
    return $[16] !== t32 ? (t42 = /* @__PURE__ */ jsx(Card, { radius: 2, tone: "critical", children: /* @__PURE__ */ jsx(Box, { paddingY: 4, paddingX: 3, children: /* @__PURE__ */ jsx(Text, { size: 1, children: t32 }) }) }), $[16] = t32, $[17] = t42) : t42 = $[17], t42;
  }
  let t3, t4;
  $[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t3 = {
    opacity: 0
  }, t4 = {
    opacity: 1
  }, $[18] = t3, $[19] = t4) : (t3 = $[18], t4 = $[19]);
  let t5;
  return $[20] !== document2 || $[21] !== handleClick || $[22] !== referencePaths[0] || $[23] !== schemaType ? (t5 = /* @__PURE__ */ jsx(Card, { radius: 2, tone: "default", children: /* @__PURE__ */ jsx(FadeInFlex, { initial: t3, animate: t4, gap: 1, align: "center", children: /* @__PURE__ */ jsx(Box, { flex: 1, children: /* @__PURE__ */ jsx(IncomingReferencePreview, { type: schemaType, value: document2, onClick: handleClick, path: referencePaths[0] }) }) }) }), $[20] = document2, $[21] = handleClick, $[22] = referencePaths[0], $[23] = schemaType, $[24] = t5) : t5 = $[24], t5;
};
function TypeSection(t0) {
  const $ = c(16), {
    type,
    documents,
    renderItem,
    getItemKey,
    emptyMessage
  } = t0, schema = useSchema(), {
    t
  } = useTranslation(structureLocaleNamespace);
  let t1;
  $[0] !== schema || $[1] !== type ? (t1 = schema.get(type), $[0] = schema, $[1] = type, $[2] = t1) : t1 = $[2];
  const title = t1?.title || type;
  let t2;
  $[3] !== title ? (t2 = /* @__PURE__ */ jsx(Flex, { align: "center", justify: "space-between", paddingBottom: 2, gap: 2, children: /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text, { size: 1, weight: "medium", children: title }) }) }), $[3] = title, $[4] = t2) : t2 = $[4];
  let t3;
  $[5] !== documents || $[6] !== emptyMessage || $[7] !== getItemKey || $[8] !== renderItem || $[9] !== t || $[10] !== title ? (t3 = documents.length > 0 ? /* @__PURE__ */ jsx(Card, { radius: 2, padding: 1, border: !0, tone: "default", children: /* @__PURE__ */ jsx(IncomingReferencesListContainer, { $itemCount: documents.length, children: /* @__PURE__ */ jsx(CommandList, { activeItemDataAttr: "data-hovered", ariaLabel: t("incoming-references-input.list-label", {
    type: title
  }), canReceiveFocus: !0, fixedHeight: !0, getItemKey, itemHeight: INCOMING_REFERENCES_ITEM_HEIGHT, items: documents, onlyShowSelectionWhenActive: !0, overscan: 5, renderItem, wrapAround: !1 }) }) }) : /* @__PURE__ */ jsx(Box, { padding: 0, children: /* @__PURE__ */ jsx(Card, { border: !0, radius: 3, padding: 1, tone: "default", children: /* @__PURE__ */ jsx(Box, { paddingY: 3, paddingX: 2, children: /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: emptyMessage }) }) }) }), $[5] = documents, $[6] = emptyMessage, $[7] = getItemKey, $[8] = renderItem, $[9] = t, $[10] = title, $[11] = t3) : t3 = $[11];
  let t4;
  return $[12] !== t2 || $[13] !== t3 || $[14] !== type ? (t4 = /* @__PURE__ */ jsxs(Stack, { padding: 2, space: 1, marginBottom: 2, children: [
    t2,
    t3
  ] }, type), $[12] = t2, $[13] = t3, $[14] = type, $[15] = t4) : t4 = $[15], t4;
}
function IncomingReferencesList() {
  const $ = c(30), {
    documentId
  } = useDocumentPaneInfo(), {
    t
  } = useTranslation(structureLocaleNamespace), {
    getClient
  } = useSource(), documentPreviewStore = useDocumentPreviewStore(), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS);
  let t0;
  $[0] !== documentId || $[1] !== documentPreviewStore || $[2] !== getClient ? (t0 = getIncomingReferences({
    documentId,
    documentPreviewStore,
    getClient
  }).pipe(map(_temp3)), $[0] = documentId, $[1] = documentPreviewStore, $[2] = getClient, $[3] = t0) : t0 = $[3];
  const references = useObservable(t0, null);
  let t1;
  $[4] !== client || $[5] !== documentId || $[6] !== documentPreviewStore ? (t1 = getCrossDatasetIncomingReferences({
    documentId,
    client,
    documentPreviewStore
  }).pipe(map(_temp6)), $[4] = client, $[5] = documentId, $[6] = documentPreviewStore, $[7] = t1) : t1 = $[7];
  const crossDatasetRefs = useObservable(t1, null);
  let t2;
  $[8] !== documentId ? (t2 = (document2) => /* @__PURE__ */ jsx(IncomingReferenceDocument, { document: document2, referenceToId: documentId }), $[8] = documentId, $[9] = t2) : t2 = $[9];
  const renderSameDatasetItem = t2, renderCrossDatasetItem = _temp7;
  let t3;
  $[10] !== t ? (t3 = t("incoming-references-pane.no-references-found"), $[10] = t, $[11] = t3) : t3 = $[11];
  const emptyMessage = t3, showEmptyState = !references?.loading && references?.list.length === 0 && !crossDatasetRefs?.loading && crossDatasetRefs?.list.length === 0;
  let t4;
  $[12] !== showEmptyState || $[13] !== t ? (t4 = showEmptyState && /* @__PURE__ */ jsx(Card, { border: !0, radius: 3, padding: 1, tone: "default", children: /* @__PURE__ */ jsx(Box, { paddingY: 3, paddingX: 2, children: /* @__PURE__ */ jsx(Text, { size: 1, muted: !0, children: t("incoming-references-pane.no-references") }) }) }), $[12] = showEmptyState, $[13] = t, $[14] = t4) : t4 = $[14];
  let t5;
  $[15] !== emptyMessage || $[16] !== references?.list || $[17] !== references?.loading || $[18] !== renderSameDatasetItem || $[19] !== t ? (t5 = references?.loading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: t("incoming-references-input.types-loading") }) : references?.list.map((t62) => {
    const {
      type: type_3,
      documents: documents_1
    } = t62;
    return /* @__PURE__ */ jsx(TypeSection, { type: type_3, documents: documents_1, renderItem: renderSameDatasetItem, getItemKey: (index) => documents_1[index]._id, emptyMessage }, type_3);
  }), $[15] = emptyMessage, $[16] = references?.list, $[17] = references?.loading, $[18] = renderSameDatasetItem, $[19] = t, $[20] = t5) : t5 = $[20];
  let t6;
  $[21] !== crossDatasetRefs?.list || $[22] !== crossDatasetRefs?.loading || $[23] !== emptyMessage || $[24] !== t ? (t6 = crossDatasetRefs?.loading ? /* @__PURE__ */ jsx(LoadingBlock, { showText: !0, title: t("incoming-references-input.types-loading-cross-dataset") }) : crossDatasetRefs?.list.map((t72) => {
    const {
      type: type_4,
      documents: documents_2
    } = t72;
    return /* @__PURE__ */ jsx(TypeSection, { type: type_4, documents: documents_2, renderItem: renderCrossDatasetItem, getItemKey: (index_0) => documents_2[index_0].id, emptyMessage }, type_4);
  }), $[21] = crossDatasetRefs?.list, $[22] = crossDatasetRefs?.loading, $[23] = emptyMessage, $[24] = t, $[25] = t6) : t6 = $[25];
  let t7;
  return $[26] !== t4 || $[27] !== t5 || $[28] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Fragment, { children: [
    t4,
    t5,
    t6
  ] }), $[26] = t4, $[27] = t5, $[28] = t6, $[29] = t7) : t7 = $[29], t7;
}
function _temp7(document_0) {
  return /* @__PURE__ */ jsx(CrossDatasetIncomingReferenceDocumentPreview, { document: document_0 });
}
function _temp6(t0) {
  const {
    documents: documents_0,
    loading: loading_0
  } = t0, documentsByType_0 = documents_0.reduce(_temp4, {});
  return {
    list: Object.entries(documentsByType_0).map(_temp5),
    loading: loading_0
  };
}
function _temp5(t0) {
  const [type_2, docs_0] = t0;
  return {
    type: type_2,
    documents: docs_0
  };
}
function _temp4(acc_0, doc_0) {
  const type_1 = doc_0.type;
  return acc_0[type_1] ? acc_0[type_1].push(doc_0) : acc_0[type_1] = [doc_0], acc_0;
}
function _temp3(t0) {
  const {
    documents,
    loading
  } = t0, documentsByType = documents.reduce(_temp$2, {});
  return {
    list: Object.entries(documentsByType).map(_temp2),
    loading
  };
}
function _temp2(t0) {
  const [type_0, docs] = t0;
  return {
    type: type_0,
    documents: docs
  };
}
function _temp$2(acc, doc) {
  const type = doc._type;
  return acc[type] ? acc[type].push(doc) : acc[type] = [doc], acc;
}
const IncomingReferencesInspector = (props) => {
  const $ = c(11), {
    t
  } = useTranslation();
  let t0;
  $[0] !== t ? (t0 = t("panel.close-button-aria-label"), $[0] = t, $[1] = t0) : t0 = $[1];
  const t1 = props.onClose;
  let t2;
  $[2] !== t ? (t2 = t("incoming-references.title"), $[2] = t, $[3] = t2) : t2 = $[3];
  let t3;
  $[4] !== props.onClose || $[5] !== t0 || $[6] !== t2 ? (t3 = /* @__PURE__ */ jsx(DocumentInspectorHeader, { as: "header", closeButtonLabel: t0, flex: "none", onClose: t1, title: t2 }), $[4] = props.onClose, $[5] = t0, $[6] = t2, $[7] = t3) : t3 = $[7];
  let t4;
  $[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t4 = /* @__PURE__ */ jsx(Card, { flex: 1, overflow: "auto", padding: 3, children: /* @__PURE__ */ jsx(IncomingReferencesList, {}) }), $[8] = t4) : t4 = $[8];
  let t5;
  return $[9] !== t3 ? (t5 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", overflow: "hidden", children: [
    t3,
    t4
  ] }), $[9] = t3, $[10] = t5) : t5 = $[10], t5;
}, incomingReferencesInspector = {
  name: INCOMING_REFERENCES_INSPECTOR_NAME,
  useMenuItem: () => {
    const {
      t
    } = useTranslation();
    return {
      icon: SyncIcon,
      title: t("incoming-references.title")
    };
  },
  component: IncomingReferencesInspector
};
function getPathTitles(options) {
  const {
    path,
    schemaType,
    value
  } = options, result = [];
  let s = schemaType, v = value;
  for (const segment of path) {
    if (typeof segment == "string") {
      if (!isRecord(v) && v !== void 0)
        throw new Error(`Parent value is not an object, cannot get path segment: .${segment}`);
      if (s.jsonType !== "object")
        throw new Error(`Parent type is not an object schema type, cannot get path segment: .${segment}`);
      v = v?.[segment];
      const field = s.fields.find((f) => f.name === segment);
      if (!field)
        return result.push({
          name: segment
        }), result;
      s = field.type, result.push(s);
      continue;
    }
    if (typeof segment == "number") {
      if (!isArray(v) && v !== void 0)
        throw new Error(`Parent value is not an array, cannot get path segment: [${segment}]`);
      if (s.jsonType !== "array")
        throw new Error(`Parent type is not an array schema type, cannot get path segment: [${segment}]`);
      v = v?.[segment];
      const itemType = s.of.find((ofType) => typeof v == "string" ? ofType.jsonType === "string" : typeof v == "number" ? ofType.jsonType === "number" : typeof v == "boolean" ? ofType.jsonType === "boolean" : isRecord(v) ? ofType.name === v?._type : !1);
      if (!itemType)
        throw new Error(`Item type not found: [${segment}]`);
      s = itemType, result.push(s);
      continue;
    }
    if (isRecord(segment) && segment._key) {
      if (typeof v > "u")
        return result;
      if (!isArray(v))
        throw new Error(`Parent value is not an array, cannot get path segment: [_key == ${segment}]`);
      if (s.jsonType !== "array")
        throw new Error(`Parent type is not an array schema type, cannot get path segment: .${segment}`);
      if (v = (v ?? []).find((i) => isRecord(i) && i._key === segment._key), typeof v > "u")
        return result;
      if (!isRecord(v))
        throw new Error(`Array item not found: [_key == ${segment._key}]`);
      let ofType = s.of.find((i) => isRecord(v) && i.name === v?._type);
      if (!ofType && !v?._type) {
        const objectTypes = s.of.filter((i) => i.jsonType === "object");
        objectTypes.length === 1 && (ofType = objectTypes[0]);
      }
      if (!ofType)
        throw new Error(`Array item type not found: .${v?._type}`);
      s = ofType, result.push(s);
      continue;
    }
    throw new Error(`Invalid path segment: ${JSON.stringify(segment)}`);
  }
  return result;
}
const MARKER_ICON = {
  error: ErrorOutlineIcon,
  warning: WarningOutlineIcon,
  info: InfoOutlineIcon
}, MARKER_TONE = {
  error: "critical",
  warning: "caution",
  info: "primary"
};
function ValidationInspector(props) {
  const $ = c(26), {
    onClose
  } = props, {
    onFocus,
    onPathOpen,
    schemaType,
    validation,
    value,
    editState
  } = useDocumentPane(), parseErrors = useParseErrors();
  let t0;
  $[0] !== parseErrors || $[1] !== validation ? (t0 = mergeParseErrors(validation, parseErrors), $[0] = parseErrors, $[1] = validation, $[2] = t0) : t0 = $[2];
  const mergedValidation = t0, {
    t
  } = useTranslation("validation");
  let t1;
  $[3] !== onFocus || $[4] !== onPathOpen ? (t1 = (path) => {
    onPathOpen(path), onFocus(path);
  }, $[3] = onFocus, $[4] = onPathOpen, $[5] = t1) : t1 = $[5];
  const handleOpen = t1;
  let t2;
  $[6] !== editState ? (t2 = editState && editState.version && isGoingToUnpublish(editState.version), $[6] = editState, $[7] = t2) : t2 = $[7];
  const isVersionGoingToUnpublish = t2;
  let t3;
  $[8] !== t ? (t3 = t("panel.close-button-aria-label"), $[8] = t, $[9] = t3) : t3 = $[9];
  let t4;
  $[10] !== t ? (t4 = t("panel.title"), $[10] = t, $[11] = t4) : t4 = $[11];
  let t5;
  $[12] !== onClose || $[13] !== t3 || $[14] !== t4 ? (t5 = /* @__PURE__ */ jsx(DocumentInspectorHeader, { as: "header", closeButtonLabel: t3, flex: "none", onClose, title: t4 }), $[12] = onClose, $[13] = t3, $[14] = t4, $[15] = t5) : t5 = $[15];
  let t6;
  $[16] !== handleOpen || $[17] !== isVersionGoingToUnpublish || $[18] !== mergedValidation || $[19] !== schemaType || $[20] !== t || $[21] !== value ? (t6 = /* @__PURE__ */ jsx(Card, { flex: 1, overflow: "auto", padding: 3, children: isVersionGoingToUnpublish ? /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("panel.unpublish-message") }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    mergedValidation.length === 0 && /* @__PURE__ */ jsx(Box, { padding: 2, children: /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: t("panel.no-errors-message") }) }),
    mergedValidation.length > 0 && /* @__PURE__ */ jsx(Stack, { space: 2, children: mergedValidation.map((marker, i) => /* @__PURE__ */ jsx(ValidationCard, { marker, onOpen: handleOpen, schemaType, value }, i)) })
  ] }) }), $[16] = handleOpen, $[17] = isVersionGoingToUnpublish, $[18] = mergedValidation, $[19] = schemaType, $[20] = t, $[21] = value, $[22] = t6) : t6 = $[22];
  let t7;
  return $[23] !== t5 || $[24] !== t6 ? (t7 = /* @__PURE__ */ jsxs(Flex, { direction: "column", height: "fill", overflow: "hidden", children: [
    t5,
    t6
  ] }), $[23] = t5, $[24] = t6, $[25] = t7) : t7 = $[25], t7;
}
function ValidationCard(props) {
  const $ = c(17), {
    marker,
    onOpen,
    schemaType,
    value
  } = props;
  let t0;
  $[0] !== marker.path || $[1] !== onOpen ? (t0 = (event) => {
    const selection = window.getSelection();
    selection && selection.toString().length > 0 && event.currentTarget.contains(selection.anchorNode) || onOpen(marker.path);
  }, $[0] = marker.path, $[1] = onOpen, $[2] = t0) : t0 = $[2];
  const handleClick = t0, [errorInfo, setErrorInfo] = useState(null), Icon = MARKER_ICON[marker.level];
  let t1;
  $[3] !== errorInfo ? (t1 = errorInfo && /* @__PURE__ */ jsx(Card, { padding: 3, radius: 2, tone: "critical", children: /* @__PURE__ */ jsx(Text, { size: 1, children: errorInfo.error.message }) }), $[3] = errorInfo, $[4] = t1) : t1 = $[4];
  let t2;
  $[5] !== Icon || $[6] !== errorInfo || $[7] !== handleClick || $[8] !== marker.level || $[9] !== marker.message || $[10] !== marker.path || $[11] !== schemaType || $[12] !== value ? (t2 = !errorInfo && /* @__PURE__ */ jsx(Card, { __unstable_focusRing: !0, as: "button", onClick: handleClick, padding: 3, radius: 2, style: {
    userSelect: "text"
  }, tone: MARKER_TONE[marker.level], children: /* @__PURE__ */ jsxs(Flex, { align: "flex-start", gap: 3, children: [
    /* @__PURE__ */ jsx(Box, { flex: "none", children: /* @__PURE__ */ jsx(Text, { size: 1, children: /* @__PURE__ */ jsx(Icon, {}) }) }),
    /* @__PURE__ */ jsxs(Stack, { flex: 1, space: 2, children: [
      /* @__PURE__ */ jsx(DocumentNodePathBreadcrumbs, { path: marker.path, schemaType, value }),
      /* @__PURE__ */ jsx(Text, { muted: !0, size: 1, children: marker.message })
    ] })
  ] }) }), $[5] = Icon, $[6] = errorInfo, $[7] = handleClick, $[8] = marker.level, $[9] = marker.message, $[10] = marker.path, $[11] = schemaType, $[12] = value, $[13] = t2) : t2 = $[13];
  let t3;
  return $[14] !== t1 || $[15] !== t2 ? (t3 = /* @__PURE__ */ jsxs(ErrorBoundary, { onCatch: setErrorInfo, children: [
    t1,
    t2
  ] }), $[14] = t1, $[15] = t2, $[16] = t3) : t3 = $[16], t3;
}
function DocumentNodePathBreadcrumbs(props) {
  const $ = c(8), {
    path,
    schemaType,
    value
  } = props;
  let t0;
  bb0: {
    try {
      let t22;
      $[0] !== path || $[1] !== schemaType || $[2] !== value ? (t22 = getPathTitles({
        path,
        schemaType,
        value
      }), $[0] = path, $[1] = schemaType, $[2] = value, $[3] = t22) : t22 = $[3], t0 = t22;
      break bb0;
    } catch (t12) {
      console.error(t12);
    }
    t0 = null;
  }
  const pathTitles = t0;
  if (!pathTitles?.length)
    return null;
  let t1;
  $[4] !== pathTitles ? (t1 = pathTitles.map(_temp$1), $[4] = pathTitles, $[5] = t1) : t1 = $[5];
  let t2;
  return $[6] !== t1 ? (t2 = /* @__PURE__ */ jsx(Text, { size: 1, children: t1 }), $[6] = t1, $[7] = t2) : t2 = $[7], t2;
}
function _temp$1(t, i) {
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    i > 0 && /* @__PURE__ */ jsx("span", { style: {
      color: "var(--card-muted-fg-color)",
      opacity: 0.5
    }, children: " / " }),
    /* @__PURE__ */ jsx("span", { style: {
      fontWeight: 500
    }, children: t.title || t.name })
  ] }, i);
}
function useMenuItem(props) {
  const $ = c(12), {
    documentType
  } = props, {
    t
  } = useTranslation("validation"), {
    selectedReleaseId
  } = usePerspective(), {
    value
  } = useDocumentPane(), {
    validation: validationMarkers
  } = useValidationStatus(value._id, documentType, !selectedReleaseId), parseErrors = useParseErrors();
  let t0;
  $[0] !== parseErrors || $[1] !== validationMarkers ? (t0 = mergeParseErrors(validationMarkers, parseErrors).map(_temp), $[0] = parseErrors, $[1] = validationMarkers, $[2] = t0) : t0 = $[2];
  const validation = t0, hasErrors = validation.some(isValidationError), hasWarnings = validation.some(isValidationWarning);
  let t1;
  $[3] !== value ? (t1 = isGoingToUnpublish(value), $[3] = value, $[4] = t1) : t1 = $[4];
  const isDocumentGoingToUnpublish = t1;
  let t2;
  bb0: {
    if (hasErrors) {
      t2 = ErrorOutlineIcon;
      break bb0;
    }
    if (hasWarnings) {
      t2 = WarningOutlineIcon;
      break bb0;
    }
    t2 = CheckmarkCircleIcon;
  }
  const icon = t2;
  let t3;
  bb1: {
    if (hasErrors) {
      t3 = "critical";
      break bb1;
    }
    if (hasWarnings) {
      t3 = "caution";
      break bb1;
    }
    t3 = "positive";
  }
  const tone = t3, t4 = validation.length === 0 || isDocumentGoingToUnpublish;
  let t5;
  $[5] !== t ? (t5 = t("panel.title"), $[5] = t, $[6] = t5) : t5 = $[6];
  let t6;
  return $[7] !== icon || $[8] !== t4 || $[9] !== t5 || $[10] !== tone ? (t6 = {
    hidden: t4,
    icon,
    title: t5,
    tone,
    showAsAction: !0
  }, $[7] = icon, $[8] = t4, $[9] = t5, $[10] = tone, $[11] = t6) : t6 = $[11], t6;
}
function _temp(item) {
  return {
    level: item.level,
    message: item.message,
    path: item.path
  };
}
const validationInspector = {
  name: VALIDATION_INSPECTOR_NAME,
  component: ValidationInspector,
  useMenuItem
}, EMPTY_PARAMS = {};
function legacyEditParamsToState(params) {
  try {
    return JSON.parse(decodeURIComponent(params));
  } catch {
    return console.warn("Failed to parse JSON parameters"), {};
  }
}
function encodePanesSegment(panes) {
  return (panes || []).map((group) => group.map(encodeChunks).join("|")).map(encodeURIComponent).join(";");
}
function legacyEditParamsToPath(params) {
  return JSON.stringify(params);
}
function toState(pathSegment) {
  return parsePanesSegment(decodeURIComponent(pathSegment));
}
function toPath(panes) {
  return encodePanesSegment(panes);
}
const router = route.create("/", [
  // "Asynchronous intent resolving" route
  route.intents("/intent"),
  // Legacy fallback route, will be redirected to new format
  route.create("/edit/:type/:editDocumentId", [route.create({
    path: "/:params",
    transform: {
      params: {
        toState: legacyEditParamsToState,
        toPath: legacyEditParamsToPath
      }
    }
  })]),
  // The regular path - when the intent can be resolved to a specific pane
  route.create({
    path: "/:panes",
    // Legacy URLs, used to handle redirects
    children: [route.create("/:action", route.create("/:legacyEditDocumentId"))],
    transform: {
      panes: {
        toState,
        toPath
      }
    }
  })
]), panePattern = /^([.a-z0-9_-]+),?({.*?})?(?:(;|$))/i, isParam = (str) => /^[a-z0-9]+=[^=]+/i.test(str), isPayloadLike = (str) => /^[A-Za-z0-9\-_]+(?:={0,2})$/.test(str), exclusiveParams = ["view", "since", "rev", "inspect", "comment"], isTruthy = Boolean;
function parseChunks(chunks, initial) {
  const sibling = {
    ...initial,
    params: EMPTY_PARAMS,
    payload: void 0
  };
  return chunks.reduce((pane, chunk) => {
    if (isParam(chunk)) {
      const key = chunk.slice(0, chunk.indexOf("=")), value = chunk.slice(key.length + 1);
      pane.params = {
        ...pane.params,
        [decodeURIComponent(key)]: decodeURIComponent(value)
      };
    } else isPayloadLike(chunk) ? pane.payload = tryParseBase64Payload(chunk) : chunk && console.warn("Unknown pane segment: %s - skipping", chunk);
    return pane;
  }, sibling);
}
function encodeChunks(pane, index, group) {
  const {
    payload,
    params = {},
    id
  } = pane, [firstSibling] = group, paneIsFirstSibling = pane === firstSibling, sameAsFirst = index !== 0 && id === firstSibling.id, encodedPayload = typeof payload > "u" ? void 0 : encodeJsonParams(payload), encodedParams = Object.entries(params).filter((entry) => {
    const [key, value] = entry;
    if (!value) return !1;
    if (paneIsFirstSibling) return !0;
    const valueFromFirstSibling = firstSibling.params?.[key];
    return !(value === valueFromFirstSibling && !exclusiveParams.includes(key));
  }).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  return [sameAsFirst ? "" : id].concat([encodedParams.length > 0 && encodedParams, encodedPayload].filter(isTruthy).flat()).join(",") || ",";
}
function parsePanesSegment(str) {
  return str.indexOf(",{") !== -1 ? parseOldPanesSegment(str) : str.split(";").map((group) => {
    const [firstSibling, ...restOfSiblings] = group.split("|").map((segment) => {
      const [id, ...chunks] = segment.split(",");
      return parseChunks(chunks, {
        id
      });
    });
    return [firstSibling, ...restOfSiblings.map((sibling) => ({
      ...firstSibling,
      ...sibling,
      id: sibling.id || firstSibling.id,
      params: {
        ...omit(firstSibling.params, exclusiveParams),
        ...sibling.params
      },
      payload: sibling.payload || firstSibling.payload
    }))];
  }).filter((group) => group.length > 0);
}
function parseOldPanesSegment(str) {
  const chunks = [];
  let buffer = str;
  for (; buffer.length; ) {
    const [match, id, payloadChunk] = buffer.match(panePattern) || [];
    if (!match) {
      buffer = buffer.slice(1);
      continue;
    }
    const payload = payloadChunk && tryParsePayload(payloadChunk);
    chunks.push({
      id,
      payload
    }), buffer = buffer.slice(match.length);
  }
  return [chunks];
}
function tryParsePayload(json) {
  try {
    return JSON.parse(json);
  } catch (err) {
    console.warn(`Failed to parse parameters: ${err.message}`);
    return;
  }
}
function tryParseBase64Payload(data) {
  try {
    return data ? decodeJsonParams(data) : void 0;
  } catch (err) {
    console.warn(`Failed to parse parameters: ${err.message}`);
    return;
  }
}
const documentActions = [usePublishAction, useUnpublishAction, useDiscardChangesAction, useDuplicateAction, useDeleteAction, useHistoryRestoreAction], destructiveActionNames = ["delete", "discardChanges"], documentBadges = [useLiveEditBadge], inspectors = [validationInspector, changesInspector, incomingReferencesInspector], structureTool = definePlugin((options) => {
  const icon = options?.icon || MasterDetailIcon;
  return {
    name: "sanity/structure",
    document: {
      actions: (prevActions, context) => {
        const combinedActions = Array.from(/* @__PURE__ */ new Set([...prevActions, ...documentActions])), destructiveActions = combinedActions.filter((action) => destructiveActionNames.includes(action.action)), otherActions = combinedActions.filter((action) => !destructiveActionNames.includes(action.action));
        return context.versionType === "published" ? [...[...otherActions].sort((a, b) => a.action === "unpublish" ? -1 : b.action === "unpublish" ? 1 : 0), ...destructiveActions] : [...otherActions, ...destructiveActions];
      },
      badges: (prevBadges) => Array.from(/* @__PURE__ */ new Set([...prevBadges, ...documentBadges])),
      inspectors: (prevInspectors) => Array.from(/* @__PURE__ */ new Set([...prevInspectors, ...inspectors]))
    },
    tools: [{
      name: options?.name || "structure",
      title: options?.title || "Structure",
      icon,
      component: lazy(() => import("./index4.js")),
      canHandleIntent: (intent, params) => intent === "create" ? canHandleCreateIntent(params) : intent === "edit" ? canHandleEditIntent(params) : !1,
      getIntentState,
      // Controlled by sanity/src/structure/components/structureTool/StructureTitle.tsx
      controlsDocumentTitle: !0,
      options,
      router,
      __internalApplicationType: "sanity/structure"
    }],
    i18n: {
      bundles: [structureUsEnglishLocaleBundle]
    }
  };
});
function canHandleCreateIntent(params) {
  if (!("type" in params))
    return !1;
  const handle = {};
  return "mode" in params && (handle.mode = params.mode === "structure"), "template" in params && (handle.template = !0), Object.keys(handle).length ? handle : !0;
}
function canHandleEditIntent(params) {
  return "id" in params ? "mode" in params ? {
    mode: params.mode === "structure"
  } : !0 : !1;
}
export {
  BackLink,
  ConfirmDeleteDialogContainer,
  CrossDatasetIncomingReferenceDocumentPreview,
  DocumentInspectorHeader,
  DocumentPane,
  DocumentPaneProviderWrapper,
  INCOMING_REFERENCES_ITEM_HEIGHT,
  INITIAL_STATE$1 as INITIAL_STATE,
  IncomingReferenceDocument$1 as IncomingReferenceDocument,
  IncomingReferencesListContainer,
  LOADING_PANE,
  LoadingPane,
  Pane,
  PaneContainer,
  PaneContent,
  PaneHeader$1 as PaneHeader,
  PaneHeaderActions,
  PaneItem,
  PaneLayout,
  StructureTitle,
  StructureToolPane,
  _DEBUG,
  assignId,
  getCrossDatasetIncomingReferences,
  getIncomingReferences,
  setActivePanes,
  structureTool,
  useDocumentPane,
  useDocumentTitle,
  usePane,
  usePaneLayout,
  usePaneOptions,
  usePaneRouter,
  useStructureTool
};
//# sourceMappingURL=structureTool.js.map
